function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

import React$2, { useLayoutEffect, useEffect, useRef, useCallback, forwardRef, createElement, useState, useMemo, useContext } from 'react';
import PropTypes from 'prop-types';
import styled, { createGlobalStyle, ThemeProvider, css } from 'styled-components';
import { normalize } from 'styled-normalize';
import reactDom from 'react-dom';
import { animated, useTransition } from 'react-spring';
import * as MaterialIcons from 'react-icons/md';
import Select, { components } from 'react-select';
import CreatableSelect from 'react-select/creatable';
import AsyncSelect from 'react-select/async';
import AsyncCreatableSelect from 'react-select/async-creatable';
import ReactSlider from 'react-slider';

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var theme = {
  baseFontSize: '16px',
  fontSize: {
    10: '0.625rem',
    11: '0.688rem',
    12: '0.750rem',
    13: '0.813rem',
    14: '0.875rem',
    15: '0.938rem',
    16: '1.000rem'
  },
  fontWeight: {
    regular: 400,
    medium: 500,
    bold: 700
  },
  colors: {
    red: '#E30613',
    charcoal: '#3C3C3C',
    blue: '#04A0B2',
    sinbad: '#9DCECF',
    scandal: '#B4D8D8',
    white: '#FFFFFF',
    black: '#000000',
    lightGrey: '#F0F0F0',
    grey: '#C8C8C8',
    darkGrey: '#A0A0A0',
    butter: '#FFE164',
    amber: '#FFA528',
    rust: '#C36900',
    apple: '#B4E678',
    wasabi: '#78AA3C',
    palmLeaf: '#3C6E00',
    fireEngine: '#B72126',
    bunker: '#21252B'
  },
  hoverColors: {
    red: '#d40208',
    charcoal: '#202020',
    blue: '#017c91',
    grey: '#aeaeae'
  },
  transitions: {
    baseTransition: 'all 0.2s ease-in-out'
  },
  gutters: {
    4: '0.250rem',
    8: '0.500rem',
    12: '0.750rem',
    16: '1.000rem',
    20: '1.250rem',
    24: '1.500rem',
    28: '1.750rem',
    32: '2.000rem',
    36: '2.250rem',
    40: '2.500rem',
    60: '3.750rem'
  },
  headings: {
    level: {
      1: {
        fontSize: '3.000rem',
        fontWeight: 700,
        lineHeight: '3.750rem'
      },
      2: {
        fontSize: '2.125rem',
        fontWeight: 600,
        lineHeight: '2.625rem'
      },
      3: {
        fontSize: '1.500rem',
        fontWeight: 400,
        lineHeight: '1.875rem'
      },
      4: {
        fontSize: '1.125rem',
        fontWeight: 400,
        lineHeight: '1.375rem'
      }
    }
  },
  BREAKPOINTS: {
    // mobile
    MOBILE_DOWN: '(max-width: 719px)',
    MOBILE_MEDIUM: '(max-width: 480px)',
    MOBILE_LARGE: '(min-width: 481px) and (max-width: 719px)',
    MOBILE_UP: '(min-width: 481px)',
    // tablet
    TABLET_DOWN: '(max-width: 959px)',
    TABLET: '(min-width: 720px) and (max-width: 959px)',
    TABLET_UP: '(min-width: 720px)',
    // desktop
    DESKTOP_SMALL: '(min-width: 960px) and (max-width: 1199px)',
    DESKTOP_MEDIUM: '(min-width: 1200px) and (max-width: 1499px)',
    DESKTOP_LARGE: '(min-width: 1500px)',
    DESKTOP_UP: '(min-width: 960px)'
  }
};

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n\n  body {\n    font-weight: ", ";\n    font-size: ", ";\n    margin: 0;\n    -webkit-text-size-adjust: 100%;\n    -ms-text-size-adjust: 100%;\n    -moz-osx-font-smoothing: grayscale;\n    -webkit-font-smoothing: antialiased;\n    -webkit-tap-highlight-color: transparent;\n  }\n\n  html, * {\n    box-sizing: border-box\n  }\n\n  input[type=\"number\"]::-webkit-outer-spin-button,\n  input[type=\"number\"]::-webkit-inner-spin-button {\n      -webkit-appearance: none;\n      margin: 0;\n  }\n\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var GlobalStyle = createGlobalStyle(_templateObject(), function (props) {
  return props.theme.fontWeight.regular;
}, function (props) {
  return props.theme.baseFontSize;
}, normalize);

function Theme(props) {
  var children = props.children;
  return React$2.createElement(React$2.Fragment, null, React$2.createElement(ThemeProvider, {
    theme: theme
  }, children), React$2.createElement(GlobalStyle, {
    theme: theme
  }));
}

Theme.propTypes = {
  children: PropTypes.node
};

function _templateObject$1() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  overflow: hidden;\n  transform: translate3d(0, 0, 0);\n\n  &:after {\n    content: '';\n    display: block;\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    background-image: radial-gradient(circle, #e9e9e9 10%, transparent 10%);\n    background-repeat: no-repeat;\n    background-position: 50%;\n    transform: scale(10, 10);\n    opacity: 0;\n    transition: transform 0.4s, opacity 1s;\n  }\n\n  &:active:after {\n    transform: scale(0, 0);\n    opacity: 0.3;\n    transition: 0s;\n  }\n"]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}

var RippleStyle = function RippleStyle() {
  return css(_templateObject$1());
}; // Benificiary Allocations Calculations
// Limit to only 2 decimal points with correct rounding applied


var squashDecimalPoints = function squashDecimalPoints(num) {
  return Math.round((num + Number.EPSILON) * 100) / 100;
}; // Works out what the Rand value of a supplied percentage and total amount is


var getRandValueFromPercent = function getRandValueFromPercent(percent, amount) {
  return squashDecimalPoints(percent / 100 * amount);
};

var getPercentFromRandValue = function getPercentFromRandValue(randValue, wholeAmount) {
  return squashDecimalPoints(randValue / wholeAmount * 100);
};

var prettifyDecimalNumber = function prettifyDecimalNumber(value) {
  var remaining = squashDecimalPoints(value);
  var parts = remaining.toString().split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return parts.join('.');
};

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n\n  ", "\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  text-decoration: none;\n  border: 0;\n  user-select: none;\n  text-transform: uppercase;\n  border-radius: 25px;\n  outline: 0;\n  letter-spacing: 0.063em;\n  user-select: none;\n\n  font-size: ", ";\n  font-weight: ", ";\n  margin: ", " 0 0 0;\n  color: ", ";\n  transition: ", ";\n  padding: ", ";\n\n  &:hover {\n    color: ", ";\n  }\n\n  ", "\n\n  ", "\n\n  @media ", " {\n    width: 100%;\n    padding-left: 0;\n    padding-right: 0;\n  }\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  animation: fadeUp 0.3s;\n\n  @keyframes fadeUp {\n    from {\n      opacity: 0;\n      bottom: -30px;\n    }\n    to {\n      opacity: 1;\n      bottom: 7px;\n    }\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  line-height: 0;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  margin: 0 ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  opacity: ", ";\n  transition: opacity 0.3s ease-in-out;\n  display: flex;\n  align-items: center;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  max-width: 500px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$2() {
  var data = _taggedTemplateLiteral(["\n  cursor: ", ";\n  color: ", ";\n\n  &:hover {\n    color: ", ";\n  }\n"]);

  _templateObject$2 = function _templateObject() {
    return data;
  };

  return data;
}

var disabledStyle = function disabledStyle() {
  return css(_templateObject$2(), function (props) {
    return props.loading ? 'default' : 'not-allowed';
  }, function (props) {
    return props.theme.colors.grey;
  }, function (props) {
    return props.theme.colors.grey;
  });
};

var fullWidthStyle = function fullWidthStyle() {
  return css(_templateObject2());
};

var ContentContainer = styled.div(_templateObject3(), function (props) {
  return props.isLoading ? '0' : '1';
});
var Content = styled.span(_templateObject4(), function (props) {
  return props.theme.gutters[4];
});
var IconWrapper = styled.div(_templateObject5());
var LoaderContainer = styled.div(_templateObject6());
var StyledButton = styled.button(_templateObject7(), function (props) {
  return RippleStyle();
}, function (props) {
  return props.theme.fontSize[13];
}, function (props) {
  return props.theme.fontWeight.bold;
}, function (props) {
  return props.theme.gutters[16];
}, function (props) {
  return props.theme.colors.charcoal;
}, function (props) {
  return props.theme.transitions.baseTransition;
}, function (props) {
  return props.size === 'small' ? '0.688em 2.500em' : '0.813em 2.500em';
}, function (props) {
  return props.theme.hoverColors.charcoal;
}, function (props) {
  return props.disabled && disabledStyle();
}, function (props) {
  return props.fullWidth && fullWidthStyle();
}, function (props) {
  return props.theme.BREAKPOINTS.MOBILE_DOWN;
});

var removeHash = function removeHash(hex) {
  return hex.charAt(0) === '#' ? hex.slice(1) : hex;
};

var parseHex = function parseHex(nakedHex) {
  var isShort = nakedHex.length === 3 || nakedHex.length === 4;
  var twoDigitHexR = isShort ? "".concat(nakedHex.slice(0, 1)).concat(nakedHex.slice(0, 1)) : nakedHex.slice(0, 2);
  var twoDigitHexG = isShort ? "".concat(nakedHex.slice(1, 2)).concat(nakedHex.slice(1, 2)) : nakedHex.slice(2, 4);
  var twoDigitHexB = isShort ? "".concat(nakedHex.slice(2, 3)).concat(nakedHex.slice(2, 3)) : nakedHex.slice(4, 6);
  var twoDigitHexA = (isShort ? "".concat(nakedHex.slice(3, 4)).concat(nakedHex.slice(3, 4)) : nakedHex.slice(6, 8)) || 'ff'; // const numericA = +((parseInt(a, 16) / 255).toFixed(2));

  return {
    r: twoDigitHexR,
    g: twoDigitHexG,
    b: twoDigitHexB,
    a: twoDigitHexA
  };
};

var hexToDecimal = function hexToDecimal(hex) {
  return parseInt(hex, 16);
};

var hexesToDecimals = function hexesToDecimals(_ref) {
  var r = _ref.r,
      g = _ref.g,
      b = _ref.b,
      a = _ref.a;
  return {
    r: hexToDecimal(r),
    g: hexToDecimal(g),
    b: hexToDecimal(b),
    a: +(hexToDecimal(a) / 255).toFixed(2)
  };
};

var isNumeric = function isNumeric(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
}; // eslint-disable-line no-restricted-globals, max-len


var formatRgb = function formatRgb(decimalObject, parameterA) {
  var r = decimalObject.r,
      g = decimalObject.g,
      b = decimalObject.b,
      parsedA = decimalObject.a;
  var a = isNumeric(parameterA) ? parameterA : parsedA;
  return "rgba(".concat(r, ", ").concat(g, ", ").concat(b, ", ").concat(a, ")");
};
/**
 * Turns an old-fashioned css hex color value into a rgb color value.
 *
 * If you specify an alpha value, you'll get a rgba() value instead.
 *
 * @param The hex value to convert. ('123456'. '#123456', ''123', '#123')
 * @param An alpha value to apply. (optional) ('0.5', '0.25')
 * @return An rgb or rgba value. ('rgb(11, 22, 33)'. 'rgba(11, 22, 33, 0.5)')
 */


var hexToRgba = function hexToRgba(hex, a) {
  var hashlessHex = removeHash(hex);
  var hexObject = parseHex(hashlessHex);
  var decimalObject = hexesToDecimals(hexObject);
  return formatRgb(decimalObject, a);
};

var build = hexToRgba;

function _templateObject$3() {
  var data = _taggedTemplateLiteral(["\n  border: ", " solid\n    ", ";\n  border-top: ", " solid\n    ", ";\n  border-radius: 50%;\n  width: ", ";\n  height: ", ";\n  animation: spin 0.7s linear infinite;\n\n  @keyframes spin {\n    0% {\n      transform: rotate(0deg);\n    }\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n"]);

  _templateObject$3 = function _templateObject() {
    return data;
  };

  return data;
}

var StyledLoader = styled.div(_templateObject$3(), function (props) {
  return props.trackWidth;
}, function (props) {
  return build(props.theme.colors[props.trackColor], props.trackOpacity);
}, function (props) {
  return props.trackWidth;
}, function (props) {
  return props.theme.colors[props.color];
}, function (props) {
  return props.size;
}, function (props) {
  return props.size;
});
var COLOR_OPTIONS = ['red', 'charcoal', 'blue', 'sinbad', 'scandal', 'white', 'black', 'lightGrey', 'grey', 'darkGrey', 'butter', 'amber', 'rust', 'apple', 'wasabi', 'palmLeaf', 'fireEngine', 'bunker'];

function Loader(_ref) {
  var color = _ref.color,
      trackColor = _ref.trackColor,
      size = _ref.size,
      trackWidth = _ref.trackWidth,
      trackOpacity = _ref.trackOpacity,
      rest = _objectWithoutProperties(_ref, ["color", "trackColor", "size", "trackWidth", "trackOpacity"]);

  return React$2.createElement(StyledLoader, _extends({
    color: color,
    size: size,
    trackColor: trackColor,
    trackWidth: trackWidth,
    trackOpacity: trackOpacity
  }, rest));
}

Loader.propTypes = {
  color: PropTypes.oneOf(COLOR_OPTIONS),
  size: PropTypes.string,
  trackColor: PropTypes.oneOf(COLOR_OPTIONS),
  trackWidth: PropTypes.string,
  trackOpacity: PropTypes.string
};
Loader.defaultProps = {
  color: 'blue',
  size: '50px',
  trackColor: 'lightGrey',
  trackWidth: '4px',
  trackOpacity: '1'
};

function Button(props) {
  var children = props.children,
      disabled = props.disabled,
      loading = props.loading,
      icon = props.icon,
      appendIcon = props.appendIcon,
      prependIcon = props.prependIcon,
      onClick = props.onClick,
      type = props.type,
      fullWidth = props.fullWidth,
      rest = _objectWithoutProperties(props, ["children", "disabled", "loading", "icon", "appendIcon", "prependIcon", "onClick", "type", "fullWidth"]);

  var renderIcon = function renderIcon() {
    return React$2.createElement(IconWrapper, {
      "data-testid": "button-icon"
    }, React$2.createElement(Icon, {
      icon: icon,
      size: '1.1rem'
    }));
  };

  return React$2.createElement(StyledButton, _extends({}, rest, {
    disabled: loading || disabled,
    onClick: onClick,
    type: type,
    fullWidth: fullWidth
  }), React$2.createElement(ContentContainer, {
    isLoading: loading
  }, icon && prependIcon && !appendIcon && renderIcon(), children && React$2.createElement(Content, null, children), icon && appendIcon && renderIcon()), loading && React$2.createElement(LoaderContainer, null, React$2.createElement(Loader, {
    size: "28px",
    color: "white",
    trackWidth: "3px",
    trackColor: "white",
    trackOpacity: "0.4"
  })));
}

Button.propTypes = {
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  icon: PropTypes.string,
  appendIcon: PropTypes.bool,
  prependIcon: PropTypes.bool,
  onClick: PropTypes.func,
  type: PropTypes.oneOf(['button', 'submit', 'reset']),
  fullWidth: PropTypes.bool
};
Button.defaultProps = {
  disabled: false,
  loading: false,
  prependIcon: true,
  type: 'button',
  fullWidth: false
};

function _templateObject6$1() {
  var data = _taggedTemplateLiteral(["\n  height: ", ";\n  font-weight: ", ";\n  font-size: ", "};\n\n  &:hover {\n    color: ", ";\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject6$1 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$1() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  background: ", ";\n  border: 1px solid ", ";\n  &:hover {\n    background: ", ";\n    color: ", ";\n    border-color: ", ";\n  }\n"]);

  _templateObject5$1 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$1() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  background: ", ";\n  border: 1px solid ", ";\n  &:hover {\n    background: ", ";\n    border-color: ", ";\n  }\n"]);

  _templateObject4$1 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$1() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  background: ", ";\n  border: 1px solid ", ";\n  &:hover {\n    background: ", ";\n    border-color: ", ";\n  }\n"]);

  _templateObject3$1 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$1() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  background: ", ";\n  border: 1px solid ", ";\n  &:hover {\n    background: ", ";\n    border-color: ", ";\n  }\n"]);

  _templateObject2$1 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$4() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  background: ", ";\n  border: 1px solid ", ";\n  &:hover {\n    background: ", ";\n    border-color: ", ";\n  }\n"]);

  _templateObject$4 = function _templateObject() {
    return data;
  };

  return data;
}

var redStyle = function redStyle(props) {
  return css(_templateObject$4(), props.theme.colors.white, props.theme.colors.red, props.theme.colors.red, !props.loading ? props.theme.hoverColors.red : props.theme.colors.red, !props.loading ? props.theme.hoverColors.red : props.theme.colors.red);
};

var charcoalStyle = function charcoalStyle(props) {
  return css(_templateObject2$1(), props.theme.colors.white, props.theme.colors.charcoal, props.theme.colors.charcoal, !props.loading ? props.theme.hoverColors.charcoal : props.theme.colors.charcoal, !props.loading ? props.theme.hoverColors.charcoal : props.theme.colors.charcoal);
};

var blueStyle = function blueStyle(props) {
  return css(_templateObject3$1(), props.theme.colors.white, props.theme.colors.blue, props.theme.colors.blue, !props.loading ? props.theme.hoverColors.blue : props.theme.colors.blue, !props.loading ? props.theme.hoverColors.blue : props.theme.colors.blue);
};

var greyStyle = function greyStyle(props) {
  return css(_templateObject4$1(), props.theme.colors.white, props.theme.colors.grey, props.theme.colors.grey, !props.loading ? props.theme.hoverColors.grey : props.theme.colors.grey, !props.loading ? props.theme.hoverColors.grey : props.theme.colors.grey);
};

var disabledStyle$1 = function disabledStyle(props) {
  return css(_templateObject5$1(), props.theme.colors.grey, props.theme.colors.lightGrey, props.theme.colors.white, props.theme.colors.lightGrey, props.theme.colors.grey, props.theme.colors.white);
};

var StyledPrimaryButton = styled(Button)(_templateObject6$1(), function (props) {
  return props.size === 'small' ? '42px' : '50px';
}, function (props) {
  return props.size === 'small' ? props.theme.fontWeight.bold : props.theme.fontWeight.regular;
}, function (props) {
  return props.size === 'small' ? props.theme.fontSize[13] : props.theme.fontSize[16];
}, function (props) {
  return props.theme.colors.white;
}, function (props) {
  return props.appearance === 'red' && redStyle(props);
}, function (props) {
  return props.appearance === 'charcoal' && charcoalStyle(props);
}, function (props) {
  return props.appearance === 'blue' && blueStyle(props);
}, function (props) {
  return props.appearance === 'grey' && greyStyle(props);
}, function (props) {
  return props.disabled && disabledStyle$1(props);
});

function PrimaryButton(props) {
  var children = props.children,
      appearance = props.appearance,
      size = props.size,
      rest = _objectWithoutProperties(props, ["children", "appearance", "size"]);

  return React$2.createElement(StyledPrimaryButton, _extends({}, rest, {
    appearance: appearance,
    size: size
  }), children);
}

PrimaryButton.propTypes = {
  appearance: PropTypes.oneOf(['red', 'charcoal', 'blue', 'grey']),
  size: PropTypes.oneOf(['large', 'small']),
  children: PropTypes.node.isRequired
};
PrimaryButton.defaultProps = {
  appearance: 'red',
  size: 'large'
};

function _templateObject5$2() {
  var data = _taggedTemplateLiteral(["\n  line-height: 1.5;\n  height: 50px;\n  font-size: ", ";\n  background: ", ";\n  font-weight: ", ";\n\n  &:hover {\n    color: ", "\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject5$2 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$2() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  background: ", ";\n  border: 1px solid ", ";\n  &:hover {\n    background: ", ";\n    color: ", ";\n  }\n"]);

  _templateObject4$2 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$2() {
  var data = _taggedTemplateLiteral(["\n  background: ", ";\n  border: 1px solid ", ";\n  color: ", ";\n  &:hover {\n    background: ", ";\n    color: ", ";\n  }\n"]);

  _templateObject3$2 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$2() {
  var data = _taggedTemplateLiteral(["\n  background: transparent;\n  border: 1px solid ", ";\n  &:hover {\n    background: ", ";\n    color: ", ";\n  }\n"]);

  _templateObject2$2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$5() {
  var data = _taggedTemplateLiteral(["\n  background: transparent;\n  border: 1px solid ", ";\n  &:hover {\n    background: ", ";\n  }\n"]);

  _templateObject$5 = function _templateObject() {
    return data;
  };

  return data;
}

var charcoalStyle$1 = function charcoalStyle(props) {
  return css(_templateObject$5(), props.theme.colors.charcoal, props.theme.colors.charcoal);
};

var greyStyle$1 = function greyStyle(props) {
  return css(_templateObject2$2(), props.theme.colors.lightGrey, props.theme.colors.lightGrey, props.theme.hoverColors.charcoal);
};

var redStyle$1 = function redStyle(props) {
  return css(_templateObject3$2(), props.theme.colors.white, props.theme.colors.red, props.theme.colors.red, props.theme.colors.red, props.theme.hoverColors.white);
};

var disabledStyle$2 = function disabledStyle(props) {
  return css(_templateObject4$2(), props.theme.colors.grey, props.theme.colors.lightGrey, props.theme.colors.white, props.theme.colors.lightGrey, props.theme.colors.grey);
};

var StyledSecondaryButton = styled(Button)(_templateObject5$2(), function (props) {
  return props.theme.fontSize[13];
}, function (props) {
  return props.theme.colors.lightGrey;
}, function (props) {
  return props.theme.fontWeight.bold;
}, function (props) {
  return props.theme.colors.white;
}, function (props) {
  return props.appearance === 'charcoal' && charcoalStyle$1(props);
}, function (props) {
  return props.appearance === 'grey' && greyStyle$1(props);
}, function (props) {
  return props.appearance === 'red' && redStyle$1(props);
}, function (props) {
  return props.disabled && disabledStyle$2(props);
});

function SecondaryButton(props) {
  var children = props.children,
      appearance = props.appearance,
      rest = _objectWithoutProperties(props, ["children", "appearance"]);

  return React$2.createElement(StyledSecondaryButton, _extends({}, rest, {
    appearance: appearance
  }), children);
}

SecondaryButton.propTypes = {
  appearance: PropTypes.oneOf(['charcoal', 'grey', 'red']),
  children: PropTypes.node.isRequired
};
SecondaryButton.defaultProps = {
  appearance: 'grey'
};

function _templateObject2$3() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  margin: 0;\n  ", "\n"]);

  _templateObject2$3 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$6() {
  var data = _taggedTemplateLiteral(["\n    font-size: ", ";\n    font-weight: ", ";\n    line-height: ", ";\n  "]);

  _templateObject$6 = function _templateObject() {
    return data;
  };

  return data;
}

var sizeStyle = function sizeStyle(props) {
  var size = props.level || 1;
  var themeStyle = props.theme.headings.level[size];
  return css(_templateObject$6(), themeStyle.fontSize, props.weight ? props.weight : themeStyle.fontWeight, themeStyle.lineHeight);
};

var StyledHeading = styled.h1(_templateObject2$3(), function (props) {
  return props.theme.colors[props.color];
}, function (props) {
  return sizeStyle(props);
});

function Heading(props) {
  var level = props.level,
      children = props.children,
      color = props.color,
      weight = props.weight,
      rest = _objectWithoutProperties(props, ["level", "children", "color", "weight"]);

  return React$2.createElement(StyledHeading, _extends({}, rest, {
    level: level,
    as: "h".concat(level),
    color: color,
    weight: weight
  }), children);
}

Heading.propTypes = {
  level: PropTypes.number,
  children: PropTypes.string,
  color: PropTypes.oneOf(['red', 'charcoal', 'blue', 'sinbad', 'scandal', 'white', 'black', 'lightGrey', 'grey', 'darkGrey', 'butter', 'amber', 'rust', 'apple', 'wasabi', 'palmLeaf', 'fireEngine', 'bunker']),
  weight: PropTypes.number
};
Heading.defaultProps = {
  level: 1,
  color: 'black'
};
var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function commonjsRequire() {
  throw new Error('Dynamic requires are not currently supported by rollup-plugin-commonjs');
}

function unwrapExports(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
  return module = {
    exports: {}
  }, fn(module, module.exports), module.exports;
}

function _interopDefault(e) {
  return e && "object" == typeof e && "default" in e ? e["default"] : e;
}

var React = _interopDefault(React$2);

function _defaults2(e, t) {
  for (var n = Object.getOwnPropertyNames(t), a = 0; a < n.length; a++) {
    var i = n[a],
        r = Object.getOwnPropertyDescriptor(t, i);
    r && r.configurable && e[i] === undefined && Object.defineProperty(e, i, r);
  }

  return e;
}

function _extends$1() {
  return (_extends$1 = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];

      for (var a in n) {
        Object.prototype.hasOwnProperty.call(n, a) && (e[a] = n[a]);
      }
    }

    return e;
  }).apply(this, arguments);
}

function _inheritsLoose(e, t) {
  e.prototype = Object.create(t.prototype), _defaults2(e.prototype.constructor = e, t);
}

function _objectWithoutPropertiesLoose$1(e, t) {
  if (null == e) return {};
  var n,
      a,
      i = {},
      r = Object.keys(e);

  for (a = 0; a < r.length; a++) {
    n = r[a], 0 <= t.indexOf(n) || (i[n] = e[n]);
  }

  return i;
}

function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}

var invariant = function invariant(e, t, n, a, i, r, o, s) {
  if (!e) {
    var l;
    if (t === undefined) l = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else {
      var u = [n, a, i, r, o, s],
          c = 0;
      (l = new Error(t.replace(/%s/g, function () {
        return u[c++];
      }))).name = "Invariant Violation";
    }
    throw l.framesToPop = 1, l;
  }
},
    invariant_1 = invariant;

function setInputSelection(e, t, n) {
  if ("selectionStart" in e && "selectionEnd" in e) e.selectionStart = t, e.selectionEnd = n;else {
    var a = e.createTextRange();
    a.collapse(!0), a.moveStart("character", t), a.moveEnd("character", n - t), a.select();
  }
}

function getInputSelection(e) {
  var t = 0,
      n = 0;
  if ("selectionStart" in e && "selectionEnd" in e) t = e.selectionStart, n = e.selectionEnd;else {
    var a = document.selection.createRange();
    a.parentElement() === e && (t = -a.moveStart("character", -e.value.length), n = -a.moveEnd("character", -e.value.length));
  }
  return {
    start: t,
    end: n,
    length: n - t
  };
}

var defaultFormatChars = {
  9: "[0-9]",
  a: "[A-Za-z]",
  "*": "[A-Za-z0-9]"
},
    defaultMaskChar = "_";

function parseMask(e, t, n) {
  var a = "",
      i = "",
      r = null,
      o = [];
  if (t === undefined && (t = defaultMaskChar), null == n && (n = defaultFormatChars), !e || "string" != typeof e) return {
    maskChar: t,
    formatChars: n,
    mask: null,
    prefix: null,
    lastEditablePosition: null,
    permanents: []
  };
  var s = !1;
  return e.split("").forEach(function (e) {
    s = !s && "\\" === e || (s || !n[e] ? (o.push(a.length), a.length === o.length - 1 && (i += e)) : r = a.length + 1, a += e, !1);
  }), {
    maskChar: t,
    formatChars: n,
    prefix: i,
    mask: a,
    lastEditablePosition: r,
    permanents: o
  };
}

function isPermanentCharacter(e, t) {
  return -1 !== e.permanents.indexOf(t);
}

function isAllowedCharacter(e, t, n) {
  var a = e.mask,
      i = e.formatChars;
  if (!n) return !1;
  if (isPermanentCharacter(e, t)) return a[t] === n;
  var r = i[a[t]];
  return new RegExp(r).test(n);
}

function isEmpty(n, e) {
  return e.split("").every(function (e, t) {
    return isPermanentCharacter(n, t) || !isAllowedCharacter(n, t, e);
  });
}

function getFilledLength(e, t) {
  var n = e.maskChar,
      a = e.prefix;

  if (!n) {
    for (; t.length > a.length && isPermanentCharacter(e, t.length - 1);) {
      t = t.slice(0, t.length - 1);
    }

    return t.length;
  }

  for (var i = a.length, r = t.length; r >= a.length; r--) {
    var o = t[r];

    if (!isPermanentCharacter(e, r) && isAllowedCharacter(e, r, o)) {
      i = r + 1;
      break;
    }
  }

  return i;
}

function isFilled(e, t) {
  return getFilledLength(e, t) === e.mask.length;
}

function formatValue(e, t) {
  var n = e.maskChar,
      a = e.mask,
      i = e.prefix;

  if (!n) {
    for ((t = insertString(e, "", t, 0)).length < i.length && (t = i); t.length < a.length && isPermanentCharacter(e, t.length);) {
      t += a[t.length];
    }

    return t;
  }

  if (t) return insertString(e, formatValue(e, ""), t, 0);

  for (var r = 0; r < a.length; r++) {
    isPermanentCharacter(e, r) ? t += a[r] : t += n;
  }

  return t;
}

function clearRange(n, e, a, t) {
  var i = a + t,
      r = n.maskChar,
      o = n.mask,
      s = n.prefix,
      l = e.split("");
  if (r) return l.map(function (e, t) {
    return t < a || i <= t ? e : isPermanentCharacter(n, t) ? o[t] : r;
  }).join("");

  for (var u = i; u < l.length; u++) {
    isPermanentCharacter(n, u) && (l[u] = "");
  }

  return a = Math.max(s.length, a), l.splice(a, i - a), e = l.join(""), formatValue(n, e);
}

function insertString(r, o, e, s) {
  var l = r.mask,
      u = r.maskChar,
      c = r.prefix,
      t = e.split(""),
      h = isFilled(r, o);
  return !u && s > o.length && (o += l.slice(o.length, s)), t.every(function (e) {
    for (; i = e, isPermanentCharacter(r, a = s) && i !== l[a];) {
      if (s >= o.length && (o += l[s]), t = e, n = s, u && isPermanentCharacter(r, n) && t === u) return !0;
      if (++s >= l.length) return !1;
    }

    var t, n, a, i;
    return !isAllowedCharacter(r, s, e) && e !== u || (s < o.length ? o = u || h || s < c.length ? o.slice(0, s) + e + o.slice(s + 1) : (o = o.slice(0, s) + e + o.slice(s), formatValue(r, o)) : u || (o += e), ++s < l.length);
  }), o;
}

function getInsertStringLength(a, e, t, i) {
  var r = a.mask,
      o = a.maskChar,
      n = t.split(""),
      s = i;
  return n.every(function (e) {
    for (; n = e, isPermanentCharacter(a, t = i) && n !== r[t];) {
      if (++i >= r.length) return !1;
    }

    var t, n;
    return (isAllowedCharacter(a, i, e) || e === o) && i++, i < r.length;
  }), i - s;
}

function getLeftEditablePosition(e, t) {
  for (var n = t; 0 <= n; --n) {
    if (!isPermanentCharacter(e, n)) return n;
  }

  return null;
}

function getRightEditablePosition(e, t) {
  for (var n = e.mask, a = t; a < n.length; ++a) {
    if (!isPermanentCharacter(e, a)) return a;
  }

  return null;
}

function getStringValue(e) {
  return e || 0 === e ? e + "" : "";
}

function processChange(e, t, n, a, i) {
  var r = e.mask,
      o = e.prefix,
      s = e.lastEditablePosition,
      l = t,
      u = "",
      c = 0,
      h = 0,
      f = Math.min(i.start, n.start);

  if (n.end > i.start ? h = (c = getInsertStringLength(e, a, u = l.slice(i.start, n.end), f)) ? i.length : 0 : l.length < a.length && (h = a.length - l.length), l = a, h) {
    if (1 === h && !i.length) f = i.start === n.start ? getRightEditablePosition(e, n.start) : getLeftEditablePosition(e, n.start);
    l = clearRange(e, l, f, h);
  }

  return l = insertString(e, l, u, f), (f += c) >= r.length ? f = r.length : f < o.length && !c ? f = o.length : f >= o.length && f < s && c && (f = getRightEditablePosition(e, f)), u || (u = null), {
    value: l = formatValue(e, l),
    enteredString: u,
    selection: {
      start: f,
      end: f
    }
  };
}

function isWindowsPhoneBrowser() {
  var e = new RegExp("windows", "i"),
      t = new RegExp("phone", "i"),
      n = navigator.userAgent;
  return e.test(n) && t.test(n);
}

function isFunction(e) {
  return "function" == typeof e;
}

function getRequestAnimationFrame() {
  return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame;
}

function getCancelAnimationFrame() {
  return window.cancelAnimationFrame || window.webkitCancelRequestAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame;
}

function defer(e) {
  return (!!getCancelAnimationFrame() ? getRequestAnimationFrame() : function () {
    return setTimeout(e, 1e3 / 60);
  })(e);
}

function cancelDefer(e) {
  (getCancelAnimationFrame() || clearTimeout)(e);
}

var InputElement = function (c) {
  function e(e) {
    var f = c.call(this, e) || this;
    f.focused = !1, f.mounted = !1, f.previousSelection = null, f.selectionDeferId = null, f.saveSelectionLoopDeferId = null, f.saveSelectionLoop = function () {
      f.previousSelection = f.getSelection(), f.saveSelectionLoopDeferId = defer(f.saveSelectionLoop);
    }, f.runSaveSelectionLoop = function () {
      null === f.saveSelectionLoopDeferId && f.saveSelectionLoop();
    }, f.stopSaveSelectionLoop = function () {
      null !== f.saveSelectionLoopDeferId && (cancelDefer(f.saveSelectionLoopDeferId), f.saveSelectionLoopDeferId = null, f.previousSelection = null);
    }, f.getInputDOMNode = function () {
      if (!f.mounted) return null;
      var e = reactDom.findDOMNode(_assertThisInitialized(_assertThisInitialized(f))),
          t = "undefined" != typeof window && e instanceof window.Element;
      if (e && !t) return null;
      if ("INPUT" !== e.nodeName && (e = e.querySelector("input")), !e) throw new Error("react-input-mask: inputComponent doesn't contain input node");
      return e;
    }, f.getInputValue = function () {
      var e = f.getInputDOMNode();
      return e ? e.value : null;
    }, f.setInputValue = function (e) {
      var t = f.getInputDOMNode();
      t && (f.value = e, t.value = e);
    }, f.setCursorToEnd = function () {
      var e = getFilledLength(f.maskOptions, f.value),
          t = getRightEditablePosition(f.maskOptions, e);
      null !== t && f.setCursorPosition(t);
    }, f.setSelection = function (e, t, n) {
      void 0 === n && (n = {});
      var a = f.getInputDOMNode(),
          i = f.isFocused();
      a && i && (n.deferred || setInputSelection(a, e, t), null !== f.selectionDeferId && cancelDefer(f.selectionDeferId), f.selectionDeferId = defer(function () {
        f.selectionDeferId = null, setInputSelection(a, e, t);
      }), f.previousSelection = {
        start: e,
        end: t,
        length: Math.abs(t - e)
      });
    }, f.getSelection = function () {
      return getInputSelection(f.getInputDOMNode());
    }, f.getCursorPosition = function () {
      return f.getSelection().start;
    }, f.setCursorPosition = function (e) {
      f.setSelection(e, e);
    }, f.isFocused = function () {
      return f.focused;
    }, f.getBeforeMaskedValueChangeConfig = function () {
      var e = f.maskOptions,
          t = e.mask,
          n = e.maskChar,
          a = e.permanents,
          i = e.formatChars;
      return {
        mask: t,
        maskChar: n,
        permanents: a,
        alwaysShowMask: !!f.props.alwaysShowMask,
        formatChars: i
      };
    }, f.isInputAutofilled = function (e, t, n, a) {
      var i = f.getInputDOMNode();

      try {
        if (i.matches(":-webkit-autofill")) return !0;
      } catch (r) {}

      return !f.focused || a.end < n.length && t.end === e.length;
    }, f.onChange = function (e) {
      var t = _assertThisInitialized(_assertThisInitialized(f)).beforePasteState,
          n = _assertThisInitialized(_assertThisInitialized(f)).previousSelection,
          a = f.props.beforeMaskedValueChange,
          i = f.getInputValue(),
          r = f.value,
          o = f.getSelection();

      f.isInputAutofilled(i, o, r, n) && (r = formatValue(f.maskOptions, ""), n = {
        start: 0,
        end: 0,
        length: 0
      }), t && (n = t.selection, r = t.value, o = {
        start: n.start + i.length,
        end: n.start + i.length,
        length: 0
      }, i = r.slice(0, n.start) + i + r.slice(n.end), f.beforePasteState = null);
      var s = processChange(f.maskOptions, i, o, r, n),
          l = s.enteredString,
          u = s.selection,
          c = s.value;

      if (isFunction(a)) {
        var h = a({
          value: c,
          selection: u
        }, {
          value: r,
          selection: n
        }, l, f.getBeforeMaskedValueChangeConfig());
        c = h.value, u = h.selection;
      }

      f.setInputValue(c), isFunction(f.props.onChange) && f.props.onChange(e), f.isWindowsPhoneBrowser ? f.setSelection(u.start, u.end, {
        deferred: !0
      }) : f.setSelection(u.start, u.end);
    }, f.onFocus = function (e) {
      var t = f.props.beforeMaskedValueChange,
          n = f.maskOptions,
          a = n.mask,
          i = n.prefix;

      if (f.focused = !0, f.mounted = !0, a) {
        if (f.value) getFilledLength(f.maskOptions, f.value) < f.maskOptions.mask.length && f.setCursorToEnd();else {
          var r = formatValue(f.maskOptions, i),
              o = formatValue(f.maskOptions, r),
              s = getFilledLength(f.maskOptions, o),
              l = getRightEditablePosition(f.maskOptions, s),
              u = {
            start: l,
            end: l
          };

          if (isFunction(t)) {
            var c = t({
              value: o,
              selection: u
            }, {
              value: f.value,
              selection: null
            }, null, f.getBeforeMaskedValueChangeConfig());
            o = c.value, u = c.selection;
          }

          var h = o !== f.getInputValue();
          h && f.setInputValue(o), h && isFunction(f.props.onChange) && f.props.onChange(e), f.setSelection(u.start, u.end);
        }
        f.runSaveSelectionLoop();
      }

      isFunction(f.props.onFocus) && f.props.onFocus(e);
    }, f.onBlur = function (e) {
      var t = f.props.beforeMaskedValueChange,
          n = f.maskOptions.mask;

      if (f.stopSaveSelectionLoop(), f.focused = !1, n && !f.props.alwaysShowMask && isEmpty(f.maskOptions, f.value)) {
        var a = "";
        if (isFunction(t)) a = t({
          value: a,
          selection: null
        }, {
          value: f.value,
          selection: f.previousSelection
        }, null, f.getBeforeMaskedValueChangeConfig()).value;
        var i = a !== f.getInputValue();
        i && f.setInputValue(a), i && isFunction(f.props.onChange) && f.props.onChange(e);
      }

      isFunction(f.props.onBlur) && f.props.onBlur(e);
    }, f.onMouseDown = function (e) {
      if (!f.focused && document.addEventListener) {
        f.mouseDownX = e.clientX, f.mouseDownY = e.clientY, f.mouseDownTime = new Date().getTime();

        var r = function r(e) {
          if (document.removeEventListener("mouseup", r), f.focused) {
            var t = Math.abs(e.clientX - f.mouseDownX),
                n = Math.abs(e.clientY - f.mouseDownY),
                a = Math.max(t, n),
                i = new Date().getTime() - f.mouseDownTime;
            (a <= 10 && i <= 200 || a <= 5 && i <= 300) && f.setCursorToEnd();
          }
        };

        document.addEventListener("mouseup", r);
      }

      isFunction(f.props.onMouseDown) && f.props.onMouseDown(e);
    }, f.onPaste = function (e) {
      isFunction(f.props.onPaste) && f.props.onPaste(e), e.defaultPrevented || (f.beforePasteState = {
        value: f.getInputValue(),
        selection: f.getSelection()
      }, f.setInputValue(""));
    }, f.handleRef = function (e) {
      null == f.props.children && isFunction(f.props.inputRef) && f.props.inputRef(e);
    };
    var t = e.mask,
        n = e.maskChar,
        a = e.formatChars,
        i = e.alwaysShowMask,
        r = e.beforeMaskedValueChange,
        o = e.defaultValue,
        s = e.value;
    f.maskOptions = parseMask(t, n, a), null == o && (o = ""), null == s && (s = o);
    var l = getStringValue(s);

    if (f.maskOptions.mask && (i || l) && (l = formatValue(f.maskOptions, l), isFunction(r))) {
      var u = e.value;
      null == e.value && (u = o), l = r({
        value: l,
        selection: null
      }, {
        value: u = getStringValue(u),
        selection: null
      }, null, f.getBeforeMaskedValueChangeConfig()).value;
    }

    return f.value = l, f;
  }

  _inheritsLoose(e, c);

  var t = e.prototype;
  return t.componentDidMount = function () {
    this.mounted = !0, this.getInputDOMNode() && (this.isWindowsPhoneBrowser = isWindowsPhoneBrowser(), this.maskOptions.mask && this.getInputValue() !== this.value && this.setInputValue(this.value));
  }, t.componentDidUpdate = function () {
    var e = this.previousSelection,
        t = this.props,
        n = t.beforeMaskedValueChange,
        a = t.alwaysShowMask,
        i = t.mask,
        r = t.maskChar,
        o = t.formatChars,
        s = this.maskOptions,
        l = a || this.isFocused(),
        u = null != this.props.value,
        c = u ? getStringValue(this.props.value) : this.value,
        h = e ? e.start : null;

    if (this.maskOptions = parseMask(i, r, o), this.maskOptions.mask) {
      !s.mask && this.isFocused() && this.runSaveSelectionLoop();
      var f = this.maskOptions.mask && this.maskOptions.mask !== s.mask;

      if (s.mask || u || (c = this.getInputValue()), (f || this.maskOptions.mask && (c || l)) && (c = formatValue(this.maskOptions, c)), f) {
        var p = getFilledLength(this.maskOptions, c);
        (null === h || p < h) && (h = isFilled(this.maskOptions, c) ? p : getRightEditablePosition(this.maskOptions, p));
      }

      !this.maskOptions.mask || !isEmpty(this.maskOptions, c) || l || u && this.props.value || (c = "");
      var d = {
        start: h,
        end: h
      };

      if (isFunction(n)) {
        var m = n({
          value: c,
          selection: d
        }, {
          value: this.value,
          selection: this.previousSelection
        }, null, this.getBeforeMaskedValueChangeConfig());
        c = m.value, d = m.selection;
      }

      this.value = c;
      var g = this.getInputValue() !== this.value;
      g ? (this.setInputValue(this.value), this.forceUpdate()) : f && this.forceUpdate();
      var v = !1;
      null != d.start && null != d.end && (v = !e || e.start !== d.start || e.end !== d.end), (v || g) && this.setSelection(d.start, d.end);
    } else s.mask && (this.stopSaveSelectionLoop(), this.forceUpdate());
  }, t.componentWillUnmount = function () {
    this.mounted = !1, null !== this.selectionDeferId && cancelDefer(this.selectionDeferId), this.stopSaveSelectionLoop();
  }, t.render = function () {
    var t,
        e = this.props,
        n = (e.mask, e.alwaysShowMask, e.maskChar, e.formatChars, e.inputRef, e.beforeMaskedValueChange, e.children),
        a = _objectWithoutPropertiesLoose$1(e, ["mask", "alwaysShowMask", "maskChar", "formatChars", "inputRef", "beforeMaskedValueChange", "children"]);

    if (n) {
      isFunction(n) || invariant_1(!1);

      var i = ["onChange", "onPaste", "onMouseDown", "onFocus", "onBlur", "value", "disabled", "readOnly"],
          r = _extends$1({}, a);

      i.forEach(function (e) {
        return delete r[e];
      }), t = n(r), i.filter(function (e) {
        return null != t.props[e] && t.props[e] !== a[e];
      }).length && invariant_1(!1);
    } else t = React.createElement("input", _extends$1({
      ref: this.handleRef
    }, a));

    var o = {
      onFocus: this.onFocus,
      onBlur: this.onBlur
    };
    return this.maskOptions.mask && (a.disabled || a.readOnly || (o.onChange = this.onChange, o.onPaste = this.onPaste, o.onMouseDown = this.onMouseDown), null != a.value && (o.value = this.value)), t = React.cloneElement(t, o);
  }, e;
}(React.Component);

var reactInputMask_production_min = InputElement;
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var NODE_ENV = process.env.NODE_ENV;

var invariant$1 = function invariant$1(condition, format, a, b, c, d, e, f) {
  if (NODE_ENV !== 'production') {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;

    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame

    throw error;
  }
};

var invariant_1$1 = invariant$1;
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = process.env.NODE_ENV !== 'production';

var warning = function warning() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);

    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });

    if (typeof console !== 'undefined') {
      console.error(message);
    }

    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);

    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }

    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

var warning_1 = warning;

function _interopDefault$1(ex) {
  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}

var React$1 = _interopDefault$1(React$2);

var invariant$2 = _interopDefault$1(invariant_1$1);

var warning$1 = _interopDefault$1(warning_1);

function _defaults2$1(obj, defaults) {
  var keys = Object.getOwnPropertyNames(defaults);

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var value = Object.getOwnPropertyDescriptor(defaults, key);

    if (value && value.configurable && obj[key] === undefined) {
      Object.defineProperty(obj, key, value);
    }
  }

  return obj;
}

function _extends$2() {
  _extends$2 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$2.apply(this, arguments);
}

function _inheritsLoose$1(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _defaults2$1(subClass, superClass);
}

function _objectWithoutPropertiesLoose$2(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _assertThisInitialized$1(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function setInputSelection$1(input, start, end) {
  if ('selectionStart' in input && 'selectionEnd' in input) {
    input.selectionStart = start;
    input.selectionEnd = end;
  } else {
    var range = input.createTextRange();
    range.collapse(true);
    range.moveStart('character', start);
    range.moveEnd('character', end - start);
    range.select();
  }
}

function getInputSelection$1(input) {
  var start = 0;
  var end = 0;

  if ('selectionStart' in input && 'selectionEnd' in input) {
    start = input.selectionStart;
    end = input.selectionEnd;
  } else {
    var range = document.selection.createRange();

    if (range.parentElement() === input) {
      start = -range.moveStart('character', -input.value.length);
      end = -range.moveEnd('character', -input.value.length);
    }
  }

  return {
    start: start,
    end: end,
    length: end - start
  };
}

var defaultFormatChars$1 = {
  '9': '[0-9]',
  'a': '[A-Za-z]',
  '*': '[A-Za-z0-9]'
};
var defaultMaskChar$1 = '_';

function parseMask$1(mask, maskChar, formatChars) {
  var parsedMaskString = '';
  var prefix = '';
  var lastEditablePosition = null;
  var permanents = [];

  if (maskChar === undefined) {
    maskChar = defaultMaskChar$1;
  }

  if (formatChars == null) {
    formatChars = defaultFormatChars$1;
  }

  if (!mask || typeof mask !== 'string') {
    return {
      maskChar: maskChar,
      formatChars: formatChars,
      mask: null,
      prefix: null,
      lastEditablePosition: null,
      permanents: []
    };
  }

  var isPermanent = false;
  mask.split('').forEach(function (character) {
    if (!isPermanent && character === '\\') {
      isPermanent = true;
    } else {
      if (isPermanent || !formatChars[character]) {
        permanents.push(parsedMaskString.length);

        if (parsedMaskString.length === permanents.length - 1) {
          prefix += character;
        }
      } else {
        lastEditablePosition = parsedMaskString.length + 1;
      }

      parsedMaskString += character;
      isPermanent = false;
    }
  });
  return {
    maskChar: maskChar,
    formatChars: formatChars,
    prefix: prefix,
    mask: parsedMaskString,
    lastEditablePosition: lastEditablePosition,
    permanents: permanents
  };
}
/* eslint no-use-before-define: ["error", { functions: false }] */


function isPermanentCharacter$1(maskOptions, pos) {
  return maskOptions.permanents.indexOf(pos) !== -1;
}

function isAllowedCharacter$1(maskOptions, pos, character) {
  var mask = maskOptions.mask,
      formatChars = maskOptions.formatChars;

  if (!character) {
    return false;
  }

  if (isPermanentCharacter$1(maskOptions, pos)) {
    return mask[pos] === character;
  }

  var ruleChar = mask[pos];
  var charRule = formatChars[ruleChar];
  return new RegExp(charRule).test(character);
}

function isEmpty$1(maskOptions, value) {
  return value.split('').every(function (character, i) {
    return isPermanentCharacter$1(maskOptions, i) || !isAllowedCharacter$1(maskOptions, i, character);
  });
}

function getFilledLength$1(maskOptions, value) {
  var maskChar = maskOptions.maskChar,
      prefix = maskOptions.prefix;

  if (!maskChar) {
    while (value.length > prefix.length && isPermanentCharacter$1(maskOptions, value.length - 1)) {
      value = value.slice(0, value.length - 1);
    }

    return value.length;
  }

  var filledLength = prefix.length;

  for (var i = value.length; i >= prefix.length; i--) {
    var character = value[i];
    var isEnteredCharacter = !isPermanentCharacter$1(maskOptions, i) && isAllowedCharacter$1(maskOptions, i, character);

    if (isEnteredCharacter) {
      filledLength = i + 1;
      break;
    }
  }

  return filledLength;
}

function isFilled$1(maskOptions, value) {
  return getFilledLength$1(maskOptions, value) === maskOptions.mask.length;
}

function formatValue$1(maskOptions, value) {
  var maskChar = maskOptions.maskChar,
      mask = maskOptions.mask,
      prefix = maskOptions.prefix;

  if (!maskChar) {
    value = insertString$1(maskOptions, '', value, 0);

    if (value.length < prefix.length) {
      value = prefix;
    }

    while (value.length < mask.length && isPermanentCharacter$1(maskOptions, value.length)) {
      value += mask[value.length];
    }

    return value;
  }

  if (value) {
    var emptyValue = formatValue$1(maskOptions, '');
    return insertString$1(maskOptions, emptyValue, value, 0);
  }

  for (var i = 0; i < mask.length; i++) {
    if (isPermanentCharacter$1(maskOptions, i)) {
      value += mask[i];
    } else {
      value += maskChar;
    }
  }

  return value;
}

function clearRange$1(maskOptions, value, start, len) {
  var end = start + len;
  var maskChar = maskOptions.maskChar,
      mask = maskOptions.mask,
      prefix = maskOptions.prefix;
  var arrayValue = value.split('');

  if (!maskChar) {
    // remove any permanent chars after clear range, they will be added back by formatValue
    for (var i = end; i < arrayValue.length; i++) {
      if (isPermanentCharacter$1(maskOptions, i)) {
        arrayValue[i] = '';
      }
    }

    start = Math.max(prefix.length, start);
    arrayValue.splice(start, end - start);
    value = arrayValue.join('');
    return formatValue$1(maskOptions, value);
  }

  return arrayValue.map(function (character, i) {
    if (i < start || i >= end) {
      return character;
    }

    if (isPermanentCharacter$1(maskOptions, i)) {
      return mask[i];
    }

    return maskChar;
  }).join('');
}

function insertString$1(maskOptions, value, insertStr, insertPosition) {
  var mask = maskOptions.mask,
      maskChar = maskOptions.maskChar,
      prefix = maskOptions.prefix;
  var arrayInsertStr = insertStr.split('');
  var isInputFilled = isFilled$1(maskOptions, value);

  var isUsablePosition = function isUsablePosition(pos, character) {
    return !isPermanentCharacter$1(maskOptions, pos) || character === mask[pos];
  };

  var isUsableCharacter = function isUsableCharacter(character, pos) {
    return !maskChar || !isPermanentCharacter$1(maskOptions, pos) || character !== maskChar;
  };

  if (!maskChar && insertPosition > value.length) {
    value += mask.slice(value.length, insertPosition);
  }

  arrayInsertStr.every(function (insertCharacter) {
    while (!isUsablePosition(insertPosition, insertCharacter)) {
      if (insertPosition >= value.length) {
        value += mask[insertPosition];
      }

      if (!isUsableCharacter(insertCharacter, insertPosition)) {
        return true;
      }

      insertPosition++; // stop iteration if maximum value length reached

      if (insertPosition >= mask.length) {
        return false;
      }
    }

    var isAllowed = isAllowedCharacter$1(maskOptions, insertPosition, insertCharacter) || insertCharacter === maskChar;

    if (!isAllowed) {
      return true;
    }

    if (insertPosition < value.length) {
      if (maskChar || isInputFilled || insertPosition < prefix.length) {
        value = value.slice(0, insertPosition) + insertCharacter + value.slice(insertPosition + 1);
      } else {
        value = value.slice(0, insertPosition) + insertCharacter + value.slice(insertPosition);
        value = formatValue$1(maskOptions, value);
      }
    } else if (!maskChar) {
      value += insertCharacter;
    }

    insertPosition++; // stop iteration if maximum value length reached

    return insertPosition < mask.length;
  });
  return value;
}

function getInsertStringLength$1(maskOptions, value, insertStr, insertPosition) {
  var mask = maskOptions.mask,
      maskChar = maskOptions.maskChar;
  var arrayInsertStr = insertStr.split('');
  var initialInsertPosition = insertPosition;

  var isUsablePosition = function isUsablePosition(pos, character) {
    return !isPermanentCharacter$1(maskOptions, pos) || character === mask[pos];
  };

  arrayInsertStr.every(function (insertCharacter) {
    while (!isUsablePosition(insertPosition, insertCharacter)) {
      insertPosition++; // stop iteration if maximum value length reached

      if (insertPosition >= mask.length) {
        return false;
      }
    }

    var isAllowed = isAllowedCharacter$1(maskOptions, insertPosition, insertCharacter) || insertCharacter === maskChar;

    if (isAllowed) {
      insertPosition++;
    } // stop iteration if maximum value length reached


    return insertPosition < mask.length;
  });
  return insertPosition - initialInsertPosition;
}

function getLeftEditablePosition$1(maskOptions, pos) {
  for (var i = pos; i >= 0; --i) {
    if (!isPermanentCharacter$1(maskOptions, i)) {
      return i;
    }
  }

  return null;
}

function getRightEditablePosition$1(maskOptions, pos) {
  var mask = maskOptions.mask;

  for (var i = pos; i < mask.length; ++i) {
    if (!isPermanentCharacter$1(maskOptions, i)) {
      return i;
    }
  }

  return null;
}

function getStringValue$1(value) {
  return !value && value !== 0 ? '' : value + '';
}

function processChange$1(maskOptions, value, selection, previousValue, previousSelection) {
  var mask = maskOptions.mask,
      prefix = maskOptions.prefix,
      lastEditablePosition = maskOptions.lastEditablePosition;
  var newValue = value;
  var enteredString = '';
  var formattedEnteredStringLength = 0;
  var removedLength = 0;
  var cursorPosition = Math.min(previousSelection.start, selection.start);

  if (selection.end > previousSelection.start) {
    enteredString = newValue.slice(previousSelection.start, selection.end);
    formattedEnteredStringLength = getInsertStringLength$1(maskOptions, previousValue, enteredString, cursorPosition);

    if (!formattedEnteredStringLength) {
      removedLength = 0;
    } else {
      removedLength = previousSelection.length;
    }
  } else if (newValue.length < previousValue.length) {
    removedLength = previousValue.length - newValue.length;
  }

  newValue = previousValue;

  if (removedLength) {
    if (removedLength === 1 && !previousSelection.length) {
      var deleteFromRight = previousSelection.start === selection.start;
      cursorPosition = deleteFromRight ? getRightEditablePosition$1(maskOptions, selection.start) : getLeftEditablePosition$1(maskOptions, selection.start);
    }

    newValue = clearRange$1(maskOptions, newValue, cursorPosition, removedLength);
  }

  newValue = insertString$1(maskOptions, newValue, enteredString, cursorPosition);
  cursorPosition = cursorPosition + formattedEnteredStringLength;

  if (cursorPosition >= mask.length) {
    cursorPosition = mask.length;
  } else if (cursorPosition < prefix.length && !formattedEnteredStringLength) {
    cursorPosition = prefix.length;
  } else if (cursorPosition >= prefix.length && cursorPosition < lastEditablePosition && formattedEnteredStringLength) {
    cursorPosition = getRightEditablePosition$1(maskOptions, cursorPosition);
  }

  newValue = formatValue$1(maskOptions, newValue);

  if (!enteredString) {
    enteredString = null;
  }

  return {
    value: newValue,
    enteredString: enteredString,
    selection: {
      start: cursorPosition,
      end: cursorPosition
    }
  };
}

function isWindowsPhoneBrowser$1() {
  var windows = new RegExp('windows', 'i');
  var phone = new RegExp('phone', 'i');
  var ua = navigator.userAgent;
  return windows.test(ua) && phone.test(ua);
}

function isFunction$1(value) {
  return typeof value === 'function';
}

function getRequestAnimationFrame$1() {
  return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame;
}

function getCancelAnimationFrame$1() {
  return window.cancelAnimationFrame || window.webkitCancelRequestAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame;
}

function defer$1(fn) {
  var hasCancelAnimationFrame = !!getCancelAnimationFrame$1();
  var deferFn;

  if (hasCancelAnimationFrame) {
    deferFn = getRequestAnimationFrame$1();
  } else {
    deferFn = function deferFn() {
      return setTimeout(fn, 1000 / 60);
    };
  }

  return deferFn(fn);
}

function cancelDefer$1(deferId) {
  var cancelFn = getCancelAnimationFrame$1() || clearTimeout;
  cancelFn(deferId);
}

var InputElement$1 = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose$1(InputElement, _React$Component);

  function InputElement(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.focused = false;
    _this.mounted = false;
    _this.previousSelection = null;
    _this.selectionDeferId = null;
    _this.saveSelectionLoopDeferId = null;

    _this.saveSelectionLoop = function () {
      _this.previousSelection = _this.getSelection();
      _this.saveSelectionLoopDeferId = defer$1(_this.saveSelectionLoop);
    };

    _this.runSaveSelectionLoop = function () {
      if (_this.saveSelectionLoopDeferId === null) {
        _this.saveSelectionLoop();
      }
    };

    _this.stopSaveSelectionLoop = function () {
      if (_this.saveSelectionLoopDeferId !== null) {
        cancelDefer$1(_this.saveSelectionLoopDeferId);
        _this.saveSelectionLoopDeferId = null;
        _this.previousSelection = null;
      }
    };

    _this.getInputDOMNode = function () {
      if (!_this.mounted) {
        return null;
      }

      var input = reactDom.findDOMNode(_assertThisInitialized$1(_assertThisInitialized$1(_this)));
      var isDOMNode = typeof window !== 'undefined' && input instanceof window.Element; // workaround for react-test-renderer
      // https://github.com/sanniassin/react-input-mask/issues/147

      if (input && !isDOMNode) {
        return null;
      }

      if (input.nodeName !== 'INPUT') {
        input = input.querySelector('input');
      }

      if (!input) {
        throw new Error('react-input-mask: inputComponent doesn\'t contain input node');
      }

      return input;
    };

    _this.getInputValue = function () {
      var input = _this.getInputDOMNode();

      if (!input) {
        return null;
      }

      return input.value;
    };

    _this.setInputValue = function (value) {
      var input = _this.getInputDOMNode();

      if (!input) {
        return;
      }

      _this.value = value;
      input.value = value;
    };

    _this.setCursorToEnd = function () {
      var filledLength = getFilledLength$1(_this.maskOptions, _this.value);
      var pos = getRightEditablePosition$1(_this.maskOptions, filledLength);

      if (pos !== null) {
        _this.setCursorPosition(pos);
      }
    };

    _this.setSelection = function (start, end, options) {
      if (options === void 0) {
        options = {};
      }

      var input = _this.getInputDOMNode();

      var isFocused = _this.isFocused(); // don't change selection on unfocused input
      // because Safari sets focus on selection change (#154)


      if (!input || !isFocused) {
        return;
      }

      var _options = options,
          deferred = _options.deferred;

      if (!deferred) {
        setInputSelection$1(input, start, end);
      }

      if (_this.selectionDeferId !== null) {
        cancelDefer$1(_this.selectionDeferId);
      } // deferred selection update is required for pre-Lollipop Android browser,
      // but for consistent behavior we do it for all browsers


      _this.selectionDeferId = defer$1(function () {
        _this.selectionDeferId = null;
        setInputSelection$1(input, start, end);
      });
      _this.previousSelection = {
        start: start,
        end: end,
        length: Math.abs(end - start)
      };
    };

    _this.getSelection = function () {
      var input = _this.getInputDOMNode();

      return getInputSelection$1(input);
    };

    _this.getCursorPosition = function () {
      return _this.getSelection().start;
    };

    _this.setCursorPosition = function (pos) {
      _this.setSelection(pos, pos);
    };

    _this.isFocused = function () {
      return _this.focused;
    };

    _this.getBeforeMaskedValueChangeConfig = function () {
      var _this$maskOptions = _this.maskOptions,
          mask = _this$maskOptions.mask,
          maskChar = _this$maskOptions.maskChar,
          permanents = _this$maskOptions.permanents,
          formatChars = _this$maskOptions.formatChars;
      var alwaysShowMask = _this.props.alwaysShowMask;
      return {
        mask: mask,
        maskChar: maskChar,
        permanents: permanents,
        alwaysShowMask: !!alwaysShowMask,
        formatChars: formatChars
      };
    };

    _this.isInputAutofilled = function (value, selection, previousValue, previousSelection) {
      var input = _this.getInputDOMNode(); // only check for positive match because it will be false negative
      // in case of autofill simulation in tests
      //
      // input.matches throws an exception if selector isn't supported


      try {
        if (input.matches(':-webkit-autofill')) {
          return true;
        }
      } catch (e) {} // if input isn't focused then change event must have been triggered
      // either by autofill or event simulation in tests


      if (!_this.focused) {
        return true;
      } // if cursor has moved to the end while previousSelection forbids it
      // then it must be autofill


      return previousSelection.end < previousValue.length && selection.end === value.length;
    };

    _this.onChange = function (event) {
      var _assertThisInitialize = _assertThisInitialized$1(_assertThisInitialized$1(_this)),
          beforePasteState = _assertThisInitialize.beforePasteState;

      var _assertThisInitialize2 = _assertThisInitialized$1(_assertThisInitialized$1(_this)),
          previousSelection = _assertThisInitialize2.previousSelection;

      var beforeMaskedValueChange = _this.props.beforeMaskedValueChange;

      var value = _this.getInputValue();

      var previousValue = _this.value;

      var selection = _this.getSelection(); // autofill replaces entire value, ignore old one
      // https://github.com/sanniassin/react-input-mask/issues/113


      if (_this.isInputAutofilled(value, selection, previousValue, previousSelection)) {
        previousValue = formatValue$1(_this.maskOptions, '');
        previousSelection = {
          start: 0,
          end: 0,
          length: 0
        };
      } // set value and selection as if we haven't
      // cleared input in onPaste handler


      if (beforePasteState) {
        previousSelection = beforePasteState.selection;
        previousValue = beforePasteState.value;
        selection = {
          start: previousSelection.start + value.length,
          end: previousSelection.start + value.length,
          length: 0
        };
        value = previousValue.slice(0, previousSelection.start) + value + previousValue.slice(previousSelection.end);
        _this.beforePasteState = null;
      }

      var changedState = processChange$1(_this.maskOptions, value, selection, previousValue, previousSelection);
      var enteredString = changedState.enteredString;
      var newSelection = changedState.selection;
      var newValue = changedState.value;

      if (isFunction$1(beforeMaskedValueChange)) {
        var modifiedValue = beforeMaskedValueChange({
          value: newValue,
          selection: newSelection
        }, {
          value: previousValue,
          selection: previousSelection
        }, enteredString, _this.getBeforeMaskedValueChangeConfig());
        newValue = modifiedValue.value;
        newSelection = modifiedValue.selection;
      }

      _this.setInputValue(newValue);

      if (isFunction$1(_this.props.onChange)) {
        _this.props.onChange(event);
      }

      if (_this.isWindowsPhoneBrowser) {
        _this.setSelection(newSelection.start, newSelection.end, {
          deferred: true
        });
      } else {
        _this.setSelection(newSelection.start, newSelection.end);
      }
    };

    _this.onFocus = function (event) {
      var beforeMaskedValueChange = _this.props.beforeMaskedValueChange;
      var _this$maskOptions2 = _this.maskOptions,
          mask = _this$maskOptions2.mask,
          prefix = _this$maskOptions2.prefix;
      _this.focused = true; // if autoFocus is set, onFocus triggers before componentDidMount

      _this.mounted = true;

      if (mask) {
        if (!_this.value) {
          var emptyValue = formatValue$1(_this.maskOptions, prefix);
          var newValue = formatValue$1(_this.maskOptions, emptyValue);
          var filledLength = getFilledLength$1(_this.maskOptions, newValue);
          var cursorPosition = getRightEditablePosition$1(_this.maskOptions, filledLength);
          var newSelection = {
            start: cursorPosition,
            end: cursorPosition
          };

          if (isFunction$1(beforeMaskedValueChange)) {
            var modifiedValue = beforeMaskedValueChange({
              value: newValue,
              selection: newSelection
            }, {
              value: _this.value,
              selection: null
            }, null, _this.getBeforeMaskedValueChangeConfig());
            newValue = modifiedValue.value;
            newSelection = modifiedValue.selection;
          }

          var isInputValueChanged = newValue !== _this.getInputValue();

          if (isInputValueChanged) {
            _this.setInputValue(newValue);
          }

          if (isInputValueChanged && isFunction$1(_this.props.onChange)) {
            _this.props.onChange(event);
          }

          _this.setSelection(newSelection.start, newSelection.end);
        } else if (getFilledLength$1(_this.maskOptions, _this.value) < _this.maskOptions.mask.length) {
          _this.setCursorToEnd();
        }

        _this.runSaveSelectionLoop();
      }

      if (isFunction$1(_this.props.onFocus)) {
        _this.props.onFocus(event);
      }
    };

    _this.onBlur = function (event) {
      var beforeMaskedValueChange = _this.props.beforeMaskedValueChange;
      var mask = _this.maskOptions.mask;

      _this.stopSaveSelectionLoop();

      _this.focused = false;

      if (mask && !_this.props.alwaysShowMask && isEmpty$1(_this.maskOptions, _this.value)) {
        var newValue = '';

        if (isFunction$1(beforeMaskedValueChange)) {
          var modifiedValue = beforeMaskedValueChange({
            value: newValue,
            selection: null
          }, {
            value: _this.value,
            selection: _this.previousSelection
          }, null, _this.getBeforeMaskedValueChangeConfig());
          newValue = modifiedValue.value;
        }

        var isInputValueChanged = newValue !== _this.getInputValue();

        if (isInputValueChanged) {
          _this.setInputValue(newValue);
        }

        if (isInputValueChanged && isFunction$1(_this.props.onChange)) {
          _this.props.onChange(event);
        }
      }

      if (isFunction$1(_this.props.onBlur)) {
        _this.props.onBlur(event);
      }
    };

    _this.onMouseDown = function (event) {
      // tiny unintentional mouse movements can break cursor
      // position on focus, so we have to restore it in that case
      //
      // https://github.com/sanniassin/react-input-mask/issues/108
      if (!_this.focused && document.addEventListener) {
        _this.mouseDownX = event.clientX;
        _this.mouseDownY = event.clientY;
        _this.mouseDownTime = new Date().getTime();

        var mouseUpHandler = function mouseUpHandler(mouseUpEvent) {
          document.removeEventListener('mouseup', mouseUpHandler);

          if (!_this.focused) {
            return;
          }

          var deltaX = Math.abs(mouseUpEvent.clientX - _this.mouseDownX);
          var deltaY = Math.abs(mouseUpEvent.clientY - _this.mouseDownY);
          var axisDelta = Math.max(deltaX, deltaY);

          var timeDelta = new Date().getTime() - _this.mouseDownTime;

          if (axisDelta <= 10 && timeDelta <= 200 || axisDelta <= 5 && timeDelta <= 300) {
            _this.setCursorToEnd();
          }
        };

        document.addEventListener('mouseup', mouseUpHandler);
      }

      if (isFunction$1(_this.props.onMouseDown)) {
        _this.props.onMouseDown(event);
      }
    };

    _this.onPaste = function (event) {
      if (isFunction$1(_this.props.onPaste)) {
        _this.props.onPaste(event);
      } // event.clipboardData might not work in Android browser
      // cleaning input to get raw text inside onChange handler


      if (!event.defaultPrevented) {
        _this.beforePasteState = {
          value: _this.getInputValue(),
          selection: _this.getSelection()
        };

        _this.setInputValue('');
      }
    };

    _this.handleRef = function (ref) {
      if (_this.props.children == null && isFunction$1(_this.props.inputRef)) {
        _this.props.inputRef(ref);
      }
    };

    var _mask = props.mask,
        _maskChar = props.maskChar,
        _formatChars = props.formatChars,
        _alwaysShowMask = props.alwaysShowMask,
        _beforeMaskedValueChange = props.beforeMaskedValueChange;
    var defaultValue = props.defaultValue,
        _value = props.value;
    _this.maskOptions = parseMask$1(_mask, _maskChar, _formatChars);

    if (defaultValue == null) {
      defaultValue = '';
    }

    if (_value == null) {
      _value = defaultValue;
    }

    var _newValue = getStringValue$1(_value);

    if (_this.maskOptions.mask && (_alwaysShowMask || _newValue)) {
      _newValue = formatValue$1(_this.maskOptions, _newValue);

      if (isFunction$1(_beforeMaskedValueChange)) {
        var oldValue = props.value;

        if (props.value == null) {
          oldValue = defaultValue;
        }

        oldValue = getStringValue$1(oldValue);

        var modifiedValue = _beforeMaskedValueChange({
          value: _newValue,
          selection: null
        }, {
          value: oldValue,
          selection: null
        }, null, _this.getBeforeMaskedValueChangeConfig());

        _newValue = modifiedValue.value;
      }
    }

    _this.value = _newValue;
    return _this;
  }

  var _proto = InputElement.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.mounted = true; // workaround for react-test-renderer
    // https://github.com/sanniassin/react-input-mask/issues/147

    if (!this.getInputDOMNode()) {
      return;
    }

    this.isWindowsPhoneBrowser = isWindowsPhoneBrowser$1();

    if (this.maskOptions.mask && this.getInputValue() !== this.value) {
      this.setInputValue(this.value);
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    var previousSelection = this.previousSelection;
    var _this$props = this.props,
        beforeMaskedValueChange = _this$props.beforeMaskedValueChange,
        alwaysShowMask = _this$props.alwaysShowMask,
        mask = _this$props.mask,
        maskChar = _this$props.maskChar,
        formatChars = _this$props.formatChars;
    var previousMaskOptions = this.maskOptions;
    var showEmpty = alwaysShowMask || this.isFocused();
    var hasValue = this.props.value != null;
    var newValue = hasValue ? getStringValue$1(this.props.value) : this.value;
    var cursorPosition = previousSelection ? previousSelection.start : null;
    this.maskOptions = parseMask$1(mask, maskChar, formatChars);

    if (!this.maskOptions.mask) {
      if (previousMaskOptions.mask) {
        this.stopSaveSelectionLoop(); // render depends on this.maskOptions and this.value,
        // call forceUpdate to keep it in sync

        this.forceUpdate();
      }

      return;
    } else if (!previousMaskOptions.mask && this.isFocused()) {
      this.runSaveSelectionLoop();
    }

    var isMaskChanged = this.maskOptions.mask && this.maskOptions.mask !== previousMaskOptions.mask;

    if (!previousMaskOptions.mask && !hasValue) {
      newValue = this.getInputValue();
    }

    if (isMaskChanged || this.maskOptions.mask && (newValue || showEmpty)) {
      newValue = formatValue$1(this.maskOptions, newValue);
    }

    if (isMaskChanged) {
      var filledLength = getFilledLength$1(this.maskOptions, newValue);

      if (cursorPosition === null || filledLength < cursorPosition) {
        if (isFilled$1(this.maskOptions, newValue)) {
          cursorPosition = filledLength;
        } else {
          cursorPosition = getRightEditablePosition$1(this.maskOptions, filledLength);
        }
      }
    }

    if (this.maskOptions.mask && isEmpty$1(this.maskOptions, newValue) && !showEmpty && (!hasValue || !this.props.value)) {
      newValue = '';
    }

    var newSelection = {
      start: cursorPosition,
      end: cursorPosition
    };

    if (isFunction$1(beforeMaskedValueChange)) {
      var modifiedValue = beforeMaskedValueChange({
        value: newValue,
        selection: newSelection
      }, {
        value: this.value,
        selection: this.previousSelection
      }, null, this.getBeforeMaskedValueChangeConfig());
      newValue = modifiedValue.value;
      newSelection = modifiedValue.selection;
    }

    this.value = newValue;
    var isValueChanged = this.getInputValue() !== this.value; // render depends on this.maskOptions and this.value,
    // call forceUpdate to keep it in sync

    if (isValueChanged) {
      this.setInputValue(this.value);
      this.forceUpdate();
    } else if (isMaskChanged) {
      this.forceUpdate();
    }

    var isSelectionChanged = false;

    if (newSelection.start != null && newSelection.end != null) {
      isSelectionChanged = !previousSelection || previousSelection.start !== newSelection.start || previousSelection.end !== newSelection.end;
    }

    if (isSelectionChanged || isValueChanged) {
      this.setSelection(newSelection.start, newSelection.end);
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;

    if (this.selectionDeferId !== null) {
      cancelDefer$1(this.selectionDeferId);
    }

    this.stopSaveSelectionLoop();
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        mask = _this$props2.mask,
        alwaysShowMask = _this$props2.alwaysShowMask,
        maskChar = _this$props2.maskChar,
        formatChars = _this$props2.formatChars,
        inputRef = _this$props2.inputRef,
        beforeMaskedValueChange = _this$props2.beforeMaskedValueChange,
        children = _this$props2.children,
        restProps = _objectWithoutPropertiesLoose$2(_this$props2, ["mask", "alwaysShowMask", "maskChar", "formatChars", "inputRef", "beforeMaskedValueChange", "children"]);

    var inputElement;
    process.env.NODE_ENV !== "production" ? warning$1( // parse mask to test against actual mask prop as this.maskOptions
    // will be updated later in componentDidUpdate
    !restProps.maxLength || !parseMask$1(mask, maskChar, formatChars).mask, 'react-input-mask: maxLength property shouldn\'t be passed to the masked input. It breaks masking and unnecessary because length is limited by the mask length.') : void 0;

    if (children) {
      !isFunction$1(children) ? process.env.NODE_ENV !== "production" ? invariant$2(false, 'react-input-mask: children must be a function') : invariant$2(false) : void 0;
      var controlledProps = ['onChange', 'onPaste', 'onMouseDown', 'onFocus', 'onBlur', 'value', 'disabled', 'readOnly'];

      var childrenProps = _extends$2({}, restProps);

      controlledProps.forEach(function (propId) {
        return delete childrenProps[propId];
      });
      inputElement = children(childrenProps);
      var conflictProps = controlledProps.filter(function (propId) {
        return inputElement.props[propId] != null && inputElement.props[propId] !== restProps[propId];
      });
      !!conflictProps.length ? process.env.NODE_ENV !== "production" ? invariant$2(false, "react-input-mask: the following props should be passed to the react-input-mask's component and should not be altered in children's function: " + conflictProps.join(', ')) : invariant$2(false) : void 0;
      process.env.NODE_ENV !== "production" ? warning$1(!inputRef, 'react-input-mask: inputRef is ignored when children is passed, attach ref to the children instead') : void 0;
    } else {
      inputElement = React$1.createElement("input", _extends$2({
        ref: this.handleRef
      }, restProps));
    }

    var changedProps = {
      onFocus: this.onFocus,
      onBlur: this.onBlur
    };

    if (this.maskOptions.mask) {
      if (!restProps.disabled && !restProps.readOnly) {
        changedProps.onChange = this.onChange;
        changedProps.onPaste = this.onPaste;
        changedProps.onMouseDown = this.onMouseDown;
      }

      if (restProps.value != null) {
        changedProps.value = this.value;
      }
    }

    inputElement = React$1.cloneElement(inputElement, changedProps);
    return inputElement;
  };

  return InputElement;
}(React$1.Component);

var reactInputMask_development = InputElement$1;
var reactInputMask = createCommonjsModule(function (module) {
  if (process.env.NODE_ENV === 'production') {
    module.exports = reactInputMask_production_min;
  } else {
    module.exports = reactInputMask_development;
  }
});
var createNumberMask = createCommonjsModule(function (module, exports) {
  !function (e, t) {
    module.exports = t();
  }(commonjsGlobal, function () {
    return function (e) {
      function t(n) {
        if (o[n]) return o[n].exports;
        var i = o[n] = {
          exports: {},
          id: n,
          loaded: !1
        };
        return e[n].call(i.exports, i, i.exports, t), i.loaded = !0, i.exports;
      }

      var o = {};
      return t.m = e, t.c = o, t.p = "", t(0);
    }([function (e, t, o) {
      e.exports = o(2);
    },, function (e, t) {
      function o() {
        function e() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : l,
              t = e.length;
          if (e === l || e[0] === y[0] && 1 === t) return y.split(l).concat([v]).concat(g.split(l));
          if (e === k && M) return y.split(l).concat(["0", k, v]).concat(g.split(l));
          var o = e[0] === s && q;
          o && (e = e.toString().substr(1));
          var c = e.lastIndexOf(k),
              u = c !== -1,
              a = void 0,
              b = void 0,
              h = void 0;

          if (e.slice(T * -1) === g && (e = e.slice(0, T * -1)), u && (M || $) ? (a = e.slice(e.slice(0, R) === y ? R : 0, c), b = e.slice(c + 1, t), b = n(b.replace(f, l))) : a = e.slice(0, R) === y ? e.slice(R) : e, P && ("undefined" == typeof P ? "undefined" : r(P)) === p) {
            var S = "." === j ? "[.]" : "" + j,
                w = (a.match(new RegExp(S, "g")) || []).length;
            a = a.slice(0, P + w * Z);
          }

          return a = a.replace(f, l), E || (a = a.replace(/^0+(0$|[^0])/, "$1")), a = x ? i(a, j) : a, h = n(a), (u && M || $ === !0) && (e[c - 1] !== k && h.push(m), h.push(k, m), b && (("undefined" == typeof L ? "undefined" : r(L)) === p && (b = b.slice(0, L)), h = h.concat(b)), $ === !0 && e[c - 1] === k && h.push(v)), R > 0 && (h = y.split(l).concat(h)), o && (h.length === R && h.push(v), h = [d].concat(h)), g.length > 0 && (h = h.concat(g.split(l))), h;
        }

        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            o = t.prefix,
            y = void 0 === o ? c : o,
            b = t.suffix,
            g = void 0 === b ? l : b,
            h = t.includeThousandsSeparator,
            x = void 0 === h || h,
            S = t.thousandsSeparatorSymbol,
            j = void 0 === S ? u : S,
            w = t.allowDecimal,
            M = void 0 !== w && w,
            N = t.decimalSymbol,
            k = void 0 === N ? a : N,
            D = t.decimalLimit,
            L = void 0 === D ? 2 : D,
            O = t.requireDecimal,
            $ = void 0 !== O && O,
            _ = t.allowNegative,
            q = void 0 !== _ && _,
            B = t.allowLeadingZeroes,
            E = void 0 !== B && B,
            I = t.integerLimit,
            P = void 0 === I ? null : I,
            R = y && y.length || 0,
            T = g && g.length || 0,
            Z = j && j.length || 0;
        return e.instanceOf = "createNumberMask", e;
      }

      function n(e) {
        return e.split(l).map(function (e) {
          return v.test(e) ? v : e;
        });
      }

      function i(e, t) {
        return e.replace(/\B(?=(\d{3})+(?!\d))/g, t);
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      };
      t.default = o;
      var c = "$",
          l = "",
          u = ",",
          a = ".",
          s = "-",
          d = /-/,
          f = /\D+/g,
          p = "number",
          v = /\d/,
          m = "[]";
    }]);
  });
});
var createNumberMask$1 = unwrapExports(createNumberMask);
var createNumberMask_1 = createNumberMask.createNumberMask;
var reactTextMask = createCommonjsModule(function (module, exports) {
  !function (e, t) {
    module.exports = t(React$2);
  }(commonjsGlobal, function (e) {
    return function (e) {
      function t(n) {
        if (r[n]) return r[n].exports;
        var o = r[n] = {
          exports: {},
          id: n,
          loaded: !1
        };
        return e[n].call(o.exports, o, o.exports, t), o.loaded = !0, o.exports;
      }

      var r = {};
      return t.m = e, t.c = r, t.p = "", t(0);
    }([function (e, t, r) {
      function n(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      function o(e, t) {
        var r = {};

        for (var n in e) {
          t.indexOf(n) >= 0 || Object.prototype.hasOwnProperty.call(e, n) && (r[n] = e[n]);
        }

        return r;
      }

      function i(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function a(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      function u(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.conformToMask = void 0;

      var s = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];

          for (var n in r) {
            Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
          }
        }

        return e;
      },
          l = function () {
        function e(e, t) {
          for (var r = 0; r < t.length; r++) {
            var n = t[r];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
          }
        }

        return function (t, r, n) {
          return r && e(t.prototype, r), n && e(t, n), t;
        };
      }(),
          f = r(3);

      Object.defineProperty(t, "conformToMask", {
        enumerable: !0,
        get: function get() {
          return n(f).default;
        }
      });

      var c = r(11),
          p = n(c),
          d = r(9),
          h = n(d),
          v = r(5),
          y = n(v),
          m = r(2),
          b = function (e) {
        function t() {
          var e;
          i(this, t);

          for (var r = arguments.length, n = Array(r), o = 0; o < r; o++) {
            n[o] = arguments[o];
          }

          var u = a(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [this].concat(n)));
          return u.setRef = u.setRef.bind(u), u.onBlur = u.onBlur.bind(u), u.onChange = u.onChange.bind(u), u;
        }

        return u(t, e), l(t, [{
          key: "setRef",
          value: function value(e) {
            this.inputElement = e;
          }
        }, {
          key: "initTextMask",
          value: function value() {
            var e = this.props,
                t = this.props.value;
            this.textMaskInputElement = (0, y.default)(s({
              inputElement: this.inputElement
            }, e)), this.textMaskInputElement.update(t);
          }
        }, {
          key: "componentDidMount",
          value: function value() {
            this.initTextMask();
          }
        }, {
          key: "componentDidUpdate",
          value: function value(e) {
            var t = this.props,
                r = t.value,
                n = t.pipe,
                o = t.mask,
                i = t.guide,
                a = t.placeholderChar,
                u = t.showMask,
                s = {
              guide: i,
              placeholderChar: a,
              showMask: u
            },
                l = "function" == typeof n && "function" == typeof e.pipe ? n.toString() !== e.pipe.toString() : (0, m.isNil)(n) && !(0, m.isNil)(e.pipe) || !(0, m.isNil)(n) && (0, m.isNil)(e.pipe),
                f = o.toString() !== e.mask.toString(),
                c = Object.keys(s).some(function (t) {
              return s[t] !== e[t];
            }) || f || l,
                p = r !== this.inputElement.value;
            (p || c) && this.initTextMask();
          }
        }, {
          key: "render",
          value: function e() {
            var t = this.props,
                e = t.render,
                r = o(t, ["render"]);
            return delete r.mask, delete r.guide, delete r.pipe, delete r.placeholderChar, delete r.keepCharPositions, delete r.value, delete r.onBlur, delete r.onChange, delete r.showMask, e(this.setRef, s({
              onBlur: this.onBlur,
              onChange: this.onChange,
              defaultValue: this.props.value
            }, r));
          }
        }, {
          key: "onChange",
          value: function value(e) {
            this.textMaskInputElement.update(), "function" == typeof this.props.onChange && this.props.onChange(e);
          }
        }, {
          key: "onBlur",
          value: function value(e) {
            "function" == typeof this.props.onBlur && this.props.onBlur(e);
          }
        }]), t;
      }(p.default.PureComponent);

      t.default = b, b.propTypes = {
        mask: h.default.oneOfType([h.default.array, h.default.func, h.default.bool, h.default.shape({
          mask: h.default.oneOfType([h.default.array, h.default.func]),
          pipe: h.default.func
        })]).isRequired,
        guide: h.default.bool,
        value: h.default.oneOfType([h.default.string, h.default.number]),
        pipe: h.default.func,
        placeholderChar: h.default.string,
        keepCharPositions: h.default.bool,
        showMask: h.default.bool
      }, b.defaultProps = {
        render: function render(e, t) {
          return p.default.createElement("input", s({
            ref: e
          }, t));
        }
      };
    }, function (e, t) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.placeholderChar = "_", t.strFunction = "function";
    }, function (e, t, r) {
      function n() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : f,
            t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : l.placeholderChar;
        if (!o(e)) throw new Error("Text-mask:convertMaskToPlaceholder; The mask property must be an array.");
        if (e.indexOf(t) !== -1) throw new Error("Placeholder character must not be used as part of the mask. Please specify a character that is not present in your mask as your placeholder character.\n\n" + ("The placeholder character that was received is: " + JSON.stringify(t) + "\n\n") + ("The mask that was received is: " + JSON.stringify(e)));
        return e.map(function (e) {
          return e instanceof RegExp ? t : e;
        }).join("");
      }

      function o(e) {
        return Array.isArray && Array.isArray(e) || e instanceof Array;
      }

      function i(e) {
        return "string" == typeof e || e instanceof String;
      }

      function a(e) {
        return "number" == typeof e && void 0 === e.length && !isNaN(e);
      }

      function u(e) {
        return "undefined" == typeof e || null === e;
      }

      function s(e) {
        for (var t = [], r = void 0; r = e.indexOf(c), r !== -1;) {
          t.push(r), e.splice(r, 1);
        }

        return {
          maskWithoutCaretTraps: e,
          indexes: t
        };
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.convertMaskToPlaceholder = n, t.isArray = o, t.isString = i, t.isNumber = a, t.isNil = u, t.processCaretTraps = s;
      var l = r(1),
          f = [],
          c = "[]";
    }, function (e, t, r) {
      function n() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : s,
            t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : u,
            r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};

        if (!(0, i.isArray)(t)) {
          if (("undefined" == typeof t ? "undefined" : o(t)) !== a.strFunction) throw new Error("Text-mask:conformToMask; The mask property must be an array.");
          t = t(e, r), t = (0, i.processCaretTraps)(t).maskWithoutCaretTraps;
        }

        var n = r.guide,
            l = void 0 === n || n,
            f = r.previousConformedValue,
            c = void 0 === f ? s : f,
            p = r.placeholderChar,
            d = void 0 === p ? a.placeholderChar : p,
            h = r.placeholder,
            v = void 0 === h ? (0, i.convertMaskToPlaceholder)(t, d) : h,
            y = r.currentCaretPosition,
            m = r.keepCharPositions,
            b = l === !1 && void 0 !== c,
            g = e.length,
            k = c.length,
            C = v.length,
            O = t.length,
            T = g - k,
            P = T > 0,
            x = y + (P ? -T : 0),
            w = x + Math.abs(T);

        if (m === !0 && !P) {
          for (var S = s, _ = x; _ < w; _++) {
            v[_] === d && (S += d);
          }

          e = e.slice(0, x) + S + e.slice(x, g);
        }

        for (var M = e.split(s).map(function (e, t) {
          return {
            char: e,
            isNew: t >= x && t < w
          };
        }), j = g - 1; j >= 0; j--) {
          var E = M[j].char;

          if (E !== d) {
            var R = j >= x && k === O;
            E === v[R ? j - T : j] && M.splice(j, 1);
          }
        }

        var V = s,
            N = !1;

        e: for (var A = 0; A < C; A++) {
          var B = v[A];

          if (B === d) {
            if (M.length > 0) for (; M.length > 0;) {
              var I = M.shift(),
                  F = I.char,
                  q = I.isNew;

              if (F === d && b !== !0) {
                V += d;
                continue e;
              }

              if (t[A].test(F)) {
                if (m === !0 && q !== !1 && c !== s && l !== !1 && P) {
                  for (var D = M.length, L = null, W = 0; W < D; W++) {
                    var J = M[W];
                    if (J.char !== d && J.isNew === !1) break;

                    if (J.char === d) {
                      L = W;
                      break;
                    }
                  }

                  null !== L ? (V += F, M.splice(L, 1)) : A--;
                } else V += F;

                continue e;
              }

              N = !0;
            }
            b === !1 && (V += v.substr(A, C));
            break;
          }

          V += B;
        }

        if (b && P === !1) {
          for (var U = null, H = 0; H < V.length; H++) {
            v[H] === d && (U = H);
          }

          V = null !== U ? V.substr(0, U + 1) : s;
        }

        return {
          conformedValue: V,
          meta: {
            someCharsRejected: N
          }
        };
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      };
      t.default = n;
      var i = r(2),
          a = r(1),
          u = [],
          s = "";
    }, function (e, t) {
      function r(e) {
        var t = e.previousConformedValue,
            r = void 0 === t ? o : t,
            i = e.previousPlaceholder,
            a = void 0 === i ? o : i,
            u = e.currentCaretPosition,
            s = void 0 === u ? 0 : u,
            l = e.conformedValue,
            f = e.rawValue,
            c = e.placeholderChar,
            p = e.placeholder,
            d = e.indexesOfPipedChars,
            h = void 0 === d ? n : d,
            v = e.caretTrapIndexes,
            y = void 0 === v ? n : v;
        if (0 === s || !f.length) return 0;
        var m = f.length,
            b = r.length,
            g = p.length,
            k = l.length,
            C = m - b,
            O = C > 0,
            T = 0 === b,
            P = C > 1 && !O && !T;
        if (P) return s;

        var x = O && (r === l || l === p),
            w = 0,
            S = void 0,
            _ = void 0;

        if (x) w = s - C;else {
          var M = l.toLowerCase(),
              j = f.toLowerCase(),
              E = j.substr(0, s).split(o),
              R = E.filter(function (e) {
            return M.indexOf(e) !== -1;
          });
          _ = R[R.length - 1];
          var V = a.substr(0, R.length).split(o).filter(function (e) {
            return e !== c;
          }).length,
              N = p.substr(0, R.length).split(o).filter(function (e) {
            return e !== c;
          }).length,
              A = N !== V,
              B = void 0 !== a[R.length - 1] && void 0 !== p[R.length - 2] && a[R.length - 1] !== c && a[R.length - 1] !== p[R.length - 1] && a[R.length - 1] === p[R.length - 2];
          !O && (A || B) && V > 0 && p.indexOf(_) > -1 && void 0 !== f[s] && (S = !0, _ = f[s]);

          for (var I = h.map(function (e) {
            return M[e];
          }), F = I.filter(function (e) {
            return e === _;
          }).length, q = R.filter(function (e) {
            return e === _;
          }).length, D = p.substr(0, p.indexOf(c)).split(o).filter(function (e, t) {
            return e === _ && f[t] !== e;
          }).length, L = D + q + F + (S ? 1 : 0), W = 0, J = 0; J < k; J++) {
            var U = M[J];
            if (w = J + 1, U === _ && W++, W >= L) break;
          }
        }

        if (O) {
          for (var H = w, Y = w; Y <= g; Y++) {
            if (p[Y] === c && (H = Y), p[Y] === c || y.indexOf(Y) !== -1 || Y === g) return H;
          }
        } else if (S) {
          for (var z = w - 1; z >= 0; z--) {
            if (l[z] === _ || y.indexOf(z) !== -1 || 0 === z) return z;
          }
        } else for (var G = w; G >= 0; G--) {
          if (p[G - 1] === c || y.indexOf(G) !== -1 || 0 === G) return G;
        }
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = r;
      var n = [],
          o = "";
    }, function (e, t, r) {
      function n(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      function o(e) {
        var t = {
          previousConformedValue: void 0,
          previousPlaceholder: void 0
        };
        return {
          state: t,
          update: function update(r) {
            var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : e,
                o = n.inputElement,
                l = n.mask,
                c = n.guide,
                y = n.pipe,
                b = n.placeholderChar,
                g = void 0 === b ? h.placeholderChar : b,
                k = n.keepCharPositions,
                C = void 0 !== k && k,
                O = n.showMask,
                T = void 0 !== O && O;

            if ("undefined" == typeof r && (r = o.value), r !== t.previousConformedValue) {
              ("undefined" == typeof l ? "undefined" : s(l)) === m && void 0 !== l.pipe && void 0 !== l.mask && (y = l.pipe, l = l.mask);
              var P = void 0,
                  x = void 0;

              if (l instanceof Array && (P = (0, d.convertMaskToPlaceholder)(l, g)), l !== !1) {
                var w = a(r),
                    S = o.selectionEnd,
                    _ = t.previousConformedValue,
                    M = t.previousPlaceholder,
                    j = void 0;

                if (("undefined" == typeof l ? "undefined" : s(l)) === h.strFunction) {
                  if (x = l(w, {
                    currentCaretPosition: S,
                    previousConformedValue: _,
                    placeholderChar: g
                  }), x === !1) return;
                  var E = (0, d.processCaretTraps)(x),
                      R = E.maskWithoutCaretTraps,
                      V = E.indexes;
                  x = R, j = V, P = (0, d.convertMaskToPlaceholder)(x, g);
                } else x = l;

                var N = {
                  previousConformedValue: _,
                  guide: c,
                  placeholderChar: g,
                  pipe: y,
                  placeholder: P,
                  currentCaretPosition: S,
                  keepCharPositions: C
                },
                    A = (0, p.default)(w, x, N),
                    B = A.conformedValue,
                    I = ("undefined" == typeof y ? "undefined" : s(y)) === h.strFunction,
                    F = {};
                I && (F = y(B, u({
                  rawValue: w
                }, N)), F === !1 ? F = {
                  value: _,
                  rejected: !0
                } : (0, d.isString)(F) && (F = {
                  value: F
                }));
                var q = I ? F.value : B,
                    D = (0, f.default)({
                  previousConformedValue: _,
                  previousPlaceholder: M,
                  conformedValue: q,
                  placeholder: P,
                  rawValue: w,
                  currentCaretPosition: S,
                  placeholderChar: g,
                  indexesOfPipedChars: F.indexesOfPipedChars,
                  caretTrapIndexes: j
                }),
                    L = q === P && 0 === D,
                    W = T ? P : v,
                    J = L ? W : q;
                t.previousConformedValue = J, t.previousPlaceholder = P, o.value !== J && (o.value = J, i(o, D));
              }
            }
          }
        };
      }

      function i(e, t) {
        document.activeElement === e && (b ? g(function () {
          return e.setSelectionRange(t, t, y);
        }, 0) : e.setSelectionRange(t, t, y));
      }

      function a(e) {
        if ((0, d.isString)(e)) return e;
        if ((0, d.isNumber)(e)) return String(e);
        if (void 0 === e || null === e) return v;
        throw new Error("The 'value' provided to Text Mask needs to be a string or a number. The value received was:\n\n " + JSON.stringify(e));
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var u = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];

          for (var n in r) {
            Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
          }
        }

        return e;
      },
          s = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      };

      t.default = o;
      var l = r(4),
          f = n(l),
          c = r(3),
          p = n(c),
          d = r(2),
          h = r(1),
          v = "",
          y = "none",
          m = "object",
          b = "undefined" != typeof navigator && /Android/i.test(navigator.userAgent),
          g = "undefined" != typeof requestAnimationFrame ? requestAnimationFrame : setTimeout;
    }, function (e, t) {
      function r(e) {
        return function () {
          return e;
        };
      }

      var n = function n() {};

      n.thatReturns = r, n.thatReturnsFalse = r(!1), n.thatReturnsTrue = r(!0), n.thatReturnsNull = r(null), n.thatReturnsThis = function () {
        return this;
      }, n.thatReturnsArgument = function (e) {
        return e;
      }, e.exports = n;
    }, function (e, t, r) {
      function n(e, t, r, n, i, a, u, s) {
        if (!e) {
          var l;
          if (void 0 === t) l = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else {
            var f = [r, n, i, a, u, s],
                c = 0;
            l = new Error(t.replace(/%s/g, function () {
              return f[c++];
            })), l.name = "Invariant Violation";
          }
          throw l.framesToPop = 1, l;
        }
      }

      e.exports = n;
    }, function (e, t, r) {
      var n = r(6),
          o = r(7),
          i = r(10);

      e.exports = function () {
        function e(e, t, r, n, a, u) {
          u !== i && o(!1, "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        }

        function t() {
          return e;
        }

        e.isRequired = e;
        var r = {
          array: e,
          bool: e,
          func: e,
          number: e,
          object: e,
          string: e,
          symbol: e,
          any: e,
          arrayOf: t,
          element: e,
          instanceOf: t,
          node: e,
          objectOf: t,
          oneOf: t,
          oneOfType: t,
          shape: t,
          exact: t
        };
        return r.checkPropTypes = n, r.PropTypes = r, r;
      };
    }, function (e, t, r) {
      e.exports = r(8)();
    }, function (e, t) {
      var r = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
      e.exports = r;
    }, function (t, r) {
      t.exports = e;
    }]);
  });
});
var MaskedInput = unwrapExports(reactTextMask);
var reactTextMask_1 = reactTextMask.reactTextMask;

function _extends$3() {
  _extends$3 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$3.apply(this, arguments);
}

function _objectWithoutPropertiesLoose$3(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var index = typeof document !== 'undefined' ? useLayoutEffect : useEffect;

var useLatest = function useLatest(value) {
  var ref = useRef(value);
  index(function () {
    ref.current = value;
  });
  return ref;
};

var updateRef = function updateRef(ref, value) {
  if (typeof ref === 'function') {
    ref(value);
    return;
  }

  ref.current = value;
};

var useComposedRef = function useComposedRef(libRef, userRef) {
  var prevUserRef = useRef();
  return useCallback(function (instance) {
    libRef.current = instance;

    if (prevUserRef.current) {
      updateRef(prevUserRef.current, null);
    }

    prevUserRef.current = userRef;

    if (!userRef) {
      return;
    }

    updateRef(userRef, instance);
  }, [userRef]);
};

var HIDDEN_TEXTAREA_STYLE = {
  'min-height': '0',
  'max-height': 'none',
  height: '0',
  visibility: 'hidden',
  overflow: 'hidden',
  position: 'absolute',
  'z-index': '-1000',
  top: '0',
  right: '0'
};

var forceHiddenStyles = function forceHiddenStyles(node) {
  Object.keys(HIDDEN_TEXTAREA_STYLE).forEach(function (key) {
    node.style.setProperty(key, HIDDEN_TEXTAREA_STYLE[key], 'important');
  });
}; //   export type CalculatedNodeHeights = [height: number, rowHeight: number];
// https://github.com/microsoft/TypeScript/issues/28259


var hiddenTextarea = null;

var getHeight = function getHeight(node, sizingData) {
  var height = node.scrollHeight;

  if (sizingData.sizingStyle.boxSizing === 'border-box') {
    // border-box: add border, since height = content + padding + border
    return height + sizingData.borderSize;
  } // remove padding, since height = content


  return height - sizingData.paddingSize;
};

function calculateNodeHeight(sizingData, value, minRows, maxRows) {
  if (minRows === void 0) {
    minRows = 1;
  }

  if (maxRows === void 0) {
    maxRows = Infinity;
  }

  if (!hiddenTextarea) {
    hiddenTextarea = document.createElement('textarea');
    hiddenTextarea.setAttribute('tab-index', '-1');
    hiddenTextarea.setAttribute('aria-hidden', 'true');
    forceHiddenStyles(hiddenTextarea);
  }

  if (hiddenTextarea.parentNode === null) {
    document.body.appendChild(hiddenTextarea);
  }

  var paddingSize = sizingData.paddingSize,
      borderSize = sizingData.borderSize,
      sizingStyle = sizingData.sizingStyle;
  var boxSizing = sizingStyle.boxSizing;
  Object.keys(sizingStyle).forEach(function (_key) {
    var key = _key;
    hiddenTextarea.style[key] = sizingStyle[key];
  });
  forceHiddenStyles(hiddenTextarea);
  hiddenTextarea.value = value;
  var height = getHeight(hiddenTextarea, sizingData); // measure height of a textarea with a single row

  hiddenTextarea.value = 'x';
  var rowHeight = hiddenTextarea.scrollHeight - paddingSize;
  var minHeight = rowHeight * minRows;

  if (boxSizing === 'border-box') {
    minHeight = minHeight + paddingSize + borderSize;
  }

  height = Math.max(minHeight, height);
  var maxHeight = rowHeight * maxRows;

  if (boxSizing === 'border-box') {
    maxHeight = maxHeight + paddingSize + borderSize;
  }

  height = Math.min(maxHeight, height);
  return [height, rowHeight];
}

var noop = function noop() {};

var pick = function pick(props, obj) {
  return props.reduce(function (acc, prop) {
    acc[prop] = obj[prop];
    return acc;
  }, {});
};

var SIZING_STYLE = ['borderBottomWidth', 'borderLeftWidth', 'borderRightWidth', 'borderTopWidth', 'boxSizing', 'fontFamily', 'fontSize', 'fontStyle', 'fontWeight', 'letterSpacing', 'lineHeight', 'paddingBottom', 'paddingLeft', 'paddingRight', 'paddingTop', // non-standard
'tabSize', 'textIndent', // non-standard
'textRendering', 'textTransform', 'width'];
var isIE = typeof document !== 'undefined' ? !!document.documentElement.currentStyle : false;

var getSizingData = function getSizingData(node) {
  var style = window.getComputedStyle(node);

  if (style === null) {
    return null;
  }

  var sizingStyle = pick(SIZING_STYLE, style);
  var boxSizing = sizingStyle.boxSizing; // probably node is detached from DOM, can't read computed dimensions

  if (boxSizing === '') {
    return null;
  } // IE (Edge has already correct behaviour) returns content width as computed width
  // so we need to add manually padding and border widths


  if (isIE && boxSizing === 'border-box') {
    sizingStyle.width = parseFloat(sizingStyle.width) + parseFloat(sizingStyle.borderRightWidth) + parseFloat(sizingStyle.borderLeftWidth) + parseFloat(sizingStyle.paddingRight) + parseFloat(sizingStyle.paddingLeft) + 'px';
  }

  var paddingSize = parseFloat(sizingStyle.paddingBottom) + parseFloat(sizingStyle.paddingTop);
  var borderSize = parseFloat(sizingStyle.borderBottomWidth) + parseFloat(sizingStyle.borderTopWidth);
  return {
    sizingStyle: sizingStyle,
    paddingSize: paddingSize,
    borderSize: borderSize
  };
};

var useWindowResizeListener = function useWindowResizeListener(listener) {
  var latestListener = useLatest(listener);
  useEffect(function () {
    var handler = function handler(event) {
      latestListener.current(event);
    };

    window.addEventListener('resize', handler);
    return function () {
      window.removeEventListener('resize', handler);
    };
  }, []);
};

var TextareaAutosize = function TextareaAutosize(_ref, userRef) {
  var cacheMeasurements = _ref.cacheMeasurements,
      maxRows = _ref.maxRows,
      minRows = _ref.minRows,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? noop : _ref$onChange,
      _ref$onHeightChange = _ref.onHeightChange,
      onHeightChange = _ref$onHeightChange === void 0 ? noop : _ref$onHeightChange,
      props = _objectWithoutPropertiesLoose$3(_ref, ["cacheMeasurements", "maxRows", "minRows", "onChange", "onHeightChange"]);

  if (process.env.NODE_ENV !== 'production' && props.style) {
    if ('maxHeight' in props.style) {
      throw new Error('Using `style.maxHeight` for <TextareaAutosize/> is not supported. Please use `maxRows`.');
    }

    if ('minHeight' in props.style) {
      throw new Error('Using `style.minHeight` for <TextareaAutosize/> is not supported. Please use `minRows`.');
    }
  }

  var isControlled = props.value !== undefined;
  var libRef = useRef(null);
  var ref = useComposedRef(libRef, userRef);
  var heightRef = useRef(0);
  var measurementsCacheRef = useRef();

  var resizeTextarea = function resizeTextarea() {
    var node = libRef.current;
    var nodeSizingData = cacheMeasurements && measurementsCacheRef.current ? measurementsCacheRef.current : getSizingData(node);

    if (!nodeSizingData) {
      return;
    }

    measurementsCacheRef.current = nodeSizingData;

    var _calculateNodeHeight = calculateNodeHeight(nodeSizingData, node.value || node.placeholder || 'x', minRows, maxRows),
        height = _calculateNodeHeight[0],
        rowHeight = _calculateNodeHeight[1];

    if (heightRef.current !== height) {
      heightRef.current = height;
      node.style.setProperty('height', height + "px", 'important');
      onHeightChange(height, {
        rowHeight: rowHeight
      });
    }
  };

  var handleChange = function handleChange(event) {
    if (!isControlled) {
      resizeTextarea();
    }

    onChange(event);
  };

  if (typeof document !== 'undefined') {
    useLayoutEffect(resizeTextarea);
  }

  useWindowResizeListener(resizeTextarea);
  return /*#__PURE__*/createElement("textarea", _extends$3({}, props, {
    onChange: handleChange,
    ref: ref
  }));
};

var index$1 = /* #__PURE__ */forwardRef(TextareaAutosize);

function _templateObject4$3() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject4$3 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$3() {
  var data = _taggedTemplateLiteral(["\n    color: ", ";\n  "]);

  _templateObject3$3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$4() {
  var data = _taggedTemplateLiteral(["\n    color: ", ";\n  "]);

  _templateObject2$4 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$7() {
  var data = _taggedTemplateLiteral(["\n    color: ", ";\n    font-size: ", ";\n    font-weight: ", ";\n    letter-spacing: 0.5px;\n    transition: ", ";\n  "]);

  _templateObject$7 = function _templateObject() {
    return data;
  };

  return data;
}

var genericStyles = function genericStyles(props) {
  var theme = props.theme;
  return css(_templateObject$7(), theme.colors.charcoal, theme.fontSize[11], theme.fontWeight.medium, theme.transitions.baseTransition);
};

var focusedStyles = function focusedStyles(props) {
  var theme = props.theme;
  return css(_templateObject2$4(), theme.colors.blue);
};

var errorStyles = function errorStyles(props) {
  var theme = props.theme;
  return css(_templateObject3$3(), theme.colors.red);
};

var StyledLabel = styled.label(_templateObject4$3(), function (props) {
  return genericStyles(props);
}, function (props) {
  return (props.focused || props.activated) && focusedStyles(props);
}, function (props) {
  return props.error && errorStyles(props);
});

function Label(props) {
  var focused = props.focused,
      activated = props.activated,
      error = props.error,
      children = props.children,
      rest = _objectWithoutProperties(props, ["focused", "activated", "error", "children"]);

  return React$2.createElement(StyledLabel, _extends({
    focused: focused,
    activated: activated,
    error: error
  }, rest), children);
}

Label.propTypes = {
  focused: PropTypes.bool,
  activated: PropTypes.bool,
  error: PropTypes.bool,
  children: PropTypes.node
};

function _templateObject2$5() {
  var data = _taggedTemplateLiteral(["\n  height: 1.125rem;\n  color: ", ";\n"]);

  _templateObject2$5 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$8() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  font-weight: ", ";\n  font-size: ", ";\n  display: flex;\n  letter-spacing: 0.5px;\n  justify-content: space-between;\n  align-items: center;\n"]);

  _templateObject$8 = function _templateObject() {
    return data;
  };

  return data;
}

var StyledValidationMessage = styled.span(_templateObject$8(), function (props) {
  return props.theme.colors.red;
}, function (props) {
  return props.theme.fontWeight.medium;
}, function (props) {
  return props.theme.fontSize[11];
});
var IconWrapper$1 = styled.div(_templateObject2$5(), function (props) {
  return props.theme.colors.red;
});

function ValidationMessage(props) {
  var children = props.children,
      showIcon = props.showIcon,
      rest = _objectWithoutProperties(props, ["children", "showIcon"]);

  return React$2.createElement(StyledValidationMessage, rest, children, showIcon && React$2.createElement(IconWrapper$1, null, React$2.createElement(Icon, {
    icon: "MdError",
    size: '18px'
  })));
}

ValidationMessage.propTypes = {
  children: PropTypes.string,
  showIcon: PropTypes.bool
};
ValidationMessage.defaultProps = {};

function _templateObject23() {
  var data = _taggedTemplateLiteral(["\n  @keyframes animateIn {\n    from {\n      left: 0px;\n      top: 0px;\n      font-size: ", ";\n    }\n    to {\n      left: 12px;\n      top: 33px;\n      font-size: ", ";\n    }\n  }\n"]);

  _templateObject23 = function _templateObject23() {
    return data;
  };

  return data;
}

function _templateObject22() {
  var data = _taggedTemplateLiteral(["\n  @keyframes animateOut {\n    from {\n      left: 12px;\n      top: 33px;\n      font-size: ", ";\n    }\n    to {\n      left: 0px;\n      top: 0px;\n      font-size: ", ";\n    }\n  }\n"]);

  _templateObject22 = function _templateObject22() {
    return data;
  };

  return data;
}

function _templateObject21() {
  var data = _taggedTemplateLiteral(["\n  @keyframes animateInWithIcon {\n    from {\n      left: 0px;\n      top: 0px;\n      font-size: ", ";\n    }\n    to {\n      left: 34px;\n      top: 33px;\n      font-size: ", ";\n    }\n  }\n"]);

  _templateObject21 = function _templateObject21() {
    return data;
  };

  return data;
}

function _templateObject20() {
  var data = _taggedTemplateLiteral(["\n  @keyframes animateOutWithIcon {\n    from {\n      left: 34px;\n      top: 33px;\n      font-size: ", ";\n    }\n    to {\n      left: 0px;\n      top: 0px;\n      font-size: ", ";\n    }\n  }\n"]);

  _templateObject20 = function _templateObject20() {
    return data;
  };

  return data;
}

function _templateObject19() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  animation-name: ", ";\n  animation-duration: 0.25s;\n  ", ";\n"]);

  _templateObject19 = function _templateObject19() {
    return data;
  };

  return data;
}

function _templateObject18() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  color: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n  left: ", "px;\n  top: 33px;\n  cursor: auto;\n  animation-name: ", ";\n  animation-duration: 0.25s;\n  ", ";\n"]);

  _templateObject18 = function _templateObject18() {
    return data;
  };

  return data;
}

function _templateObject17() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n"]);

  _templateObject17 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16() {
  var data = _taggedTemplateLiteral(["\n  + ", ":before {\n    width: 50%;\n  }\n  + ", ":after {\n    width: 50%;\n  }\n"]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  position: relative;\n  ", ";\n\n  &:hover + ", " {\n    background-color: ", ";\n  }\n\n  input {\n    ", "\n  }\n"]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n"]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  font-weight: ", ";\n  margin-top: ", ";\n  margin-right: 1em;\n  margin-left: 1em;\n  font-size: ", ";\n  display: block;\n  letter-spacing: 0.5px;\n  text-align: ", ";\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n  margin-top: ", ";\n  margin-left: 1em;\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n  padding-top: 1px;\n  padding-left: ", "px;\n  padding-right: ", "px;\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n  padding-top: 1px;\n  padding-left: ", "px;\n  padding-right: ", "px;\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  height: 22px;\n  padding-left: ", ";\n  padding-right: ", ";\n  margin-right: ", ";\n  margin-left: ", ";\n  color: ", ";\n\n  ", "\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7$1() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  display: block;\n  width: 100%;\n  height: 1px;\n  transition: ", ";\n  background-color: ", ";\n\n  &:before,\n  &:after {\n    content: '';\n    height: 2px;\n    width: 0;\n    position: absolute;\n    background: ", ";\n    transition: ", ";\n  }\n\n  &:before {\n    left: 50%;\n  }\n\n  &:after {\n    right: 50%;\n  }\n\n  ", "\n"]);

  _templateObject7$1 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$2() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n"]);

  _templateObject6$2 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$3() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  min-height: 150px;\n  resize: none;\n"]);

  _templateObject5$3 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$4() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject4$4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$4() {
  var data = _taggedTemplateLiteral(["\n  background: transparent;\n  outline: none;\n  border: 0;\n  width: 100%;\n  color: ", ";\n  caret-color: ", ";\n  padding: 0.938em ", " 0.875em;\n  font-size: ", ";\n\n  &:focus {\n    outline: none;\n  }\n\n  &::-moz-focus-inner {\n    border: none;\n    outline: none;\n  }\n\n  ::-webkit-input-placeholder {\n    color: ", ";\n  }\n\n  :-ms-input-placeholder {\n    color: ", ";\n  }\n\n  ::placeholder {\n    color: ", ";\n  }\n\n  ", "\n"]);

  _templateObject3$4 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$6() {
  var data = _taggedTemplateLiteral(["\n  cursor: not-allowed;\n  ::-webkit-input-placeholder {\n    color: ", ";\n  }\n\n  :-ms-input-placeholder {\n    color: ", ";\n  }\n\n  ::placeholder {\n    color: ", ";\n  }\n"]);

  _templateObject2$6 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$9() {
  var data = _taggedTemplateLiteral(["\n  cursor: pointer;\n"]);

  _templateObject$9 = function _templateObject() {
    return data;
  };

  return data;
}

var iconCursorStyle = function iconCursorStyle() {
  return css(_templateObject$9());
};

var disabledInputStyle = function disabledInputStyle(props) {
  return css(_templateObject2$6(), props.theme.colors.grey, props.theme.colors.grey, props.theme.colors.grey);
};

var defaultInputStyle = function defaultInputStyle(props) {
  return css(_templateObject3$4(), props.theme.colors.black, props.theme.colors.blue, props.leadingIcon ? 0 : props.theme.gutters[12], function (props) {
    return props.theme.fontSize[16];
  }, props.theme.colors.darkGrey, props.theme.colors.darkGrey, props.theme.colors.darkGrey, props.disabled && disabledInputStyle(props));
};

var Input = styled.input(_templateObject4$4());
var TextArea = styled(index$1)(_templateObject5$3(), function (props) {
  return defaultInputStyle(props);
});

var disabledBottomBarStyle = function disabledBottomBarStyle(props) {
  return css(_templateObject6$2(), props.theme.colors.lightGrey);
};

var BottomBar = styled.div(_templateObject7$1(), function (props) {
  return props.theme.transitions.baseTransition;
}, function (props) {
  return props.error ? props.theme.colors.red : props.activated ? props.theme.colors.charcoal : props.theme.colors.darkGrey;
}, function (props) {
  return props.error ? props.theme.colors.red : props.theme.colors.blue;
}, function (props) {
  return props.theme.transitions.baseTransition;
}, function (props) {
  return props.disabled && disabledBottomBarStyle(props);
});
var IconWrapper$2 = styled.div(_templateObject8(), function (props) {
  return props.isLeadingIcon ? '8px' : 0;
}, function (props) {
  return !props.isLeadingIcon ? '8px' : 0;
}, function (props) {
  return props.isLeadingIcon ? '-6px' : 0;
}, function (props) {
  return !props.isLeadingIcon ? '-6px' : 0;
}, function (props) {
  return props.isLeadingIcon ? props.theme.colors.charcoal : props.error ? props.theme.colors.red : props.theme.colors.charcoal;
}, function (props) {
  return props.onClick && iconCursorStyle();
});

var prefixSuffixNotActive = function prefixSuffixNotActive(props) {
  return css(_templateObject9(), props.theme.colors.darkGrey, function (props) {
    return props.theme.fontSize[16];
  }, props.theme.fontWeight.regular, props.isPrefix ? 8 : 0, !props.isPrefix ? 8 : 0);
};

var prefixSuffixActive = function prefixSuffixActive(props) {
  return css(_templateObject10(), props.theme.colors.black, function (props) {
    return props.theme.fontSize[16];
  }, props.theme.fontWeight.regular, props.isPrefix ? 8 : 0, !props.isPrefix ? 8 : 0);
};

var ExtendedPrefixSuffixLabel = styled(Label)(_templateObject11(), function (props) {
  return props.focused || props.activated ? prefixSuffixActive(props) : prefixSuffixNotActive(props);
});
var Validation = styled(ValidationMessage)(_templateObject12(), function (props) {
  return props.theme.gutters[8];
});
var AssistiveMessage = styled.span(_templateObject13(), function (props) {
  return props.theme.colors.charcoal;
}, function (props) {
  return props.theme.fontWeight.medium;
}, function (props) {
  return props.theme.gutters[8];
}, function (props) {
  return props.theme.fontSize[11];
}, function (props) {
  return props.assistiveMessageAlign;
});
var StyledTextInput = styled.div(_templateObject14());
var InputContainer = styled.div(_templateObject15(), function (props) {
  return props.focused && inputContainerFocusedStyle();
}, BottomBar, function (props) {
  return props.error ? props.theme.colors.red : props.disabled ? props.theme.colors.lightGrey : props.theme.colors.charcoal;
}, defaultInputStyle);

var inputContainerFocusedStyle = function inputContainerFocusedStyle() {
  return css(_templateObject16(), BottomBar, BottomBar);
};

var ExtendedLabel = styled(Label)(_templateObject17(), function (props) {
  return props.animateLabel ? props.focused || props.activated ? fieldActiveStyle(props) : fieldNotActiveStyle(props) : '';
});

var fieldNotActiveStyle = function fieldNotActiveStyle(props) {
  return css(_templateObject18(), props.theme.colors.darkGrey, function (props) {
    return props.theme.fontSize[16];
  }, props.theme.fontWeight.regular, props.leadingIcon || props.prefix ? 34 : 12, props.leadingIcon || props.prefix ? 'animateInWithIcon' : 'animateIn', props.mounted ? props.leadingIcon || props.prefix ? animateInWithIcon(props) : animateIn(props) : '');
};

var fieldActiveStyle = function fieldActiveStyle(props) {
  return css(_templateObject19(), props.leadingIcon || props.prefix ? 'animateOutWithIcon' : 'animateOut', props.leadingIcon || props.prefix ? animateOutWithIcon(props) : animateOut(props));
};

var animateOutWithIcon = function animateOutWithIcon(props) {
  return css(_templateObject20(), props.theme.fontSize[16], props.theme.fontSize[11]);
};

var animateInWithIcon = function animateInWithIcon(props) {
  return css(_templateObject21(), props.theme.fontSize[11], props.theme.fontSize[16]);
};

var animateOut = function animateOut(props) {
  return css(_templateObject22(), props.theme.fontSize[16], props.theme.fontSize[11]);
};

var animateIn = function animateIn(props) {
  return css(_templateObject23(), props.theme.fontSize[11], props.theme.fontSize[16]);
};

function TextInput(props) {
  var placeholder = props.placeholder,
      label = props.label,
      error = props.error,
      errorMessage = props.errorMessage,
      disabled = props.disabled,
      multiline = props.multiline,
      rows = props.rows,
      assistiveMessage = props.assistiveMessage,
      assistiveMessageAlign = props.assistiveMessageAlign,
      _onChange = props.onChange,
      _onFocus = props.onFocus,
      onIconClick = props.onIconClick,
      animateLabel = props.animateLabel,
      fieldType = props.fieldType,
      value = props.value,
      _onBlur = props.onBlur,
      id = props.id,
      name = props.name,
      prefix = props.prefix,
      suffix = props.suffix,
      mask = props.mask,
      currency = props.currency;
  var leadingIcon = prefix && prefix.length >= 2 && prefix.toUpperCase().substring(0, 2) === 'MD' ? prefix : '';
  var trailingIcon = suffix && suffix.length >= 2 && suffix.toUpperCase().substring(0, 2) === 'MD' ? suffix : '';

  var _useState = useState(value ? true : false),
      _useState2 = _slicedToArray(_useState, 2),
      activated = _useState2[0],
      setActivated = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      focused = _useState4[0],
      setFocused = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      mounted = _useState6[0],
      setMounted = _useState6[1];

  var hasLeadingIcon = leadingIcon && !trailingIcon;

  var _useState7 = useState(''),
      _useState8 = _slicedToArray(_useState7, 2),
      currentValue = _useState8[0],
      setCurrentValue = _useState8[1];

  useEffect(function () {
    if (value) {
      setCurrentValue(value);
    }
  }, [value]);

  if (leadingIcon && trailingIcon) {
    console.warn('Inputs can not have both a leading icon and a trailing icon');
  }

  if (!leadingIcon && prefix && prefix.length > 1 || !trailingIcon && suffix && suffix.length > 1) {
    console.error('Prefix and suffix can only be one character long');
  }

  if (!label) {
    console.warn('Label is required');
  }

  var renderIcon = function renderIcon(icon, isLeadingIcon) {
    return React$2.createElement(IconWrapper$2, {
      error: error,
      isLeadingIcon: isLeadingIcon,
      onClick: onIconClick
    }, React$2.createElement(Icon, {
      icon: icon,
      size: '22px'
    }));
  };

  var renderPrefixSuffix = function renderPrefixSuffix(isPrefix) {
    return React$2.createElement(ExtendedPrefixSuffixLabel, {
      isPrefix: isPrefix,
      activated: activated,
      focused: focused,
      animateLabel: animateLabel
    }, prefix ? prefix : suffix ? suffix : '');
  };

  var fieldTypeOptions = {
    type: fieldType,
    inputmode: fieldType === 'number' ? 'numeric' : undefined,
    pattern: fieldType === 'number' ? '[0-9]*' : undefined
  };
  var currencyMask = createNumberMask$1({
    prefix: '',
    suffix: '',
    includeThousandsSeparator: true,
    thousandsSeparatorSymbol: ',',
    allowDecimal: true,
    decimalSymbol: '.',
    decimalLimit: 2,
    integerLimit: 10,
    allowNegative: false,
    allowLeadingZeroes: false
  });
  return React$2.createElement(StyledTextInput, {
    error: error,
    "data-form-field-name": name,
    "data-has-form-field-error": !!error
  }, React$2.createElement(ExtendedLabel, {
    prefix: prefix,
    mounted: mounted,
    activated: activated,
    focused: focused,
    error: error,
    animateLabel: animateLabel,
    leadingIcon: hasLeadingIcon
  }, label), React$2.createElement(InputContainer, {
    focused: focused,
    error: error,
    disabled: disabled
  }, leadingIcon && !trailingIcon && renderIcon(leadingIcon, true), !leadingIcon && !trailingIcon && prefix && renderPrefixSuffix(true), !multiline && !mask && !currency && React$2.createElement(Input, _extends({
    onChange: function onChange(event) {
      _onChange(event);

      setCurrentValue(event.target.value);
      event.target.value ? setActivated(true) : setActivated(false);
    },
    onFocus: function onFocus() {
      setFocused(!focused);
      setMounted(true);

      _onFocus();
    },
    value: currentValue,
    onBlur: function onBlur(event) {
      _onBlur(event);

      setFocused(!focused);
    },
    error: error,
    disabled: disabled,
    placeholder: animateLabel ? '' : placeholder,
    id: id,
    name: name
  }, fieldTypeOptions)), multiline && !mask && !currency && React$2.createElement(TextArea, {
    onChange: function onChange(event) {
      _onChange(event);

      setCurrentValue(event.target.value);
      event.target.value ? setActivated(true) : setActivated(false);
    },
    onFocus: function onFocus() {
      setFocused(!focused);
      setMounted(true);
    },
    value: currentValue,
    onBlur: function onBlur(event) {
      _onBlur(event);

      setFocused(!focused);
    },
    error: error,
    disabled: disabled,
    placeholder: animateLabel ? '' : placeholder,
    id: id,
    name: name
  }), mask && !currency && React$2.createElement(reactInputMask, _extends({
    mask: mask,
    onChange: function onChange(event) {
      _onChange(event);

      setCurrentValue(event.target.value);
      event.target.value ? setActivated(true) : setActivated(false);
    },
    onFocus: function onFocus() {
      setFocused(!focused);
      setMounted(true);

      _onFocus();
    },
    value: currentValue,
    onBlur: function onBlur(event) {
      _onBlur(event);

      setFocused(!focused);
    },
    error: error,
    disabled: disabled,
    placeholder: animateLabel ? '' : placeholder,
    id: id,
    name: name,
    maskChar: null
  }, fieldTypeOptions), function (inputProps) {
    return React$2.createElement(Input, inputProps);
  }), !mask && currency && React$2.createElement(MaskedInput, _extends({
    mask: currencyMask,
    onChange: function onChange(event) {
      _onChange(event);

      setCurrentValue(event.target.value);
      event.target.value ? setActivated(true) : setActivated(false);
    },
    onFocus: function onFocus() {
      setFocused(!focused);
      setMounted(true);

      _onFocus();
    },
    value: currentValue,
    onBlur: function onBlur(event) {
      _onBlur(event);

      setFocused(!focused);
    },
    error: error,
    disabled: disabled,
    placeholder: animateLabel ? '' : placeholder,
    id: id,
    name: name
  }, fieldTypeOptions)), trailingIcon && !leadingIcon && !error && renderIcon(trailingIcon, false), !leadingIcon && !trailingIcon && !error && suffix && renderPrefixSuffix(false), error && renderIcon('MdError', false)), React$2.createElement(BottomBar, {
    activated: activated,
    error: error,
    disabled: disabled
  }), error && errorMessage && React$2.createElement(Validation, null, errorMessage), assistiveMessage && !error && !errorMessage && React$2.createElement(AssistiveMessage, {
    assistiveMessageAlign: assistiveMessageAlign
  }, assistiveMessage));
}

TextInput.propTypes = {
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  error: PropTypes.bool,
  errorMessage: PropTypes.string,
  disabled: PropTypes.bool,
  multiline: PropTypes.bool,
  rows: PropTypes.number,
  assistiveMessage: PropTypes.string,
  assistiveMessageAlign: PropTypes.string,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  animateLabel: PropTypes.bool,
  fieldType: PropTypes.oneOf(['text', 'email', 'password', 'tel', 'number', 'url']),
  value: PropTypes.string,
  onIconClick: PropTypes.func,
  prefix: PropTypes.string,
  suffix: PropTypes.string,
  mask: PropTypes.string,
  currency: PropTypes.bool
};
TextInput.defaultProps = {
  id: '',
  name: '',
  error: false,
  errorMessage: '',
  disabled: false,
  multiline: false,
  rows: 3,
  assistiveMessage: '',
  assistiveMessageAlign: 'left',
  onChange: function onChange() {},
  onFocus: function onFocus() {},
  onBlur: function onBlur() {},
  animateLabel: true,
  fieldType: 'text',
  onIconClick: function onIconClick() {},
  value: '',
  mask: '',
  currency: false
};

function _templateObject$a() {
  var data = _taggedTemplateLiteral(["\n  margin-right: 10px;\n"]);

  _templateObject$a = function _templateObject() {
    return data;
  };

  return data;
}

var MaterialIcon = function MaterialIcon(props) {
  var mdIcon = MaterialIcons[props.icon];
  return React$2.createElement(mdIcon, {
    color: props.color,
    size: props.size,
    style: props.style
  });
};

MaterialIcon.propTypes = {
  icon: PropTypes.string.isRequired,
  color: PropTypes.string,
  size: PropTypes.string,
  style: PropTypes.object
};
var StyledIcon = styled(MaterialIcon)(_templateObject$a());

function Icon(props) {
  var icon = props.icon,
      size = props.size,
      color = props.color;
  return React$2.createElement(StyledIcon, {
    icon: icon,
    size: size,
    color: color && color
  });
}

Icon.propTypes = {
  icon: PropTypes.string.isRequired,
  size: PropTypes.string,
  color: PropTypes.string
};
Icon.defaultProps = {
  icon: 'MdSentimentDissatisfied',
  size: '1.5em',
  color: null
};

function _templateObject14$1() {
  var data = _taggedTemplateLiteral(["\n  padding: 0.813em ", ";\n"]);

  _templateObject14$1 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13$1() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border-radius: 0 0 0.5em 0.5em;\n  overflow: hidden;\n"]);

  _templateObject13$1 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12$1() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  line-height: 1.5;\n  margin-left: 0.6em;\n  user-select: none;\n  font-size: ", ";\n  margin-top: 2px;\n"]);

  _templateObject12$1 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11$1() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n"]);

  _templateObject11$1 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10$1() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  margin-left: 0.5em;\n  line-height: 1.2em;\n  user-select: none;\n"]);

  _templateObject10$1 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9$1() {
  var data = _taggedTemplateLiteral(["\n  height: 1.25em;\n  color: ", ";\n"]);

  _templateObject9$1 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8$1() {
  var data = _taggedTemplateLiteral(["\n  border: 0;\n  clip: rect(0 0 0 0);\n  clippath: inset(50%);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  white-space: nowrap;\n  width: 1px;\n"]);

  _templateObject8$1 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7$2() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: ", ";\n  flex-direction: row;\n  width: 100%;\n"]);

  _templateObject7$2 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$3() {
  var data = _taggedTemplateLiteral(["\n  ", "\n\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  background-color: ", ";\n  border: 1px solid\n    ", ";\n  border-radius: ", ";\n  padding: 0.813em ", ";\n  transition: ", ";\n  margin-top: ", ";\n\n  &:hover {\n    border-color: ", ";\n    box-shadow: '0 0 10px 0 rgba(0, 0, 0, 0.08)';\n    cursor: pointer;\n  }\n\n  @media ", " {\n    margin-top: ", ";\n  }\n\n  ", "\n  ", "\n"]);

  _templateObject6$3 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$4() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n  letter-spacing: 0.5px;\n"]);

  _templateObject5$4 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$5() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  margin-right: ", ";\n  position: relative;\n  top: 1px;\n"]);

  _templateObject4$5 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$5() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  margin-top: ", ";\n"]);

  _templateObject3$5 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$7() {
  var data = _taggedTemplateLiteral(["\n  &:hover {\n    border-color: ", ";\n    cursor: not-allowed;\n    box-shadow: none;\n  }\n"]);

  _templateObject2$7 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$b() {
  var data = _taggedTemplateLiteral(["\n  border-color: ", ";\n\n  &:hover {\n    border-color: ", ";\n  }\n"]);

  _templateObject$b = function _templateObject() {
    return data;
  };

  return data;
}

var errorStyle = function errorStyle(props) {
  return css(_templateObject$b(), props.theme.colors.red, props.theme.colors.red);
};

var disabledStyle$3 = function disabledStyle(props) {
  return css(_templateObject2$7(), props.theme.colors.lightGrey);
};

var AlternateWrapper = styled.div(_templateObject3$5(), function (props) {
  return props.theme.gutters[12];
});
var AlternateIconWrapper = styled.div(_templateObject4$5(), function (props) {
  return props.theme.colors.blue;
}, function (props) {
  return props.theme.gutters[4];
});
var AlternateLabel = styled.span(_templateObject5$4(), function (props) {
  return props.theme.colors.blue;
}, function (props) {
  return props.theme.fontSize[11];
}, function (props) {
  return props.theme.fontWeight.medium;
});
var StyledCheckbox = styled.label(_templateObject6$3(), function (props) {
  return RippleStyle();
}, function (props) {
  return !props.isChecked ? props.theme.colors.white : props.alternate ? props.theme.colors.blue : props.theme.colors.charcoal;
}, function (props) {
  return !props.isChecked ? props.alternate ? props.theme.colors.sinbad : props.theme.colors.lightGrey : props.alternate ? props.theme.colors.blue : props.theme.colors.charcoal;
}, function (props) {
  return !props.isAccordionOpen ? '0.5em' : '0.5em 0.5em 0 0';
}, function (props) {
  return props.theme.gutters[12];
}, function (props) {
  return props.theme.transitions.baseTransition;
}, function (props) {
  return props.alternate ? props.theme.gutters[8] : props.theme.gutters[12];
}, function (props) {
  return props.isChecked ? props.alternate ? props.theme.colors.blue : props.theme.colors.charcoal : props.theme.colors.sinbad;
}, function (props) {
  return props.theme.BREAKPOINTS.MOBILE_DOWN;
}, function (props) {
  return props.theme.gutters[8];
}, function (props) {
  return props.error && !props.checked && errorStyle(props);
}, function (props) {
  return props.disabled && disabledStyle$3(props);
});
var CheckboxContainer = styled.div(_templateObject7$2(), function (props) {
  return !props.subtext ? 'center' : 'none';
});
var HiddenCheckbox = styled.input.attrs({
  type: 'checkbox'
})(_templateObject8$1());
var IconWrapper$3 = styled.div(_templateObject9$1(), function (props) {
  return props.isChecked ? props.theme.colors.white : props.disabled ? props.theme.colors.grey : props.alternate ? props.theme.colors.blue : props.theme.colors.sinbad;
});
var CheckboxLabel = styled.span(_templateObject10$1(), function (props) {
  return props.isChecked ? props.theme.colors.white : props.disabled ? props.theme.colors.grey : props.theme.colors.charcoal;
});
var CheckboxSubLabelWrapper = styled.div(_templateObject11$1());
var CheckboxSubLabel = styled.span(_templateObject12$1(), function (props) {
  return !props.disabled ? props.alternate ? props.theme.colors.white : props.theme.colors.darkGrey : props.theme.colors.grey;
}, function (props) {
  return props.theme.fontSize[14];
});
var AccordionWrapper = styled(animated.div)(_templateObject13$1(), function (props) {
  return props.theme.colors.lightGrey;
});
var AccordionInner = styled.div(_templateObject14$1(), function (props) {
  return props.theme.gutters[12];
});

function Checkbox(props) {
  var label = props.label,
      subtext = props.subtext,
      error = props.error,
      disabled = props.disabled,
      checked = props.checked,
      value = props.value,
      onChange = props.onChange,
      name = props.name,
      alternate = props.alternate,
      alternateText = props.alternateText,
      children = props.children;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isChecked = _useState2[0],
      setIsChecked = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isAccordionOpen = _useState4[0],
      setIsAccordionOpen = _useState4[1];

  var accordionInnerRef = useRef(null);
  useEffect(function () {
    setIsChecked(checked);
    checked && children && setIsAccordionOpen(true);
  }, [children, checked]);

  var handleChange = function handleChange(event) {
    onChange(event);
    setIsChecked(!isChecked);
    children && setIsAccordionOpen(!isAccordionOpen);
  };

  function getElementHeight(ref) {
    return ref.current ? ref.current.getBoundingClientRect().height : 0;
  }

  var accordionTransition = useTransition(isAccordionOpen, null, {
    from: {
      height: 0
    },
    enter: function enter() {
      return /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(next, cancel) {
          var height;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  height = getElementHeight(accordionInnerRef);
                  cancel();
                  _context.next = 4;
                  return next({
                    height: height
                  });

                case 4:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }();
    },
    leave: {
      height: 0
    }
  });
  return React$2.createElement(React$2.Fragment, null, alternate && React$2.createElement(AlternateWrapper, {
    "data-testid": "alternate-wrapper"
  }, React$2.createElement(AlternateIconWrapper, {
    "data-testid": "alternate-icon-wrapper"
  }, React$2.createElement(Icon, {
    icon: 'MdFingerprint',
    size: "1.375em"
  })), React$2.createElement(AlternateLabel, null, alternateText)), React$2.createElement(StyledCheckbox, {
    "data-testid": "checkbox",
    "data-form-field-name": name,
    "data-has-form-field-error": !!error,
    isChecked: isChecked,
    disabled: disabled,
    error: !checked && error,
    isAccordionOpen: isAccordionOpen,
    alternate: alternate
  }, React$2.createElement(CheckboxContainer, props, React$2.createElement(HiddenCheckbox, {
    checked: isChecked || checked,
    disabled: disabled,
    value: value,
    name: name,
    onChange: function onChange(event) {
      return handleChange(event);
    },
    "data-testid": "hidden-checkbox"
  }), React$2.createElement(IconWrapper$3, {
    isChecked: isChecked,
    disabled: disabled,
    "data-testid": "icon-wrapper"
  }, React$2.createElement(Icon, {
    icon: !isChecked ? 'MdCheckBoxOutlineBlank' : 'MdCheckBox',
    size: "1.3em",
    color: !isChecked ? theme.colors.sinbad : theme.colors.white
  })), !subtext && React$2.createElement(CheckboxLabel, {
    isChecked: isChecked,
    disabled: disabled,
    "data-testid": "checkbox-label"
  }, label), subtext && React$2.createElement(CheckboxSubLabelWrapper, null, React$2.createElement(CheckboxLabel, {
    isChecked: isChecked,
    disabled: disabled,
    "data-testid": "checkbox-label"
  }, label), React$2.createElement(CheckboxSubLabel, {
    disabled: disabled,
    "data-testid": "checkbox-sublabel"
  }, subtext)))), children && accordionTransition.map(function (_ref2) {
    var item = _ref2.item,
        key = _ref2.key,
        props = _ref2.props;
    return item && React$2.createElement(AccordionWrapper, {
      style: props,
      key: key
    }, React$2.createElement(AccordionInner, {
      ref: accordionInnerRef
    }, React$2.createElement(React$2.Fragment, null, children)));
  }));
}

Checkbox.propTypes = {
  label: PropTypes.string.isRequired,
  subtext: PropTypes.string,
  error: PropTypes.bool,
  disabled: PropTypes.bool,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  name: PropTypes.string,
  alternate: PropTypes.bool,
  alternateText: PropTypes.string,
  children: PropTypes.node
};
Checkbox.defaultProps = {
  checked: false,
  error: false,
  disabled: false,
  onChange: function onChange() {},
  alternate: false
};

function _templateObject2$8() {
  var data = _taggedTemplateLiteral(["\n  margin-top: ", ";\n  margin-left: ", ";\n  margin-right: ", ";\n"]);

  _templateObject2$8 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$c() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject$c = function _templateObject() {
    return data;
  };

  return data;
}

var StyledRadioButtonGroup = styled.div(_templateObject$c());
var Validation$1 = styled(ValidationMessage)(_templateObject2$8(), function (props) {
  return props.theme.gutters[8];
}, function (props) {
  return props.theme.gutters[12];
}, function (props) {
  return props.theme.gutters[12];
});

function RadioButtonGroup(props) {
  var options = props.options,
      error = props.error,
      errorMessage = props.errorMessage,
      disabled = props.disabled,
      value = props.value,
      onChange = props.onChange,
      name = props.name;

  var _useState = useState(value ? value : ''),
      _useState2 = _slicedToArray(_useState, 2),
      selectedOption = _useState2[0],
      setSelectedOption = _useState2[1];

  var handleChange = function handleChange(event) {
    var val = onChange(event);

    if (val !== false) {
      setSelectedOption(event.target.value);
    }
  };

  useEffect(function () {
    setSelectedOption(value);
  }, [value]);
  return React$2.createElement("div", null, React$2.createElement(StyledRadioButtonGroup, {
    "data-form-field-name": name,
    "data-has-form-field-error": !!error
  }, options.map(function (_ref) {
    var label = _ref.label,
        value = _ref.value,
        subtext = _ref.subtext,
        accordionContent = _ref.accordionContent;
    return React$2.createElement(RadioButton, {
      key: value,
      isChecked: selectedOption === value,
      onChange: function onChange(event) {
        return handleChange(event);
      },
      value: value,
      label: label,
      subtext: subtext,
      error: !selectedOption && error,
      disabled: disabled,
      "data-testid": "radio-button",
      accordionContent: accordionContent,
      isAccordionOpen: accordionContent && selectedOption === value,
      name: name
    });
  })), !selectedOption && error && errorMessage && React$2.createElement(Validation$1, {
    showIcon: true
  }, errorMessage));
}

RadioButtonGroup.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    subtext: PropTypes.string,
    accordionContent: PropTypes.element
  })).isRequired,
  error: PropTypes.bool,
  errorMessage: PropTypes.string,
  disabled: PropTypes.bool,
  value: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func
};
RadioButtonGroup.defaultProps = {
  error: false,
  disabled: false,
  value: '',
  onChange: function onChange() {}
};

function _templateObject10$2() {
  var data = _taggedTemplateLiteral(["\n  padding: 0.813em ", ";\n"]);

  _templateObject10$2 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9$2() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border-radius: 0 0 0.5em 0.5em;\n  overflow: hidden;\n"]);

  _templateObject9$2 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8$2() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  line-height: 1.5;\n  margin-left: 0.6em;\n  user-select: none;\n  font-size: ", ";\n  margin-top: 2px;\n"]);

  _templateObject8$2 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7$3() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n"]);

  _templateObject7$3 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$4() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  margin-left: 0.5em;\n  line-height: 1.2em;\n  user-select: none;\n"]);

  _templateObject6$4 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$5() {
  var data = _taggedTemplateLiteral(["\n  height: 1.25em;\n  color: ", ";\n"]);

  _templateObject5$5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$6() {
  var data = _taggedTemplateLiteral(["\n  border: 0;\n  clip: rect(0 0 0 0);\n  clippath: inset(50%);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  white-space: nowrap;\n  width: 1px;\n"]);

  _templateObject4$6 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$6() {
  var data = _taggedTemplateLiteral(["\n  ", "\n\n  display: flex;\n  align-items: ", ";\n  flex-direction: row;\n  width: 100%;\n  background-color: ", ";\n  border: 1px solid\n    ", ";\n  border-radius: ", ";\n  padding: 0.813em ", ";\n  transition: ", ";\n  margin-top: ", ";\n\n  &:hover {\n    border-color: ", ";\n    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.08);\n    cursor: pointer;\n  }\n\n  @media ", " {\n    margin-top: ", ";\n  }\n\n  ", "\n  ", "\n"]);

  _templateObject3$6 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$9() {
  var data = _taggedTemplateLiteral(["\n  &:hover {\n    border-color: ", ";\n    cursor: not-allowed;\n    box-shadow: none;\n  }\n"]);

  _templateObject2$9 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$d() {
  var data = _taggedTemplateLiteral(["\n  border-color: ", ";\n\n  &:hover {\n    border-color: ", ";\n  }\n"]);

  _templateObject$d = function _templateObject() {
    return data;
  };

  return data;
}

var errorStyle$1 = function errorStyle(props) {
  return css(_templateObject$d(), !props.isChecked ? props.theme.colors.red : props.theme.colors.charcoal, !props.isChecked ? props.theme.colors.red : props.theme.colors.lightGrey);
};

var disabledStyle$4 = function disabledStyle(props) {
  return css(_templateObject2$9(), props.theme.colors.lightGrey);
};

var StyledRadioButton = styled.label(_templateObject3$6(), function (props) {
  return RippleStyle();
}, function (props) {
  return !props.subtext ? 'center' : 'none';
}, function (props) {
  return !props.isChecked ? props.theme.colors.white : props.theme.colors.charcoal;
}, function (props) {
  return !props.isChecked ? props.theme.colors.lightGrey : props.theme.colors.charcoal;
}, function (props) {
  return !props.isAccordionOpen ? '0.5em' : '0.5em 0.5em 0 0';
}, function (props) {
  return props.theme.gutters[12];
}, function (props) {
  return props.theme.transitions.baseTransition;
}, function (props) {
  return props.theme.gutters[12];
}, function (props) {
  return !props.isChecked ? props.theme.colors.sinbad : props.theme.colors.charcoal;
}, function (props) {
  return props.theme.BREAKPOINTS.MOBILE_DOWN;
}, function (props) {
  return props.theme.gutters[8];
}, function (props) {
  return props.error && errorStyle$1(props);
}, function (props) {
  return props.disabled && disabledStyle$4(props);
});
var HiddenRadioButton = styled.input.attrs({
  type: 'radio'
})(_templateObject4$6());
var IconWrapper$4 = styled.div(_templateObject5$5(), function (props) {
  return props.isChecked ? props.theme.colors.white : props.disabled ? props.theme.colors.grey : props.theme.colors.sinbad;
});
var RadioButtonLabel = styled.span(_templateObject6$4(), function (props) {
  return props.isChecked ? props.theme.colors.white : props.disabled ? props.theme.colors.grey : props.theme.colors.charcoal;
});
var RadioButtonSubtextWrapper = styled.div(_templateObject7$3());
var RadioButtonSubtext = styled.span(_templateObject8$2(), function (props) {
  return !props.disabled ? props.theme.colors.darkGrey : props.theme.colors.grey;
}, function (props) {
  return props.theme.fontSize[14];
});
var AccordionWrapper$1 = styled(animated.div)(_templateObject9$2(), function (props) {
  return props.theme.colors.lightGrey;
});
var AccordionInner$1 = styled.div(_templateObject10$2(), function (props) {
  return props.theme.gutters[12];
});

function RadioButton(props) {
  var isChecked = props.isChecked,
      onChange = props.onChange,
      value = props.value,
      label = props.label,
      error = props.error,
      subtext = props.subtext,
      disabled = props.disabled,
      accordionContent = props.accordionContent,
      isAccordionOpen = props.isAccordionOpen,
      name = props.name;
  var accordionInnerRef = useRef(null);

  function getElementHeight(ref) {
    return ref.current ? ref.current.getBoundingClientRect().height : 0;
  }

  var accordionTransition = useTransition(isAccordionOpen, null, {
    from: {
      height: 0
    },
    enter: function enter() {
      return /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(next, cancel) {
          var height;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  height = getElementHeight(accordionInnerRef);
                  cancel();
                  _context.next = 4;
                  return next({
                    height: height
                  });

                case 4:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }();
    },
    leave: {
      height: 0
    }
  });
  return React$2.createElement(React$2.Fragment, null, React$2.createElement(StyledRadioButton, {
    subtext: subtext,
    isChecked: isChecked,
    disabled: disabled,
    error: !isChecked && error,
    isAccordionOpen: isAccordionOpen
  }, React$2.createElement(HiddenRadioButton, {
    checked: isChecked,
    disabled: disabled,
    onChange: onChange,
    value: value,
    name: name,
    "data-testid": "hidden-radio-button"
  }), React$2.createElement(IconWrapper$4, {
    isChecked: isChecked,
    disabled: disabled
  }, React$2.createElement(Icon, {
    icon: !isChecked ? 'MdRadioButtonUnchecked' : 'MdRadioButtonChecked',
    size: "1.3em",
    color: !isChecked ? theme.colors.sinbad : theme.colors.white
  })), !subtext && React$2.createElement(RadioButtonLabel, {
    isChecked: isChecked,
    disabled: disabled,
    "data-testid": "radio-button-label"
  }, label), subtext && React$2.createElement(RadioButtonSubtextWrapper, null, React$2.createElement(RadioButtonLabel, {
    isChecked: isChecked,
    disabled: disabled,
    "data-testid": "radio-button-label"
  }, label), React$2.createElement(RadioButtonSubtext, {
    disabled: disabled,
    "data-testid": "radio-button-sublabel"
  }, subtext))), accordionContent && accordionTransition.map(function (_ref2) {
    var item = _ref2.item,
        key = _ref2.key,
        props = _ref2.props;
    return item && React$2.createElement(AccordionWrapper$1, {
      style: props,
      key: key
    }, React$2.createElement(AccordionInner$1, {
      ref: accordionInnerRef
    }, accordionContent));
  }));
}

RadioButton.propTypes = {
  isChecked: PropTypes.bool,
  onChange: PropTypes.func,
  value: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
  error: PropTypes.bool,
  subtext: PropTypes.string,
  disabled: PropTypes.bool,
  accordionContent: PropTypes.element,
  isAccordionOpen: PropTypes.bool
};
RadioButton.defaultProps = {
  checked: false,
  error: false,
  disabled: false
};

function _templateObject9$3() {
  var data = _taggedTemplateLiteral(["\n  border: 0;\n  clip: rect(0 0 0 0);\n  clippath: inset(50%);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  white-space: nowrap;\n  width: 1px;\n"]);

  _templateObject9$3 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8$3() {
  var data = _taggedTemplateLiteral(["\n  padding-top: ", ";\n  padding-left: ", ";\n  padding-right: ", ";\n  width: 458px;\n"]);

  _templateObject8$3 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7$4() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  margin-bottom: ", ";\n"]);

  _templateObject7$4 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$5() {
  var data = _taggedTemplateLiteral(["\n  transition: ", ";\n  text-transform: uppercase;\n  color: ", ";\n\n  ", ":hover & {\n    color: ", ";\n  }\n"]);

  _templateObject6$5 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$6() {
  var data = _taggedTemplateLiteral(["\n  ", "\n\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 2.625em;\n  width: 13.875rem;\n  background-color: ", ";\n  border-radius: 1.313em;\n  border: 1px solid\n    ", ";\n  cursor: pointer;\n  user-select: none;\n  transition: ", ";\n  margin: 0 0.125em;\n  user-select: none;\n\n  &:hover {\n    background-color: ", ";\n  }\n\n  ", "\n"]);

  _templateObject5$6 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$7() {
  var data = _taggedTemplateLiteral(["\n  cursor: not-allowed;\n\n  &:hover {\n    background-color: ", ";\n  }\n"]);

  _templateObject4$7 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$7() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border: 1px solid ", ";\n  display: flex;\n  justify-content: flex-start;\n  flex-direction: row;\n  align-items: center;\n  height: 3.125em;\n  border-radius: 1.875em;\n  cursor: pointer;\n  user-select: none;\n  padding: 0 0.125em;\n\n  ", "\n"]);

  _templateObject3$7 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$a() {
  var data = _taggedTemplateLiteral(["\n  border-color: ", ";\n"]);

  _templateObject2$a = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$e() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n\n  @media ", " {\n    display: block;\n  }\n"]);

  _templateObject$e = function _templateObject() {
    return data;
  };

  return data;
}

var StyledSegmentedControlContainer = styled.div(_templateObject$e(), function (props) {
  return props.theme.BREAKPOINTS.MOBILE_DOWN;
});

var errorStyle$2 = function errorStyle(props) {
  return css(_templateObject2$a(), props.theme.colors.red);
};

var StyledSegmentedControl = styled.div(_templateObject3$7(), function (props) {
  return props.theme.colors.lightGrey;
}, function (props) {
  return props.theme.colors.lightGrey;
}, function (props) {
  return props.error && errorStyle$2(props);
});

var disabledStyle$5 = function disabledStyle(props) {
  return css(_templateObject4$7(), props.theme.colors.grey);
};

var SegmentedControlContainer = styled.label(_templateObject5$6(), function (props) {
  return RippleStyle();
}, function (props) {
  return !props.checked ? props.theme.colors.light_grey : props.theme.colors.charcoal;
}, function (props) {
  return props.defaultOption && !props.disabled ? props.theme.colors.white : props.theme.colors.lightGrey;
}, function (props) {
  return props.theme.transitions.baseTransition;
}, function (props) {
  return !props.checked ? props.theme.colors.red : props.theme.colors.charcoal;
}, function (props) {
  return props.disabled && disabledStyle$5(props);
});
var SegmentLabel = styled.span(_templateObject6$5(), function (props) {
  return props.theme.transitions.baseTransition;
}, function (props) {
  return !props.checked ? props.theme.colors.charcoal : props.theme.colors.white;
}, SegmentedControlContainer, function (props) {
  return props.theme.colors.white;
});
var SegmentedControlLabel = styled(Label)(_templateObject7$4(), function (props) {
  return props.theme.gutters[8];
});
var Validation$2 = styled(ValidationMessage)(_templateObject8$3(), function (props) {
  return props.theme.gutters[8];
}, function (props) {
  return props.theme.gutters[12];
}, function (props) {
  return props.theme.gutters[12];
});
var HiddenRadio = styled.input.attrs({
  type: 'radio'
})(_templateObject9$3());

function SegmentedControl(props) {
  var segments = props.segments,
      defaultOption = props.defaultOption,
      error = props.error,
      errorMessage = props.errorMessage,
      disabled = props.disabled,
      _onChange = props.onChange,
      label = props.label,
      value = props.value,
      name = props.name;

  var _useState = useState(value ? value : ''),
      _useState2 = _slicedToArray(_useState, 2),
      selectedOption = _useState2[0],
      setSelectedOption = _useState2[1];

  useEffect(function () {
    setSelectedOption(value);
  }, [value]);
  return React$2.createElement("div", null, React$2.createElement(StyledSegmentedControlContainer, {
    "data-form-field-name": name,
    "data-has-form-field-error": !!error
  }, label && React$2.createElement(SegmentedControlLabel, null, label), React$2.createElement(StyledSegmentedControl, {
    error: error && !selectedOption
  }, segments.map(function (segment) {
    return React$2.createElement(SegmentedControlContainer, {
      key: segment,
      checked: selectedOption === segment,
      disabled: disabled,
      defaultOption: defaultOption === segment && selectedOption === ''
    }, React$2.createElement(HiddenRadio, {
      name: name,
      value: segment,
      checked: selectedOption === segment,
      disabled: disabled,
      onChange: function onChange(event) {
        var val = _onChange(event);

        if (val !== false) {
          setSelectedOption(event.target.value);
        }
      },
      "data-testid": "segment-radio"
    }), React$2.createElement(SegmentLabel, {
      checked: selectedOption === segment,
      "data-testid": "segment-label"
    }, segment));
  })), error && errorMessage && !selectedOption && React$2.createElement(Validation$2, {
    showIcon: true
  }, errorMessage)));
}

SegmentedControl.propTypes = {
  segments: PropTypes.array.isRequired,
  defaultOption: PropTypes.string,
  error: PropTypes.bool,
  errorMessage: PropTypes.string,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  label: PropTypes.string,
  value: PropTypes.string,
  name: PropTypes.string
};
SegmentedControl.defaultProps = {
  error: false,
  disabled: false,
  onChange: function onChange() {},
  value: ''
};

function _templateObject$f() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  padding-left: ", ";\n\n  &:before {\n    height: 100%;\n    background-color: red;\n    content: '';\n    width: 4px;\n    position: absolute;\n    left: 0;\n    top: -1px;\n  }\n\n  h3 {\n    line-height: 1.25;\n    margin-bottom: 0;\n    text-transform: capitalize;\n    color: ", ";\n  }\n\n  p {\n    margin-top: 0.5em;\n    line-height: 1.5;\n  }\n"]);

  _templateObject$f = function _templateObject() {
    return data;
  };

  return data;
}

var StyledIndent = styled.div(_templateObject$f(), function (props) {
  return props.gutter;
}, function (props) {
  return props.theme.colors.black;
});

function Indent(props) {
  var gutter = props.gutter,
      children = props.children,
      rest = _objectWithoutProperties(props, ["gutter", "children"]);

  return React$2.createElement(StyledIndent, _extends({
    gutter: gutter
  }, rest), children);
}

Indent.propTypes = {
  gutter: PropTypes.string,
  children: PropTypes.node.isRequired
};
Indent.defaultProps = {
  gutter: '1.000rem'
};

function _templateObject10$3() {
  var data = _taggedTemplateLiteral(["\n  margin-top: ", ";\n  margin-left: 1em;\n"]);

  _templateObject10$3 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9$4() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  font-weight: ", ";\n  margin-top: ", ";\n  margin-left: 1em;\n  font-size: ", ";\n  display: block;\n  letter-spacing: 0.5px;\n"]);

  _templateObject9$4 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8$4() {
  var data = _taggedTemplateLiteral(["\n  margin-left: 8px;\n  margin-right: -6px;\n  line-height: 10px;\n"]);

  _templateObject8$4 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7$5() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n"]);

  _templateObject7$5 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$6() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject6$6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$7() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject5$7 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$8() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject4$8 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$8() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject3$8 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$b() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  display: block;\n  width: 100%;\n  height: 1px;\n  transition: ", ";\n  ", "\n\n  &:before,\n  &:after {\n    content: '';\n    height: 2px;\n    width: 0;\n    position: absolute;\n    background: ", ";\n    transition: ", ";\n  }\n\n  &:before {\n    left: 50%;\n  }\n\n  &:after {\n    right: 50%;\n  }\n"]);

  _templateObject2$b = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$g() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", " !important;\n"]);

  _templateObject$g = function _templateObject() {
    return data;
  };

  return data;
}

var styles = {
  container: function container(provided, state) {
    return _objectSpread2({}, provided, {
      '+ div': {
        '&:before': {
          width: state.isFocused ? '50%' : '0'
        },
        '&:after': {
          width: state.isFocused ? '50%' : '0'
        },
        backgroundColor: state.hasValue ? theme.colors.charcoal : theme.colors.darkGrey
      }
    });
  },
  control: function control(provided, state) {
    return {
      display: 'flex',
      alignItems: 'center',
      transition: theme.transitions.baseTransition,
      width: '100%',
      height: state.getValue().length > 1 ? 'auto' : '49px',
      padding: state.isMulti && state.hasValue ? '7px 12px 6px' : '14px 12px 13px'
    };
  },
  menuList: function menuList(provided) {
    return _objectSpread2({}, provided, {
      padding: 0
    });
  },
  menu: function menu(provided) {
    return _objectSpread2({}, provided, {
      borderRadius: '4px',
      boxShadow: '0 0 10px 0 rgba(0, 0, 0, 0.08)',
      backgroundColor: theme.colors.white
    });
  },
  valueContainer: function valueContainer(provided) {
    return _objectSpread2({}, provided, {
      padding: 0
    });
  },
  option: function option(provided, state) {
    var defaultStyles = {
      cursor: 'pointer',
      fontSize: theme.fontSize[16],
      padding: "15px 20px 14px"
    };
    var selectedStyles = {
      color: theme.colors.blue,
      backgroundColor: theme.colors.lightGrey,
      fontWeight: theme.fontWeight.medium,
      borderLeft: '4px solid ' + theme.colors.red,
      paddingLeft: '28px'
    };

    if (state.isSelected || state.isFocused) {
      return _objectSpread2({}, defaultStyles, {}, selectedStyles);
    }

    return _objectSpread2({}, defaultStyles, {
      '&:hover': _objectSpread2({}, selectedStyles)
    });
  },
  input: function input(provided) {
    return _objectSpread2({}, provided, {
      margin: 0,
      padding: 0
    });
  },
  dropdownIndicator: function dropdownIndicator(provided, state) {
    return _objectSpread2({}, provided, {
      color: state.selectProps.focused ? theme.colors.blue : theme.colors.charcoal,
      transform: state.selectProps.menuIsOpen && !state.selectProps.error ? 'rotate(180deg)' : 'none',
      '&:hover': {
        color: state.selectProps.focused ? theme.colors.blue : theme.colors.charcoal
      }
    });
  },
  clearIndicator: function clearIndicator(provided) {
    return _objectSpread2({}, provided, {
      color: theme.colors.grey,
      '&:hover': {
        color: theme.colors.grey
      }
    });
  },
  placeholder: function placeholder(provided) {
    return _objectSpread2({}, provided, {
      color: theme.colors.darkGrey,
      margin: '0'
    });
  },
  indicatorSeparator: function indicatorSeparator() {
    return {
      display: 'none'
    };
  },
  indicatorsContainer: function indicatorsContainer(provided) {
    return _objectSpread2({}, provided, {
      div: {
        padding: 0
      }
    });
  },
  loadingMessage: function loadingMessage(provided) {
    return _objectSpread2({}, provided, {
      padding: "9px 20px 8px",
      display: 'flex',
      justifyContent: 'center'
    });
  },
  noOptionsMessage: function noOptionsMessage(provided) {
    return _objectSpread2({}, provided, {
      fontSize: theme.fontSize[16],
      padding: "15px 20px 14px",
      color: theme.colors.darkGrey
    });
  },
  singleValue: function singleValue(provided) {
    return _objectSpread2({}, provided, {
      marginLeft: 0
    });
  },
  group: function group(provided) {
    return _objectSpread2({}, provided, {
      padding: '0'
    });
  },
  groupHeading: function groupHeading(provided) {
    return _objectSpread2({}, provided, {
      color: theme.colors.sinbad,
      padding: '16px 0 8px 20px',
      margin: '0'
    });
  },
  multiValue: function multiValue(provided) {
    return _objectSpread2({}, provided, {
      backgroundColor: theme.colors.white
    });
  },
  multiValueLabel: function multiValueLabel(provided) {
    return _objectSpread2({}, provided, {
      color: theme.colors.white,
      backgroundColor: theme.colors.blue,
      borderTopLeftRadius: '8px',
      borderTopRightRadius: '0',
      borderBottomLeftRadius: '8px',
      borderBottomRightRadius: '0',
      fontSize: '14px',
      height: '32px',
      lineHeight: '27px',
      paddingLeft: '12px'
    });
  },
  multiValueRemove: function multiValueRemove(provided) {
    return _objectSpread2({}, provided, {
      color: theme.colors.white,
      backgroundColor: theme.colors.blue,
      borderTopLeftRadius: 0,
      borderTopRightRadius: '8px',
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: '8px',
      paddingLeft: '8px',
      paddingRight: '12px',
      '&:hover': {
        color: theme.colors.sinbad,
        backgroundColor: theme.colors.blue
      }
    });
  }
};

var bottomBarErrorStyles = function bottomBarErrorStyles(props) {
  return css(_templateObject$g(), props.theme.colors.red);
};

var BottomBar$1 = styled.div(_templateObject2$b(), function (props) {
  return props.theme.transitions.baseTransition;
}, function (props) {
  return props.error && bottomBarErrorStyles(props);
}, function (props) {
  return props.theme.colors.blue;
}, function (props) {
  return props.theme.transitions.baseTransition;
});
var StyledSelect = styled(Select)(_templateObject3$8());
var StyledAsyncSelect = styled(AsyncSelect)(_templateObject4$8());
var StyledCreatableSelect = styled(CreatableSelect)(_templateObject5$7());
var StyledAsyncCreatableSelect = styled(AsyncCreatableSelect)(_templateObject6$6());
var StyledControlWrapper = styled.div(_templateObject7$5());
var StyledIconContainer = styled.div(_templateObject8$4());
var AssistiveMessage$1 = styled.span(_templateObject9$4(), function (props) {
  return props.theme.colors.charcoal;
}, function (props) {
  return props.theme.fontWeight.medium;
}, function (props) {
  return props.theme.gutters[8];
}, function (props) {
  return props.theme.fontSize[11];
});
var Validation$3 = styled(ValidationMessage)(_templateObject10$3(), function (props) {
  return props.theme.gutters[8];
});

var Control = function Control(props) {
  return React$2.createElement(React$2.Fragment, null, React$2.createElement(Label, {
    activated: props.isFocused || props.hasValue,
    error: props.error,
    "data-testid": "select-label"
  }, props.label), React$2.createElement(StyledControlWrapper, null, props.showSearchIcon && React$2.createElement(StyledIconContainer, null, ' ', React$2.createElement(Icon, {
    icon: 'MdSearch',
    size: "22px"
  })), React$2.createElement(components.Control, props)));
};

Control.propTypes = {
  isFocused: PropTypes.bool,
  hasValue: PropTypes.bool,
  error: PropTypes.bool,
  label: PropTypes.string,
  showSearchIcon: PropTypes.bool
};

var DropdownIndicator = function DropdownIndicator(props) {
  return !props.isSearchable && React$2.createElement(components.DropdownIndicator, props, props.error && React$2.createElement(Icon, {
    icon: 'MdError',
    size: "22px",
    color: theme.colors.red
  }), !props.error && React$2.createElement(Icon, {
    icon: 'MdExpandMore',
    size: "22px"
  }));
};

DropdownIndicator.propTypes = {
  error: PropTypes.bool,
  isSearchable: PropTypes.bool
};

var ClearIndicator = function ClearIndicator(props) {
  return props.isClearable && React$2.createElement(components.ClearIndicator, props, React$2.createElement(Icon, {
    icon: 'MdClear',
    size: "18px",
    color: props.error ? theme.colors.red : theme.colors.black
  }));
};

ClearIndicator.propTypes = {
  error: PropTypes.bool,
  isClearable: PropTypes.bool
};

var MultiValueRemove = function MultiValueRemove(props) {
  return React$2.createElement(components.MultiValueRemove, props, React$2.createElement(Icon, {
    icon: 'MdClear',
    size: "16px",
    color: theme.colors.white
  }));
};

MultiValueRemove.propTypes = {
  error: PropTypes.bool,
  isClearable: PropTypes.bool
};

function SelectComponent(props) {
  var placeholder = props.placeholder,
      label = props.label,
      options = props.options,
      isSearchable = props.isSearchable,
      showSearchIcon = props.showSearchIcon,
      isCreatable = props.isCreatable,
      assistiveMessage = props.assistiveMessage,
      onChange = props.onChange,
      isClearable = props.isClearable,
      value = props.value,
      name = props.name,
      id = props.id,
      error = props.error,
      errorMessage = props.errorMessage,
      isMulti = props.isMulti;

  var CapitalizeFirstLetterOfWords = function CapitalizeFirstLetterOfWords(value) {
    // return value.slice(0, 1).toUpperCase() + value.slice(1, value.length);
    return value.toLowerCase().split(' ').map(function (s) {
      return s.charAt(0).toUpperCase() + s.substring(1);
    }).join(' ');
  };

  var handleChange = function handleChange(value, action) {
    if (action.action === 'create-option') {
      var capitalizedValue = CapitalizeFirstLetterOfWords(value.value);
      value.label = capitalizedValue;
    }

    onChange({
      action: action,
      value: value
    });
  };

  return React$2.createElement("div", {
    "data-form-field-name": name,
    "data-has-form-field-error": !!error
  }, !isCreatable && React$2.createElement(Select, {
    name: name,
    id: id,
    isClearable: isClearable,
    placeholder: placeholder,
    options: options,
    styles: styles,
    defaultValue: value,
    isSearchable: isSearchable,
    onChange: function onChange(value, action) {
      return handleChange(value, action);
    },
    blurInputOnSelect: true,
    noOptionsMessage: function noOptionsMessage() {
      return 'No results found';
    },
    isMulti: isMulti,
    components: {
      Control: function Control$1(selectProps) {
        return React$2.createElement(Control, _extends({}, selectProps, {
          showSearchIcon: showSearchIcon,
          label: label,
          error: error
        }));
      },
      DropdownIndicator: function DropdownIndicator$1(selectProps) {
        return React$2.createElement(DropdownIndicator, _extends({}, selectProps, {
          error: error
        }));
      },
      ClearIndicator: function ClearIndicator$1(selectProps) {
        return React$2.createElement(ClearIndicator, _extends({}, selectProps, {
          isClearable: isClearable,
          error: error
        }));
      },
      MultiValueRemove: function MultiValueRemove$1(selectProps) {
        return React$2.createElement(MultiValueRemove, selectProps);
      }
    },
    error: error
  }), isCreatable && React$2.createElement(CreatableSelect, {
    name: name,
    id: id,
    isClearable: isClearable,
    placeholder: placeholder,
    options: options,
    styles: styles,
    defaultValue: value,
    isSearchable: true,
    onChange: function onChange(value, action) {
      return handleChange(value, action);
    },
    blurInputOnSelect: true,
    noOptionsMessage: function noOptionsMessage() {
      return 'No results found';
    },
    components: {
      Control: function Control$1(selectProps) {
        return React$2.createElement(Control, _extends({}, selectProps, {
          showSearchIcon: showSearchIcon,
          label: label,
          error: error
        }));
      },
      DropdownIndicator: function DropdownIndicator$1(selectProps) {
        return React$2.createElement(DropdownIndicator, _extends({}, selectProps, {
          error: error
        }));
      },
      ClearIndicator: function ClearIndicator$1(selectProps) {
        return React$2.createElement(ClearIndicator, _extends({}, selectProps, {
          isClearable: isClearable,
          error: error
        }));
      }
    },
    error: error,
    formatCreateLabel: function formatCreateLabel(value) {
      return React$2.createElement("span", {
        style: {
          color: theme.colors.blue
        }
      }, "Create ", React$2.createElement("strong", null, "\"", value, "\""));
    }
  }), React$2.createElement(BottomBar$1, {
    error: error
  }), error && errorMessage && React$2.createElement(Validation$3, null, errorMessage), !error && !errorMessage && React$2.createElement(AssistiveMessage$1, null, assistiveMessage));
}

SelectComponent.propTypes = {
  placeholder: PropTypes.string,
  label: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired
  })).isRequired,
  isSearchable: PropTypes.bool,
  showSearchIcon: PropTypes.bool,
  isCreatable: PropTypes.bool,
  assistiveMessage: PropTypes.string,
  onChange: PropTypes.func,
  isClearable: PropTypes.bool,
  value: PropTypes.object,
  name: PropTypes.string,
  id: PropTypes.string,
  error: PropTypes.bool,
  errorMessage: PropTypes.string,
  isMulti: PropTypes.bool
};
SelectComponent.defaultProps = {
  placeholder: 'Select',
  isSearchable: false,
  showSearchIcon: false,
  isCreatable: false,
  assistiveMessage: '',
  onChange: function onChange() {},
  isClearable: true,
  value: null,
  error: false,
  isMulti: false
};

var LoadingMessage = function LoadingMessage(props) {
  return React$2.createElement(components.LoadingMessage, props, React$2.createElement(Loader, {
    color: "red",
    size: "30px",
    trackWidth: "3px"
  }));
};

function AsyncSelectComponent(props) {
  var placeholder = props.placeholder,
      label = props.label,
      options = props.options,
      cacheOptions = props.cacheOptions,
      defaultOptions = props.defaultOptions,
      isClearable = props.isClearable,
      onChange = props.onChange,
      value = props.value,
      name = props.name,
      id = props.id,
      error = props.error,
      errorMessage = props.errorMessage,
      isCreatable = props.isCreatable,
      showSearchIcon = props.showSearchIcon,
      isMulti = props.isMulti;

  var CapitalizeFirstLetterOfWords = function CapitalizeFirstLetterOfWords(value) {
    // return value.slice(0, 1).toUpperCase() + value.slice(1, value.length);
    return value.toLowerCase().split(' ').map(function (s) {
      return s.charAt(0).toUpperCase() + s.substring(1);
    }).join(' ');
  };

  var handleChange = function handleChange(value, action) {
    if (action.action === 'create-option') {
      var capitalizedValue = CapitalizeFirstLetterOfWords(value.value);
      value.label = capitalizedValue;
    }

    onChange({
      action: action,
      value: value
    });
  };

  return React$2.createElement("div", {
    "data-form-field-name": name,
    "data-has-form-field-error": !!error
  }, !isCreatable && React$2.createElement(AsyncSelect, {
    name: name,
    id: id,
    isClearable: isClearable,
    cacheOptions: cacheOptions,
    defaultOptions: defaultOptions,
    loadOptions: options,
    placeholder: placeholder,
    styles: styles,
    defaultValue: value,
    onChange: function onChange(value, action) {
      return handleChange(value, action);
    },
    blurInputOnSelect: true,
    noOptionsMessage: function noOptionsMessage() {
      return placeholder;
    },
    isMulti: isMulti,
    components: {
      Control: function Control$1(selectProps) {
        return React$2.createElement(Control, _extends({}, selectProps, {
          showSearchIcon: showSearchIcon,
          label: label,
          error: error
        }));
      },
      ClearIndicator: function ClearIndicator$1(selectProps) {
        return React$2.createElement(ClearIndicator, _extends({}, selectProps, {
          isClearable: isClearable,
          error: error
        }));
      },
      MultiValueRemove: function MultiValueRemove$1(selectProps) {
        return React$2.createElement(MultiValueRemove, selectProps);
      },
      LoadingMessage: function LoadingMessage$1(selectProps) {
        return React$2.createElement(LoadingMessage, selectProps);
      },
      DropdownIndicator: null,
      LoadingIndicator: null
    }
  }), isCreatable && React$2.createElement(AsyncCreatableSelect, {
    name: name,
    id: id,
    isClearable: isClearable,
    cacheOptions: cacheOptions,
    defaultOptions: defaultOptions,
    loadOptions: options,
    placeholder: placeholder,
    styles: styles,
    defaultValue: value,
    onChange: function onChange(value, action) {
      return handleChange(value, action);
    },
    blurInputOnSelect: true,
    noOptionsMessage: function noOptionsMessage() {
      return placeholder;
    },
    components: {
      Control: function Control$1(selectProps) {
        return React$2.createElement(Control, _extends({}, selectProps, {
          showSearchIcon: showSearchIcon,
          label: label,
          error: error
        }));
      },
      ClearIndicator: function ClearIndicator$1(selectProps) {
        return React$2.createElement(ClearIndicator, _extends({}, selectProps, {
          isClearable: isClearable,
          error: error
        }));
      },
      LoadingMessage: function LoadingMessage$1(selectProps) {
        return React$2.createElement(LoadingMessage, selectProps);
      },
      DropdownIndicator: null,
      LoadingIndicator: null
    },
    formatCreateLabel: function formatCreateLabel(value) {
      return React$2.createElement("span", {
        style: {
          color: theme.colors.blue
        }
      }, "Create ", React$2.createElement("strong", null, "\"", value, "\""));
    }
  }), React$2.createElement(BottomBar$1, {
    error: error
  }), error && errorMessage && React$2.createElement(Validation$3, null, errorMessage));
}

AsyncSelectComponent.propTypes = {
  placeholder: PropTypes.string,
  label: PropTypes.string,
  options: PropTypes.func.isRequired,
  cacheOptions: PropTypes.bool,
  defaultOptions: PropTypes.bool,
  isClearable: PropTypes.bool,
  onChange: PropTypes.func,
  value: PropTypes.object,
  name: PropTypes.string,
  id: PropTypes.string,
  error: PropTypes.bool,
  errorMessage: PropTypes.string,
  isCreatable: PropTypes.bool,
  showSearchIcon: PropTypes.bool,
  isMulti: PropTypes.bool
};
AsyncSelectComponent.defaultProps = {
  placeholder: 'Select',
  cacheOptions: true,
  defaultOptions: false,
  isClearable: true,
  onChange: function onChange() {},
  value: null,
  error: false,
  isCreatable: false,
  showSearchIcon: false,
  isMulti: false
};

function _templateObject6$7() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 10px;\n  margin-top: 1em;\n"]);

  _templateObject6$7 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$8() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject5$8 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$9() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  margin-top: 20px;\n"]);

  _templateObject4$9 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$9() {
  var data = _taggedTemplateLiteral(["\n  top: 0;\n  bottom: 0;\n  border: 2px solid ", ";\n  background: ", ";\n  border-radius: 999px;\n"]);

  _templateObject3$9 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$c() {
  var data = _taggedTemplateLiteral(["\n  width: 2px;\n  height: 16px;\n  border-radius: 1px;\n  margin: 0 1px;\n  background-color: ", ";\n"]);

  _templateObject2$c = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$h() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 2em;\n  width: 2em;\n  line-height: 2em;\n  text-align: center;\n  background-color: ", ";\n  color: black;\n  border-radius: 50%;\n  box-shadow: 0 2px 4px 0 rgba(140, 140, 140, 0.3),\n    0 -2px 4px 0 rgba(140, 140, 140, 0.2);\n  cursor: grab;\n  outline: 0;\n  margin-top: -10px;\n  z-index: 0 !important;\n"]);

  _templateObject$h = function _templateObject() {
    return data;
  };

  return data;
}

var StyledThumb = styled.div(_templateObject$h(), function (props) {
  return props.theme.colors.white;
});
var StyledKnob = styled.div(_templateObject2$c(), function (props) {
  return props.theme.colors.lightGrey;
});
var StyledTrack = styled.div(_templateObject3$9(), function (props) {
  return props.theme.colors[props.color];
}, function (props) {
  return props.index === 1 ? props.theme.colors[props.color] : props.theme.colors.white;
});
var StyledLabelContainer = styled.div(_templateObject4$9());
var StyledLabel$1 = styled(Label)(_templateObject5$8());
var StyledSlider = styled(ReactSlider)(_templateObject6$7());

function Slider(props) {
  var defaultValue = props.defaultValue,
      minValue = props.minValue,
      maxValue = props.maxValue,
      step = props.step,
      onChange = props.onChange,
      showLabels = props.showLabels,
      color = props.color,
      value = props.value,
      unitLabel = props.unitLabel,
      id = props.id,
      name = props.name;

  var Track = function Track(props, state) {
    return React$2.createElement(StyledTrack, _extends({
      color: color
    }, props, {
      index: state.index
    }));
  };

  var Thumb = function Thumb(props) {
    return React$2.createElement(StyledThumb, props, React$2.createElement(StyledKnob, null), React$2.createElement(StyledKnob, null));
  };

  return React$2.createElement(React$2.Fragment, null, React$2.createElement(StyledSlider, {
    "data-form-field-name": name,
    defaultValue: defaultValue,
    min: minValue,
    max: maxValue,
    step: step,
    renderTrack: Track,
    renderThumb: Thumb,
    onChange: onChange,
    value: value,
    id: id,
    name: name
  }), showLabels && React$2.createElement(StyledLabelContainer, null, React$2.createElement(StyledLabel$1, null, "".concat(minValue, " ").concat(unitLabel)), React$2.createElement(StyledLabel$1, null, "".concat(maxValue, " ").concat(unitLabel))));
}

Slider.propTypes = {
  defaultValue: PropTypes.number,
  minValue: PropTypes.number,
  maxValue: PropTypes.number,
  step: PropTypes.number,
  value: PropTypes.number,
  onChange: PropTypes.func,
  showLabels: PropTypes.bool,
  unitLabel: PropTypes.string,
  color: PropTypes.oneOf(['red', 'charcoal', 'blue', 'sinbad', 'scandal', 'white', 'black', 'lightGrey', 'grey', 'darkGrey', 'butter', 'amber', 'rust', 'apple', 'wasabi', 'palmLeaf', 'fireEngine', 'bunker']),
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired
};
Slider.defaultProps = {
  defaultValue: 0,
  minValue: 0,
  maxValue: 100,
  step: 1,
  showLabels: true,
  color: 'wasabi',
  value: 0,
  unitLabel: '%',
  id: '',
  name: ''
};

function _templateObject7$6() {
  var data = _taggedTemplateLiteral(["\n  border: none;\n  color: ", ";\n  max-width: 3.125rem;\n  font-size: 1.5rem;\n  &:focus {\n    outline: 0;\n  }\n  background-color: transparent;\n"]);

  _templateObject7$6 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$8() {
  var data = _taggedTemplateLiteral(["\n  height: 1.375em;\n  align-self: flex-end;\n  color: ", ";\n  margin-bottom: 0.125em;\n  ", "\n"]);

  _templateObject6$8 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$9() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  margin-right: ", ";\n"]);

  _templateObject5$9 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$a() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-content: space-between;\n  align-items: center;\n"]);

  _templateObject4$a = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$a() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject3$a = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$d() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n"]);

  _templateObject2$d = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$i() {
  var data = _taggedTemplateLiteral(["\n  cursor: pointer;\n"]);

  _templateObject$i = function _templateObject() {
    return data;
  };

  return data;
}

var iconCursorStyle$1 = function iconCursorStyle() {
  return css(_templateObject$i());
};

var StyledContainer = styled.div(_templateObject2$d());
var StyledKeyboardSlider = styled(Slider)(_templateObject3$a());
var StyledKeyboardContainer = styled.div(_templateObject4$a());
var StyledKeyboardInputContainer = styled.div(_templateObject5$9(), function (props) {
  return props.theme.gutters[20];
});
var IconWrapper$5 = styled.div(_templateObject6$8(), function (props) {
  return props.theme.colors.charcoal;
}, function (props) {
  return props.onClick && iconCursorStyle$1();
});
var StyledInput = styled.input(_templateObject7$6(), function (props) {
  return props.theme.colors[props.color];
});

function useOnClickOutside(ref, handler) {
  useEffect(function () {
    var listener = function listener(event) {
      // Do nothing if clicking ref's element or descendent elements
      if (!ref.current || ref.current.contains(event.target)) {
        return;
      }

      handler(event);
    };

    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);
    return function () {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [ref, handler]);
}

function KeyboardSlider(props) {
  var defaultValue = props.defaultValue,
      minValue = props.minValue,
      maxValue = props.maxValue,
      step = props.step,
      onChange = props.onChange,
      showLabels = props.showLabels,
      color = props.color,
      unitLabel = props.unitLabel,
      id = props.id,
      name = props.name;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      inputVisible = _useState2[0],
      setInputVisible = _useState2[1];

  var _useState3 = useState(defaultValue),
      _useState4 = _slicedToArray(_useState3, 2),
      sliderValue = _useState4[0],
      setSliderValue = _useState4[1];

  var onSliderChange = function onSliderChange(value) {
    if (onChange) {
      onChange(value);
    }

    if (!isNaN(value)) {
      setSliderValue(value);
    }
  };

  var onInputChange = function onInputChange(event) {
    var value = event.target.value;

    if (!isNaN(value)) {
      setSliderValue(value);
    }
  };

  var inputRef = useRef(null);
  var containerRef = useRef(null);
  useOnClickOutside(containerRef, function () {
    if (inputVisible) setInputVisible(!inputVisible);
  });
  return React$2.createElement("div", {
    ref: containerRef
  }, React$2.createElement(StyledContainer, null, React$2.createElement(StyledKeyboardContainer, null, React$2.createElement(StyledKeyboardInputContainer, null, React$2.createElement(React$2.Fragment, null, React$2.createElement(StyledInput, {
    value: sliderValue,
    onChange: function onChange(e) {
      return onInputChange(e);
    },
    type: "tel",
    color: color,
    ref: inputRef
  }), React$2.createElement(Heading, {
    level: 3,
    color: color
  }, unitLabel))), React$2.createElement(IconWrapper$5, {
    onClick: function onClick() {
      setInputVisible(!inputVisible);
      if (!inputVisible) inputRef.current.focus();
    }
  }, React$2.createElement(Icon, {
    icon: "MdKeyboard",
    size: '22px',
    color: inputVisible ? theme.colors[color] : theme.colors.charcoal
  }))), React$2.createElement(StyledKeyboardSlider, {
    defaultValue: sliderValue,
    minValue: minValue,
    maxValue: maxValue,
    step: step,
    onChange: onSliderChange,
    showLabels: showLabels,
    color: color,
    value: sliderValue,
    unitLabel: unitLabel,
    id: id,
    name: name
  })));
}

KeyboardSlider.propTypes = {
  defaultValue: PropTypes.number,
  minValue: PropTypes.number,
  maxValue: PropTypes.number,
  step: PropTypes.number,
  onChange: PropTypes.func,
  showLabels: PropTypes.bool,
  unitLabel: PropTypes.string,
  color: PropTypes.oneOf(['red', 'charcoal', 'blue', 'sinbad', 'scandal', 'white', 'black', 'lightGrey', 'grey', 'darkGrey', 'butter', 'amber', 'rust', 'apple', 'wasabi', 'palmLeaf', 'fireEngine', 'bunker']),
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired
};
KeyboardSlider.defaultProps = {
  defaultValue: 0,
  minValue: 0,
  maxValue: 100,
  step: 1,
  showLabels: true,
  color: 'wasabi',
  unitLabel: '%',
  id: '',
  name: ''
};

function _templateObject4$b() {
  var data = _taggedTemplateLiteral(["\n  flex: 1;\n  padding: ", ";\n  border-radius: ", ";\n  font-weight: ", ";\n  font-size: ", ";\n  line-height: 21px;\n  box-shadow: 0 2px 0 0 rgba(0,0,0,0.04);\n\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject4$b = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$b() {
  var data = _taggedTemplateLiteral(["\n    color: ", ";\n    background: ", ";\n  "]);

  _templateObject3$b = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$e() {
  var data = _taggedTemplateLiteral(["\n    color: ", ";\n    background: ", ";\n  "]);

  _templateObject2$e = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$j() {
  var data = _taggedTemplateLiteral(["\n    color: ", ";\n    background: ", ";\n  "]);

  _templateObject$j = function _templateObject() {
    return data;
  };

  return data;
}

var baseStyles = function baseStyles(props) {
  var theme = props.theme;
  return css(_templateObject$j(), theme.colors.charcoal, theme.colors.lightGrey);
};

var successStyles = function successStyles(props) {
  var theme = props.theme;
  return css(_templateObject2$e(), theme.colors.palmLeaf, theme.colors.apple);
};

var warningStyles = function warningStyles(props) {
  var theme = props.theme;
  return css(_templateObject3$b(), theme.colors.rust, theme.colors.butter);
};

var StyledAlert = styled.div(_templateObject4$b(), function (props) {
  return props.theme.gutters[16];
}, function (props) {
  return props.theme.gutters[8];
}, function (props) {
  return props.theme.fontWeight.bold;
}, function (props) {
  return props.theme.fontSize[14];
}, function (props) {
  return !props.type && baseStyles(props);
}, function (props) {
  return props.type === 'success' && successStyles(props);
}, function (props) {
  return props.type === 'warning' && warningStyles(props);
});

function Alert(props) {
  var type = props.type,
      children = props.children;
  return React$2.createElement(StyledAlert, {
    type: type
  }, children);
}

Alert.propTypes = {
  type: PropTypes.oneOf(['success', 'warning']),
  children: PropTypes.string.isRequired
};

function _templateObject5$a() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: ", ";\n  line-height: 1.5em;\n  font-weight: ", ";\n  margin: ", " 0;\n\n  ", "\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject5$a = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$c() {
  var data = _taggedTemplateLiteral(["\n    font-size: 0.938em;\n    font-weight: ", ";\n    line-height: 1.125em;\n    text-transform: uppercase;\n  "]);

  _templateObject4$c = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$c() {
  var data = _taggedTemplateLiteral(["\n    font-weight: ", ";\n  "]);

  _templateObject3$c = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$f() {
  var data = _taggedTemplateLiteral(["\n    font-size: ", ";\n    line-height: 1.313em;\n  "]);

  _templateObject2$f = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$k() {
  var data = _taggedTemplateLiteral(["\n    font-size: ", ";\n    line-height: 1.313em;\n  "]);

  _templateObject$k = function _templateObject() {
    return data;
  };

  return data;
}

var smallStyles = function smallStyles(props) {
  var theme = props.theme;
  return css(_templateObject$k(), theme.fontSize[14]);
};

var tinyStyles = function tinyStyles(props) {
  var theme = props.theme;
  return css(_templateObject2$f(), theme.fontSize[13]);
};

var boldStyles = function boldStyles(props) {
  var theme = props.theme;
  return css(_templateObject3$c(), theme.fontWeight.bold);
};

var miscStyles = function miscStyles(props) {
  var theme = props.theme;
  return css(_templateObject4$c(), theme.fontWeight.bold);
};

var StyledText = styled.p(_templateObject5$a(), function (props) {
  return props.theme.colors[props.color];
}, function (props) {
  return props.theme.fontSize[16];
}, function (props) {
  return props.theme.fontWeight.regular;
}, function (props) {
  return props.theme.gutters[12];
}, function (props) {
  return props.appearance === 'small' && smallStyles(props);
}, function (props) {
  return props.appearance === 'tiny' && tinyStyles(props);
}, function (props) {
  return props.appearance === 'bold' && boldStyles(props);
}, function (props) {
  return props.appearance === 'misc' && miscStyles(props);
});
var APPEARANCES = {
  "default": 'default',
  tiny: 'tiny',
  small: 'small',
  bold: 'bold',
  misc: 'misc'
};

function Text(props) {
  var appearance = props.appearance,
      children = props.children,
      color = props.color,
      rest = _objectWithoutProperties(props, ["appearance", "children", "color"]);

  return React$2.createElement(StyledText, _extends({}, rest, {
    appearance: appearance,
    color: color
  }), children);
}

Text.propTypes = {
  children: PropTypes.node.isRequired,
  bold: PropTypes.bool,
  appearance: PropTypes.oneOf(Object.keys(APPEARANCES)),
  color: PropTypes.oneOf(['red', 'charcoal', 'blue', 'sinbad', 'scandal', 'white', 'black', 'lightGrey', 'grey', 'darkGrey', 'butter', 'amber', 'rust', 'apple', 'wasabi', 'palmLeaf', 'fireEngine', 'bunker'])
};
Text.defaultProps = {
  bold: false,
  appearance: 'default',
  color: 'black'
};

function _templateObject3$d() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: ", ";\n  z-index: 100;\n"]);

  _templateObject3$d = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$g() {
  var data = _taggedTemplateLiteral(["\n  z-index: 100;\n  padding-left: ", ";\n  padding-right: ", ";\n  padding-top: ", ";\n  padding-bottom: ", ";\n  margin: ", " 0;\n  max-width: ", "px;\n  background-color: white;\n  border-radius: ", ";\n  box-shadow: 0 6px 60px 0 rgba(0, 0, 0, 0.28);\n\n  @media ", " {\n    max-width: ", "px;\n    margin: ", ";\n  }\n"]);

  _templateObject2$g = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$l() {
  var data = _taggedTemplateLiteral(["\n  display: ", ";\n  justify-content: center;\n  align-items: center;\n  position: fixed;\n  top: 0;\n  z-index: 1000;\n  width: 100%;\n  height: 100%;\n"]);

  _templateObject$l = function _templateObject() {
    return data;
  };

  return data;
}

var MOBILE_WIDTH = 343;
var StyledModalContainer = styled.div(_templateObject$l(), function (props) {
  return props.isOpen ? 'flex' : 'none';
});
var StyledModal = styled(animated.div)(_templateObject2$g(), function (props) {
  return props.theme.gutters[24];
}, function (props) {
  return props.theme.gutters[24];
}, function (props) {
  return props.theme.gutters[40];
}, function (props) {
  return props.theme.gutters[40];
}, function (props) {
  return props.theme.gutters[60];
}, function (props) {
  return props.width;
}, function (props) {
  return props.theme.gutters[8];
}, function (props) {
  return props.theme.BREAKPOINTS.MOBILE_DOWN;
}, MOBILE_WIDTH, function (props) {
  return props.theme.gutters[16];
});
var Overlay = styled(animated.div)(_templateObject3$d(), function (props) {
  return props.theme.colors.bunker;
});

function Modal(props) {
  var children = props.children,
      width = props.width,
      height = props.height,
      isOpen = props.isOpen;

  var _useState = useState(undefined),
      _useState2 = _slicedToArray(_useState, 2),
      modalRoot = _useState2[0],
      setModalRoot = _useState2[1];

  useEffect(function () {
    setModalRoot(document.querySelector('#modal-root'));
    isOpen && (document.body.style.overflow = 'hidden');
    return function () {
      document.body.style.overflow = 'scroll';
    };
  }, [isOpen]);
  var overlayTransition = useTransition(isOpen, null, {
    from: {
      opacity: 0
    },
    enter: {
      opacity: 0.8
    },
    leave: {
      opacity: 0
    },
    trail: 100
  });
  var modalTransition = useTransition(isOpen, null, {
    from: {
      opacity: 1,
      transform: 'scale(0.95)'
    },
    enter: {
      opacity: 1,
      transform: 'scale(1)'
    },
    leave: {
      opacity: 0,
      transform: 'scale(0.95)'
    }
  });

  if (modalRoot === undefined) {
    return null;
  }

  return reactDom.createPortal(React$2.createElement(StyledModalContainer, {
    isOpen: isOpen
  }, overlayTransition.map(function (_ref) {
    var item = _ref.item,
        key = _ref.key,
        props = _ref.props;
    return item && React$2.createElement(Overlay, {
      style: props,
      key: key
    });
  }), modalTransition.map(function (_ref2) {
    var item = _ref2.item,
        key = _ref2.key,
        props = _ref2.props;
    return item && React$2.createElement(StyledModal, {
      key: key,
      style: props,
      role: "dialog",
      width: width,
      height: height
    }, children);
  })), modalRoot);
}

Modal.propTypes = {
  children: PropTypes.element,
  width: PropTypes.number,
  height: PropTypes.number,
  isOpen: PropTypes.bool
};
Modal.defaultProps = {
  children: '',
  width: 443,
  height: 340,
  isOpen: false
};

function _templateObject$m() {
  var data = _taggedTemplateLiteral(["\n  font-size: ", ";\n  letter-spacing: 1px;\n  font-weight: ", ";\n  line-height: 1.5;\n  text-transform: uppercase;\n"]);

  _templateObject$m = function _templateObject() {
    return data;
  };

  return data;
}

var StyledCaption = styled.span(_templateObject$m(), function (props) {
  return props.size === 'small' ? props.theme.fontSize[10] : props.theme.fontSize[12];
}, function (props) {
  return props.theme.fontWeight.medium;
});
var SIZES = {
  large: 'large',
  small: 'small'
};

function Caption(props) {
  var size = props.size,
      children = props.children;
  return React$2.createElement(StyledCaption, {
    size: size
  }, children);
}

Caption.propTypes = {
  size: PropTypes.oneOf(Object.keys(SIZES)),
  children: PropTypes.string.isRequired
};
Caption.defaultProps = {
  size: 'large',
  children: ''
};

function _templateObject2$h() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  margin-right: ", ";\n  position: relative;\n  top: 1px;\n"]);

  _templateObject2$h = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$n() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n"]);

  _templateObject$n = function _templateObject() {
    return data;
  };

  return data;
}

var StyledHint = styled.div(_templateObject$n());
var IconWrapper$6 = styled.div(_templateObject2$h(), function (props) {
  return props.theme.colors[props.color];
}, function (props) {
  return props.theme.gutters[4];
});
var controlColors = ['red', 'charcoal', 'blue', 'sinbad', 'scandal', 'white', 'black', 'lightGrey', 'grey', 'darkGrey', 'butter', 'amber', 'rust', 'apple', 'wasabi', 'palmLeaf', 'fireEngine', 'bunker'];

function Hint(props) {
  var children = props.children,
      icon = props.icon,
      iconSize = props.iconSize,
      iconColor = props.iconColor;
  return React$2.createElement(StyledHint, null, React$2.createElement(IconWrapper$6, {
    color: iconColor
  }, React$2.createElement(Icon, {
    icon: icon,
    size: iconSize
  })), React$2.createElement(Label, null, children));
}

Hint.propTypes = {
  children: PropTypes.string,
  icon: PropTypes.string,
  iconSize: PropTypes.string,
  iconColor: PropTypes.oneOf(controlColors)
};
Hint.defaultProps = {
  icon: 'MdInfoOutline',
  iconSize: '1.375em',
  iconColor: 'sinbad'
};

function _templateObject$o() {
  var data = _taggedTemplateLiteral(["\n  border-radius: ", ";\n  background: ", ";\n  padding: ", ";\n"]);

  _templateObject$o = function _templateObject() {
    return data;
  };

  return data;
}

var StyledCard = styled.div(_templateObject$o(), function (props) {
  return props.theme.gutters[8];
}, function (props) {
  return props.theme.colors[props.color];
}, function (props) {
  return props.theme.gutters[24];
});

function Card(props) {
  var color = props.color,
      children = props.children,
      rest = _objectWithoutProperties(props, ["color", "children"]);

  return React$2.createElement(StyledCard, _extends({
    color: color
  }, rest), children);
}

Card.propTypes = {
  color: PropTypes.oneOf(['red', 'charcoal', 'blue', 'sinbad', 'scandal', 'white', 'black', 'lightGrey', 'grey', 'darkGrey', 'butter', 'amber', 'rust', 'apple', 'wasabi', 'palmLeaf', 'fireEngine', 'bunker']),
  children: PropTypes.node.isRequired
};
Card.defaultProps = {
  color: 'lightGrey'
};

function _templateObject16$1() {
  var data = _taggedTemplateLiteral(["\n  margin-right: ", ";\n"]);

  _templateObject16$1 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15$1() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  width: ", ";\n"]);

  _templateObject15$1 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14$2() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n\n  button {\n    font-size: ", ";\n    font-weight: ", ";\n    margin-top: ", ";\n  }\n\n  @media ", " {\n    flex-direction: row-reverse;\n\n    button {\n      margin-left: ", ";\n      margin-right: ", ";\n      width: 162px;\n    }\n  }\n"]);

  _templateObject14$2 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13$2() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n"]);

  _templateObject13$2 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12$2() {
  var data = _taggedTemplateLiteral(["\n  background: ", ";\n  border-radius: 0.5rem;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 2px 0 0 rgba(0, 0, 0, 0.04);\n  margin-top: ", ";\n  padding: ", ";\n\n  @media ", " {\n    padding: ", ";\n  }\n\n  @media ", " {\n    padding: ", ";\n  }\n"]);

  _templateObject12$2 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11$2() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  background-color: transparent;\n  border: 0;\n  border-left: 1px solid ", ";\n  color: ", ";\n  display: flex;\n  align-items: center;\n  padding: 0 ", ";\n  cursor: pointer;\n  outline: 0;\n"]);

  _templateObject11$2 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10$4() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n"]);

  _templateObject10$4 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9$5() {
  var data = _taggedTemplateLiteral(["\n  margin: 0;\n"]);

  _templateObject9$5 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8$5() {
  var data = _taggedTemplateLiteral(["\n  margin: 0;\n"]);

  _templateObject8$5 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7$7() {
  var data = _taggedTemplateLiteral(["\n  margin: 8px 0 0.25rem;\n  font-size: ", ";\n  letter-spacing: 1px;\n"]);

  _templateObject7$7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$9() {
  var data = _taggedTemplateLiteral(["\n  margin: 0 0 0.25rem;\n  color: ", ";\n  text-transform: uppercase;\n  font-size: ", ";\n  letter-spacing: 1px;\n"]);

  _templateObject6$9 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$b() {
  var data = _taggedTemplateLiteral(["\n  padding: ", ";\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n"]);

  _templateObject5$b = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$d() {
  var data = _taggedTemplateLiteral(["\n  background: ", ";\n  border-radius: 0.5rem;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  box-shadow: 0 2px 0 0 rgba(0, 0, 0, 0.04);\n  margin-top: ", ";\n"]);

  _templateObject4$d = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$e() {
  var data = _taggedTemplateLiteral(["\n  margin: 0 auto;\n"]);

  _templateObject3$e = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$i() {
  var data = _taggedTemplateLiteral(["\n  margin: 0;\n  margin-top: ", ";\n  letter-spacing: 1;\n  line-height: 1.54;\n  text-align: center;\n  font-size: ", ";\n"]);

  _templateObject2$i = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$p() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject$p = function _templateObject() {
    return data;
  };

  return data;
}
/**
 * Interactive Card Styles
 */


var StyledInteractiveCard = styled(Card)(_templateObject$p());
var TitleText = styled(Text)(_templateObject2$i(), function (props) {
  return props.hideButton ? 0 : props.theme.gutters[24];
}, function (props) {
  return props.theme.fontSize[13];
});
var StyledPrimaryButton$1 = styled(PrimaryButton)(_templateObject3$e());
/**
 * Interactive Card Item Styles
 */

var StyledInteractiveCardItem = styled.div(_templateObject4$d(), function (props) {
  return props.theme.colors.white;
}, function (props) {
  return props.theme.gutters[16];
});
var LeftContent = styled.div(_templateObject5$b(), function (props) {
  return props.theme.gutters[16];
});
var TypeText = styled(Text)(_templateObject6$9(), function (props) {
  return props.theme.colors.wasabi;
}, function (props) {
  return props.theme.fontSize[10];
});
var TypeText2 = styled(TypeText)(_templateObject7$7(), function (props) {
  return props.theme.fontSize[10];
});
var HeadingText = styled(Text)(_templateObject8$5());
var SubheadingText = styled(Text)(_templateObject9$5());
var RightContent = styled.div(_templateObject10$4());
var Action = styled.button(_templateObject11$2(), function (props) {
  return RippleStyle();
}, function (props) {
  return props.theme.colors.lightGrey;
}, function (props) {
  return props.theme.colors.charcoal;
}, function (props) {
  return props.theme.gutters[16];
});
/**
 * V2 Interactive Card Item Styles
 */

var InteractiveCardItemContainer = styled.div(_templateObject12$2(), function (props) {
  return props.theme.colors.white;
}, function (props) {
  return props.theme.gutters[16];
}, function (props) {
  return props.theme.gutters[16];
}, function (props) {
  return props.theme.BREAKPOINTS.TABLET_UP;
}, function (props) {
  return props.theme.gutters[20];
}, function (props) {
  return props.theme.BREAKPOINTS.DESKTOP_UP;
}, function (props) {
  return props.theme.gutters[24];
});
var TopContent = styled.div(_templateObject13$2());
var BottomContent = styled.div(_templateObject14$2(), function (props) {
  return props.theme.fontSize[13];
}, function (props) {
  return props.theme.fontWeight.bold;
}, function (props) {
  return props.theme.gutters[24];
}, function (props) {
  return props.theme.BREAKPOINTS.TABLET_UP;
}, function (props) {
  return props.theme.gutters[12];
}, function (props) {
  return props.theme.gutters[12];
});
var ChildrenContainer = styled.div(_templateObject15$1(), function (props) {
  return props.fullWidth ? '100%' : 'auto';
});
var IconWrapper$7 = styled.div(_templateObject16$1(), function (props) {
  return props.theme.gutters[8];
});

function _templateObject$q() {
  var data = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: column;\n    text-align: center;\n  "]);

  _templateObject$q = function _templateObject() {
    return data;
  };

  return data;
}

function InteractiveCard(props) {
  var cardTitle = props.cardTitle,
      buttonText = props.buttonText,
      buttonIcon = props.buttonIcon,
      onButtonClick = props.onButtonClick,
      onItemDelete = props.onItemDelete,
      onItemEdit = props.onItemEdit,
      items = props.items,
      footer = props.footer,
      hideButton = props.hideButton;
  var transitions = useTransition(items ? items : [], function (item) {
    return item.key;
  }, {
    unique: true,
    from: {
      opacity: 0,
      transform: 'scale(0)'
    },
    enter: {
      opacity: 1,
      transform: 'scale(1)'
    },
    leave: {
      display: 'none'
    }
  });

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      key = _useState4[0],
      setKey = _useState4[1];

  var StyledModalContent = styled.div(_templateObject$q());

  var ModalContent = function ModalContent() {
    return React$2.createElement(StyledModalContent, null, React$2.createElement(Heading, {
      level: 3
    }, "Delete Confirmation"), React$2.createElement(Text, null, "Are you sure you want to delete this information?"), React$2.createElement(PrimaryButton, {
      appearance: "charcoal",
      "data-testid": "action-delete-confirm",
      onClick: function onClick() {
        return handleOnDelete();
      }
    }, "Yes, delete it"), React$2.createElement(SecondaryButton, {
      onClick: function onClick() {
        return setIsOpen(false);
      }
    }, "Cancel"));
  };

  var handleOnDelete = function handleOnDelete() {
    setIsOpen(false);
    onItemDelete(key);
  };

  return React$2.createElement(React$2.Fragment, null, React$2.createElement(StyledInteractiveCard, null, !hideButton && React$2.createElement(StyledPrimaryButton$1, {
    appearance: "blue",
    icon: buttonIcon,
    onClick: onButtonClick
  }, buttonText), items && items.length > 0 && React$2.createElement(React$2.Fragment, null, React$2.createElement(TitleText, {
    appearance: "misc",
    hideButton: hideButton
  }, cardTitle), transitions.map(function (_ref) {
    var item = _ref.item,
        key = _ref.key,
        props = _ref.props;
    return React$2.createElement(animated.div, {
      key: key,
      style: props
    }, React$2.createElement(InteractiveCardItem, {
      content: item,
      onItemEdit: onItemEdit,
      onItemDelete: function onItemDelete(key) {
        setIsOpen(true);
        setKey(key);
      }
    }));
  }), footer && footer)), React$2.createElement(Modal, {
    isOpen: isOpen
  }, React$2.createElement(ModalContent, null)));
}

InteractiveCard.propTypes = {
  cardTitle: PropTypes.string,
  buttonText: PropTypes.string,
  buttonIcon: PropTypes.string,
  onButtonClick: PropTypes.func,
  onItemDelete: PropTypes.func,
  onItemEdit: PropTypes.func,
  items: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string,
    type: PropTypes.string,
    heading: PropTypes.string,
    subheading: PropTypes.string
  })),
  footer: PropTypes.node,
  hideButton: PropTypes.bool
};
InteractiveCard.defaultProps = {
  hideButton: false
};

function InteractiveCardItem(props) {
  var content = props.content,
      onItemDelete = props.onItemDelete,
      onItemEdit = props.onItemEdit;
  return React$2.createElement(StyledInteractiveCardItem, null, React$2.createElement(LeftContent, null, React$2.createElement(TypeText, null, content.type), React$2.createElement(HeadingText, {
    appearance: "bold"
  }, content.heading), content.subheading && React$2.createElement(SubheadingText, {
    color: "charcoal"
  }, content.subheading), content.type2 && React$2.createElement(TypeText2, null, content.type2), content.heading2 && React$2.createElement(HeadingText, {
    appearance: "bold"
  }, content.heading2)), React$2.createElement(RightContent, null, React$2.createElement(Action, {
    type: "button",
    onClick: function onClick() {
      return onItemDelete(content.key);
    },
    "data-testid": "action-delete"
  }, React$2.createElement(Icon, {
    icon: "MdDelete",
    size: "22px"
  })), React$2.createElement(Action, {
    type: "button",
    onClick: function onClick() {
      return onItemEdit(content.key);
    },
    "data-testid": "action-edit"
  }, React$2.createElement(Icon, {
    icon: "MdModeEdit",
    size: "22px"
  }))));
}

InteractiveCardItem.propTypes = {
  content: PropTypes.shape({
    key: PropTypes.string,
    type: PropTypes.string,
    heading: PropTypes.string,
    subheading: PropTypes.string,
    type2: PropTypes.string,
    heading2: PropTypes.string
  }),
  onItemDelete: PropTypes.func,
  onItemEdit: PropTypes.func
};

function StandardInteractiveCard(props) {
  var cardTitle = props.cardTitle,
      buttonText = props.buttonText,
      buttonIcon = props.buttonIcon,
      onButtonClick = props.onButtonClick,
      footer = props.footer,
      header = props.header,
      hideButton = props.hideButton,
      children = props.children;
  return React$2.createElement(React$2.Fragment, null, React$2.createElement(StyledInteractiveCard, null, header && header, !hideButton && React$2.createElement(StyledPrimaryButton$1, {
    appearance: "blue",
    icon: buttonIcon,
    onClick: onButtonClick
  }, buttonText), children && React$2.createElement(React$2.Fragment, null, React$2.createElement(TitleText, {
    appearance: "misc",
    hideButton: hideButton
  }, cardTitle), children), footer && footer));
}

StandardInteractiveCard.propTypes = {
  cardTitle: PropTypes.string,
  buttonText: PropTypes.string,
  buttonIcon: PropTypes.string,
  onButtonClick: PropTypes.func,
  footer: PropTypes.node,
  header: PropTypes.node,
  hideButton: PropTypes.bool,
  children: PropTypes.node
};
StandardInteractiveCard.defaultProps = {
  hideButton: false
};

function _templateObject$r() {
  var data = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: column;\n    text-align: center;\n  "]);

  _templateObject$r = function _templateObject() {
    return data;
  };

  return data;
}

function InteractiveCardItem$1(props) {
  var children = props.children,
      onDelete = props.onDelete,
      onEdit = props.onEdit,
      key = props.key,
      _props$hideEditButton = props.hideEditButton,
      hideEditButton = _props$hideEditButton === void 0 ? false : _props$hideEditButton,
      _props$hideDeleteButt = props.hideDeleteButton,
      hideDeleteButton = _props$hideDeleteButt === void 0 ? false : _props$hideDeleteButt,
      _props$selectable = props.selectable,
      selectable = _props$selectable === void 0 ? false : _props$selectable,
      _props$isSelected = props.isSelected,
      isSelected = _props$isSelected === void 0 ? false : _props$isSelected,
      onSelect = props.onSelect,
      _props$fullWidth = props.fullWidth,
      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
      rest = _objectWithoutProperties(props, ["children", "onDelete", "onEdit", "key", "hideEditButton", "hideDeleteButton", "selectable", "isSelected", "onSelect", "fullWidth"]);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isModalOpen = _useState2[0],
      setIsModalOpen = _useState2[1];

  var StyledModalContent = styled.div(_templateObject$r());

  var ModalContent = function ModalContent() {
    return React$2.createElement(StyledModalContent, null, React$2.createElement(Heading, {
      level: 3
    }, "Delete Confirmation"), React$2.createElement(Text, null, "Are you sure you want to delete this information?"), React$2.createElement(PrimaryButton, {
      appearance: "charcoal",
      "data-testid": "action-delete-confirm",
      onClick: function onClick() {
        return handleOnDelete();
      }
    }, "Yes, delete it"), React$2.createElement(SecondaryButton, {
      onClick: function onClick() {
        return setIsModalOpen(false);
      }
    }, "Cancel"));
  };

  var handleOnDelete = function handleOnDelete() {
    setIsModalOpen(false);
    onDelete(key);
  };

  return React$2.createElement(React$2.Fragment, null, React$2.createElement(InteractiveCardItemContainer, _extends({
    key: key,
    onClick: onSelect
  }, rest), React$2.createElement(TopContent, null, selectable && React$2.createElement(IconWrapper$7, null, React$2.createElement(Icon, {
    icon: !isSelected ? 'MdRadioButtonUnchecked' : 'MdRadioButtonChecked',
    size: "1.3em",
    color: !isSelected ? theme.colors.charcoal : theme.colors.sinbad
  })), React$2.createElement(ChildrenContainer, {
    fullWidth: fullWidth
  }, children)), React$2.createElement(BottomContent, null, !hideEditButton && React$2.createElement(PrimaryButton, {
    appearance: "charcoal",
    onClick: onEdit
  }, "Edit"), !hideDeleteButton && React$2.createElement(SecondaryButton, {
    appearance: "grey",
    onClick: function onClick() {
      return setIsModalOpen(true);
    }
  }, "Delete"))), React$2.createElement(Modal, {
    isOpen: isModalOpen
  }, React$2.createElement(ModalContent, null)));
}

InteractiveCardItem$1.propTypes = {
  key: PropTypes.string,
  onDelete: PropTypes.func,
  onEdit: PropTypes.func,
  children: PropTypes.node,
  hideEditButton: PropTypes.bool,
  hideDeleteButton: PropTypes.bool,
  selectable: PropTypes.bool,
  isSelected: PropTypes.bool,
  onSelect: PropTypes.func,
  fullWidth: PropTypes.bool
};

function _templateObject11$3() {
  var data = _taggedTemplateLiteral(["\n  margin-bottom: ", ";\n  &:last-child {\n    margin-bottom: 0;\n  }\n"]);

  _templateObject11$3 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10$5() {
  var data = _taggedTemplateLiteral(["\n  margin: 0;\n"]);

  _templateObject10$5 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9$6() {
  var data = _taggedTemplateLiteral(["\n  margin: 0 0 0.25rem;\n  color: ", ";\n  text-transform: uppercase;\n"]);

  _templateObject9$6 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8$6() {
  var data = _taggedTemplateLiteral(["\n  margin: 0 0 2px 0;\n  letter-spacing: 1px;\n  line-height: 1.54;\n  font-size: ", ";\n  color: ", ";\n  text-transform: uppercase;\n"]);

  _templateObject8$6 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7$8() {
  var data = _taggedTemplateLiteral(["\n  margin: 0 0 ", " 0;\n  font-size: ", ";\n"]);

  _templateObject7$8 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$a() {
  var data = _taggedTemplateLiteral(["\n  border: none;\n  height: 100%;\n  width: 2px;\n  background: ", ";\n  border-right: 1px solid ", ";\n  border-left: 1px solid ", ";\n  border-bottom-left-radius: 25px;\n  border-bottom-right-radius: 25px;\n  margin: 0 auto;\n  padding: 0;\n"]);

  _templateObject6$a = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$c() {
  var data = _taggedTemplateLiteral(["\n  width: 54px;\n  height: 54px;\n  border-radius: 50%;\n  border: 3px solid ", ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-sizing: border-box;\n  color: ", ";\n  background: ", ";\n"]);

  _templateObject5$c = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$e() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  align-items: center;\n  width: 54px;\n  height: 54px;\n"]);

  _templateObject4$e = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$f() {
  var data = _taggedTemplateLiteral(["\n  padding-left: ", ";\n  justify-content: center;\n"]);

  _templateObject3$f = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$j() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n"]);

  _templateObject2$j = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$s() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n"]);

  _templateObject$s = function _templateObject() {
    return data;
  };

  return data;
}
/**
 * Details Card Styles
 */


var StyledDetailsCard = styled(Card)(_templateObject$s());
var LeftContent$1 = styled.div(_templateObject2$j());
var RightContent$1 = styled.div(_templateObject3$f(), function (props) {
  return props.theme.gutters[16];
});
var IconWrapper$8 = styled.div(_templateObject4$e());
var IconCircle = styled.div(_templateObject5$c(), function (props) {
  return props.theme.colors.white;
}, function (props) {
  return props.theme.colors.white;
}, function (props) {
  return props.background === 'amber' ? props.theme.colors.amber : props.theme.colors.wasabi;
});
var VerticalLine = styled.hr(_templateObject6$a(), function (props) {
  return props.theme.colors.white;
}, function (props) {
  return props.theme.colors.white;
}, function (props) {
  return props.theme.colors.white;
});
var HeadingText$1 = styled(Text)(_templateObject7$8(), function (props) {
  return props.theme.gutters[12];
}, function (props) {
  return props.theme.fontSize[13];
});
var TitleText$1 = styled(Text)(_templateObject8$6(), function (props) {
  return props.theme.fontSize[11];
}, function (props) {
  return props.theme.colors.darkGrey;
});
var BeneficiaryText = styled(Text)(_templateObject9$6(), function (props) {
  return props.theme.colors.wasabi;
});
var ItemText = styled(Text)(_templateObject10$5());
var ItemWrapper = styled.div(_templateObject11$3(), function (props) {
  return props.theme.gutters[16];
});

function DetailsCard(props) {
  var title = props.title,
      details = props.details,
      iconAppearance = props.iconAppearance,
      relationshipText = props.relationshipText,
      termText = props.termText,
      amountText = props.amountText;
  return React$2.createElement(StyledDetailsCard, null, React$2.createElement(LeftContent$1, null, React$2.createElement(IconWrapper$8, null, React$2.createElement(IconCircle, {
    background: iconAppearance
  }, React$2.createElement(Icon, {
    icon: "MdAssignmentInd",
    size: "22px"
  }))), React$2.createElement(VerticalLine, null)), React$2.createElement(RightContent$1, null, React$2.createElement(HeadingText$1, {
    appearance: "misc"
  }, title), details && React$2.createElement(CardContent, {
    relationship: details.relationship,
    term: details.term,
    amount: details.amount,
    relationshipText: relationshipText,
    termText: termText,
    amountText: amountText
  })));
}

DetailsCard.propTypes = {
  title: PropTypes.string,
  iconAppearance: PropTypes.oneOf(['amber', 'wasabi']),
  details: PropTypes.shape({
    relationship: PropTypes.string,
    term: PropTypes.string,
    amount: PropTypes.string
  }),
  relationshipText: PropTypes.string,
  termText: PropTypes.string,
  amountText: PropTypes.string
};
DetailsCard.defaultProps = {
  relationshipText: 'Relationship',
  termText: 'Benefit Term',
  amountText: 'Benefit Amount'
};

function CardContent(props) {
  var relationship = props.relationship,
      term = props.term,
      amount = props.amount,
      relationshipText = props.relationshipText,
      termText = props.termText,
      amountText = props.amountText;
  return React$2.createElement(React$2.Fragment, null, relationship && React$2.createElement(ItemWrapper, null, React$2.createElement(TitleText$1, {
    appearance: "tiny"
  }, relationshipText), React$2.createElement(BeneficiaryText, {
    appearance: "bold"
  }, relationship)), term && React$2.createElement(ItemWrapper, null, React$2.createElement(TitleText$1, {
    appearance: "tiny"
  }, termText), React$2.createElement(ItemText, {
    color: "charcoal"
  }, term)), amount && React$2.createElement(ItemWrapper, null, React$2.createElement(TitleText$1, {
    appearance: "tiny"
  }, amountText), React$2.createElement(ItemText, {
    color: "charcoal"
  }, amount)));
}

CardContent.propTypes = {
  relationship: PropTypes.string,
  term: PropTypes.string,
  amount: PropTypes.string,
  relationshipText: PropTypes.string,
  termText: PropTypes.string,
  amountText: PropTypes.string
};

function _templateObject10$6() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  line-height: 1.5em;\n  margin-right: 0.5em;\n  font-size: ", ";\n  ", "\n  ", "\n"]);

  _templateObject10$6 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9$7() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  outline: 0;\n  background: transparent;\n  border: 0;\n  margin-top: 0.25em;\n  cursor: pointer;\n"]);

  _templateObject9$7 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8$7() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  margin: 0.75em;\n  align-items: center;\n"]);

  _templateObject8$7 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7$9() {
  var data = _taggedTemplateLiteral(["\n  margin: 1em 0.75em 0 0.75em;\n"]);

  _templateObject7$9 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$b() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  margin-left: 0.25em;\n"]);

  _templateObject6$b = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$d() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-content: flex-start;\n"]);

  _templateObject5$d = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$f() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  margin: 0.75em 0.75em 0 0.75em;\n  justify-content: space-between;\n"]);

  _templateObject4$f = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$g() {
  var data = _taggedTemplateLiteral(["\n  background: ", ";\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  box-shadow: 0 0.125em 0 0 rgba(0, 0, 0, 0.04);\n  margin-top: ", ";\n  border-radius: 0.5em;\n  border: solid 0.063em ", ";\n"]);

  _templateObject3$g = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$k() {
  var data = _taggedTemplateLiteral(["\n    font-weight: ", ";\n  "]);

  _templateObject2$k = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$t() {
  var data = _taggedTemplateLiteral(["\n  &:after {\n    content: '';\n    width: 0.188em;\n    height: 0.188em;\n    border-radius: 50%;\n    background: ", ";\n    display: inline-block;\n    margin: 0 0 0 0.5em;\n    top: -0.188em;\n    position: relative;\n  }\n"]);

  _templateObject$t = function _templateObject() {
    return data;
  };

  return data;
}

var styledDot = function styledDot() {
  return css(_templateObject$t(), function (props) {
    return props.theme.colors.grey;
  });
};

var boldStyles$1 = function boldStyles(props) {
  var theme = props.theme;
  return css(_templateObject2$k(), theme.fontWeight.bold);
};

var StyledUploadCard = styled.div(_templateObject3$g(), function (props) {
  return props.theme.colors.white;
}, function (props) {
  return props.theme.gutters[16];
}, function (props) {
  return props.theme.colors.lightGrey;
});
var StyledHeaderWrapper = styled.div(_templateObject4$f());
var StyledHeaderTitleWrapper = styled.div(_templateObject5$d());
var StyledHeaderText = styled.span(_templateObject6$b(), function (props) {
  return props.theme.colors.charcoal;
});
var StyledContentWrapper = styled.div(_templateObject7$9());
var StyledFooterContent = styled.div(_templateObject8$7());
var StyledActionWrapper = styled.button(_templateObject9$7(), function (props) {
  return RippleStyle();
});
var StyledStatusText = styled.span(_templateObject10$6(), function (props) {
  return props.error ? props.theme.colors.red : props.color;
}, function (props) {
  return props.theme.fontSize[props.size];
}, function (props) {
  return props.bold && boldStyles$1(props);
}, function (props) {
  return props.showDot && styledDot();
});

function UploadCard(props) {
  var filename = props.filename,
      fileSize = props.fileSize,
      fileProgress = props.fileProgress,
      status = props.status,
      sizeTag = props.sizeTag,
      onDismiss = props.onDismiss;
  var progress = Math.round(fileProgress / fileSize * 100);

  var _useState = useState(status === 'error'),
      _useState2 = _slicedToArray(_useState, 1),
      isError = _useState2[0];

  var _useState3 = useState(status === 'uploading'),
      _useState4 = _slicedToArray(_useState3, 1),
      isUploading = _useState4[0];

  var _useState5 = useState(status === 'success'),
      _useState6 = _slicedToArray(_useState5, 1),
      isSuccess = _useState6[0];

  return React$2.createElement(StyledUploadCard, null, React$2.createElement(StyledHeaderWrapper, null, React$2.createElement(StyledHeaderTitleWrapper, null, React$2.createElement(Icon, {
    icon: isUploading || isError ? 'MdInsertDriveFile' : 'MdPlaylistAddCheck',
    size: "22px",
    color: isSuccess ? theme.colors.wasabi : isUploading ? theme.colors.blue : isError ? theme.colors.red : theme.colors.blue
  }), React$2.createElement(StyledHeaderText, {
    success: isSuccess
  }, filename)), React$2.createElement(StyledActionWrapper, {
    "data-testid": "action-dismiss",
    onClick: function onClick() {
      return onDismiss({
        filename: filename,
        fileSize: fileSize,
        fileProgress: fileProgress,
        status: status,
        sizeTag: sizeTag
      });
    }
  }, React$2.createElement(Icon, {
    icon: isSuccess ? 'MdDelete' : 'MdClose',
    size: "22px",
    color: theme.colors.charcoal
  }))), isUploading && React$2.createElement(StyledContentWrapper, null, React$2.createElement(Progressbar, {
    min: 0,
    max: 100,
    value: progress
  })), React$2.createElement(StyledFooterContent, null, React$2.createElement(StyledStatusText, {
    color: isSuccess ? theme.colors.wasabi : isUploading ? theme.colors.blue : isError ? theme.colors.red : theme.colors.grey,
    showDot: true,
    bold: true,
    size: 16
  }, isSuccess && 'Successful Upload', isError && 'Error', isUploading && 'Uploading'), React$2.createElement(StyledStatusText, {
    color: isSuccess ? theme.colors.grey : theme.colors.charcoal,
    showDot: false,
    size: 14
  }, !isSuccess && "".concat(fileProgress, " ").concat(sizeTag, " of ").concat(fileSize, " ").concat(sizeTag), isSuccess && "".concat(fileSize, " ").concat(sizeTag)), !isSuccess && React$2.createElement(StyledStatusText, {
    color: theme.colors.grey,
    showDot: false,
    size: 14
  }, "(".concat(Math.round(fileProgress / fileSize * 100), "% Done)"))));
}

UploadCard.propTypes = {
  filename: PropTypes.string,
  fileSize: PropTypes.number,
  fileProgress: PropTypes.number,
  status: PropTypes.oneOf(['uploading', 'error', 'success']),
  sizeTag: PropTypes.oneOf(['B', 'KB', 'MB', 'GB']),
  onDismiss: PropTypes.func
};
UploadCard.defaultProps = {
  sizeTag: 'KB',
  status: 'uploading',
  fileSize: 0,
  fileProgress: 0
};

function _templateObject2$l() {
  var data = _taggedTemplateLiteral(["\n  padding-right: ", ";\n"]);

  _templateObject2$l = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$u() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  overflow-y: scroll;\n  max-height: ", ";\n\n  ::-webkit-scrollbar-track {\n    border-radius: 0.188em;\n    background-color: ", ";\n  }\n\n  ::-webkit-scrollbar {\n    width: 0.375em;\n    border-radius: 0.188em;\n    background-color: ", ";\n  }\n\n  ::-webkit-scrollbar-thumb {\n    border-radius: 0.188em;\n    background-color: ", ";\n    margin-bottom: 0.188em;\n    margin: 10px 0px !important;\n  }\n"]);

  _templateObject$u = function _templateObject() {
    return data;
  };

  return data;
}

var StyledScrollable = styled.div(_templateObject$u(), function (props) {
  return props.height;
}, function (props) {
  return props.theme.colors.lightGrey;
}, function (props) {
  return props.theme.colors.lightGrey;
}, function (props) {
  return props.theme.colors.grey;
});
var StyledChildrenWrapper = styled.div(_templateObject2$l(), function (props) {
  return props.theme.gutters[16];
});

function Scrollable(props) {
  var children = props.children,
      height = props.height;
  return React$2.createElement(StyledScrollable, {
    height: height
  }, React$2.createElement(StyledChildrenWrapper, {
    "data-testid": "children-wrapper"
  }, children));
}

Scrollable.propTypes = {
  children: PropTypes.node.isRequired,
  height: PropTypes.string
};
Scrollable.defaultProps = {
  height: '12.500em'
};

function _templateObject$v() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  padding: ", ";\n  border-radius: ", ";\n\n  @media ", " {\n    padding: ", ";\n    border-radius: 0;\n  }\n"]);

  _templateObject$v = function _templateObject() {
    return data;
  };

  return data;
}

var StyledCopybox = styled.div(_templateObject$v(), function (props) {
  return props.theme.colors.lightGrey;
}, function (props) {
  return props.theme.gutters[32];
}, function (props) {
  return props.theme.gutters[8];
}, function (props) {
  return props.theme.BREAKPOINTS.MOBILE_DOWN;
}, function (props) {
  return props.theme.gutters[16];
});

function Copybox(props) {
  var children = props.children,
      height = props.height,
      scrollable = props.scrollable,
      rest = _objectWithoutProperties(props, ["children", "height", "scrollable"]);

  return React$2.createElement(StyledCopybox, null, scrollable && height && React$2.createElement(Scrollable, _extends({
    height: height
  }, rest), children), !scrollable && React$2.createElement("div", null, children));
}

Copybox.propTypes = {
  children: PropTypes.arrayOf(PropTypes.element),
  height: PropTypes.string,
  scrollable: PropTypes.bool
};
Copybox.defaultProps = {
  height: '12.500em',
  scrollable: false
};

function _templateObject4$g() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject4$g = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$h() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  padding-left: 1.125em;\n  margin-bottom: ", ";\n\n  &:before {\n    position: absolute;\n    left: 0;\n    top: 0.563em;\n    content: '';\n    display: inline-block;\n    width: 0.375em;\n    height: 0.375em;\n    border-radius: 0.375em;\n    background-color: ", ";\n  }\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n\n  p {\n    margin: 0;\n  }\n"]);

  _templateObject3$h = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$m() {
  var data = _taggedTemplateLiteral(["\n  list-style-type: none;\n  line-height: 1.5;\n  margin: 0;\n  padding-left: ", ";\n"]);

  _templateObject2$m = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$w() {
  var data = _taggedTemplateLiteral(["\n    font-style: italic;\n  "]);

  _templateObject$w = function _templateObject() {
    return data;
  };

  return data;
}

var italicStyle = function italicStyle() {
  return css(_templateObject$w());
};

var StyledList = styled.ul(_templateObject2$m(), function (props) {
  return props.spacingLeft;
});
var StyledListItem = styled.li(_templateObject3$h(), function (props) {
  return props.theme.gutters[24];
}, function (props) {
  return props.theme.colors.wasabi;
});
var StyledText$1 = styled(Text)(_templateObject4$g(), function (props) {
  return props.italic && italicStyle();
});
var APPEARANCES$1 = {
  "default": 'default',
  tiny: 'tiny',
  small: 'small',
  bold: 'bold',
  misc: 'misc'
};

function List(props) {
  var items = props.items,
      italic = props.italic,
      spacingLeft = props.spacingLeft,
      appearance = props.appearance,
      color = props.color;
  return React$2.createElement(StyledList, {
    spacingLeft: spacingLeft
  }, items.map(function (item) {
    return React$2.createElement(StyledListItem, {
      key: item.key
    }, React$2.createElement(StyledText$1, {
      "data-testid": "list-item",
      italic: italic,
      appearance: appearance,
      color: color
    }, item.text));
  }));
}

List.propTypes = {
  italic: PropTypes.bool,
  items: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.number.isRequired,
    text: PropTypes.string.isRequired
  })),
  spacingLeft: PropTypes.string,
  appearance: PropTypes.oneOf(Object.keys(APPEARANCES$1)),
  color: PropTypes.oneOf(['red', 'charcoal', 'blue', 'sinbad', 'scandal', 'white', 'black', 'lightGrey', 'grey', 'darkGrey', 'butter', 'amber', 'rust', 'apple', 'wasabi', 'palmLeaf', 'fireEngine', 'bunker'])
};
List.defaultProps = {
  italic: false,
  items: [],
  spacingLeft: '1.500rem',
  appearance: 'default',
  color: 'black'
};

function _templateObject2$n() {
  var data = _taggedTemplateLiteral(["\n  width: ", "%;\n  height: 0.25em;\n  border-radius: 0.125em;\n  background-color: ", ";\n  margin: 0 0.188em;\n"]);

  _templateObject2$n = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$x() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  height: 0.625em;\n  border-radius: 0.313em;\n  justify-content: flex-start;\n  align-items: center;\n  background-color: ", ";\n"]);

  _templateObject$x = function _templateObject() {
    return data;
  };

  return data;
}

var StyledProgressbar = styled.div(_templateObject$x(), function (props) {
  return props.theme.colors.blue;
});
var StyledProgressIndicator = styled.div(_templateObject2$n(), function (props) {
  return props.value / props.max * 100;
}, function (props) {
  return props.theme.colors.white;
});

function Progressbar(props) {
  var min = props.min,
      max = props.max,
      value = props.value;
  return React$2.createElement(StyledProgressbar, {
    min: min,
    max: max
  }, React$2.createElement(StyledProgressIndicator, {
    min: min,
    max: max,
    value: value
  }));
}

Progressbar.propTypes = {
  min: PropTypes.number,
  max: PropTypes.number,
  value: PropTypes.number
};
Progressbar.defaultProps = {
  min: 0,
  max: 100,
  value: 0
};

function _templateObject19$1() {
  var data = _taggedTemplateLiteral(["\n  text-align: center;\n  color: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n"]);

  _templateObject19$1 = function _templateObject19() {
    return data;
  };

  return data;
}

function _templateObject18$1() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  margin: 28px 0 0 0;\n  padding-top: 28px;\n  border-top-style: solid;\n  border-top-width: 1px;\n  border-top-color: ", ";\n"]);

  _templateObject18$1 = function _templateObject18() {
    return data;
  };

  return data;
}

function _templateObject17$1() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 2.375em;\n  height: 2.375em;\n  cursor: pointer;\n  font-size: ", ";\n  background-color: ", ";\n  color: ", ";\n  margin: 0px;\n  border-width: 0;\n  outline: 0;\n"]);

  _templateObject17$1 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16$2() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 10px;\n"]);

  _templateObject16$2 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15$2() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject15$2 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14$3() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject14$3 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13$3() {
  var data = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  grid-gap: 8px;\n"]);

  _templateObject13$3 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12$3() {
  var data = _taggedTemplateLiteral(["\n  text-align: center;\n  width: 40px;\n  height: 40px;\n  color: ", ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: ", ";\n"]);

  _templateObject12$3 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11$4() {
  var data = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  justify-content: center;\n  grid-gap: 8px;\n"]);

  _templateObject11$4 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10$7() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 40px;\n  width: 40px;\n  outline: 0;\n  box-sizing: border-box;\n  font-size: ", ";\n  text-align: center;\n  cursor: pointer;\n  color: ", ";\n  background-color: ", ";\n  border-width: 0.063em;\n  border-style: solid;\n  overflow: hidden;\n  border-radius: 4px;\n  border-color: ", ";\n\n  font-weight: bold;\n\n  &:hover {\n    border-color: ", ";\n    background-color: ", ";\n    color: ", ";\n  }\n"]);

  _templateObject10$7 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9$8() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  flex-wrap: wrap;\n  position: absolute;\n\n  ", "\n  border-radius: 0.25em;\n  box-shadow: 0 0 0.625em 0 rgba(0, 0, 0, 0.08);\n  background-color: ", ";\n  padding: 1.75em;\n  z-index: 9999;\n"]);

  _templateObject9$8 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8$8() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n"]);

  _templateObject8$8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7$a() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  &:before {\n    ", "\n    background-color: ", ";\n    border-color: ", ";\n  }\n"]);

  _templateObject7$a = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$c() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  &:before {\n    ", "\n    background-color: ", ";\n    border-color: ", ";\n  }\n"]);

  _templateObject6$c = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$e() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  &:before {\n    ", "\n    background-color: ", ";\n    border-color: ", ";\n  }\n"]);

  _templateObject5$e = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$h() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  width: 20px;\n  height: 20px;\n  border-radius: 4px;\n  border-width: 0.063em;\n  border-style: solid;\n  margin-right: 6px;\n  content: '';\n"]);

  _templateObject4$h = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$i() {
  var data = _taggedTemplateLiteral(["\n    top: 4.375em;\n  "]);

  _templateObject3$i = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$o() {
  var data = _taggedTemplateLiteral(["\n    bottom: 4.375em;\n  "]);

  _templateObject2$o = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$y() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  margin: 6px;\n  color: ", ";\n  font-size: ", ";\n"]);

  _templateObject$y = function _templateObject() {
    return data;
  };

  return data;
}

var StyledInfo = function StyledInfo() {
  return css(_templateObject$y(), function (props) {
    return props.theme.colors.black;
  }, function (props) {
    return props.theme.fontSize[14];
  });
};

var StyledPositionTop = function StyledPositionTop() {
  return css(_templateObject2$o());
};

var StyledPositionBottom = function StyledPositionBottom() {
  return css(_templateObject3$i());
};

var StyledInfoBlock = function StyledInfoBlock() {
  return css(_templateObject4$h());
};

var StyledAvailableInfo = styled.div(_templateObject5$e(), function (props) {
  return StyledInfo();
}, function (props) {
  return StyledInfoBlock();
}, function (props) {
  return props.theme.colors.white;
}, function (props) {
  return props.theme.colors.blue;
});
var StyledDisabledInfo = styled.div(_templateObject6$c(), function (props) {
  return StyledInfo();
}, function (props) {
  return StyledInfoBlock();
}, function (props) {
  return props.theme.colors.lightGrey;
}, function (props) {
  return props.theme.colors.lightGrey;
});
var StyledSelectedInfo = styled.div(_templateObject7$a(), function (props) {
  return StyledInfo();
}, function (props) {
  return StyledInfoBlock();
}, function (props) {
  return props.theme.colors.red;
}, function (props) {
  return props.theme.colors.red;
});
var StyledDatePicker = styled.div(_templateObject8$8());
var StyledDatePickerWrapper = styled.div(_templateObject9$8(), function (props) {
  return props.popupPosition === 'top' ? StyledPositionTop() : StyledPositionBottom();
}, function (props) {
  return props.theme.colors.white;
});
var StyledDayWrapper = styled.button(_templateObject10$7(), function (props) {
  return props.theme.fontSize[14];
}, function (props) {
  return props.blockedDate ? props.theme.colors.grey : props.selected ? props.theme.colors.white : props.theme.colors.blue;
}, function (props) {
  return props.blockedDate ? props.theme.colors.lightGrey : props.selected ? props.theme.colors.red : props.theme.colors.white;
}, function (props) {
  return props.blockedDate ? props.theme.colors.lightGrey : props.selected ? props.theme.colors.red : props.theme.colors.blue;
}, function (props) {
  return props.blockedDate ? props.theme.colors.lightGrey : props.theme.colors.red;
}, function (props) {
  return props.blockedDate ? props.theme.colors.lightGrey : props.theme.colors.red;
}, function (props) {
  return props.blockedDate ? props.theme.colors.grey : props.theme.colors.white;
});
var StyledWeekDayWrapper = styled.div(_templateObject11$4());
var StyledWeekDay = styled.div(_templateObject12$3(), function (props) {
  return props.theme.colors.black;
}, function (props) {
  return props.theme.fontSize[14];
});
var StyledDayContainerWrapper = styled.div(_templateObject13$3());
var StyledMonthWrapper = styled.div(_templateObject14$3());
var StyledMonthContainerWrapper = styled.div(_templateObject15$2());
var StyledMonthHeaderWrapper = styled.div(_templateObject16$2());
var StyledNavButton = styled.button(_templateObject17$1(), function (props) {
  return props.theme.fontSize[14];
}, function (props) {
  return props.theme.colors.white;
}, function (props) {
  return props.theme.colors.green;
});
var StyledInformationWrapper = styled.div(_templateObject18$1(), function (props) {
  return props.theme.colors.grey;
});
var StyledMonthLabel = styled.div(_templateObject19$1(), function (props) {
  return props.theme.colors.black;
}, function (props) {
  return props.theme.fontSize[16];
}, function (props) {
  return props.theme.fontWeight.medium;
});
var moment = createCommonjsModule(function (module, exports) {
  (function (global, factory) {
    module.exports = factory();
  })(commonjsGlobal, function () {
    var hookCallback;

    function hooks() {
      return hookCallback.apply(null, arguments);
    } // This is done to register the method called with moment()
    // without creating circular dependencies.


    function setHookCallback(callback) {
      hookCallback = callback;
    }

    function isArray(input) {
      return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }

    function isObject(input) {
      // IE8 will treat undefined and null as object if it wasn't for
      // input != null
      return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }

    function isObjectEmpty(obj) {
      if (Object.getOwnPropertyNames) {
        return Object.getOwnPropertyNames(obj).length === 0;
      } else {
        var k;

        for (k in obj) {
          if (obj.hasOwnProperty(k)) {
            return false;
          }
        }

        return true;
      }
    }

    function isUndefined(input) {
      return input === void 0;
    }

    function isNumber(input) {
      return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }

    function isDate(input) {
      return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }

    function map(arr, fn) {
      var res = [],
          i;

      for (i = 0; i < arr.length; ++i) {
        res.push(fn(arr[i], i));
      }

      return res;
    }

    function hasOwnProp(a, b) {
      return Object.prototype.hasOwnProperty.call(a, b);
    }

    function extend(a, b) {
      for (var i in b) {
        if (hasOwnProp(b, i)) {
          a[i] = b[i];
        }
      }

      if (hasOwnProp(b, 'toString')) {
        a.toString = b.toString;
      }

      if (hasOwnProp(b, 'valueOf')) {
        a.valueOf = b.valueOf;
      }

      return a;
    }

    function createUTC(input, format, locale, strict) {
      return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
      // We need to deep clone this object.
      return {
        empty: false,
        unusedTokens: [],
        unusedInput: [],
        overflow: -2,
        charsLeftOver: 0,
        nullInput: false,
        invalidMonth: null,
        invalidFormat: false,
        userInvalidated: false,
        iso: false,
        parsedDateParts: [],
        meridiem: null,
        rfc2822: false,
        weekdayMismatch: false
      };
    }

    function getParsingFlags(m) {
      if (m._pf == null) {
        m._pf = defaultParsingFlags();
      }

      return m._pf;
    }

    var some;

    if (Array.prototype.some) {
      some = Array.prototype.some;
    } else {
      some = function some(fun) {
        var t = Object(this);
        var len = t.length >>> 0;

        for (var i = 0; i < len; i++) {
          if (i in t && fun.call(this, t[i], i, t)) {
            return true;
          }
        }

        return false;
      };
    }

    function isValid(m) {
      if (m._isValid == null) {
        var flags = getParsingFlags(m);
        var parsedParts = some.call(flags.parsedDateParts, function (i) {
          return i != null;
        });
        var isNowValid = !isNaN(m._d.getTime()) && flags.overflow < 0 && !flags.empty && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);

        if (m._strict) {
          isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
        }

        if (Object.isFrozen == null || !Object.isFrozen(m)) {
          m._isValid = isNowValid;
        } else {
          return isNowValid;
        }
      }

      return m._isValid;
    }

    function createInvalid(flags) {
      var m = createUTC(NaN);

      if (flags != null) {
        extend(getParsingFlags(m), flags);
      } else {
        getParsingFlags(m).userInvalidated = true;
      }

      return m;
    } // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.


    var momentProperties = hooks.momentProperties = [];

    function copyConfig(to, from) {
      var i, prop, val;

      if (!isUndefined(from._isAMomentObject)) {
        to._isAMomentObject = from._isAMomentObject;
      }

      if (!isUndefined(from._i)) {
        to._i = from._i;
      }

      if (!isUndefined(from._f)) {
        to._f = from._f;
      }

      if (!isUndefined(from._l)) {
        to._l = from._l;
      }

      if (!isUndefined(from._strict)) {
        to._strict = from._strict;
      }

      if (!isUndefined(from._tzm)) {
        to._tzm = from._tzm;
      }

      if (!isUndefined(from._isUTC)) {
        to._isUTC = from._isUTC;
      }

      if (!isUndefined(from._offset)) {
        to._offset = from._offset;
      }

      if (!isUndefined(from._pf)) {
        to._pf = getParsingFlags(from);
      }

      if (!isUndefined(from._locale)) {
        to._locale = from._locale;
      }

      if (momentProperties.length > 0) {
        for (i = 0; i < momentProperties.length; i++) {
          prop = momentProperties[i];
          val = from[prop];

          if (!isUndefined(val)) {
            to[prop] = val;
          }
        }
      }

      return to;
    }

    var updateInProgress = false; // Moment prototype object

    function Moment(config) {
      copyConfig(this, config);
      this._d = new Date(config._d != null ? config._d.getTime() : NaN);

      if (!this.isValid()) {
        this._d = new Date(NaN);
      } // Prevent infinite loop in case updateOffset creates new moment
      // objects.


      if (updateInProgress === false) {
        updateInProgress = true;
        hooks.updateOffset(this);
        updateInProgress = false;
      }
    }

    function isMoment(obj) {
      return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }

    function absFloor(number) {
      if (number < 0) {
        // -0 -> 0
        return Math.ceil(number) || 0;
      } else {
        return Math.floor(number);
      }
    }

    function toInt(argumentForCoercion) {
      var coercedNumber = +argumentForCoercion,
          value = 0;

      if (coercedNumber !== 0 && isFinite(coercedNumber)) {
        value = absFloor(coercedNumber);
      }

      return value;
    } // compare two arrays, return the number of differences


    function compareArrays(array1, array2, dontConvert) {
      var len = Math.min(array1.length, array2.length),
          lengthDiff = Math.abs(array1.length - array2.length),
          diffs = 0,
          i;

      for (i = 0; i < len; i++) {
        if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) {
          diffs++;
        }
      }

      return diffs + lengthDiff;
    }

    function warn(msg) {
      if (hooks.suppressDeprecationWarnings === false && typeof console !== 'undefined' && console.warn) {
        console.warn('Deprecation warning: ' + msg);
      }
    }

    function deprecate(msg, fn) {
      var firstTime = true;
      return extend(function () {
        if (hooks.deprecationHandler != null) {
          hooks.deprecationHandler(null, msg);
        }

        if (firstTime) {
          var args = [];
          var arg;

          for (var i = 0; i < arguments.length; i++) {
            arg = '';

            if (typeof arguments[i] === 'object') {
              arg += '\n[' + i + '] ';

              for (var key in arguments[0]) {
                arg += key + ': ' + arguments[0][key] + ', ';
              }

              arg = arg.slice(0, -2); // Remove trailing comma and space
            } else {
              arg = arguments[i];
            }

            args.push(arg);
          }

          warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + new Error().stack);
          firstTime = false;
        }

        return fn.apply(this, arguments);
      }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
      if (hooks.deprecationHandler != null) {
        hooks.deprecationHandler(name, msg);
      }

      if (!deprecations[name]) {
        warn(msg);
        deprecations[name] = true;
      }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
      return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }

    function set(config) {
      var prop, i;

      for (i in config) {
        prop = config[i];

        if (isFunction(prop)) {
          this[i] = prop;
        } else {
          this['_' + i] = prop;
        }
      }

      this._config = config; // Lenient ordinal parsing accepts just a number in addition to
      // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
      // TODO: Remove "ordinalParse" fallback in next major release.

      this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + '|' + /\d{1,2}/.source);
    }

    function mergeConfigs(parentConfig, childConfig) {
      var res = extend({}, parentConfig),
          prop;

      for (prop in childConfig) {
        if (hasOwnProp(childConfig, prop)) {
          if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
            res[prop] = {};
            extend(res[prop], parentConfig[prop]);
            extend(res[prop], childConfig[prop]);
          } else if (childConfig[prop] != null) {
            res[prop] = childConfig[prop];
          } else {
            delete res[prop];
          }
        }
      }

      for (prop in parentConfig) {
        if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) {
          // make sure changes to properties don't modify parent config
          res[prop] = extend({}, res[prop]);
        }
      }

      return res;
    }

    function Locale(config) {
      if (config != null) {
        this.set(config);
      }
    }

    var keys;

    if (Object.keys) {
      keys = Object.keys;
    } else {
      keys = function keys(obj) {
        var i,
            res = [];

        for (i in obj) {
          if (hasOwnProp(obj, i)) {
            res.push(i);
          }
        }

        return res;
      };
    }

    var defaultCalendar = {
      sameDay: '[Today at] LT',
      nextDay: '[Tomorrow at] LT',
      nextWeek: 'dddd [at] LT',
      lastDay: '[Yesterday at] LT',
      lastWeek: '[Last] dddd [at] LT',
      sameElse: 'L'
    };

    function calendar(key, mom, now) {
      var output = this._calendar[key] || this._calendar['sameElse'];
      return isFunction(output) ? output.call(mom, now) : output;
    }

    var defaultLongDateFormat = {
      LTS: 'h:mm:ss A',
      LT: 'h:mm A',
      L: 'MM/DD/YYYY',
      LL: 'MMMM D, YYYY',
      LLL: 'MMMM D, YYYY h:mm A',
      LLLL: 'dddd, MMMM D, YYYY h:mm A'
    };

    function longDateFormat(key) {
      var format = this._longDateFormat[key],
          formatUpper = this._longDateFormat[key.toUpperCase()];

      if (format || !formatUpper) {
        return format;
      }

      this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
        return val.slice(1);
      });
      return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate() {
      return this._invalidDate;
    }

    var defaultOrdinal = '%d';
    var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal(number) {
      return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
      future: 'in %s',
      past: '%s ago',
      s: 'a few seconds',
      ss: '%d seconds',
      m: 'a minute',
      mm: '%d minutes',
      h: 'an hour',
      hh: '%d hours',
      d: 'a day',
      dd: '%d days',
      M: 'a month',
      MM: '%d months',
      y: 'a year',
      yy: '%d years'
    };

    function relativeTime(number, withoutSuffix, string, isFuture) {
      var output = this._relativeTime[string];
      return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }

    function pastFuture(diff, output) {
      var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
      return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias(unit, shorthand) {
      var lowerCase = unit.toLowerCase();
      aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
      return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }

    function normalizeObjectUnits(inputObject) {
      var normalizedInput = {},
          normalizedProp,
          prop;

      for (prop in inputObject) {
        if (hasOwnProp(inputObject, prop)) {
          normalizedProp = normalizeUnits(prop);

          if (normalizedProp) {
            normalizedInput[normalizedProp] = inputObject[prop];
          }
        }
      }

      return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
      priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
      var units = [];

      for (var u in unitsObj) {
        units.push({
          unit: u,
          priority: priorities[u]
        });
      }

      units.sort(function (a, b) {
        return a.priority - b.priority;
      });
      return units;
    }

    function zeroFill(number, targetLength, forceSign) {
      var absNumber = '' + Math.abs(number),
          zerosToFill = targetLength - absNumber.length,
          sign = number >= 0;
      return (sign ? forceSign ? '+' : '' : '-') + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
    var formatFunctions = {};
    var formatTokenFunctions = {}; // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }

    function addFormatToken(token, padded, ordinal, callback) {
      var func = callback;

      if (typeof callback === 'string') {
        func = function func() {
          return this[callback]();
        };
      }

      if (token) {
        formatTokenFunctions[token] = func;
      }

      if (padded) {
        formatTokenFunctions[padded[0]] = function () {
          return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
      }

      if (ordinal) {
        formatTokenFunctions[ordinal] = function () {
          return this.localeData().ordinal(func.apply(this, arguments), token);
        };
      }
    }

    function removeFormattingTokens(input) {
      if (input.match(/\[[\s\S]/)) {
        return input.replace(/^\[|\]$/g, '');
      }

      return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
      var array = format.match(formattingTokens),
          i,
          length;

      for (i = 0, length = array.length; i < length; i++) {
        if (formatTokenFunctions[array[i]]) {
          array[i] = formatTokenFunctions[array[i]];
        } else {
          array[i] = removeFormattingTokens(array[i]);
        }
      }

      return function (mom) {
        var output = '',
            i;

        for (i = 0; i < length; i++) {
          output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
        }

        return output;
      };
    } // format date using native date object


    function formatMoment(m, format) {
      if (!m.isValid()) {
        return m.localeData().invalidDate();
      }

      format = expandFormat(format, m.localeData());
      formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
      return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
      var i = 5;

      function replaceLongDateFormatTokens(input) {
        return locale.longDateFormat(input) || input;
      }

      localFormattingTokens.lastIndex = 0;

      while (i >= 0 && localFormattingTokens.test(format)) {
        format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
        localFormattingTokens.lastIndex = 0;
        i -= 1;
      }

      return format;
    }

    var match1 = /\d/; //       0 - 9

    var match2 = /\d\d/; //      00 - 99

    var match3 = /\d{3}/; //     000 - 999

    var match4 = /\d{4}/; //    0000 - 9999

    var match6 = /[+-]?\d{6}/; // -999999 - 999999

    var match1to2 = /\d\d?/; //       0 - 99

    var match3to4 = /\d\d\d\d?/; //     999 - 9999

    var match5to6 = /\d\d\d\d\d\d?/; //   99999 - 999999

    var match1to3 = /\d{1,3}/; //       0 - 999

    var match1to4 = /\d{1,4}/; //       0 - 9999

    var match1to6 = /[+-]?\d{1,6}/; // -999999 - 999999

    var matchUnsigned = /\d+/; //       0 - inf

    var matchSigned = /[+-]?\d+/; //    -inf - inf

    var matchOffset = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z

    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
    // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months

    var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;
    var regexes = {};

    function addRegexToken(token, regex, strictRegex) {
      regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
        return isStrict && strictRegex ? strictRegex : regex;
      };
    }

    function getParseRegexForToken(token, config) {
      if (!hasOwnProp(regexes, token)) {
        return new RegExp(unescapeFormat(token));
      }

      return regexes[token](config._strict, config._locale);
    } // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript


    function unescapeFormat(s) {
      return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
        return p1 || p2 || p3 || p4;
      }));
    }

    function regexEscape(s) {
      return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken(token, callback) {
      var i,
          func = callback;

      if (typeof token === 'string') {
        token = [token];
      }

      if (isNumber(callback)) {
        func = function func(input, array) {
          array[callback] = toInt(input);
        };
      }

      for (i = 0; i < token.length; i++) {
        tokens[token[i]] = func;
      }
    }

    function addWeekParseToken(token, callback) {
      addParseToken(token, function (input, array, config, token) {
        config._w = config._w || {};
        callback(input, config._w, config, token);
      });
    }

    function addTimeToArrayFromToken(token, input, config) {
      if (input != null && hasOwnProp(tokens, token)) {
        tokens[token](input, config._a, config, token);
      }
    }

    var YEAR = 0;
    var MONTH = 1;
    var DATE = 2;
    var HOUR = 3;
    var MINUTE = 4;
    var SECOND = 5;
    var MILLISECOND = 6;
    var WEEK = 7;
    var WEEKDAY = 8; // FORMATTING

    addFormatToken('Y', 0, 0, function () {
      var y = this.year();
      return y <= 9999 ? '' + y : '+' + y;
    });
    addFormatToken(0, ['YY', 2], 0, function () {
      return this.year() % 100;
    });
    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year'); // ALIASES

    addUnitAlias('year', 'y'); // PRIORITIES

    addUnitPriority('year', 1); // PARSING

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);
    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
      array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
      array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
      array[YEAR] = parseInt(input, 10);
    }); // HELPERS

    function daysInYear(year) {
      return isLeapYear(year) ? 366 : 365;
    }

    function isLeapYear(year) {
      return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    } // HOOKS


    hooks.parseTwoDigitYear = function (input) {
      return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    }; // MOMENTS


    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear() {
      return isLeapYear(this.year());
    }

    function makeGetSet(unit, keepTime) {
      return function (value) {
        if (value != null) {
          set$1(this, unit, value);
          hooks.updateOffset(this, keepTime);
          return this;
        } else {
          return get(this, unit);
        }
      };
    }

    function get(mom, unit) {
      return mom.isValid() ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
    }

    function set$1(mom, unit, value) {
      if (mom.isValid() && !isNaN(value)) {
        if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
          mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
        } else {
          mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
        }
      }
    } // MOMENTS


    function stringGet(units) {
      units = normalizeUnits(units);

      if (isFunction(this[units])) {
        return this[units]();
      }

      return this;
    }

    function stringSet(units, value) {
      if (typeof units === 'object') {
        units = normalizeObjectUnits(units);
        var prioritized = getPrioritizedUnits(units);

        for (var i = 0; i < prioritized.length; i++) {
          this[prioritized[i].unit](units[prioritized[i].unit]);
        }
      } else {
        units = normalizeUnits(units);

        if (isFunction(this[units])) {
          return this[units](value);
        }
      }

      return this;
    }

    function mod(n, x) {
      return (n % x + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
      indexOf = Array.prototype.indexOf;
    } else {
      indexOf = function indexOf(o) {
        // I know
        var i;

        for (i = 0; i < this.length; ++i) {
          if (this[i] === o) {
            return i;
          }
        }

        return -1;
      };
    }

    function daysInMonth(year, month) {
      if (isNaN(year) || isNaN(month)) {
        return NaN;
      }

      var modMonth = mod(month, 12);
      year += (month - modMonth) / 12;
      return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    } // FORMATTING


    addFormatToken('M', ['MM', 2], 'Mo', function () {
      return this.month() + 1;
    });
    addFormatToken('MMM', 0, 0, function (format) {
      return this.localeData().monthsShort(this, format);
    });
    addFormatToken('MMMM', 0, 0, function (format) {
      return this.localeData().months(this, format);
    }); // ALIASES

    addUnitAlias('month', 'M'); // PRIORITY

    addUnitPriority('month', 8); // PARSING

    addRegexToken('M', match1to2);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
      return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
      return locale.monthsRegex(isStrict);
    });
    addParseToken(['M', 'MM'], function (input, array) {
      array[MONTH] = toInt(input) - 1;
    });
    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
      var month = config._locale.monthsParse(input, token, config._strict); // if we didn't find a month name, mark the date as invalid.


      if (month != null) {
        array[MONTH] = month;
      } else {
        getParsingFlags(config).invalidMonth = input;
      }
    }); // LOCALES

    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');

    function localeMonths(m, format) {
      if (!m) {
        return isArray(this._months) ? this._months : this._months['standalone'];
      }

      return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }

    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');

    function localeMonthsShort(m, format) {
      if (!m) {
        return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort['standalone'];
      }

      return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
      var i,
          ii,
          mom,
          llc = monthName.toLocaleLowerCase();

      if (!this._monthsParse) {
        // this is not used
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];

        for (i = 0; i < 12; ++i) {
          mom = createUTC([2000, i]);
          this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
          this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
        }
      }

      if (strict) {
        if (format === 'MMM') {
          ii = indexOf.call(this._shortMonthsParse, llc);
          return ii !== -1 ? ii : null;
        } else {
          ii = indexOf.call(this._longMonthsParse, llc);
          return ii !== -1 ? ii : null;
        }
      } else {
        if (format === 'MMM') {
          ii = indexOf.call(this._shortMonthsParse, llc);

          if (ii !== -1) {
            return ii;
          }

          ii = indexOf.call(this._longMonthsParse, llc);
          return ii !== -1 ? ii : null;
        } else {
          ii = indexOf.call(this._longMonthsParse, llc);

          if (ii !== -1) {
            return ii;
          }

          ii = indexOf.call(this._shortMonthsParse, llc);
          return ii !== -1 ? ii : null;
        }
      }
    }

    function localeMonthsParse(monthName, format, strict) {
      var i, mom, regex;

      if (this._monthsParseExact) {
        return handleStrictParse.call(this, monthName, format, strict);
      }

      if (!this._monthsParse) {
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
      } // TODO: add sorting
      // Sorting makes sure if one month (or abbr) is a prefix of another
      // see sorting in computeMonthsParse


      for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);

        if (strict && !this._longMonthsParse[i]) {
          this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
          this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
        }

        if (!strict && !this._monthsParse[i]) {
          regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
          this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
        } // test the regex


        if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
          return i;
        } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
          return i;
        } else if (!strict && this._monthsParse[i].test(monthName)) {
          return i;
        }
      }
    } // MOMENTS


    function setMonth(mom, value) {
      var dayOfMonth;

      if (!mom.isValid()) {
        // No op
        return mom;
      }

      if (typeof value === 'string') {
        if (/^\d+$/.test(value)) {
          value = toInt(value);
        } else {
          value = mom.localeData().monthsParse(value); // TODO: Another silent failure?

          if (!isNumber(value)) {
            return mom;
          }
        }
      }

      dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));

      mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);

      return mom;
    }

    function getSetMonth(value) {
      if (value != null) {
        setMonth(this, value);
        hooks.updateOffset(this, true);
        return this;
      } else {
        return get(this, 'Month');
      }
    }

    function getDaysInMonth() {
      return daysInMonth(this.year(), this.month());
    }

    var defaultMonthsShortRegex = matchWord;

    function monthsShortRegex(isStrict) {
      if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
          computeMonthsParse.call(this);
        }

        if (isStrict) {
          return this._monthsShortStrictRegex;
        } else {
          return this._monthsShortRegex;
        }
      } else {
        if (!hasOwnProp(this, '_monthsShortRegex')) {
          this._monthsShortRegex = defaultMonthsShortRegex;
        }

        return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
      }
    }

    var defaultMonthsRegex = matchWord;

    function monthsRegex(isStrict) {
      if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
          computeMonthsParse.call(this);
        }

        if (isStrict) {
          return this._monthsStrictRegex;
        } else {
          return this._monthsRegex;
        }
      } else {
        if (!hasOwnProp(this, '_monthsRegex')) {
          this._monthsRegex = defaultMonthsRegex;
        }

        return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
      }
    }

    function computeMonthsParse() {
      function cmpLenRev(a, b) {
        return b.length - a.length;
      }

      var shortPieces = [],
          longPieces = [],
          mixedPieces = [],
          i,
          mom;

      for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);
        shortPieces.push(this.monthsShort(mom, ''));
        longPieces.push(this.months(mom, ''));
        mixedPieces.push(this.months(mom, ''));
        mixedPieces.push(this.monthsShort(mom, ''));
      } // Sorting makes sure if one month (or abbr) is a prefix of another it
      // will match the longer piece.


      shortPieces.sort(cmpLenRev);
      longPieces.sort(cmpLenRev);
      mixedPieces.sort(cmpLenRev);

      for (i = 0; i < 12; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
      }

      for (i = 0; i < 24; i++) {
        mixedPieces[i] = regexEscape(mixedPieces[i]);
      }

      this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
      this._monthsShortRegex = this._monthsRegex;
      this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
      this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }

    function createDate(y, m, d, h, M, s, ms) {
      // can't just apply() to create a date:
      // https://stackoverflow.com/q/181348
      var date; // the date constructor remaps years 0-99 to 1900-1999

      if (y < 100 && y >= 0) {
        // preserve leap years using a full 400 year cycle, then reset
        date = new Date(y + 400, m, d, h, M, s, ms);

        if (isFinite(date.getFullYear())) {
          date.setFullYear(y);
        }
      } else {
        date = new Date(y, m, d, h, M, s, ms);
      }

      return date;
    }

    function createUTCDate(y) {
      var date; // the Date.UTC function remaps years 0-99 to 1900-1999

      if (y < 100 && y >= 0) {
        var args = Array.prototype.slice.call(arguments); // preserve leap years using a full 400 year cycle, then reset

        args[0] = y + 400;
        date = new Date(Date.UTC.apply(null, args));

        if (isFinite(date.getUTCFullYear())) {
          date.setUTCFullYear(y);
        }
      } else {
        date = new Date(Date.UTC.apply(null, arguments));
      }

      return date;
    } // start-of-first-week - start-of-year


    function firstWeekOffset(year, dow, doy) {
      var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
      fwd = 7 + dow - doy,
          // first-week day local weekday -- which local weekday is fwd
      fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
      return -fwdlw + fwd - 1;
    } // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday


    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
      var localWeekday = (7 + weekday - dow) % 7,
          weekOffset = firstWeekOffset(year, dow, doy),
          dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
          resYear,
          resDayOfYear;

      if (dayOfYear <= 0) {
        resYear = year - 1;
        resDayOfYear = daysInYear(resYear) + dayOfYear;
      } else if (dayOfYear > daysInYear(year)) {
        resYear = year + 1;
        resDayOfYear = dayOfYear - daysInYear(year);
      } else {
        resYear = year;
        resDayOfYear = dayOfYear;
      }

      return {
        year: resYear,
        dayOfYear: resDayOfYear
      };
    }

    function weekOfYear(mom, dow, doy) {
      var weekOffset = firstWeekOffset(mom.year(), dow, doy),
          week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
          resWeek,
          resYear;

      if (week < 1) {
        resYear = mom.year() - 1;
        resWeek = week + weeksInYear(resYear, dow, doy);
      } else if (week > weeksInYear(mom.year(), dow, doy)) {
        resWeek = week - weeksInYear(mom.year(), dow, doy);
        resYear = mom.year() + 1;
      } else {
        resYear = mom.year();
        resWeek = week;
      }

      return {
        week: resWeek,
        year: resYear
      };
    }

    function weeksInYear(year, dow, doy) {
      var weekOffset = firstWeekOffset(year, dow, doy),
          weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
      return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    } // FORMATTING


    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek'); // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W'); // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5); // PARSING

    addRegexToken('w', match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2);
    addRegexToken('WW', match1to2, match2);
    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
      week[token.substr(0, 1)] = toInt(input);
    }); // HELPERS
    // LOCALES

    function localeWeek(mom) {
      return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
      dow: 0,
      // Sunday is the first day of the week.
      doy: 6 // The week that contains Jan 6th is the first week of the year.

    };

    function localeFirstDayOfWeek() {
      return this._week.dow;
    }

    function localeFirstDayOfYear() {
      return this._week.doy;
    } // MOMENTS


    function getSetWeek(input) {
      var week = this.localeData().week(this);
      return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek(input) {
      var week = weekOfYear(this, 1, 4).week;
      return input == null ? week : this.add((input - week) * 7, 'd');
    } // FORMATTING


    addFormatToken('d', 0, 'do', 'day');
    addFormatToken('dd', 0, 0, function (format) {
      return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken('ddd', 0, 0, function (format) {
      return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken('dddd', 0, 0, function (format) {
      return this.localeData().weekdays(this, format);
    });
    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday'); // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E'); // PRIORITY

    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11); // PARSING

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
      return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
      return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
      return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
      var weekday = config._locale.weekdaysParse(input, token, config._strict); // if we didn't get a weekday name, mark the date as invalid


      if (weekday != null) {
        week.d = weekday;
      } else {
        getParsingFlags(config).invalidWeekday = input;
      }
    });
    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
      week[token] = toInt(input);
    }); // HELPERS

    function parseWeekday(input, locale) {
      if (typeof input !== 'string') {
        return input;
      }

      if (!isNaN(input)) {
        return parseInt(input, 10);
      }

      input = locale.weekdaysParse(input);

      if (typeof input === 'number') {
        return input;
      }

      return null;
    }

    function parseIsoWeekday(input, locale) {
      if (typeof input === 'string') {
        return locale.weekdaysParse(input) % 7 || 7;
      }

      return isNaN(input) ? null : input;
    } // LOCALES


    function shiftWeekdays(ws, n) {
      return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');

    function localeWeekdays(m, format) {
      var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? 'format' : 'standalone'];
      return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }

    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');

    function localeWeekdaysShort(m) {
      return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }

    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');

    function localeWeekdaysMin(m) {
      return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
      var i,
          ii,
          mom,
          llc = weekdayName.toLocaleLowerCase();

      if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._minWeekdaysParse = [];

        for (i = 0; i < 7; ++i) {
          mom = createUTC([2000, 1]).day(i);
          this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
          this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
          this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
        }
      }

      if (strict) {
        if (format === 'dddd') {
          ii = indexOf.call(this._weekdaysParse, llc);
          return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
          ii = indexOf.call(this._shortWeekdaysParse, llc);
          return ii !== -1 ? ii : null;
        } else {
          ii = indexOf.call(this._minWeekdaysParse, llc);
          return ii !== -1 ? ii : null;
        }
      } else {
        if (format === 'dddd') {
          ii = indexOf.call(this._weekdaysParse, llc);

          if (ii !== -1) {
            return ii;
          }

          ii = indexOf.call(this._shortWeekdaysParse, llc);

          if (ii !== -1) {
            return ii;
          }

          ii = indexOf.call(this._minWeekdaysParse, llc);
          return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
          ii = indexOf.call(this._shortWeekdaysParse, llc);

          if (ii !== -1) {
            return ii;
          }

          ii = indexOf.call(this._weekdaysParse, llc);

          if (ii !== -1) {
            return ii;
          }

          ii = indexOf.call(this._minWeekdaysParse, llc);
          return ii !== -1 ? ii : null;
        } else {
          ii = indexOf.call(this._minWeekdaysParse, llc);

          if (ii !== -1) {
            return ii;
          }

          ii = indexOf.call(this._weekdaysParse, llc);

          if (ii !== -1) {
            return ii;
          }

          ii = indexOf.call(this._shortWeekdaysParse, llc);
          return ii !== -1 ? ii : null;
        }
      }
    }

    function localeWeekdaysParse(weekdayName, format, strict) {
      var i, mom, regex;

      if (this._weekdaysParseExact) {
        return handleStrictParse$1.call(this, weekdayName, format, strict);
      }

      if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._minWeekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._fullWeekdaysParse = [];
      }

      for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, 1]).day(i);

        if (strict && !this._fullWeekdaysParse[i]) {
          this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
          this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
          this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
        }

        if (!this._weekdaysParse[i]) {
          regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
          this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
        } // test the regex


        if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
          return i;
        } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
          return i;
        } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
          return i;
        } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
          return i;
        }
      }
    } // MOMENTS


    function getSetDayOfWeek(input) {
      if (!this.isValid()) {
        return input != null ? this : NaN;
      }

      var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();

      if (input != null) {
        input = parseWeekday(input, this.localeData());
        return this.add(input - day, 'd');
      } else {
        return day;
      }
    }

    function getSetLocaleDayOfWeek(input) {
      if (!this.isValid()) {
        return input != null ? this : NaN;
      }

      var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
      return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek(input) {
      if (!this.isValid()) {
        return input != null ? this : NaN;
      } // behaves the same as moment#day except
      // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
      // as a setter, sunday should belong to the previous week.


      if (input != null) {
        var weekday = parseIsoWeekday(input, this.localeData());
        return this.day(this.day() % 7 ? weekday : weekday - 7);
      } else {
        return this.day() || 7;
      }
    }

    var defaultWeekdaysRegex = matchWord;

    function weekdaysRegex(isStrict) {
      if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
          computeWeekdaysParse.call(this);
        }

        if (isStrict) {
          return this._weekdaysStrictRegex;
        } else {
          return this._weekdaysRegex;
        }
      } else {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
          this._weekdaysRegex = defaultWeekdaysRegex;
        }

        return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
      }
    }

    var defaultWeekdaysShortRegex = matchWord;

    function weekdaysShortRegex(isStrict) {
      if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
          computeWeekdaysParse.call(this);
        }

        if (isStrict) {
          return this._weekdaysShortStrictRegex;
        } else {
          return this._weekdaysShortRegex;
        }
      } else {
        if (!hasOwnProp(this, '_weekdaysShortRegex')) {
          this._weekdaysShortRegex = defaultWeekdaysShortRegex;
        }

        return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
      }
    }

    var defaultWeekdaysMinRegex = matchWord;

    function weekdaysMinRegex(isStrict) {
      if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
          computeWeekdaysParse.call(this);
        }

        if (isStrict) {
          return this._weekdaysMinStrictRegex;
        } else {
          return this._weekdaysMinRegex;
        }
      } else {
        if (!hasOwnProp(this, '_weekdaysMinRegex')) {
          this._weekdaysMinRegex = defaultWeekdaysMinRegex;
        }

        return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
      }
    }

    function computeWeekdaysParse() {
      function cmpLenRev(a, b) {
        return b.length - a.length;
      }

      var minPieces = [],
          shortPieces = [],
          longPieces = [],
          mixedPieces = [],
          i,
          mom,
          minp,
          shortp,
          longp;

      for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, 1]).day(i);
        minp = this.weekdaysMin(mom, '');
        shortp = this.weekdaysShort(mom, '');
        longp = this.weekdays(mom, '');
        minPieces.push(minp);
        shortPieces.push(shortp);
        longPieces.push(longp);
        mixedPieces.push(minp);
        mixedPieces.push(shortp);
        mixedPieces.push(longp);
      } // Sorting makes sure if one weekday (or abbr) is a prefix of another it
      // will match the longer piece.


      minPieces.sort(cmpLenRev);
      shortPieces.sort(cmpLenRev);
      longPieces.sort(cmpLenRev);
      mixedPieces.sort(cmpLenRev);

      for (i = 0; i < 7; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
        mixedPieces[i] = regexEscape(mixedPieces[i]);
      }

      this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
      this._weekdaysShortRegex = this._weekdaysRegex;
      this._weekdaysMinRegex = this._weekdaysRegex;
      this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
      this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
      this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    } // FORMATTING


    function hFormat() {
      return this.hours() % 12 || 12;
    }

    function kFormat() {
      return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);
    addFormatToken('hmm', 0, 0, function () {
      return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken('hmmss', 0, 0, function () {
      return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken('Hmm', 0, 0, function () {
      return '' + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken('Hmmss', 0, 0, function () {
      return '' + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });

    function meridiem(token, lowercase) {
      addFormatToken(token, 0, 0, function () {
        return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
      });
    }

    meridiem('a', true);
    meridiem('A', false); // ALIASES

    addUnitAlias('hour', 'h'); // PRIORITY

    addUnitPriority('hour', 13); // PARSING

    function matchMeridiem(isStrict, locale) {
      return locale._meridiemParse;
    }

    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2);
    addRegexToken('h', match1to2);
    addRegexToken('k', match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);
    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);
    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
      var kInput = toInt(input);
      array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
      config._isPm = config._locale.isPM(input);
      config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
      array[HOUR] = toInt(input);
      getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
      var pos = input.length - 2;
      array[HOUR] = toInt(input.substr(0, pos));
      array[MINUTE] = toInt(input.substr(pos));
      getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
      var pos1 = input.length - 4;
      var pos2 = input.length - 2;
      array[HOUR] = toInt(input.substr(0, pos1));
      array[MINUTE] = toInt(input.substr(pos1, 2));
      array[SECOND] = toInt(input.substr(pos2));
      getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
      var pos = input.length - 2;
      array[HOUR] = toInt(input.substr(0, pos));
      array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
      var pos1 = input.length - 4;
      var pos2 = input.length - 2;
      array[HOUR] = toInt(input.substr(0, pos1));
      array[MINUTE] = toInt(input.substr(pos1, 2));
      array[SECOND] = toInt(input.substr(pos2));
    }); // LOCALES

    function localeIsPM(input) {
      // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
      // Using charAt should be more compatible.
      return (input + '').toLowerCase().charAt(0) === 'p';
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;

    function localeMeridiem(hours, minutes, isLower) {
      if (hours > 11) {
        return isLower ? 'pm' : 'PM';
      } else {
        return isLower ? 'am' : 'AM';
      }
    } // MOMENTS
    // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.


    var getSetHour = makeGetSet('Hours', true);
    var baseConfig = {
      calendar: defaultCalendar,
      longDateFormat: defaultLongDateFormat,
      invalidDate: defaultInvalidDate,
      ordinal: defaultOrdinal,
      dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
      relativeTime: defaultRelativeTime,
      months: defaultLocaleMonths,
      monthsShort: defaultLocaleMonthsShort,
      week: defaultLocaleWeek,
      weekdays: defaultLocaleWeekdays,
      weekdaysMin: defaultLocaleWeekdaysMin,
      weekdaysShort: defaultLocaleWeekdaysShort,
      meridiemParse: defaultLocaleMeridiemParse
    }; // internal storage for locale config files

    var locales = {};
    var localeFamilies = {};
    var globalLocale;

    function normalizeLocale(key) {
      return key ? key.toLowerCase().replace('_', '-') : key;
    } // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root


    function chooseLocale(names) {
      var i = 0,
          j,
          next,
          locale,
          split;

      while (i < names.length) {
        split = normalizeLocale(names[i]).split('-');
        j = split.length;
        next = normalizeLocale(names[i + 1]);
        next = next ? next.split('-') : null;

        while (j > 0) {
          locale = loadLocale(split.slice(0, j).join('-'));

          if (locale) {
            return locale;
          }

          if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
            //the next array item is better than a shallower substring of this one
            break;
          }

          j--;
        }

        i++;
      }

      return globalLocale;
    }

    function loadLocale(name) {
      var oldLocale = null; // TODO: Find a better way to register and load all the locales in Node

      if (!locales[name] && 'object' !== 'undefined' && module && module.exports) {
        try {
          oldLocale = globalLocale._abbr;
          var aliasedRequire = commonjsRequire;
          aliasedRequire('./locale/' + name);
          getSetGlobalLocale(oldLocale);
        } catch (e) {}
      }

      return locales[name];
    } // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.


    function getSetGlobalLocale(key, values) {
      var data;

      if (key) {
        if (isUndefined(values)) {
          data = getLocale(key);
        } else {
          data = defineLocale(key, values);
        }

        if (data) {
          // moment.duration._locale = moment._locale = data;
          globalLocale = data;
        } else {
          if (typeof console !== 'undefined' && console.warn) {
            //warn user if arguments are passed but the locale could not be set
            console.warn('Locale ' + key + ' not found. Did you forget to load it?');
          }
        }
      }

      return globalLocale._abbr;
    }

    function defineLocale(name, config) {
      if (config !== null) {
        var locale,
            parentConfig = baseConfig;
        config.abbr = name;

        if (locales[name] != null) {
          deprecateSimple('defineLocaleOverride', 'use moment.updateLocale(localeName, config) to change ' + 'an existing locale. moment.defineLocale(localeName, ' + 'config) should only be used for creating a new locale ' + 'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
          parentConfig = locales[name]._config;
        } else if (config.parentLocale != null) {
          if (locales[config.parentLocale] != null) {
            parentConfig = locales[config.parentLocale]._config;
          } else {
            locale = loadLocale(config.parentLocale);

            if (locale != null) {
              parentConfig = locale._config;
            } else {
              if (!localeFamilies[config.parentLocale]) {
                localeFamilies[config.parentLocale] = [];
              }

              localeFamilies[config.parentLocale].push({
                name: name,
                config: config
              });
              return null;
            }
          }
        }

        locales[name] = new Locale(mergeConfigs(parentConfig, config));

        if (localeFamilies[name]) {
          localeFamilies[name].forEach(function (x) {
            defineLocale(x.name, x.config);
          });
        } // backwards compat for now: also set the locale
        // make sure we set the locale AFTER all child locales have been
        // created, so we won't end up with the child locale set.


        getSetGlobalLocale(name);
        return locales[name];
      } else {
        // useful for testing
        delete locales[name];
        return null;
      }
    }

    function updateLocale(name, config) {
      if (config != null) {
        var locale,
            tmpLocale,
            parentConfig = baseConfig; // MERGE

        tmpLocale = loadLocale(name);

        if (tmpLocale != null) {
          parentConfig = tmpLocale._config;
        }

        config = mergeConfigs(parentConfig, config);
        locale = new Locale(config);
        locale.parentLocale = locales[name];
        locales[name] = locale; // backwards compat for now: also set the locale

        getSetGlobalLocale(name);
      } else {
        // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
          if (locales[name].parentLocale != null) {
            locales[name] = locales[name].parentLocale;
          } else if (locales[name] != null) {
            delete locales[name];
          }
        }
      }

      return locales[name];
    } // returns locale data


    function getLocale(key) {
      var locale;

      if (key && key._locale && key._locale._abbr) {
        key = key._locale._abbr;
      }

      if (!key) {
        return globalLocale;
      }

      if (!isArray(key)) {
        //short-circuit everything else
        locale = loadLocale(key);

        if (locale) {
          return locale;
        }

        key = [key];
      }

      return chooseLocale(key);
    }

    function listLocales() {
      return keys(locales);
    }

    function checkOverflow(m) {
      var overflow;
      var a = m._a;

      if (a && getParsingFlags(m).overflow === -2) {
        overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;

        if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
          overflow = DATE;
        }

        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
          overflow = WEEK;
        }

        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
          overflow = WEEKDAY;
        }

        getParsingFlags(m).overflow = overflow;
      }

      return m;
    } // Pick the first defined of two or three arguments.


    function defaults(a, b, c) {
      if (a != null) {
        return a;
      }

      if (b != null) {
        return b;
      }

      return c;
    }

    function currentDateArray(config) {
      // hooks is actually the exported moment object
      var nowValue = new Date(hooks.now());

      if (config._useUTC) {
        return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
      }

      return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    } // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]


    function configFromArray(config) {
      var i,
          date,
          input = [],
          currentDate,
          expectedWeekday,
          yearToUse;

      if (config._d) {
        return;
      }

      currentDate = currentDateArray(config); //compute day of the year from weeks and weekdays

      if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
        dayOfYearFromWeekInfo(config);
      } //if the day of the year is set, figure out what it is


      if (config._dayOfYear != null) {
        yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

        if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
          getParsingFlags(config)._overflowDayOfYear = true;
        }

        date = createUTCDate(yearToUse, 0, config._dayOfYear);
        config._a[MONTH] = date.getUTCMonth();
        config._a[DATE] = date.getUTCDate();
      } // Default to current date.
      // * if no year, month, day of month are given, default to today
      // * if day of month is given, default month and year
      // * if month is given, default only year
      // * if year is given, don't default anything


      for (i = 0; i < 3 && config._a[i] == null; ++i) {
        config._a[i] = input[i] = currentDate[i];
      } // Zero out whatever was not defaulted, including time


      for (; i < 7; i++) {
        config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
      } // Check for 24:00:00.000


      if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
        config._nextDay = true;
        config._a[HOUR] = 0;
      }

      config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
      expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay(); // Apply timezone offset from input. The actual utcOffset can be changed
      // with parseZone.

      if (config._tzm != null) {
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
      }

      if (config._nextDay) {
        config._a[HOUR] = 24;
      } // check for mismatching day of week


      if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
        getParsingFlags(config).weekdayMismatch = true;
      }
    }

    function dayOfYearFromWeekInfo(config) {
      var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;
      w = config._w;

      if (w.GG != null || w.W != null || w.E != null) {
        dow = 1;
        doy = 4; // TODO: We need to take the current isoWeekYear, but that depends on
        // how we interpret now (local, utc, fixed offset). So create
        // a now version of current config (take local/utc/offset flags, and
        // create now).

        weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
        week = defaults(w.W, 1);
        weekday = defaults(w.E, 1);

        if (weekday < 1 || weekday > 7) {
          weekdayOverflow = true;
        }
      } else {
        dow = config._locale._week.dow;
        doy = config._locale._week.doy;
        var curWeek = weekOfYear(createLocal(), dow, doy);
        weekYear = defaults(w.gg, config._a[YEAR], curWeek.year); // Default to current week.

        week = defaults(w.w, curWeek.week);

        if (w.d != null) {
          // weekday -- low day numbers are considered next week
          weekday = w.d;

          if (weekday < 0 || weekday > 6) {
            weekdayOverflow = true;
          }
        } else if (w.e != null) {
          // local weekday -- counting starts from beginning of week
          weekday = w.e + dow;

          if (w.e < 0 || w.e > 6) {
            weekdayOverflow = true;
          }
        } else {
          // default to beginning of week
          weekday = dow;
        }
      }

      if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
        getParsingFlags(config)._overflowWeeks = true;
      } else if (weekdayOverflow != null) {
        getParsingFlags(config)._overflowWeekday = true;
      } else {
        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
        config._a[YEAR] = temp.year;
        config._dayOfYear = temp.dayOfYear;
      }
    } // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)


    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;
    var isoDates = [['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/], ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/], ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/], ['GGGG-[W]WW', /\d{4}-W\d\d/, false], ['YYYY-DDD', /\d{4}-\d{3}/], ['YYYY-MM', /\d{4}-\d\d/, false], ['YYYYYYMMDD', /[+-]\d{10}/], ['YYYYMMDD', /\d{8}/], // YYYYMM is NOT allowed by the standard
    ['GGGG[W]WWE', /\d{4}W\d{3}/], ['GGGG[W]WW', /\d{4}W\d{2}/, false], ['YYYYDDD', /\d{7}/]]; // iso time formats and regexes

    var isoTimes = [['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/], ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/], ['HH:mm:ss', /\d\d:\d\d:\d\d/], ['HH:mm', /\d\d:\d\d/], ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/], ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/], ['HHmmss', /\d\d\d\d\d\d/], ['HHmm', /\d\d\d\d/], ['HH', /\d\d/]];
    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i; // date from iso format

    function configFromISO(config) {
      var i,
          l,
          string = config._i,
          match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
          allowTime,
          dateFormat,
          timeFormat,
          tzFormat;

      if (match) {
        getParsingFlags(config).iso = true;

        for (i = 0, l = isoDates.length; i < l; i++) {
          if (isoDates[i][1].exec(match[1])) {
            dateFormat = isoDates[i][0];
            allowTime = isoDates[i][2] !== false;
            break;
          }
        }

        if (dateFormat == null) {
          config._isValid = false;
          return;
        }

        if (match[3]) {
          for (i = 0, l = isoTimes.length; i < l; i++) {
            if (isoTimes[i][1].exec(match[3])) {
              // match[2] should be 'T' or space
              timeFormat = (match[2] || ' ') + isoTimes[i][0];
              break;
            }
          }

          if (timeFormat == null) {
            config._isValid = false;
            return;
          }
        }

        if (!allowTime && timeFormat != null) {
          config._isValid = false;
          return;
        }

        if (match[4]) {
          if (tzRegex.exec(match[4])) {
            tzFormat = 'Z';
          } else {
            config._isValid = false;
            return;
          }
        }

        config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
        configFromStringAndFormat(config);
      } else {
        config._isValid = false;
      }
    } // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3


    var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;

    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
      var result = [untruncateYear(yearStr), defaultLocaleMonthsShort.indexOf(monthStr), parseInt(dayStr, 10), parseInt(hourStr, 10), parseInt(minuteStr, 10)];

      if (secondStr) {
        result.push(parseInt(secondStr, 10));
      }

      return result;
    }

    function untruncateYear(yearStr) {
      var year = parseInt(yearStr, 10);

      if (year <= 49) {
        return 2000 + year;
      } else if (year <= 999) {
        return 1900 + year;
      }

      return year;
    }

    function preprocessRFC2822(s) {
      // Remove comments and folding whitespace and replace multiple-spaces with a single space
      return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
      if (weekdayStr) {
        // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
        var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
            weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();

        if (weekdayProvided !== weekdayActual) {
          getParsingFlags(config).weekdayMismatch = true;
          config._isValid = false;
          return false;
        }
      }

      return true;
    }

    var obsOffsets = {
      UT: 0,
      GMT: 0,
      EDT: -4 * 60,
      EST: -5 * 60,
      CDT: -5 * 60,
      CST: -6 * 60,
      MDT: -6 * 60,
      MST: -7 * 60,
      PDT: -7 * 60,
      PST: -8 * 60
    };

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
      if (obsOffset) {
        return obsOffsets[obsOffset];
      } else if (militaryOffset) {
        // the only allowed military tz is Z
        return 0;
      } else {
        var hm = parseInt(numOffset, 10);
        var m = hm % 100,
            h = (hm - m) / 100;
        return h * 60 + m;
      }
    } // date and time from ref 2822 format


    function configFromRFC2822(config) {
      var match = rfc2822.exec(preprocessRFC2822(config._i));

      if (match) {
        var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);

        if (!checkWeekday(match[1], parsedArray, config)) {
          return;
        }

        config._a = parsedArray;
        config._tzm = calculateOffset(match[8], match[9], match[10]);
        config._d = createUTCDate.apply(null, config._a);

        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

        getParsingFlags(config).rfc2822 = true;
      } else {
        config._isValid = false;
      }
    } // date from iso format or fallback


    function configFromString(config) {
      var matched = aspNetJsonRegex.exec(config._i);

      if (matched !== null) {
        config._d = new Date(+matched[1]);
        return;
      }

      configFromISO(config);

      if (config._isValid === false) {
        delete config._isValid;
      } else {
        return;
      }

      configFromRFC2822(config);

      if (config._isValid === false) {
        delete config._isValid;
      } else {
        return;
      } // Final attempt, use Input Fallback


      hooks.createFromInputFallback(config);
    }

    hooks.createFromInputFallback = deprecate('value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' + 'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' + 'discouraged and will be removed in an upcoming major release. Please refer to ' + 'http://momentjs.com/guides/#/warnings/js-date/ for more info.', function (config) {
      config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    }); // constant that refers to the ISO standard

    hooks.ISO_8601 = function () {}; // constant that refers to the RFC 2822 form


    hooks.RFC_2822 = function () {}; // date from string and format string


    function configFromStringAndFormat(config) {
      // TODO: Move this to another part of the creation flow to prevent circular deps
      if (config._f === hooks.ISO_8601) {
        configFromISO(config);
        return;
      }

      if (config._f === hooks.RFC_2822) {
        configFromRFC2822(config);
        return;
      }

      config._a = [];
      getParsingFlags(config).empty = true; // This array is used to make a Date, either with `new Date` or `Date.UTC`

      var string = '' + config._i,
          i,
          parsedInput,
          tokens,
          token,
          skipped,
          stringLength = string.length,
          totalParsedInputLength = 0;
      tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

      for (i = 0; i < tokens.length; i++) {
        token = tokens[i];
        parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0]; // console.log('token', token, 'parsedInput', parsedInput,
        //         'regex', getParseRegexForToken(token, config));

        if (parsedInput) {
          skipped = string.substr(0, string.indexOf(parsedInput));

          if (skipped.length > 0) {
            getParsingFlags(config).unusedInput.push(skipped);
          }

          string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
          totalParsedInputLength += parsedInput.length;
        } // don't parse if it's not a known token


        if (formatTokenFunctions[token]) {
          if (parsedInput) {
            getParsingFlags(config).empty = false;
          } else {
            getParsingFlags(config).unusedTokens.push(token);
          }

          addTimeToArrayFromToken(token, parsedInput, config);
        } else if (config._strict && !parsedInput) {
          getParsingFlags(config).unusedTokens.push(token);
        }
      } // add remaining unparsed input length to the string


      getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;

      if (string.length > 0) {
        getParsingFlags(config).unusedInput.push(string);
      } // clear _12h flag if hour is <= 12


      if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) {
        getParsingFlags(config).bigHour = undefined;
      }

      getParsingFlags(config).parsedDateParts = config._a.slice(0);
      getParsingFlags(config).meridiem = config._meridiem; // handle meridiem

      config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
      configFromArray(config);
      checkOverflow(config);
    }

    function meridiemFixWrap(locale, hour, meridiem) {
      var isPm;

      if (meridiem == null) {
        // nothing to do
        return hour;
      }

      if (locale.meridiemHour != null) {
        return locale.meridiemHour(hour, meridiem);
      } else if (locale.isPM != null) {
        // Fallback
        isPm = locale.isPM(meridiem);

        if (isPm && hour < 12) {
          hour += 12;
        }

        if (!isPm && hour === 12) {
          hour = 0;
        }

        return hour;
      } else {
        // this is not supposed to happen
        return hour;
      }
    } // date from string and array of format strings


    function configFromStringAndArray(config) {
      var tempConfig, bestMoment, scoreToBeat, i, currentScore;

      if (config._f.length === 0) {
        getParsingFlags(config).invalidFormat = true;
        config._d = new Date(NaN);
        return;
      }

      for (i = 0; i < config._f.length; i++) {
        currentScore = 0;
        tempConfig = copyConfig({}, config);

        if (config._useUTC != null) {
          tempConfig._useUTC = config._useUTC;
        }

        tempConfig._f = config._f[i];
        configFromStringAndFormat(tempConfig);

        if (!isValid(tempConfig)) {
          continue;
        } // if there is any input that was not parsed add a penalty for that format


        currentScore += getParsingFlags(tempConfig).charsLeftOver; //or tokens

        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
        getParsingFlags(tempConfig).score = currentScore;

        if (scoreToBeat == null || currentScore < scoreToBeat) {
          scoreToBeat = currentScore;
          bestMoment = tempConfig;
        }
      }

      extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
      if (config._d) {
        return;
      }

      var i = normalizeObjectUnits(config._i);
      config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
        return obj && parseInt(obj, 10);
      });
      configFromArray(config);
    }

    function createFromConfig(config) {
      var res = new Moment(checkOverflow(prepareConfig(config)));

      if (res._nextDay) {
        // Adding is smart enough around DST
        res.add(1, 'd');
        res._nextDay = undefined;
      }

      return res;
    }

    function prepareConfig(config) {
      var input = config._i,
          format = config._f;
      config._locale = config._locale || getLocale(config._l);

      if (input === null || format === undefined && input === '') {
        return createInvalid({
          nullInput: true
        });
      }

      if (typeof input === 'string') {
        config._i = input = config._locale.preparse(input);
      }

      if (isMoment(input)) {
        return new Moment(checkOverflow(input));
      } else if (isDate(input)) {
        config._d = input;
      } else if (isArray(format)) {
        configFromStringAndArray(config);
      } else if (format) {
        configFromStringAndFormat(config);
      } else {
        configFromInput(config);
      }

      if (!isValid(config)) {
        config._d = null;
      }

      return config;
    }

    function configFromInput(config) {
      var input = config._i;

      if (isUndefined(input)) {
        config._d = new Date(hooks.now());
      } else if (isDate(input)) {
        config._d = new Date(input.valueOf());
      } else if (typeof input === 'string') {
        configFromString(config);
      } else if (isArray(input)) {
        config._a = map(input.slice(0), function (obj) {
          return parseInt(obj, 10);
        });
        configFromArray(config);
      } else if (isObject(input)) {
        configFromObject(config);
      } else if (isNumber(input)) {
        // from milliseconds
        config._d = new Date(input);
      } else {
        hooks.createFromInputFallback(config);
      }
    }

    function createLocalOrUTC(input, format, locale, strict, isUTC) {
      var c = {};

      if (locale === true || locale === false) {
        strict = locale;
        locale = undefined;
      }

      if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) {
        input = undefined;
      } // object construction must be done this way.
      // https://github.com/moment/moment/issues/1423


      c._isAMomentObject = true;
      c._useUTC = c._isUTC = isUTC;
      c._l = locale;
      c._i = input;
      c._f = format;
      c._strict = strict;
      return createFromConfig(c);
    }

    function createLocal(input, format, locale, strict) {
      return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate('moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/', function () {
      var other = createLocal.apply(null, arguments);

      if (this.isValid() && other.isValid()) {
        return other < this ? this : other;
      } else {
        return createInvalid();
      }
    });
    var prototypeMax = deprecate('moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/', function () {
      var other = createLocal.apply(null, arguments);

      if (this.isValid() && other.isValid()) {
        return other > this ? this : other;
      } else {
        return createInvalid();
      }
    }); // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.

    function pickBy(fn, moments) {
      var res, i;

      if (moments.length === 1 && isArray(moments[0])) {
        moments = moments[0];
      }

      if (!moments.length) {
        return createLocal();
      }

      res = moments[0];

      for (i = 1; i < moments.length; ++i) {
        if (!moments[i].isValid() || moments[i][fn](res)) {
          res = moments[i];
        }
      }

      return res;
    } // TODO: Use [].sort instead?


    function min() {
      var args = [].slice.call(arguments, 0);
      return pickBy('isBefore', args);
    }

    function max() {
      var args = [].slice.call(arguments, 0);
      return pickBy('isAfter', args);
    }

    var now = function now() {
      return Date.now ? Date.now() : +new Date();
    };

    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

    function isDurationValid(m) {
      for (var key in m) {
        if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
          return false;
        }
      }

      var unitHasDecimal = false;

      for (var i = 0; i < ordering.length; ++i) {
        if (m[ordering[i]]) {
          if (unitHasDecimal) {
            return false; // only allow non-integers for smallest unit
          }

          if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
            unitHasDecimal = true;
          }
        }
      }

      return true;
    }

    function isValid$1() {
      return this._isValid;
    }

    function createInvalid$1() {
      return createDuration(NaN);
    }

    function Duration(duration) {
      var normalizedInput = normalizeObjectUnits(duration),
          years = normalizedInput.year || 0,
          quarters = normalizedInput.quarter || 0,
          months = normalizedInput.month || 0,
          weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
          days = normalizedInput.day || 0,
          hours = normalizedInput.hour || 0,
          minutes = normalizedInput.minute || 0,
          seconds = normalizedInput.second || 0,
          milliseconds = normalizedInput.millisecond || 0;
      this._isValid = isDurationValid(normalizedInput); // representation for dateAddRemove

      this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
      minutes * 6e4 + // 1000 * 60
      hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
      // Because of dateAddRemove treats 24 hours as different from a
      // day when working around DST, we need to store them separately

      this._days = +days + weeks * 7; // It is impossible to translate months into days without knowing
      // which months you are are talking about, so we have to store
      // it separately.

      this._months = +months + quarters * 3 + years * 12;
      this._data = {};
      this._locale = getLocale();

      this._bubble();
    }

    function isDuration(obj) {
      return obj instanceof Duration;
    }

    function absRound(number) {
      if (number < 0) {
        return Math.round(-1 * number) * -1;
      } else {
        return Math.round(number);
      }
    } // FORMATTING


    function offset(token, separator) {
      addFormatToken(token, 0, 0, function () {
        var offset = this.utcOffset();
        var sign = '+';

        if (offset < 0) {
          offset = -offset;
          sign = '-';
        }

        return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
      });
    }

    offset('Z', ':');
    offset('ZZ', ''); // PARSING

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
      config._useUTC = true;
      config._tzm = offsetFromString(matchShortOffset, input);
    }); // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']

    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
      var matches = (string || '').match(matcher);

      if (matches === null) {
        return null;
      }

      var chunk = matches[matches.length - 1] || [];
      var parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
      var minutes = +(parts[1] * 60) + toInt(parts[2]);
      return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    } // Return a moment from input, that is local/utc/zone equivalent to model.


    function cloneWithOffset(input, model) {
      var res, diff;

      if (model._isUTC) {
        res = model.clone();
        diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf(); // Use low-level api, because this fn is low-level api.

        res._d.setTime(res._d.valueOf() + diff);

        hooks.updateOffset(res, false);
        return res;
      } else {
        return createLocal(input).local();
      }
    }

    function getDateOffset(m) {
      // On Firefox.24 Date#getTimezoneOffset returns a floating point.
      // https://github.com/moment/moment/pull/1871
      return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
    } // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.


    hooks.updateOffset = function () {}; // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.


    function getSetOffset(input, keepLocalTime, keepMinutes) {
      var offset = this._offset || 0,
          localAdjust;

      if (!this.isValid()) {
        return input != null ? this : NaN;
      }

      if (input != null) {
        if (typeof input === 'string') {
          input = offsetFromString(matchShortOffset, input);

          if (input === null) {
            return this;
          }
        } else if (Math.abs(input) < 16 && !keepMinutes) {
          input = input * 60;
        }

        if (!this._isUTC && keepLocalTime) {
          localAdjust = getDateOffset(this);
        }

        this._offset = input;
        this._isUTC = true;

        if (localAdjust != null) {
          this.add(localAdjust, 'm');
        }

        if (offset !== input) {
          if (!keepLocalTime || this._changeInProgress) {
            addSubtract(this, createDuration(input - offset, 'm'), 1, false);
          } else if (!this._changeInProgress) {
            this._changeInProgress = true;
            hooks.updateOffset(this, true);
            this._changeInProgress = null;
          }
        }

        return this;
      } else {
        return this._isUTC ? offset : getDateOffset(this);
      }
    }

    function getSetZone(input, keepLocalTime) {
      if (input != null) {
        if (typeof input !== 'string') {
          input = -input;
        }

        this.utcOffset(input, keepLocalTime);
        return this;
      } else {
        return -this.utcOffset();
      }
    }

    function setOffsetToUTC(keepLocalTime) {
      return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal(keepLocalTime) {
      if (this._isUTC) {
        this.utcOffset(0, keepLocalTime);
        this._isUTC = false;

        if (keepLocalTime) {
          this.subtract(getDateOffset(this), 'm');
        }
      }

      return this;
    }

    function setOffsetToParsedOffset() {
      if (this._tzm != null) {
        this.utcOffset(this._tzm, false, true);
      } else if (typeof this._i === 'string') {
        var tZone = offsetFromString(matchOffset, this._i);

        if (tZone != null) {
          this.utcOffset(tZone);
        } else {
          this.utcOffset(0, true);
        }
      }

      return this;
    }

    function hasAlignedHourOffset(input) {
      if (!this.isValid()) {
        return false;
      }

      input = input ? createLocal(input).utcOffset() : 0;
      return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime() {
      return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }

    function isDaylightSavingTimeShifted() {
      if (!isUndefined(this._isDSTShifted)) {
        return this._isDSTShifted;
      }

      var c = {};
      copyConfig(c, this);
      c = prepareConfig(c);

      if (c._a) {
        var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
        this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
      } else {
        this._isDSTShifted = false;
      }

      return this._isDSTShifted;
    }

    function isLocal() {
      return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset() {
      return this.isValid() ? this._isUTC : false;
    }

    function isUtc() {
      return this.isValid() ? this._isUTC && this._offset === 0 : false;
    } // ASP.NET json date format regex


    var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/; // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day

    var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration(input, key) {
      var duration = input,
          // matching against regexp is expensive, do it on demand
      match = null,
          sign,
          ret,
          diffRes;

      if (isDuration(input)) {
        duration = {
          ms: input._milliseconds,
          d: input._days,
          M: input._months
        };
      } else if (isNumber(input)) {
        duration = {};

        if (key) {
          duration[key] = input;
        } else {
          duration.milliseconds = input;
        }
      } else if (!!(match = aspNetRegex.exec(input))) {
        sign = match[1] === '-' ? -1 : 1;
        duration = {
          y: 0,
          d: toInt(match[DATE]) * sign,
          h: toInt(match[HOUR]) * sign,
          m: toInt(match[MINUTE]) * sign,
          s: toInt(match[SECOND]) * sign,
          ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match

        };
      } else if (!!(match = isoRegex.exec(input))) {
        sign = match[1] === '-' ? -1 : 1;
        duration = {
          y: parseIso(match[2], sign),
          M: parseIso(match[3], sign),
          w: parseIso(match[4], sign),
          d: parseIso(match[5], sign),
          h: parseIso(match[6], sign),
          m: parseIso(match[7], sign),
          s: parseIso(match[8], sign)
        };
      } else if (duration == null) {
        // checks for null or undefined
        duration = {};
      } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
        diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
        duration = {};
        duration.ms = diffRes.milliseconds;
        duration.M = diffRes.months;
      }

      ret = new Duration(duration);

      if (isDuration(input) && hasOwnProp(input, '_locale')) {
        ret._locale = input._locale;
      }

      return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso(inp, sign) {
      // We'd normally use ~~inp for this, but unfortunately it also
      // converts floats to ints.
      // inp may be undefined, so careful calling replace on it.
      var res = inp && parseFloat(inp.replace(',', '.')); // apply sign while we're at it

      return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
      var res = {};
      res.months = other.month() - base.month() + (other.year() - base.year()) * 12;

      if (base.clone().add(res.months, 'M').isAfter(other)) {
        --res.months;
      }

      res.milliseconds = +other - +base.clone().add(res.months, 'M');
      return res;
    }

    function momentsDifference(base, other) {
      var res;

      if (!(base.isValid() && other.isValid())) {
        return {
          milliseconds: 0,
          months: 0
        };
      }

      other = cloneWithOffset(other, base);

      if (base.isBefore(other)) {
        res = positiveMomentsDifference(base, other);
      } else {
        res = positiveMomentsDifference(other, base);
        res.milliseconds = -res.milliseconds;
        res.months = -res.months;
      }

      return res;
    } // TODO: remove 'name' arg after deprecation is removed


    function createAdder(direction, name) {
      return function (val, period) {
        var dur, tmp; //invert the arguments, but complain about it

        if (period !== null && !isNaN(+period)) {
          deprecateSimple(name, 'moment().' + name + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' + 'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
          tmp = val;
          val = period;
          period = tmp;
        }

        val = typeof val === 'string' ? +val : val;
        dur = createDuration(val, period);
        addSubtract(this, dur, direction);
        return this;
      };
    }

    function addSubtract(mom, duration, isAdding, updateOffset) {
      var milliseconds = duration._milliseconds,
          days = absRound(duration._days),
          months = absRound(duration._months);

      if (!mom.isValid()) {
        // No op
        return;
      }

      updateOffset = updateOffset == null ? true : updateOffset;

      if (months) {
        setMonth(mom, get(mom, 'Month') + months * isAdding);
      }

      if (days) {
        set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
      }

      if (milliseconds) {
        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
      }

      if (updateOffset) {
        hooks.updateOffset(mom, days || months);
      }
    }

    var add = createAdder(1, 'add');
    var subtract = createAdder(-1, 'subtract');

    function getCalendarFormat(myMoment, now) {
      var diff = myMoment.diff(now, 'days', true);
      return diff < -6 ? 'sameElse' : diff < -1 ? 'lastWeek' : diff < 0 ? 'lastDay' : diff < 1 ? 'sameDay' : diff < 2 ? 'nextDay' : diff < 7 ? 'nextWeek' : 'sameElse';
    }

    function calendar$1(time, formats) {
      // We want to compare the start of today, vs this.
      // Getting start-of-today depends on whether we're local/utc/offset or not.
      var now = time || createLocal(),
          sod = cloneWithOffset(now, this).startOf('day'),
          format = hooks.calendarFormat(this, sod) || 'sameElse';
      var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
      return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }

    function clone() {
      return new Moment(this);
    }

    function isAfter(input, units) {
      var localInput = isMoment(input) ? input : createLocal(input);

      if (!(this.isValid() && localInput.isValid())) {
        return false;
      }

      units = normalizeUnits(units) || 'millisecond';

      if (units === 'millisecond') {
        return this.valueOf() > localInput.valueOf();
      } else {
        return localInput.valueOf() < this.clone().startOf(units).valueOf();
      }
    }

    function isBefore(input, units) {
      var localInput = isMoment(input) ? input : createLocal(input);

      if (!(this.isValid() && localInput.isValid())) {
        return false;
      }

      units = normalizeUnits(units) || 'millisecond';

      if (units === 'millisecond') {
        return this.valueOf() < localInput.valueOf();
      } else {
        return this.clone().endOf(units).valueOf() < localInput.valueOf();
      }
    }

    function isBetween(from, to, units, inclusivity) {
      var localFrom = isMoment(from) ? from : createLocal(from),
          localTo = isMoment(to) ? to : createLocal(to);

      if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
        return false;
      }

      inclusivity = inclusivity || '()';
      return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }

    function isSame(input, units) {
      var localInput = isMoment(input) ? input : createLocal(input),
          inputMs;

      if (!(this.isValid() && localInput.isValid())) {
        return false;
      }

      units = normalizeUnits(units) || 'millisecond';

      if (units === 'millisecond') {
        return this.valueOf() === localInput.valueOf();
      } else {
        inputMs = localInput.valueOf();
        return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
      }
    }

    function isSameOrAfter(input, units) {
      return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore(input, units) {
      return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff(input, units, asFloat) {
      var that, zoneDelta, output;

      if (!this.isValid()) {
        return NaN;
      }

      that = cloneWithOffset(input, this);

      if (!that.isValid()) {
        return NaN;
      }

      zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
      units = normalizeUnits(units);

      switch (units) {
        case 'year':
          output = monthDiff(this, that) / 12;
          break;

        case 'month':
          output = monthDiff(this, that);
          break;

        case 'quarter':
          output = monthDiff(this, that) / 3;
          break;

        case 'second':
          output = (this - that) / 1e3;
          break;
        // 1000

        case 'minute':
          output = (this - that) / 6e4;
          break;
        // 1000 * 60

        case 'hour':
          output = (this - that) / 36e5;
          break;
        // 1000 * 60 * 60

        case 'day':
          output = (this - that - zoneDelta) / 864e5;
          break;
        // 1000 * 60 * 60 * 24, negate dst

        case 'week':
          output = (this - that - zoneDelta) / 6048e5;
          break;
        // 1000 * 60 * 60 * 24 * 7, negate dst

        default:
          output = this - that;
      }

      return asFloat ? output : absFloor(output);
    }

    function monthDiff(a, b) {
      // difference in months
      var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
          // b is in (anchor - 1 month, anchor + 1 month)
      anchor = a.clone().add(wholeMonthDiff, 'months'),
          anchor2,
          adjust;

      if (b - anchor < 0) {
        anchor2 = a.clone().add(wholeMonthDiff - 1, 'months'); // linear across the month

        adjust = (b - anchor) / (anchor - anchor2);
      } else {
        anchor2 = a.clone().add(wholeMonthDiff + 1, 'months'); // linear across the month

        adjust = (b - anchor) / (anchor2 - anchor);
      } //check for negative zero, return zero if negative zero


      return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString() {
      return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
      if (!this.isValid()) {
        return null;
      }

      var utc = keepOffset !== true;
      var m = utc ? this.clone().utc() : this;

      if (m.year() < 0 || m.year() > 9999) {
        return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
      }

      if (isFunction(Date.prototype.toISOString)) {
        // native implementation is ~50x faster, use it when we can
        if (utc) {
          return this.toDate().toISOString();
        } else {
          return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
        }
      }

      return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */


    function inspect() {
      if (!this.isValid()) {
        return 'moment.invalid(/* ' + this._i + ' */)';
      }

      var func = 'moment';
      var zone = '';

      if (!this.isLocal()) {
        func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
        zone = 'Z';
      }

      var prefix = '[' + func + '("]';
      var year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
      var datetime = '-MM-DD[T]HH:mm:ss.SSS';
      var suffix = zone + '[")]';
      return this.format(prefix + year + datetime + suffix);
    }

    function format(inputString) {
      if (!inputString) {
        inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
      }

      var output = formatMoment(this, inputString);
      return this.localeData().postformat(output);
    }

    function from(time, withoutSuffix) {
      if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) {
        return createDuration({
          to: this,
          from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
      } else {
        return this.localeData().invalidDate();
      }
    }

    function fromNow(withoutSuffix) {
      return this.from(createLocal(), withoutSuffix);
    }

    function to(time, withoutSuffix) {
      if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) {
        return createDuration({
          from: this,
          to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
      } else {
        return this.localeData().invalidDate();
      }
    }

    function toNow(withoutSuffix) {
      return this.to(createLocal(), withoutSuffix);
    } // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.


    function locale(key) {
      var newLocaleData;

      if (key === undefined) {
        return this._locale._abbr;
      } else {
        newLocaleData = getLocale(key);

        if (newLocaleData != null) {
          this._locale = newLocaleData;
        }

        return this;
      }
    }

    var lang = deprecate('moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.', function (key) {
      if (key === undefined) {
        return this.localeData();
      } else {
        return this.locale(key);
      }
    });

    function localeData() {
      return this._locale;
    }

    var MS_PER_SECOND = 1000;
    var MS_PER_MINUTE = 60 * MS_PER_SECOND;
    var MS_PER_HOUR = 60 * MS_PER_MINUTE;
    var MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR; // actual modulo - handles negative numbers (for dates before 1970):

    function mod$1(dividend, divisor) {
      return (dividend % divisor + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
      // the date constructor remaps years 0-99 to 1900-1999
      if (y < 100 && y >= 0) {
        // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
      } else {
        return new Date(y, m, d).valueOf();
      }
    }

    function utcStartOfDate(y, m, d) {
      // Date.UTC remaps years 0-99 to 1900-1999
      if (y < 100 && y >= 0) {
        // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
      } else {
        return Date.UTC(y, m, d);
      }
    }

    function startOf(units) {
      var time;
      units = normalizeUnits(units);

      if (units === undefined || units === 'millisecond' || !this.isValid()) {
        return this;
      }

      var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

      switch (units) {
        case 'year':
          time = startOfDate(this.year(), 0, 1);
          break;

        case 'quarter':
          time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
          break;

        case 'month':
          time = startOfDate(this.year(), this.month(), 1);
          break;

        case 'week':
          time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
          break;

        case 'isoWeek':
          time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
          break;

        case 'day':
        case 'date':
          time = startOfDate(this.year(), this.month(), this.date());
          break;

        case 'hour':
          time = this._d.valueOf();
          time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
          break;

        case 'minute':
          time = this._d.valueOf();
          time -= mod$1(time, MS_PER_MINUTE);
          break;

        case 'second':
          time = this._d.valueOf();
          time -= mod$1(time, MS_PER_SECOND);
          break;
      }

      this._d.setTime(time);

      hooks.updateOffset(this, true);
      return this;
    }

    function endOf(units) {
      var time;
      units = normalizeUnits(units);

      if (units === undefined || units === 'millisecond' || !this.isValid()) {
        return this;
      }

      var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

      switch (units) {
        case 'year':
          time = startOfDate(this.year() + 1, 0, 1) - 1;
          break;

        case 'quarter':
          time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
          break;

        case 'month':
          time = startOfDate(this.year(), this.month() + 1, 1) - 1;
          break;

        case 'week':
          time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
          break;

        case 'isoWeek':
          time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
          break;

        case 'day':
        case 'date':
          time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
          break;

        case 'hour':
          time = this._d.valueOf();
          time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
          break;

        case 'minute':
          time = this._d.valueOf();
          time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
          break;

        case 'second':
          time = this._d.valueOf();
          time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
          break;
      }

      this._d.setTime(time);

      hooks.updateOffset(this, true);
      return this;
    }

    function valueOf() {
      return this._d.valueOf() - (this._offset || 0) * 60000;
    }

    function unix() {
      return Math.floor(this.valueOf() / 1000);
    }

    function toDate() {
      return new Date(this.valueOf());
    }

    function toArray() {
      var m = this;
      return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
    }

    function toObject() {
      var m = this;
      return {
        years: m.year(),
        months: m.month(),
        date: m.date(),
        hours: m.hours(),
        minutes: m.minutes(),
        seconds: m.seconds(),
        milliseconds: m.milliseconds()
      };
    }

    function toJSON() {
      // new Date(NaN).toJSON() === null
      return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2() {
      return isValid(this);
    }

    function parsingFlags() {
      return extend({}, getParsingFlags(this));
    }

    function invalidAt() {
      return getParsingFlags(this).overflow;
    }

    function creationData() {
      return {
        input: this._i,
        format: this._f,
        locale: this._locale,
        isUTC: this._isUTC,
        strict: this._strict
      };
    } // FORMATTING


    addFormatToken(0, ['gg', 2], 0, function () {
      return this.weekYear() % 100;
    });
    addFormatToken(0, ['GG', 2], 0, function () {
      return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken(token, getter) {
      addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear'); // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG'); // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1); // PARSING

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);
    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
      week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
      week[token] = hooks.parseTwoDigitYear(input);
    }); // MOMENTS

    function getSetWeekYear(input) {
      return getSetWeekYearHelper.call(this, input, this.week(), this.weekday(), this.localeData()._week.dow, this.localeData()._week.doy);
    }

    function getSetISOWeekYear(input) {
      return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }

    function getISOWeeksInYear() {
      return weeksInYear(this.year(), 1, 4);
    }

    function getWeeksInYear() {
      var weekInfo = this.localeData()._week;

      return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
      var weeksTarget;

      if (input == null) {
        return weekOfYear(this, dow, doy).year;
      } else {
        weeksTarget = weeksInYear(input, dow, doy);

        if (week > weeksTarget) {
          week = weeksTarget;
        }

        return setWeekAll.call(this, input, week, weekday, dow, doy);
      }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
      var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
          date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
      this.year(date.getUTCFullYear());
      this.month(date.getUTCMonth());
      this.date(date.getUTCDate());
      return this;
    } // FORMATTING


    addFormatToken('Q', 0, 'Qo', 'quarter'); // ALIASES

    addUnitAlias('quarter', 'Q'); // PRIORITY

    addUnitPriority('quarter', 7); // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
      array[MONTH] = (toInt(input) - 1) * 3;
    }); // MOMENTS

    function getSetQuarter(input) {
      return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    } // FORMATTING


    addFormatToken('D', ['DD', 2], 'Do', 'date'); // ALIASES

    addUnitAlias('date', 'D'); // PRIORITY

    addUnitPriority('date', 9); // PARSING

    addRegexToken('D', match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
      // TODO: Remove "ordinalParse" fallback in next major release.
      return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
      array[DATE] = toInt(input.match(match1to2)[0]);
    }); // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true); // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear'); // ALIASES

    addUnitAlias('dayOfYear', 'DDD'); // PRIORITY

    addUnitPriority('dayOfYear', 4); // PARSING

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
      config._dayOfYear = toInt(input);
    }); // HELPERS
    // MOMENTS

    function getSetDayOfYear(input) {
      var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
      return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    } // FORMATTING


    addFormatToken('m', ['mm', 2], 0, 'minute'); // ALIASES

    addUnitAlias('minute', 'm'); // PRIORITY

    addUnitPriority('minute', 14); // PARSING

    addRegexToken('m', match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE); // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false); // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second'); // ALIASES

    addUnitAlias('second', 's'); // PRIORITY

    addUnitPriority('second', 15); // PARSING

    addRegexToken('s', match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND); // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false); // FORMATTING

    addFormatToken('S', 0, 0, function () {
      return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, ['SS', 2], 0, function () {
      return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
      return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
      return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
      return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
      return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
      return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
      return this.millisecond() * 1000000;
    }); // ALIASES

    addUnitAlias('millisecond', 'ms'); // PRIORITY

    addUnitPriority('millisecond', 16); // PARSING

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);
    var token;

    for (token = 'SSSS'; token.length <= 9; token += 'S') {
      addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
      array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
      addParseToken(token, parseMs);
    } // MOMENTS


    var getSetMillisecond = makeGetSet('Milliseconds', false); // FORMATTING

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName'); // MOMENTS

    function getZoneAbbr() {
      return this._isUTC ? 'UTC' : '';
    }

    function getZoneName() {
      return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

    function createUnix(input) {
      return createLocal(input * 1000);
    }

    function createInZone() {
      return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat(string) {
      return string;
    }

    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1(format, index, field, setter) {
      var locale = getLocale();
      var utc = createUTC().set(setter, index);
      return locale[field](utc, format);
    }

    function listMonthsImpl(format, index, field) {
      if (isNumber(format)) {
        index = format;
        format = undefined;
      }

      format = format || '';

      if (index != null) {
        return get$1(format, index, field, 'month');
      }

      var i;
      var out = [];

      for (i = 0; i < 12; i++) {
        out[i] = get$1(format, i, field, 'month');
      }

      return out;
    } // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)


    function listWeekdaysImpl(localeSorted, format, index, field) {
      if (typeof localeSorted === 'boolean') {
        if (isNumber(format)) {
          index = format;
          format = undefined;
        }

        format = format || '';
      } else {
        format = localeSorted;
        index = format;
        localeSorted = false;

        if (isNumber(format)) {
          index = format;
          format = undefined;
        }

        format = format || '';
      }

      var locale = getLocale(),
          shift = localeSorted ? locale._week.dow : 0;

      if (index != null) {
        return get$1(format, (index + shift) % 7, field, 'day');
      }

      var i;
      var out = [];

      for (i = 0; i < 7; i++) {
        out[i] = get$1(format, (i + shift) % 7, field, 'day');
      }

      return out;
    }

    function listMonths(format, index) {
      return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort(format, index) {
      return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays(localeSorted, format, index) {
      return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort(localeSorted, format, index) {
      return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin(localeSorted, format, index) {
      return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
      dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
      ordinal: function ordinal(number) {
        var b = number % 10,
            output = toInt(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
        return number + output;
      }
    }); // Side effect imports

    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
    var mathAbs = Math.abs;

    function abs() {
      var data = this._data;
      this._milliseconds = mathAbs(this._milliseconds);
      this._days = mathAbs(this._days);
      this._months = mathAbs(this._months);
      data.milliseconds = mathAbs(data.milliseconds);
      data.seconds = mathAbs(data.seconds);
      data.minutes = mathAbs(data.minutes);
      data.hours = mathAbs(data.hours);
      data.months = mathAbs(data.months);
      data.years = mathAbs(data.years);
      return this;
    }

    function addSubtract$1(duration, input, value, direction) {
      var other = createDuration(input, value);
      duration._milliseconds += direction * other._milliseconds;
      duration._days += direction * other._days;
      duration._months += direction * other._months;
      return duration._bubble();
    } // supports only 2.0-style add(1, 's') or add(duration)


    function add$1(input, value) {
      return addSubtract$1(this, input, value, 1);
    } // supports only 2.0-style subtract(1, 's') or subtract(duration)


    function subtract$1(input, value) {
      return addSubtract$1(this, input, value, -1);
    }

    function absCeil(number) {
      if (number < 0) {
        return Math.floor(number);
      } else {
        return Math.ceil(number);
      }
    }

    function bubble() {
      var milliseconds = this._milliseconds;
      var days = this._days;
      var months = this._months;
      var data = this._data;
      var seconds, minutes, hours, years, monthsFromDays; // if we have a mix of positive and negative values, bubble down first
      // check: https://github.com/moment/moment/issues/2166

      if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
        milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
        days = 0;
        months = 0;
      } // The following code bubbles up values, see the tests for
      // examples of what that means.


      data.milliseconds = milliseconds % 1000;
      seconds = absFloor(milliseconds / 1000);
      data.seconds = seconds % 60;
      minutes = absFloor(seconds / 60);
      data.minutes = minutes % 60;
      hours = absFloor(minutes / 60);
      data.hours = hours % 24;
      days += absFloor(hours / 24); // convert days to months

      monthsFromDays = absFloor(daysToMonths(days));
      months += monthsFromDays;
      days -= absCeil(monthsToDays(monthsFromDays)); // 12 months -> 1 year

      years = absFloor(months / 12);
      months %= 12;
      data.days = days;
      data.months = months;
      data.years = years;
      return this;
    }

    function daysToMonths(days) {
      // 400 years have 146097 days (taking into account leap year rules)
      // 400 years have 12 months === 4800
      return days * 4800 / 146097;
    }

    function monthsToDays(months) {
      // the reverse of daysToMonths
      return months * 146097 / 4800;
    }

    function as(units) {
      if (!this.isValid()) {
        return NaN;
      }

      var days;
      var months;
      var milliseconds = this._milliseconds;
      units = normalizeUnits(units);

      if (units === 'month' || units === 'quarter' || units === 'year') {
        days = this._days + milliseconds / 864e5;
        months = this._months + daysToMonths(days);

        switch (units) {
          case 'month':
            return months;

          case 'quarter':
            return months / 3;

          case 'year':
            return months / 12;
        }
      } else {
        // handle milliseconds separately because of floating point math errors (issue #1867)
        days = this._days + Math.round(monthsToDays(this._months));

        switch (units) {
          case 'week':
            return days / 7 + milliseconds / 6048e5;

          case 'day':
            return days + milliseconds / 864e5;

          case 'hour':
            return days * 24 + milliseconds / 36e5;

          case 'minute':
            return days * 1440 + milliseconds / 6e4;

          case 'second':
            return days * 86400 + milliseconds / 1000;
          // Math.floor prevents floating point math errors here

          case 'millisecond':
            return Math.floor(days * 864e5) + milliseconds;

          default:
            throw new Error('Unknown unit ' + units);
        }
      }
    } // TODO: Use this.as('ms')?


    function valueOf$1() {
      if (!this.isValid()) {
        return NaN;
      }

      return this._milliseconds + this._days * 864e5 + this._months % 12 * 2592e6 + toInt(this._months / 12) * 31536e6;
    }

    function makeAs(alias) {
      return function () {
        return this.as(alias);
      };
    }

    var asMilliseconds = makeAs('ms');
    var asSeconds = makeAs('s');
    var asMinutes = makeAs('m');
    var asHours = makeAs('h');
    var asDays = makeAs('d');
    var asWeeks = makeAs('w');
    var asMonths = makeAs('M');
    var asQuarters = makeAs('Q');
    var asYears = makeAs('y');

    function clone$1() {
      return createDuration(this);
    }

    function get$2(units) {
      units = normalizeUnits(units);
      return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
      return function () {
        return this.isValid() ? this._data[name] : NaN;
      };
    }

    var milliseconds = makeGetter('milliseconds');
    var seconds = makeGetter('seconds');
    var minutes = makeGetter('minutes');
    var hours = makeGetter('hours');
    var days = makeGetter('days');
    var months = makeGetter('months');
    var years = makeGetter('years');

    function weeks() {
      return absFloor(this.days() / 7);
    }

    var round = Math.round;
    var thresholds = {
      ss: 44,
      // a few seconds to seconds
      s: 45,
      // seconds to minute
      m: 45,
      // minutes to hour
      h: 22,
      // hours to day
      d: 26,
      // days to month
      M: 11 // months to year

    }; // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize

    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
      return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1(posNegDuration, withoutSuffix, locale) {
      var duration = createDuration(posNegDuration).abs();
      var seconds = round(duration.as('s'));
      var minutes = round(duration.as('m'));
      var hours = round(duration.as('h'));
      var days = round(duration.as('d'));
      var months = round(duration.as('M'));
      var years = round(duration.as('y'));
      var a = seconds <= thresholds.ss && ['s', seconds] || seconds < thresholds.s && ['ss', seconds] || minutes <= 1 && ['m'] || minutes < thresholds.m && ['mm', minutes] || hours <= 1 && ['h'] || hours < thresholds.h && ['hh', hours] || days <= 1 && ['d'] || days < thresholds.d && ['dd', days] || months <= 1 && ['M'] || months < thresholds.M && ['MM', months] || years <= 1 && ['y'] || ['yy', years];
      a[2] = withoutSuffix;
      a[3] = +posNegDuration > 0;
      a[4] = locale;
      return substituteTimeAgo.apply(null, a);
    } // This function allows you to set the rounding function for relative time strings


    function getSetRelativeTimeRounding(roundingFunction) {
      if (roundingFunction === undefined) {
        return round;
      }

      if (typeof roundingFunction === 'function') {
        round = roundingFunction;
        return true;
      }

      return false;
    } // This function allows you to set a threshold for relative time strings


    function getSetRelativeTimeThreshold(threshold, limit) {
      if (thresholds[threshold] === undefined) {
        return false;
      }

      if (limit === undefined) {
        return thresholds[threshold];
      }

      thresholds[threshold] = limit;

      if (threshold === 's') {
        thresholds.ss = limit - 1;
      }

      return true;
    }

    function humanize(withSuffix) {
      if (!this.isValid()) {
        return this.localeData().invalidDate();
      }

      var locale = this.localeData();
      var output = relativeTime$1(this, !withSuffix, locale);

      if (withSuffix) {
        output = locale.pastFuture(+this, output);
      }

      return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
      return (x > 0) - (x < 0) || +x;
    }

    function toISOString$1() {
      // for ISO strings we do not use the normal bubbling rules:
      //  * milliseconds bubble up until they become hours
      //  * days do not bubble at all
      //  * months bubble up until they become years
      // This is because there is no context-free conversion between hours and days
      // (think of clock changes)
      // and also not between days and months (28-31 days per month)
      if (!this.isValid()) {
        return this.localeData().invalidDate();
      }

      var seconds = abs$1(this._milliseconds) / 1000;
      var days = abs$1(this._days);
      var months = abs$1(this._months);
      var minutes, hours, years; // 3600 seconds -> 60 minutes -> 1 hour

      minutes = absFloor(seconds / 60);
      hours = absFloor(minutes / 60);
      seconds %= 60;
      minutes %= 60; // 12 months -> 1 year

      years = absFloor(months / 12);
      months %= 12; // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js

      var Y = years;
      var M = months;
      var D = days;
      var h = hours;
      var m = minutes;
      var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
      var total = this.asSeconds();

      if (!total) {
        // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
      }

      var totalSign = total < 0 ? '-' : '';
      var ymSign = sign(this._months) !== sign(total) ? '-' : '';
      var daysSign = sign(this._days) !== sign(total) ? '-' : '';
      var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
      return totalSign + 'P' + (Y ? ymSign + Y + 'Y' : '') + (M ? ymSign + M + 'M' : '') + (D ? daysSign + D + 'D' : '') + (h || m || s ? 'T' : '') + (h ? hmsSign + h + 'H' : '') + (m ? hmsSign + m + 'M' : '') + (s ? hmsSign + s + 'S' : '');
    }

    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang; // Side effect imports
    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf'); // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
      config._d = new Date(parseFloat(input, 10) * 1000);
    });
    addParseToken('x', function (input, array, config) {
      config._d = new Date(toInt(input));
    }); // Side effect imports

    hooks.version = '2.24.0';
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto; // currently HTML5 input type only supports 24-hour formats

    hooks.HTML5_FMT = {
      DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',
      // <input type="datetime-local" />
      DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',
      // <input type="datetime-local" step="1" />
      DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',
      // <input type="datetime-local" step="0.001" />
      DATE: 'YYYY-MM-DD',
      // <input type="date" />
      TIME: 'HH:mm',
      // <input type="time" />
      TIME_SECONDS: 'HH:mm:ss',
      // <input type="time" step="1" />
      TIME_MS: 'HH:mm:ss.SSS',
      // <input type="time" step="0.001" />
      WEEK: 'GGGG-[W]WW',
      // <input type="week" />
      MONTH: 'YYYY-MM' // <input type="month" />

    };
    return hooks;
  });
});
var a = {
  lessThanXSeconds: {
    one: 'less than a second',
    other: 'less than {{count}} seconds'
  },
  xSeconds: {
    one: '1 second',
    other: '{{count}} seconds'
  },
  halfAMinute: 'half a minute',
  lessThanXMinutes: {
    one: 'less than a minute',
    other: 'less than {{count}} minutes'
  },
  xMinutes: {
    one: '1 minute',
    other: '{{count}} minutes'
  },
  aboutXHours: {
    one: 'about 1 hour',
    other: 'about {{count}} hours'
  },
  xHours: {
    one: '1 hour',
    other: '{{count}} hours'
  },
  xDays: {
    one: '1 day',
    other: '{{count}} days'
  },
  aboutXMonths: {
    one: 'about 1 month',
    other: 'about {{count}} months'
  },
  xMonths: {
    one: '1 month',
    other: '{{count}} months'
  },
  aboutXYears: {
    one: 'about 1 year',
    other: 'about {{count}} years'
  },
  xYears: {
    one: '1 year',
    other: '{{count}} years'
  },
  overXYears: {
    one: 'over 1 year',
    other: 'over {{count}} years'
  },
  almostXYears: {
    one: 'almost 1 year',
    other: 'almost {{count}} years'
  }
};

function i(t) {
  return function (e) {
    var n = e || {},
        r = n.width ? String(n.width) : t.defaultWidth;
    return t.formats[r] || t.formats[t.defaultWidth];
  };
}

var o = {
  date: i({
    formats: {
      full: 'EEEE, MMMM do, y',
      long: 'MMMM do, y',
      medium: 'MMM d, y',
      short: 'MM/dd/yyyy'
    },
    defaultWidth: 'full'
  }),
  time: i({
    formats: {
      full: 'h:mm:ss a zzzz',
      long: 'h:mm:ss a z',
      medium: 'h:mm:ss a',
      short: 'h:mm a'
    },
    defaultWidth: 'full'
  }),
  dateTime: i({
    formats: {
      full: "{{date}} 'at' {{time}}",
      long: "{{date}} 'at' {{time}}",
      medium: '{{date}}, {{time}}',
      short: '{{date}}, {{time}}'
    },
    defaultWidth: 'full'
  })
},
    u = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: 'P'
};

function s(t) {
  return function (e, n) {
    var r,
        a = n || {};

    if ('formatting' === (a.context ? String(a.context) : 'standalone') && t.formattingValues) {
      var i = t.defaultFormattingWidth || t.defaultWidth,
          o = a.width ? String(a.width) : i;
      r = t.formattingValues[o] || t.formattingValues[i];
    } else {
      var u = t.defaultWidth,
          s = a.width ? String(a.width) : t.defaultWidth;
      r = t.values[s] || t.values[u];
    }

    return r[t.argumentCallback ? t.argumentCallback(e) : e];
  };
}

function c(t) {
  return function (e, n) {
    var r = String(e),
        a = n || {},
        i = a.width,
        o = i && t.matchPatterns[i] || t.matchPatterns[t.defaultMatchWidth],
        u = r.match(o);
    if (!u) return null;
    var s,
        c = u[0],
        d = i && t.parsePatterns[i] || t.parsePatterns[t.defaultParseWidth];
    return s = '[object Array]' === Object.prototype.toString.call(d) ? function (t, e) {
      for (var n = 0; n < t.length; n++) {
        if (e(t[n])) return n;
      }
    }(d, function (t) {
      return t.test(r);
    }) : function (t, e) {
      for (var n in t) {
        if (t.hasOwnProperty(n) && e(t[n])) return n;
      }
    }(d, function (t) {
      return t.test(r);
    }), s = t.valueCallback ? t.valueCallback(s) : s, {
      value: s = a.valueCallback ? a.valueCallback(s) : s,
      rest: r.slice(c.length)
    };
  };
}

var d,
    l = {
  code: 'en-US',
  formatDistance: function formatDistance(t, e, n) {
    var r;
    return n = n || {}, r = 'string' == typeof a[t] ? a[t] : 1 === e ? a[t].one : a[t].other.replace('{{count}}', e), n.addSuffix ? n.comparison > 0 ? 'in ' + r : r + ' ago' : r;
  },
  formatLong: o,
  formatRelative: function formatRelative(t, e, n, r) {
    return u[t];
  },
  localize: {
    ordinalNumber: function ordinalNumber(t, e) {
      var n = Number(t),
          r = n % 100;
      if (r > 20 || r < 10) switch (r % 10) {
        case 1:
          return n + 'st';

        case 2:
          return n + 'nd';

        case 3:
          return n + 'rd';
      }
      return n + 'th';
    },
    era: s({
      values: {
        narrow: ['B', 'A'],
        abbreviated: ['BC', 'AD'],
        wide: ['Before Christ', 'Anno Domini']
      },
      defaultWidth: 'wide'
    }),
    quarter: s({
      values: {
        narrow: ['1', '2', '3', '4'],
        abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
        wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter']
      },
      defaultWidth: 'wide',
      argumentCallback: function argumentCallback(t) {
        return Number(t) - 1;
      }
    }),
    month: s({
      values: {
        narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
        abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
      },
      defaultWidth: 'wide'
    }),
    day: s({
      values: {
        narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
        short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
        abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
      },
      defaultWidth: 'wide'
    }),
    dayPeriod: s({
      values: {
        narrow: {
          am: 'a',
          pm: 'p',
          midnight: 'mi',
          noon: 'n',
          morning: 'morning',
          afternoon: 'afternoon',
          evening: 'evening',
          night: 'night'
        },
        abbreviated: {
          am: 'AM',
          pm: 'PM',
          midnight: 'midnight',
          noon: 'noon',
          morning: 'morning',
          afternoon: 'afternoon',
          evening: 'evening',
          night: 'night'
        },
        wide: {
          am: 'a.m.',
          pm: 'p.m.',
          midnight: 'midnight',
          noon: 'noon',
          morning: 'morning',
          afternoon: 'afternoon',
          evening: 'evening',
          night: 'night'
        }
      },
      defaultWidth: 'wide',
      formattingValues: {
        narrow: {
          am: 'a',
          pm: 'p',
          midnight: 'mi',
          noon: 'n',
          morning: 'in the morning',
          afternoon: 'in the afternoon',
          evening: 'in the evening',
          night: 'at night'
        },
        abbreviated: {
          am: 'AM',
          pm: 'PM',
          midnight: 'midnight',
          noon: 'noon',
          morning: 'in the morning',
          afternoon: 'in the afternoon',
          evening: 'in the evening',
          night: 'at night'
        },
        wide: {
          am: 'a.m.',
          pm: 'p.m.',
          midnight: 'midnight',
          noon: 'noon',
          morning: 'in the morning',
          afternoon: 'in the afternoon',
          evening: 'in the evening',
          night: 'at night'
        }
      },
      defaultFormattingWidth: 'wide'
    })
  },
  match: {
    ordinalNumber: (d = {
      matchPattern: /^(\d+)(th|st|nd|rd)?/i,
      parsePattern: /\d+/i,
      valueCallback: function valueCallback(t) {
        return parseInt(t, 10);
      }
    }, function (t, e) {
      var n = String(t),
          r = e || {},
          a = n.match(d.matchPattern);
      if (!a) return null;
      var i = a[0],
          o = n.match(d.parsePattern);
      if (!o) return null;
      var u = d.valueCallback ? d.valueCallback(o[0]) : o[0];
      return {
        value: u = r.valueCallback ? r.valueCallback(u) : u,
        rest: n.slice(i.length)
      };
    }),
    era: c({
      matchPatterns: {
        narrow: /^(b|a)/i,
        abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
        wide: /^(before christ|before common era|anno domini|common era)/i
      },
      defaultMatchWidth: 'wide',
      parsePatterns: {
        any: [/^b/i, /^(a|c)/i]
      },
      defaultParseWidth: 'any'
    }),
    quarter: c({
      matchPatterns: {
        narrow: /^[1234]/i,
        abbreviated: /^q[1234]/i,
        wide: /^[1234](th|st|nd|rd)? quarter/i
      },
      defaultMatchWidth: 'wide',
      parsePatterns: {
        any: [/1/i, /2/i, /3/i, /4/i]
      },
      defaultParseWidth: 'any',
      valueCallback: function valueCallback(t) {
        return t + 1;
      }
    }),
    month: c({
      matchPatterns: {
        narrow: /^[jfmasond]/i,
        abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
        wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
      },
      defaultMatchWidth: 'wide',
      parsePatterns: {
        narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
        any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
      },
      defaultParseWidth: 'any'
    }),
    day: c({
      matchPatterns: {
        narrow: /^[smtwf]/i,
        short: /^(su|mo|tu|we|th|fr|sa)/i,
        abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
        wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
      },
      defaultMatchWidth: 'wide',
      parsePatterns: {
        narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
        any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
      },
      defaultParseWidth: 'any'
    }),
    dayPeriod: c({
      matchPatterns: {
        narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
        any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
      },
      defaultMatchWidth: 'any',
      parsePatterns: {
        any: {
          am: /^a/i,
          pm: /^p/i,
          midnight: /^mi/i,
          noon: /^no/i,
          morning: /morning/i,
          afternoon: /afternoon/i,
          evening: /evening/i,
          night: /night/i
        }
      },
      defaultParseWidth: 'any'
    })
  },
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};

function f(t) {
  if (null === t || !0 === t || !1 === t) return NaN;
  var e = Number(t);
  return isNaN(e) ? e : e < 0 ? Math.ceil(e) : Math.floor(e);
}

function h(t) {
  if (arguments.length < 1) throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  var e = Object.prototype.toString.call(t);
  return t instanceof Date || 'object' == typeof t && '[object Date]' === e ? new Date(t.getTime()) : 'number' == typeof t || '[object Number]' === e ? new Date(t) : ('string' != typeof t && '[object String]' !== e || 'undefined' == typeof console || (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"), console.warn(new Error().stack)), new Date(NaN));
}

function g(t, e) {
  if (arguments.length < 2) throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  return function (t, e) {
    if (arguments.length < 2) throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
    var n = h(t).getTime(),
        r = f(e);
    return new Date(n + r);
  }(t, -f(e));
}

function m(t, e) {
  switch (t) {
    case 'P':
      return e.date({
        width: 'short'
      });

    case 'PP':
      return e.date({
        width: 'medium'
      });

    case 'PPP':
      return e.date({
        width: 'long'
      });

    case 'PPPP':
    default:
      return e.date({
        width: 'full'
      });
  }
}

function y(t, e) {
  switch (t) {
    case 'p':
      return e.time({
        width: 'short'
      });

    case 'pp':
      return e.time({
        width: 'medium'
      });

    case 'ppp':
      return e.time({
        width: 'long'
      });

    case 'pppp':
    default:
      return e.time({
        width: 'full'
      });
  }
}

var v = {
  p: y,
  P: function P(t, e) {
    var n,
        r = t.match(/(P+)(p+)?/),
        a = r[1],
        i = r[2];
    if (!i) return m(t, e);

    switch (a) {
      case 'P':
        n = e.dateTime({
          width: 'short'
        });
        break;

      case 'PP':
        n = e.dateTime({
          width: 'medium'
        });
        break;

      case 'PPP':
        n = e.dateTime({
          width: 'long'
        });
        break;

      case 'PPPP':
      default:
        n = e.dateTime({
          width: 'full'
        });
    }

    return n.replace('{{date}}', m(a, e)).replace('{{time}}', y(i, e));
  }
},
    b = 6e4;

function p(t) {
  var e = new Date(t.getTime()),
      n = Math.ceil(e.getTimezoneOffset());
  e.setSeconds(0, 0);
  var r = e.getTime() % b;
  return n * b + r;
}

var T = ['D', 'DD'],
    D = ['YY', 'YYYY'];

function k(t) {
  return -1 !== T.indexOf(t);
}

function x(t) {
  return -1 !== D.indexOf(t);
}

function C(t) {
  if ('YYYY' === t) throw new RangeError('Use `yyyy` instead of `YYYY` for formatting years; see: https://git.io/fxCyr');
  if ('YY' === t) throw new RangeError('Use `yy` instead of `YY` for formatting years; see: https://git.io/fxCyr');
  if ('D' === t) throw new RangeError('Use `d` instead of `D` for formatting days of the month; see: https://git.io/fxCyr');
  if ('DD' === t) throw new RangeError('Use `dd` instead of `DD` for formatting days of the month; see: https://git.io/fxCyr');
}

function M(t, e) {
  if (arguments.length < 1) throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  var n = e || {},
      r = n.locale,
      a = r && r.options && r.options.weekStartsOn,
      i = null == a ? 0 : f(a),
      o = null == n.weekStartsOn ? i : f(n.weekStartsOn);
  if (!(o >= 0 && o <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  var u = h(t),
      s = u.getUTCDay(),
      c = (s < o ? 7 : 0) + s - o;
  return u.setUTCDate(u.getUTCDate() - c), u.setUTCHours(0, 0, 0, 0), u;
}

function U(t, e) {
  if (arguments.length < 1) throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  var n = h(t, e),
      r = n.getUTCFullYear(),
      a = e || {},
      i = a.locale,
      o = i && i.options && i.options.firstWeekContainsDate,
      u = null == o ? 1 : f(o),
      s = null == a.firstWeekContainsDate ? u : f(a.firstWeekContainsDate);
  if (!(s >= 1 && s <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  var c = new Date(0);
  c.setUTCFullYear(r + 1, 0, s), c.setUTCHours(0, 0, 0, 0);
  var d = M(c, e),
      l = new Date(0);
  l.setUTCFullYear(r, 0, s), l.setUTCHours(0, 0, 0, 0);
  var g = M(l, e);
  return n.getTime() >= d.getTime() ? r + 1 : n.getTime() >= g.getTime() ? r : r - 1;
}

function q(t) {
  if (arguments.length < 1) throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  var e = h(t),
      n = e.getUTCDay(),
      r = (n < 1 ? 7 : 0) + n - 1;
  return e.setUTCDate(e.getUTCDate() - r), e.setUTCHours(0, 0, 0, 0), e;
}

function S(t) {
  if (arguments.length < 1) throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  var e = h(t),
      n = e.getUTCFullYear(),
      r = new Date(0);
  r.setUTCFullYear(n + 1, 0, 4), r.setUTCHours(0, 0, 0, 0);
  var a = q(r),
      i = new Date(0);
  i.setUTCFullYear(n, 0, 4), i.setUTCHours(0, 0, 0, 0);
  var o = q(i);
  return e.getTime() >= a.getTime() ? n + 1 : e.getTime() >= o.getTime() ? n : n - 1;
}

var Y = 6048e5;

function P(t) {
  if (arguments.length < 1) throw new TypeError('1 argument required, but only ' + arguments.length + ' present');

  var e = h(t),
      n = q(e).getTime() - function (t) {
    if (arguments.length < 1) throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
    var e = S(t),
        n = new Date(0);
    return n.setUTCFullYear(e, 0, 4), n.setUTCHours(0, 0, 0, 0), q(n);
  }(e).getTime();

  return Math.round(n / Y) + 1;
}

var H = 6048e5;

function O(t, e) {
  if (arguments.length < 1) throw new TypeError('1 argument required, but only ' + arguments.length + ' present');

  var n = h(t),
      r = M(n, e).getTime() - function (t, e) {
    if (arguments.length < 1) throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
    var n = e || {},
        r = n.locale,
        a = r && r.options && r.options.firstWeekContainsDate,
        i = null == a ? 1 : f(a),
        o = null == n.firstWeekContainsDate ? i : f(n.firstWeekContainsDate),
        u = U(t, e),
        s = new Date(0);
    return s.setUTCFullYear(u, 0, o), s.setUTCHours(0, 0, 0, 0), M(s, e);
  }(n, e).getTime();

  return Math.round(r / H) + 1;
}

function dt(t, e) {
  for (var n = t < 0 ? '-' : '', r = Math.abs(t).toString(); r.length < e;) {
    r = '0' + r;
  }

  return n + r;
}

var lt = function lt(t, e) {
  var n = t.getUTCFullYear(),
      r = n > 0 ? n : 1 - n;
  return dt('yy' === e ? r % 100 : r, e.length);
},
    ft = function ft(t, e) {
  var n = t.getUTCMonth();
  return 'M' === e ? String(n + 1) : dt(n + 1, 2);
},
    ht = function ht(t, e) {
  return dt(t.getUTCDate(), e.length);
},
    gt = function gt(t, e) {
  return dt(t.getUTCHours() % 12 || 12, e.length);
},
    wt = function wt(t, e) {
  return dt(t.getUTCHours(), e.length);
},
    mt = function mt(t, e) {
  return dt(t.getUTCMinutes(), e.length);
},
    yt = function yt(t, e) {
  return dt(t.getUTCSeconds(), e.length);
},
    vt = function vt(t, e) {
  var n = e.length,
      r = t.getUTCMilliseconds();
  return dt(Math.floor(r * Math.pow(10, n - 3)), e.length);
},
    bt = 864e5;

var pt = 'midnight',
    Tt = 'noon',
    Dt = 'morning',
    kt = 'afternoon',
    xt = 'evening',
    Ct = 'night',
    Mt = {
  G: function G(t, e, n) {
    var r = t.getUTCFullYear() > 0 ? 1 : 0;

    switch (e) {
      case 'G':
      case 'GG':
      case 'GGG':
        return n.era(r, {
          width: 'abbreviated'
        });

      case 'GGGGG':
        return n.era(r, {
          width: 'narrow'
        });

      case 'GGGG':
      default:
        return n.era(r, {
          width: 'wide'
        });
    }
  },
  y: function y(t, e, n) {
    if ('yo' === e) {
      var r = t.getUTCFullYear(),
          a = r > 0 ? r : 1 - r;
      return n.ordinalNumber(a, {
        unit: 'year'
      });
    }

    return lt(t, e);
  },
  Y: function Y(t, e, n, r) {
    var a = U(t, r),
        i = a > 0 ? a : 1 - a;
    return 'YY' === e ? dt(i % 100, 2) : 'Yo' === e ? n.ordinalNumber(i, {
      unit: 'year'
    }) : dt(i, e.length);
  },
  R: function R(t, e) {
    return dt(S(t), e.length);
  },
  u: function u(t, e) {
    return dt(t.getUTCFullYear(), e.length);
  },
  Q: function Q(t, e, n) {
    var r = Math.ceil((t.getUTCMonth() + 1) / 3);

    switch (e) {
      case 'Q':
        return String(r);

      case 'QQ':
        return dt(r, 2);

      case 'Qo':
        return n.ordinalNumber(r, {
          unit: 'quarter'
        });

      case 'QQQ':
        return n.quarter(r, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'QQQQQ':
        return n.quarter(r, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'QQQQ':
      default:
        return n.quarter(r, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  q: function q(t, e, n) {
    var r = Math.ceil((t.getUTCMonth() + 1) / 3);

    switch (e) {
      case 'q':
        return String(r);

      case 'qq':
        return dt(r, 2);

      case 'qo':
        return n.ordinalNumber(r, {
          unit: 'quarter'
        });

      case 'qqq':
        return n.quarter(r, {
          width: 'abbreviated',
          context: 'standalone'
        });

      case 'qqqqq':
        return n.quarter(r, {
          width: 'narrow',
          context: 'standalone'
        });

      case 'qqqq':
      default:
        return n.quarter(r, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  M: function M(t, e, n) {
    var r = t.getUTCMonth();

    switch (e) {
      case 'M':
      case 'MM':
        return ft(t, e);

      case 'Mo':
        return n.ordinalNumber(r + 1, {
          unit: 'month'
        });

      case 'MMM':
        return n.month(r, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'MMMMM':
        return n.month(r, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'MMMM':
      default:
        return n.month(r, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  L: function L(t, e, n) {
    var r = t.getUTCMonth();

    switch (e) {
      case 'L':
        return String(r + 1);

      case 'LL':
        return dt(r + 1, 2);

      case 'Lo':
        return n.ordinalNumber(r + 1, {
          unit: 'month'
        });

      case 'LLL':
        return n.month(r, {
          width: 'abbreviated',
          context: 'standalone'
        });

      case 'LLLLL':
        return n.month(r, {
          width: 'narrow',
          context: 'standalone'
        });

      case 'LLLL':
      default:
        return n.month(r, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  w: function w(t, e, n, r) {
    var a = O(t, r);
    return 'wo' === e ? n.ordinalNumber(a, {
      unit: 'week'
    }) : dt(a, e.length);
  },
  I: function I(t, e, n) {
    var r = P(t);
    return 'Io' === e ? n.ordinalNumber(r, {
      unit: 'week'
    }) : dt(r, e.length);
  },
  d: function d(t, e, n) {
    return 'do' === e ? n.ordinalNumber(t.getUTCDate(), {
      unit: 'date'
    }) : ht(t, e);
  },
  D: function D(t, e, n) {
    var r = function (t) {
      if (arguments.length < 1) throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
      var e = h(t),
          n = e.getTime();
      e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0);
      var r = n - e.getTime();
      return Math.floor(r / bt) + 1;
    }(t);

    return 'Do' === e ? n.ordinalNumber(r, {
      unit: 'dayOfYear'
    }) : dt(r, e.length);
  },
  E: function E(t, e, n) {
    var r = t.getUTCDay();

    switch (e) {
      case 'E':
      case 'EE':
      case 'EEE':
        return n.day(r, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'EEEEE':
        return n.day(r, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'EEEEEE':
        return n.day(r, {
          width: 'short',
          context: 'formatting'
        });

      case 'EEEE':
      default:
        return n.day(r, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  e: function e(t, _e2, n, r) {
    var a = t.getUTCDay(),
        i = (a - r.weekStartsOn + 8) % 7 || 7;

    switch (_e2) {
      case 'e':
        return String(i);

      case 'ee':
        return dt(i, 2);

      case 'eo':
        return n.ordinalNumber(i, {
          unit: 'day'
        });

      case 'eee':
        return n.day(a, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'eeeee':
        return n.day(a, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'eeeeee':
        return n.day(a, {
          width: 'short',
          context: 'formatting'
        });

      case 'eeee':
      default:
        return n.day(a, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  c: function c(t, e, n, r) {
    var a = t.getUTCDay(),
        i = (a - r.weekStartsOn + 8) % 7 || 7;

    switch (e) {
      case 'c':
        return String(i);

      case 'cc':
        return dt(i, e.length);

      case 'co':
        return n.ordinalNumber(i, {
          unit: 'day'
        });

      case 'ccc':
        return n.day(a, {
          width: 'abbreviated',
          context: 'standalone'
        });

      case 'ccccc':
        return n.day(a, {
          width: 'narrow',
          context: 'standalone'
        });

      case 'cccccc':
        return n.day(a, {
          width: 'short',
          context: 'standalone'
        });

      case 'cccc':
      default:
        return n.day(a, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  i: function i(t, e, n) {
    var r = t.getUTCDay(),
        a = 0 === r ? 7 : r;

    switch (e) {
      case 'i':
        return String(a);

      case 'ii':
        return dt(a, e.length);

      case 'io':
        return n.ordinalNumber(a, {
          unit: 'day'
        });

      case 'iii':
        return n.day(r, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'iiiii':
        return n.day(r, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'iiiiii':
        return n.day(r, {
          width: 'short',
          context: 'formatting'
        });

      case 'iiii':
      default:
        return n.day(r, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  a: function a(t, e, n) {
    var r = t.getUTCHours() / 12 >= 1 ? 'pm' : 'am';

    switch (e) {
      case 'a':
      case 'aa':
      case 'aaa':
        return n.dayPeriod(r, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'aaaaa':
        return n.dayPeriod(r, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'aaaa':
      default:
        return n.dayPeriod(r, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  b: function b(t, e, n) {
    var r,
        a = t.getUTCHours();

    switch (r = 12 === a ? Tt : 0 === a ? pt : a / 12 >= 1 ? 'pm' : 'am', e) {
      case 'b':
      case 'bb':
      case 'bbb':
        return n.dayPeriod(r, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'bbbbb':
        return n.dayPeriod(r, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'bbbb':
      default:
        return n.dayPeriod(r, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  B: function B(t, e, n) {
    var r,
        a = t.getUTCHours();

    switch (r = a >= 17 ? xt : a >= 12 ? kt : a >= 4 ? Dt : Ct, e) {
      case 'B':
      case 'BB':
      case 'BBB':
        return n.dayPeriod(r, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'BBBBB':
        return n.dayPeriod(r, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'BBBB':
      default:
        return n.dayPeriod(r, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  h: function h(t, e, n) {
    if ('ho' === e) {
      var r = t.getUTCHours() % 12;
      return 0 === r && (r = 12), n.ordinalNumber(r, {
        unit: 'hour'
      });
    }

    return gt(t, e);
  },
  H: function H(t, e, n) {
    return 'Ho' === e ? n.ordinalNumber(t.getUTCHours(), {
      unit: 'hour'
    }) : wt(t, e);
  },
  K: function K(t, e, n) {
    var r = t.getUTCHours() % 12;
    return 'Ko' === e ? n.ordinalNumber(r, {
      unit: 'hour'
    }) : dt(r, e.length);
  },
  k: function k(t, e, n) {
    var r = t.getUTCHours();
    return 0 === r && (r = 24), 'ko' === e ? n.ordinalNumber(r, {
      unit: 'hour'
    }) : dt(r, e.length);
  },
  m: function m(t, e, n) {
    return 'mo' === e ? n.ordinalNumber(t.getUTCMinutes(), {
      unit: 'minute'
    }) : mt(t, e);
  },
  s: function s(t, e, n) {
    return 'so' === e ? n.ordinalNumber(t.getUTCSeconds(), {
      unit: 'second'
    }) : yt(t, e);
  },
  S: function S(t, e) {
    return vt(t, e);
  },
  X: function X(t, e, n, r) {
    var a = (r._originalDate || t).getTimezoneOffset();
    if (0 === a) return 'Z';

    switch (e) {
      case 'X':
        return Et(a);

      case 'XXXX':
      case 'XX':
        return qt(a);

      case 'XXXXX':
      case 'XXX':
      default:
        return qt(a, ':');
    }
  },
  x: function x(t, e, n, r) {
    var a = (r._originalDate || t).getTimezoneOffset();

    switch (e) {
      case 'x':
        return Et(a);

      case 'xxxx':
      case 'xx':
        return qt(a);

      case 'xxxxx':
      case 'xxx':
      default:
        return qt(a, ':');
    }
  },
  O: function O(t, e, n, r) {
    var a = (r._originalDate || t).getTimezoneOffset();

    switch (e) {
      case 'O':
      case 'OO':
      case 'OOO':
        return 'GMT' + Ut(a, ':');

      case 'OOOO':
      default:
        return 'GMT' + qt(a, ':');
    }
  },
  z: function z(t, e, n, r) {
    var a = (r._originalDate || t).getTimezoneOffset();

    switch (e) {
      case 'z':
      case 'zz':
      case 'zzz':
        return 'GMT' + Ut(a, ':');

      case 'zzzz':
      default:
        return 'GMT' + qt(a, ':');
    }
  },
  t: function t(_t2, e, n, r) {
    var a = r._originalDate || _t2;
    return dt(Math.floor(a.getTime() / 1e3), e.length);
  },
  T: function T(t, e, n, r) {
    return dt((r._originalDate || t).getTime(), e.length);
  }
};

function Ut(t, e) {
  var n = t > 0 ? '-' : '+',
      r = Math.abs(t),
      a = Math.floor(r / 60),
      i = r % 60;
  if (0 === i) return n + String(a);
  var o = e || '';
  return n + String(a) + o + dt(i, 2);
}

function Et(t, e) {
  return t % 60 == 0 ? (t > 0 ? '-' : '+') + dt(Math.abs(t) / 60, 2) : qt(t, e);
}

function qt(t, e) {
  var n = e || '',
      r = t > 0 ? '-' : '+',
      a = Math.abs(t);
  return r + dt(Math.floor(a / 60), 2) + n + dt(a % 60, 2);
}

var St = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g,
    Yt = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g,
    Pt = /^'([^]*?)'?$/,
    Ht = /''/g,
    Ot = /[a-zA-Z]/;

function Bt(t, e, n) {
  if (arguments.length < 2) throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  var r = String(e),
      a = n || {},
      i = a.locale || l,
      o = i.options && i.options.firstWeekContainsDate,
      u = null == o ? 1 : f(o),
      s = null == a.firstWeekContainsDate ? u : f(a.firstWeekContainsDate);
  if (!(s >= 1 && s <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  var c = i.options && i.options.weekStartsOn,
      d = null == c ? 0 : f(c),
      w = null == a.weekStartsOn ? d : f(a.weekStartsOn);
  if (!(w >= 0 && w <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  if (!i.localize) throw new RangeError('locale must contain localize property');
  if (!i.formatLong) throw new RangeError('locale must contain formatLong property');
  var m = h(t);
  if (!function (t) {
    if (arguments.length < 1) throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
    var e = h(t);
    return !isNaN(e);
  }(m)) throw new RangeError('Invalid time value');
  var y = g(m, p(m)),
      b = {
    firstWeekContainsDate: s,
    weekStartsOn: w,
    locale: i,
    _originalDate: m
  };
  return r.match(Yt).map(function (t) {
    var e = t[0];
    return 'p' === e || 'P' === e ? (0, v[e])(t, i.formatLong, b) : t;
  }).join('').match(St).map(function (t) {
    if ("''" === t) return "'";
    var e = t[0];
    if ("'" === e) return t.match(Pt)[1].replace(Ht, "'");
    var n = Mt[e];
    if (n) return !a.useAdditionalWeekYearTokens && x(t) && C(t), !a.useAdditionalDayOfYearTokens && k(t) && C(t), n(y, t, i.localize, b);
    if (e.match(Ot)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + e + '`');
    return t;
  }).join('');
}

function Nt(t, e) {
  if (arguments.length < 2) throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  var n = h(t),
      r = f(e);
  return n.setDate(n.getDate() + r), n;
}

function Lt(t, e) {
  if (arguments.length < 1) throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  var n = t || {},
      r = h(n.start),
      a = h(n.end).getTime();
  if (!(r.getTime() <= a)) throw new RangeError('Invalid interval');
  var i = [],
      o = r;
  o.setHours(0, 0, 0, 0);
  var u = e && 'step' in e ? Number(e.step) : 1;
  if (u < 1 || isNaN(u)) throw new RangeError('`options.step` must be a number greater than 1');

  for (; o.getTime() <= a;) {
    i.push(h(o)), o.setDate(o.getDate() + u), o.setHours(0, 0, 0, 0);
  }

  return i;
}

function Wt(t, e) {
  if (arguments.length < 1) throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  var n = e || {},
      r = n.locale,
      a = r && r.options && r.options.weekStartsOn,
      i = null == a ? 0 : f(a),
      o = null == n.weekStartsOn ? i : f(n.weekStartsOn);
  if (!(o >= 0 && o <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  var u = h(t),
      s = u.getDay(),
      c = 6 + (s < o ? -7 : 0) - (s - o);
  return u.setDate(u.getDate() + c), u.setHours(23, 59, 59, 999), u;
}

function Ft(t) {
  if (arguments.length < 1) throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  var e = h(t);
  return e.setDate(1), e.setHours(0, 0, 0, 0), e;
}

function Qt(t, e) {
  if (arguments.length < 1) throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  var n = e || {},
      r = n.locale,
      a = r && r.options && r.options.weekStartsOn,
      i = null == a ? 0 : f(a),
      o = null == n.weekStartsOn ? i : f(n.weekStartsOn);
  if (!(o >= 0 && o <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  var u = h(t),
      s = u.getDay(),
      c = (s < o ? 7 : 0) + s - o;
  return u.setDate(u.getDate() - c), u.setHours(0, 0, 0, 0), u;
}

function Rt(t) {
  var e = void 0 === t ? {} : t,
      n = e.firstDayOfWeek,
      r = void 0 === n ? 1 : n,
      a = e.weekdayLabelFormat,
      i = void 0 === a ? function (t) {
    return Bt(t, 'iiiiii');
  } : a,
      o = new Date();
  return Lt({
    start: Nt(Qt(o), r),
    end: Nt(Wt(o), r)
  }).reduce(function (t, e) {
    return t.push(i(e)), t;
  }, []);
}

function It(t) {
  var e = t.year,
      n = t.month,
      r = t.firstDayOfWeek,
      a = void 0 === r ? 1 : r,
      i = t.dayLabelFormat,
      o = void 0 === i ? function (t) {
    return Bt(t, 'dd');
  } : i,
      u = new Date(e, n),
      s = Ft(u),
      c = function (t) {
    if (arguments.length < 1) throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
    return h(t).getDay();
  }(s),
      d = function (t) {
    if (arguments.length < 1) throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
    var e = h(t),
        n = e.getMonth();
    return e.setFullYear(e.getFullYear(), n + 1, 0), e.setHours(23, 59, 59, 999), e;
  }(u);

  return function () {
    for (var t = 0, e = 0, n = arguments.length; e < n; e++) {
      t += arguments[e].length;
    }

    var r = Array(t),
        a = 0;

    for (e = 0; e < n; e++) {
      for (var i = arguments[e], o = 0, u = i.length; o < u; o++, a++) {
        r[a] = i[o];
      }
    }

    return r;
  }(Array.from(Array(c >= a ? c - a : 6 - a + c + 1).keys()).fill(0), Lt({
    start: s,
    end: d
  }).map(function (t) {
    return {
      date: t,
      dayLabel: o(t)
    };
  }));
}

var Xt = function Xt(t) {
  return Bt(t, 'dd');
},
    Gt = function Gt(t) {
  return Bt(t, 'eeeeee');
},
    At = function At(t) {
  return Bt(t, 'MMMM yyyy');
};

function zt(e) {
  var n = e.year,
      r = e.month,
      a = e.firstDayOfWeek,
      i = void 0 === a ? 1 : a,
      o = e.dayLabelFormat,
      u = void 0 === o ? Xt : o,
      s = e.weekdayLabelFormat,
      c = void 0 === s ? Gt : s,
      d = e.monthLabelFormat,
      l = void 0 === d ? At : d;
  return {
    days: useMemo(function () {
      return It({
        year: n,
        month: r,
        firstDayOfWeek: i,
        dayLabelFormat: u
      });
    }, [n, r, i, u]),
    weekdayLabels: useMemo(function () {
      return Rt({
        firstDayOfWeek: i,
        weekdayLabelFormat: c
      });
    }, [i, c]),
    monthLabel: l(new Date(n, r))
  };
}

function jt(t, e) {
  if (arguments.length < 2) throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  var n = h(t),
      r = h(e);
  return n.getTime() < r.getTime();
}

function Kt(t, e) {
  if (arguments.length < 2) throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  var n = h(t),
      r = h(e);
  return n.getTime() > r.getTime();
}

function Jt(t, e) {
  if (arguments.length < 2) throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  var n = e || {},
      r = h(t).getTime(),
      a = h(n.start).getTime(),
      i = h(n.end).getTime();
  if (!(a <= i)) throw new RangeError('Invalid interval');
  return r >= a && r <= i;
}

function Zt(t) {
  if (arguments.length < 1) throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  var e = h(t);
  return e.setHours(0, 0, 0, 0), e;
}

function _t(t, e) {
  if (arguments.length < 2) throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  var n = Zt(t),
      r = Zt(e);
  return n.getTime() === r.getTime();
}

function $t(t, e) {
  if (arguments.length < 2) throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  var n = h(t),
      r = f(e),
      a = n.getMonth() + r,
      i = new Date(0);
  i.setFullYear(n.getFullYear(), a, 1), i.setHours(0, 0, 0, 0);

  var o = function (t) {
    if (arguments.length < 1) throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
    var e = h(t),
        n = e.getFullYear(),
        r = e.getMonth(),
        a = new Date(0);
    return a.setFullYear(n, r + 1, 0), a.setHours(0, 0, 0, 0), a.getDate();
  }(i);

  return n.setMonth(a, Math.min(o, n.getDate())), n;
}

var Vt = function Vt(t, e) {
  return void 0 === t && (t = []), t.some(function (t) {
    return _t(e, t);
  });
};

function te(t, e, n) {
  return !(!e || !n) && Jt(t, {
    start: e,
    end: n
  });
}

function ee(t, e, n) {
  return !!(e && _t(t, e) || n && _t(t, n));
}

function ne(t) {
  var e = t.date,
      n = t.minBookingDate,
      r = t.maxBookingDate,
      a = t.isDateBlockedFn,
      i = t.startDate,
      o = t.endDate,
      u = t.minBookingDays,
      s = void 0 === u ? 1 : u,
      c = t.unavailableDates,
      d = void 0 === c ? [] : c,
      l = n ? new Date(n.getFullYear(), n.getMonth(), n.getDate(), 0, 0, 0) : n,
      f = r ? new Date(r.getFullYear(), r.getMonth(), r.getDate(), 0, 0, 0) : r;
  return !!(Vt(d, e) || l && jt(e, l) || f && Kt(e, f) || i && !o && s > 1 && Jt(e, {
    start: i,
    end: Nt(i, s - 2)
  }) || a && a(e));
}

function re(t) {
  var e = Ft(t);
  return {
    year: function (t) {
      if (arguments.length < 1) throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
      return h(t).getFullYear();
    }(e),
    month: function (t) {
      if (arguments.length < 1) throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
      return h(t).getMonth();
    }(e),
    date: e
  };
}

function ae() {
  return re(Zt(Date.now()));
}

function ie(t, e) {
  var n = e ? re(e) : ae(),
      r = n.date,
      a = [n];
  return t > 1 && (a = Array.from(Array(t - 1).keys()).reduce(function (t) {
    return r = $t(t[t.length - 1].date, 1), t.concat([re(r)]);
  }, a)), a;
}

function oe(t, e, n) {
  var r = t[n > 0 ? t.length - 1 : 0].date;
  return Array.from(Array(e).keys()).reduce(function (t) {
    return r = 0 === t.length ? $t(r, n) : $t(r, n >= 0 ? 1 : -1), n > 0 ? t.concat([re(r)]) : [re(r)].concat(t);
  }, []);
}

function se(t) {
  var e = t.startDate,
      n = t.endDate,
      r = t.isDateBlocked,
      a = t.minBookingDays,
      i = t.exactMinBookingDays,
      o = t.minBookingDate,
      u = t.maxBookingDate,
      s = !o || !jt(e, Nt(o, -1)),
      c = !u || !Kt(Nt(e, a - 1), u);
  return !(!e || 1 !== a || n || r(e)) || (e && a > 1 && !n && !i || e && a > 0 && i && s && c || e && a > 0 && i && !o && !u ? !Lt({
    start: e,
    end: Nt(e, a - 1)
  }).some(function (t) {
    return r(t);
  }) : !(!e || !n || i) && !jt(n, Nt(e, a - 1)) && !Lt({
    start: e,
    end: n
  }).some(function (t) {
    return r(t);
  }));
}

var ce = 'startDate',
    de = 'endDate';

function le(t) {
  var r = t.startDate,
      a = t.endDate,
      i = t.focusedInput,
      o = t.minBookingDate,
      u = t.maxBookingDate,
      s = t.onDatesChange,
      c = t.initialVisibleMonth,
      d = t.exactMinBookingDays,
      l = void 0 !== d && d,
      f = t.minBookingDays,
      h = void 0 === f ? 1 : f,
      g = t.numberOfMonths,
      w = void 0 === g ? 2 : g,
      m = t.firstDayOfWeek,
      y = void 0 === m ? 1 : m,
      v = t.isDateBlocked,
      b = void 0 === v ? function () {
    return !1;
  } : v,
      p = t.unavailableDates,
      T = void 0 === p ? [] : p,
      D = useState(function () {
    return ie(w, r || c || null);
  }),
      k = D[0],
      x = D[1],
      C = useState(null),
      M = C[0],
      U = C[1],
      E = useState(r),
      q = E[0],
      S = E[1];
  useEffect(function () {
    return 'undefined' != typeof window && window.addEventListener('keydown', O), function () {
      window.removeEventListener('keydown', O);
    };
  });

  var Y = function Y(t) {
    return Vt(T, t) || b(t);
  },
      P = function P(t) {
    S(t), (!q || q && !_t(t, q)) && x(ie(w, t));
  },
      H = function H(t) {
    return ne({
      date: t,
      minBookingDate: o,
      maxBookingDate: u,
      startDate: r,
      endDate: a,
      minBookingDays: h,
      isDateBlockedFn: Y
    });
  };

  function O(t) {
    if (('ArrowRight' === t.key || 'ArrowLeft' === t.key || 'ArrowDown' === t.key || 'ArrowUp' === t.key) && !q) {
      var e = k[0];
      P(e.date), x(ie(w, e.date));
    }
  }

  return {
    firstDayOfWeek: y,
    activeMonths: k,
    isDateSelected: function isDateSelected(t) {
      return te(t, r, a);
    },
    isDateHovered: function isDateHovered(t) {
      return function (t) {
        var e = t.date,
            n = t.startDate,
            r = t.endDate,
            a = t.isDateBlocked,
            i = t.hoveredDate,
            o = t.minBookingDays,
            u = t.exactMinBookingDays;
        return i && o > 1 && u && Jt(e, {
          start: i,
          end: Nt(i, o - 1)
        }) ? !Lt({
          start: i,
          end: Nt(i, o - 1)
        }).some(function (t) {
          return a(t);
        }) : n && !r && i && Jt(e, {
          start: n,
          end: Nt(n, o - 1)
        }) && _t(n, i) && o > 1 ? !Lt({
          start: n,
          end: Nt(n, o - 1)
        }).some(function (t) {
          return a(t);
        }) : !(!n || r || !i || jt(i, n) || !Jt(e, {
          start: n,
          end: i
        }) || Lt({
          start: n,
          end: i
        }).some(function (t) {
          return a(t);
        }));
      }({
        date: t,
        hoveredDate: M,
        startDate: r,
        endDate: a,
        minBookingDays: h,
        exactMinBookingDays: l,
        isDateBlocked: Y
      });
    },
    isFirstOrLastSelectedDate: function isFirstOrLastSelectedDate(t) {
      return ee(t, r, a);
    },
    isDateBlocked: H,
    numberOfMonths: w,
    isDateFocused: function isDateFocused(t) {
      return !!q && _t(t, q);
    },
    focusedDate: q,
    hoveredDate: M,
    onResetDates: function onResetDates() {
      s({
        startDate: null,
        endDate: null,
        focusedInput: ce
      });
    },
    onDateHover: function onDateHover(t) {
      if (t) {
        if (t) {
          var e = !H(t) || r && _t(t, r),
              n = !o || !jt(t, Nt(o, -1)),
              i = !u || !Kt(t, u),
              s = Nt(t, h - 1),
              c = !o || !jt(s, o),
              d = !u || !Kt(s, u),
              f = l && h > 1 && n && i && c && d,
              g = r && !a && !l && n && i,
              w = !(h > 1 && r) || Jt(t, {
            start: r,
            end: Nt(r, h - 2)
          }),
              m = r && _t(t, r) && w;

          e && (f || g || m) ? U(t) : null !== M && U(null);
        }
      } else U(null);
    },
    onDateSelect: function onDateSelect(t) {
      (i === de || i === ce) && h > 0 && l && se({
        minBookingDays: h,
        exactMinBookingDays: l,
        minBookingDate: o,
        maxBookingDate: u,
        isDateBlocked: Y,
        startDate: t,
        endDate: null
      }) ? s({
        startDate: t,
        endDate: Nt(t, h - 1),
        focusedInput: null
      }) : (i === de && r && jt(t, r) || i === ce && a && Kt(t, a)) && !l && se({
        minBookingDays: h,
        isDateBlocked: Y,
        startDate: t,
        endDate: null
      }) ? s({
        endDate: null,
        startDate: t,
        focusedInput: de
      }) : i === ce && !l && se({
        minBookingDays: h,
        isDateBlocked: Y,
        endDate: a,
        startDate: t
      }) ? s({
        endDate: a,
        startDate: t,
        focusedInput: de
      }) : i === ce && !l && se({
        minBookingDays: h,
        isDateBlocked: Y,
        endDate: null,
        startDate: t
      }) ? s({
        endDate: null,
        startDate: t,
        focusedInput: de
      }) : i === de && r && !jt(t, r) && !l && se({
        minBookingDays: h,
        isDateBlocked: Y,
        startDate: r,
        endDate: t
      }) && s({
        startDate: r,
        endDate: t,
        focusedInput: null
      }), i === de || q && (!q || _t(t, q)) || x(ie(w, t));
    },
    onDateFocus: P,
    goToPreviousMonths: function goToPreviousMonths() {
      x(oe(k, w, -1)), S(null);
    },
    goToNextMonths: function goToNextMonths() {
      x(oe(k, w, 1)), S(null);
    },
    goToPreviousYear: function goToPreviousYear(t) {
      void 0 === t && (t = 1), x(oe(k, w, -(12 * t - w + 1))), S(null);
    },
    goToNextYear: function goToNextYear(t) {
      void 0 === t && (t = 1), x(oe(k, w, 12 * t - w + 1)), S(null);
    }
  };
}

function fe(t) {
  var e = t.date,
      a = t.focusedDate,
      i = t.isDateSelected,
      o = t.isDateFocused,
      u = t.isFirstOrLastSelectedDate,
      s = t.isDateHovered,
      c = t.isDateBlocked,
      d = t.onDateSelect,
      l = t.onDateFocus,
      f = t.onDateHover,
      h = t.dayRef,
      g = useCallback(function () {
    return d(e);
  }, [e, d]),
      w = useCallback(function () {
    return f(e);
  }, [e, f]);
  useEffect(function () {
    h && h.current && o(e) && h.current.focus();
  }, [h, e, o]);
  var m = c(e) && !s(e);
  return {
    tabIndex: null === a || o(e) ? 0 : -1,
    isSelected: i(e),
    isSelectedStartOrEnd: u(e),
    isWithinHoverRange: s(e),
    disabledDate: m,
    onKeyDown: function onKeyDown(t) {
      'ArrowRight' === t.key ? l(Nt(e, 1)) : 'ArrowLeft' === t.key ? l(Nt(e, -1)) : 'ArrowUp' === t.key ? l(Nt(e, -7)) : 'ArrowDown' === t.key && l(Nt(e, 7));
    },
    onClick: m ? function () {} : g,
    onMouseEnter: w
  };
}

var datepickerContextDefaultValue = {
  focusedDate: null,
  isDateFocused: function isDateFocused() {
    return false;
  },
  isDateSelected: function isDateSelected() {
    return false;
  },
  isDateHovered: function isDateHovered() {
    return false;
  },
  isDateBlocked: function isDateBlocked() {
    return false;
  },
  isFirstOrLastSelectedDate: function isFirstOrLastSelectedDate() {
    return false;
  },
  onDateFocus: function onDateFocus() {},
  onDateHover: function onDateHover() {},
  onDateSelect: function onDateSelect() {}
};
var DatePickerContext = React$2.createContext(datepickerContextDefaultValue);

function Day(_ref) {
  var day = _ref.day,
      date = _ref.date;
  var dayRef = useRef(null);

  var _useContext = useContext(DatePickerContext),
      focusedDate = _useContext.focusedDate,
      isDateFocused = _useContext.isDateFocused,
      isDateSelected = _useContext.isDateSelected,
      isDateHovered = _useContext.isDateHovered,
      isDateBlocked = _useContext.isDateBlocked,
      isFirstOrLastSelectedDate = _useContext.isFirstOrLastSelectedDate,
      onDateSelect = _useContext.onDateSelect,
      onDateFocus = _useContext.onDateFocus,
      onDateHover = _useContext.onDateHover,
      onDayClick = _useContext.onDayClick,
      selectedDate = _useContext.selectedDate,
      blockedDates = _useContext.blockedDates,
      dateFormat = _useContext.dateFormat,
      blockWeekends = _useContext.blockWeekends;

  var _useDay = fe({
    date: date,
    focusedDate: focusedDate,
    isDateFocused: isDateFocused,
    isDateSelected: isDateSelected,
    isDateHovered: isDateHovered,
    isDateBlocked: isDateBlocked,
    isFirstOrLastSelectedDate: isFirstOrLastSelectedDate,
    onDateFocus: onDateFocus,
    onDateSelect: onDateSelect,
    onDateHover: onDateHover,
    dayRef: dayRef
  }),
      onKeyDown = _useDay.onKeyDown,
      onMouseEnter = _useDay.onMouseEnter,
      tabIndex = _useDay.tabIndex;

  if (!day) {
    return React$2.createElement("div", null);
  }

  function handleDateSelect() {
    if (!isCurrentDateBlocked) onDayClick(date);
  }

  var selectedDateFormat = moment(selectedDate).format(dateFormat);
  var currentDate = moment(date).format(dateFormat);
  var isWeekend = date.getDay() === 0 || date.getDay() === 6;
  var isSelectedDate = selectedDateFormat === currentDate;
  var isBlockedDate = blockedDates ? blockedDates.findIndex(function (i) {
    return i === currentDate;
  }) > -1 : false;
  var isCurrentDateBlocked = blockWeekends && isWeekend || isBlockedDate;
  return React$2.createElement(StyledDayWrapper, {
    onClick: handleDateSelect,
    onKeyDown: onKeyDown,
    onMouseEnter: onMouseEnter,
    tabIndex: tabIndex,
    ref: dayRef,
    selected: isSelectedDate,
    blockedDate: isCurrentDateBlocked
  }, day);
}

Day.propTypes = {
  day: PropTypes.string,
  date: PropTypes.instanceOf(Date)
};

function Month(_ref) {
  var year = _ref.year,
      month = _ref.month;

  var _useContext = useContext(DatePickerContext),
      goToNextMonths = _useContext.goToNextMonths,
      goToPreviousMonths = _useContext.goToPreviousMonths,
      firstDayOfWeek = _useContext.firstDayOfWeek;

  var _useMonth = zt({
    year: year,
    month: month,
    firstDayOfWeek: firstDayOfWeek
  }),
      days = _useMonth.days,
      weekdayLabels = _useMonth.weekdayLabels,
      monthLabel = _useMonth.monthLabel;

  return React$2.createElement(StyledMonthWrapper, null, React$2.createElement(StyledMonthHeaderWrapper, null, React$2.createElement(StyledNavButton, {
    onClick: goToPreviousMonths
  }, React$2.createElement(Icon, {
    icon: 'MdArrowBack',
    size: '30px',
    color: theme.colors['wasabi']
  })), React$2.createElement(StyledMonthLabel, null, monthLabel), React$2.createElement(StyledNavButton, {
    onClick: goToNextMonths
  }, React$2.createElement(Icon, {
    icon: 'MdArrowForward',
    size: '30px',
    color: theme.colors['wasabi']
  }))), React$2.createElement(StyledWeekDayWrapper, null, weekdayLabels.map(function (dayLabel) {
    return React$2.createElement(StyledWeekDay, {
      key: dayLabel
    }, dayLabel);
  })), React$2.createElement(StyledDayContainerWrapper, null, days.map(function (day) {
    return React$2.createElement(Day, {
      date: day.date,
      key: Math.random(),
      day: day.dayLabel
    });
  })));
}

Month.propTypes = {
  year: PropTypes.number,
  month: PropTypes.number
};

function ReactDatePicker(props) {
  var onDayClick = props.onDayClick,
      selectedDate = props.selectedDate,
      blockedDates = props.blockedDates,
      dateFormat = props.dateFormat,
      blockWeekends = props.blockWeekends,
      popupPosition = props.popupPosition;

  var _useDatepicker = le({
    focusedInput: ce,
    numberOfMonths: 1,
    firstDayOfWeek: 0
  }),
      firstDayOfWeek = _useDatepicker.firstDayOfWeek,
      activeMonths = _useDatepicker.activeMonths,
      isDateSelected = _useDatepicker.isDateSelected,
      isDateHovered = _useDatepicker.isDateHovered,
      isFirstOrLastSelectedDate = _useDatepicker.isFirstOrLastSelectedDate,
      isDateBlocked = _useDatepicker.isDateBlocked,
      isDateFocused = _useDatepicker.isDateFocused,
      focusedDate = _useDatepicker.focusedDate,
      onDateHover = _useDatepicker.onDateHover,
      onDateSelect = _useDatepicker.onDateSelect,
      onDateFocus = _useDatepicker.onDateFocus,
      goToPreviousMonths = _useDatepicker.goToPreviousMonths,
      goToNextMonths = _useDatepicker.goToNextMonths;

  return React$2.createElement(DatePickerContext.Provider, {
    value: {
      firstDayOfWeek: firstDayOfWeek,
      focusedDate: focusedDate,
      isDateFocused: isDateFocused,
      isDateSelected: isDateSelected,
      isDateHovered: isDateHovered,
      isDateBlocked: isDateBlocked,
      isFirstOrLastSelectedDate: isFirstOrLastSelectedDate,
      onDateSelect: onDateSelect,
      onDateFocus: onDateFocus,
      onDateHover: onDateHover,
      goToPreviousMonths: goToPreviousMonths,
      goToNextMonths: goToNextMonths,
      onDayClick: onDayClick,
      selectedDate: selectedDate,
      blockedDates: blockedDates,
      dateFormat: dateFormat,
      blockWeekends: blockWeekends
    }
  }, React$2.createElement(StyledDatePickerWrapper, {
    popupPosition: popupPosition
  }, React$2.createElement(StyledMonthContainerWrapper, {
    style: {
      display: 'flex',
      margin: '0',
      gridTemplateColumns: "repeat(".concat(activeMonths.length, ", 18.750em)")
    }
  }, activeMonths.map(function (month) {
    return React$2.createElement(Month, {
      key: "".concat(month.year, "-").concat(month.month),
      year: month.year,
      month: month.month
    });
  })), React$2.createElement(StyledInformationWrapper, null, React$2.createElement(StyledAvailableInfo, null, "Available"), React$2.createElement(StyledDisabledInfo, null, "Disabled"), React$2.createElement(StyledSelectedInfo, null, "Selected"))));
}

ReactDatePicker.propTypes = {
  onDayClick: PropTypes.func,
  selectedDate: PropTypes.instanceOf(Date),
  blockedDates: PropTypes.arrayOf(PropTypes.string),
  dateFormat: PropTypes.string,
  blockWeekends: PropTypes.bool,
  popupPosition: PropTypes.oneOf(['top', 'bottom'])
};

function DatePicker(props) {
  var id = props.id,
      name = props.name,
      label = props.label,
      placeholder = props.placeholder,
      blockedDates = props.blockedDates,
      dateFormat = props.dateFormat,
      blockWeekends = props.blockWeekends,
      open = props.open,
      onChange = props.onChange,
      error = props.error,
      errorMessage = props.errorMessage,
      value = props.value,
      assistiveMessage = props.assistiveMessage,
      assistiveMessageAlign = props.assistiveMessageAlign,
      popupPosition = props.popupPosition;

  var _useState = useState(open ? true : false),
      _useState2 = _slicedToArray(_useState, 2),
      showDatePicker = _useState2[0],
      setShowDatePicker = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      selectedDate = _useState4[0],
      setSelectedDate = _useState4[1];

  var _useState5 = useState(''),
      _useState6 = _slicedToArray(_useState5, 2),
      selectedFormattedDate = _useState6[0],
      setSelectedFormattedDate = _useState6[1];

  var ref = useRef();
  useOnClickOutside(ref, function () {
    return setShowDatePicker(false);
  });

  var isUTC = function isUTC(date) {
    if (date === undefined) return false;
    var checkDate = moment(date);
    return checkDate.isUTC();
  };

  var isValidDate = function isValidDate(date) {
    if (date === undefined) return false;
    var checkDate = moment(date);
    return checkDate.isValid() || isUTC(value);
  };

  var parseToUtc = function parseToUtc(date) {
    var utc = moment(date).utc(false);
    return utc.format();
  }; // eslint-disable-next-line react-hooks/exhaustive-deps


  var formatDate = function formatDate(date) {
    return moment(date).format(dateFormat);
  };

  var handleDayClick = function handleDayClick(date) {
    var dateSelected = formatDate(date);

    if (dateSelected !== selectedDate) {
      var utc = parseToUtc(date);
      onChange(utc);
    }

    setSelectedDate(date);
    setSelectedFormattedDate(dateSelected);
    setShowDatePicker(false);
  };

  useEffect(function () {
    if (isValidDate(value)) {
      var utc = parseToUtc(value);
      var formattedDate = formatDate(utc);
      setSelectedFormattedDate(formattedDate);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [value]);
  return React$2.createElement(StyledDatePicker, null, React$2.createElement(TextInput, {
    id: id,
    name: name,
    animateLabel: false,
    error: error,
    errorMessage: errorMessage,
    label: label,
    placeholder: placeholder,
    suffix: "MdEvent",
    onIconClick: function onIconClick() {
      return setShowDatePicker(!showDatePicker);
    },
    onFocus: function onFocus() {
      return setShowDatePicker(!showDatePicker);
    },
    value: selectedFormattedDate,
    assistiveMessage: assistiveMessage,
    assistiveMessageAlign: assistiveMessageAlign
  }), showDatePicker && React$2.createElement("div", {
    ref: ref
  }, React$2.createElement(ReactDatePicker, {
    onDayClick: handleDayClick,
    selectedDate: selectedDate,
    blockedDates: blockedDates,
    dateFormat: dateFormat,
    blockWeekends: blockWeekends,
    popupPosition: popupPosition
  })));
}

DatePicker.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  blockedDates: PropTypes.arrayOf(PropTypes.string),
  blockWeekends: PropTypes.bool,
  dateFormat: PropTypes.string,
  open: PropTypes.bool,
  onChange: PropTypes.func,
  error: PropTypes.bool,
  errorMessage: PropTypes.string,
  value: PropTypes.string,
  assistiveMessage: PropTypes.string,
  assistiveMessageAlign: PropTypes.string,
  popupPosition: PropTypes.oneOf(['top', 'bottom'])
};
DatePicker.defaultProps = {
  dateFormat: 'DD/MM/YYYY',
  blockWeekends: false,
  open: false,
  onChange: function onChange() {},
  error: false,
  placeholder: 'DD/MM/YYYY',
  assistiveMessage: '',
  assistiveMessageAlign: 'left',
  popupPosition: 'bottom'
};

function _templateObject3$j() {
  var data = _taggedTemplateLiteral(["\n  align-self: center;\n  font-size: ", ";\n  font-weight: ", ";\n  text-align: center;\n  color: ", ";\n  margin-top: 0.625em;\n  margin-bottom: 1.5em;\n"]);

  _templateObject3$j = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$p() {
  var data = _taggedTemplateLiteral(["\n  align-self: center;\n  font-size: ", ";\n  font-weight: ", ";\n  text-align: center;\n  color: ", ";\n"]);

  _templateObject2$p = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$z() {
  var data = _taggedTemplateLiteral(["\n  flex-direction: column;\n  display: flex;\n"]);

  _templateObject$z = function _templateObject() {
    return data;
  };

  return data;
}

var StyledFileUpload = styled(Card)(_templateObject$z());
var StyledHeaderText$1 = styled.span(_templateObject2$p(), function (props) {
  return props.theme.fontSize[13];
}, function (props) {
  return props.theme.fontWeight.bold;
}, function (props) {
  return props.theme.colors.black;
});
var StyledSubHeaderText = styled.span(_templateObject3$j(), function (props) {
  return props.theme.fontSize[16];
}, function (props) {
  return props.theme.fontWeight.regular;
}, function (props) {
  return props.theme.colors.charcoal;
});

function FileUpload(props) {
  var onButtonClick = props.onButtonClick,
      onItemDismiss = props.onItemDismiss,
      items = props.items;
  var transitions = useTransition(items ? items : [], function (item) {
    return item.key;
  }, {
    unique: true,
    from: {
      opacity: 0,
      transform: 'scale(0)'
    },
    enter: {
      opacity: 1,
      transform: 'scale(1)'
    },
    leave: {
      display: 'none'
    }
  });
  var allItemsUploaded = items.filter(function (x) {
    return x.status === 'success';
  }).length === items.length;
  return React$2.createElement(StyledFileUpload, null, !allItemsUploaded && React$2.createElement(StyledHeaderText$1, {
    appearance: "bold"
  }, "TAP TO UPLOAD"), React$2.createElement(StyledSubHeaderText, null, allItemsUploaded ? 'Your documents uploaded successfully!' : 'Please upload the following documents:'), !allItemsUploaded && React$2.createElement(SecondaryButton, {
    appearance: "red",
    icon: "MdAdd",
    onClick: onButtonClick
  }, "UPLOAD ANOTHER"), items && items.length > 0 && React$2.createElement(React$2.Fragment, null, transitions.map(function (_ref) {
    var item = _ref.item,
        key = _ref.key,
        props = _ref.props;
    return React$2.createElement(animated.div, {
      key: key,
      style: props
    }, React$2.createElement(UploadCard, {
      filename: item.filename,
      fileProgress: item.fileProgress,
      status: item.status,
      fileSize: item.fileSize,
      sizeTag: item.sizeTag,
      onDismiss: onItemDismiss
    }));
  })));
}

FileUpload.propTypes = {
  onButtonClick: PropTypes.func,
  onItemDismiss: PropTypes.func,
  items: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string,
    title: PropTypes.string,
    progress: PropTypes.number,
    fileSizeProgress: PropTypes.string,
    status: PropTypes.string,
    error: PropTypes.bool
  }))
};

function _templateObject10$8() {
  var data = _taggedTemplateLiteral(["\n  margin-top: ", ";\n  margin-left: 1em;\n"]);

  _templateObject10$8 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9$9() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  background: ", ";\n  outline: none;\n"]);

  _templateObject9$9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8$9() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  background: ", ";\n  outline: none;\n"]);

  _templateObject8$9 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7$b() {
  var data = _taggedTemplateLiteral(["\n  width: 40px;\n  height: 40px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n"]);

  _templateObject7$b = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$d() {
  var data = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  height: 44px;\n  width: 80px\n  display: flex;\n  align-items: center;\n  background: white;\n  margin-left: -84px;\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n"]);

  _templateObject6$d = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$f() {
  var data = _taggedTemplateLiteral(["\n  width: 295px;\n  height: 48px;\n  background: white;\n  border: none;\n  border-radius: 2px;\n  padding-left: 12px;\n  padding-right: 84px;\n  outline: none;\n  -moz-appearance: textfield;\n\n  :invalid {\n    // border: none;\n    // box-shadow: none;\n  }\n\n  ::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n  ::-webkit-outer-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n"]);

  _templateObject5$f = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$i() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  margin-top: 6px;\n"]);

  _templateObject4$i = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$k() {
  var data = _taggedTemplateLiteral(["\n  text-align: center;\n  margin-bottom: 24px;\n  font-size: 14px;\n  color: #3c3c3c;\n\n  & span {\n    font-weight: 800;\n    padding-left: 5px;\n    color: #000000;\n  }\n"]);

  _templateObject3$k = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$q() {
  var data = _taggedTemplateLiteral(["\n  text-align: center;\n  font-size: 13px;\n  font-weight: 800;\n  line-height: 20px;\n  text-transform: uppercase;\n  margin-bottom: 6px;\n"]);

  _templateObject2$q = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$A() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n"]);

  _templateObject$A = function _templateObject() {
    return data;
  };

  return data;
}

var StyledContainer$1 = styled.div(_templateObject$A());
var StyledHeader = styled.div(_templateObject2$q());
var StyledCaption$1 = styled.div(_templateObject3$k());
var StyledInputContainer = styled.div(_templateObject4$i());
var StyledInput$1 = styled(MaskedInput)(_templateObject5$f());
var StyledButtonContainer = styled.div(_templateObject6$d());
var Button$1 = styled.button(_templateObject7$b());
var StyledRandButton = styled(Button$1)(_templateObject8$9(), function (props) {
  return props.inputMode === 'R' ? props.theme.colors.white : props.theme.colors.wasabi;
}, function (props) {
  return props.inputMode === 'R' ? props.theme.colors.wasabi : props.theme.colors.white;
});
var StyledPercentButton = styled(Button$1)(_templateObject9$9(), function (props) {
  return props.inputMode === '%' ? props.theme.colors.white : props.theme.colors.wasabi;
}, function (props) {
  return props.inputMode === '%' ? props.theme.colors.wasabi : props.theme.colors.white;
});
var Validation$4 = styled(ValidationMessage)(_templateObject10$8(), function (props) {
  return props.theme.gutters[8];
});

var BenefitAllocationCaption = function BenefitAllocationCaption(_ref) {
  var remainingRands = _ref.remainingRands,
      remainingPercent = _ref.remainingPercent;
  return React$2.createElement(React$2.Fragment, null, React$2.createElement(StyledHeader, null, "Benefit Allocation"), React$2.createElement(StyledCaption$1, null, "Remaining to allocate:", React$2.createElement("span", {
    "data-testid": "text-amount-allocated"
  }, "R", prettifyDecimalNumber(remainingRands)), React$2.createElement("span", {
    "data-testid": "text-percent-allocated"
  }, "(", prettifyDecimalNumber(remainingPercent), "%)")));
};

BenefitAllocationCaption.propTypes = {
  remainingRands: PropTypes.number.isRequired,
  remainingPercent: PropTypes.number.isRequired
};

var ToggleModeButtons = function ToggleModeButtons(_ref) {
  var onToggle = _ref.onToggle,
      unit = _ref.unit;
  return React$2.createElement(StyledButtonContainer, null, React$2.createElement(StyledRandButton, {
    "data-testid": "action-rand-mode",
    type: "button",
    onClick: function onClick() {
      return onToggle('R');
    },
    inputMode: unit
  }, "R"), React$2.createElement(StyledPercentButton, {
    "data-testid": "action-percent-mode",
    type: "button",
    onClick: function onClick() {
      return onToggle('%');
    },
    inputMode: unit
  }, "%"));
};

ToggleModeButtons.propTypes = {
  onToggle: PropTypes.func.isRequired,
  unit: PropTypes.string.isRequired
};

var getSeletedAmount = function getSeletedAmount(value) {
  return value.unit === 'R' ? value.rands : value.percentage;
};

function BenefitAllocationInput(_ref2) {
  var id = _ref2.id,
      name = _ref2.name,
      value = _ref2.value,
      remainingToAllocate = _ref2.remainingToAllocate,
      totalBenfitAmount = _ref2.totalBenfitAmount,
      onChange = _ref2.onChange;
  var textInput = useRef(null);

  var _useState = useState(getSeletedAmount(value) || ''),
      _useState2 = _slicedToArray(_useState, 2),
      displayValue = _useState2[0],
      setDisplayValue = _useState2[1];

  useEffect(function () {
    var num = getSeletedAmount(value);

    if (!isNaN(num)) {
      setDisplayValue(num);
    }
  }, [value]);
  useEffect(function () {
    var num = getSeletedAmount(value);

    if (!isNaN(num)) {
      setDisplayValue(num);
    }
  }, [value.unit]);

  var handleRandInput = function handleRandInput(input) {
    onChange(_objectSpread2({}, value, {
      rands: input,
      percentage: getPercentFromRandValue(input, totalBenfitAmount)
    }));
  };

  var handlePercentageInput = function handlePercentageInput(input) {
    onChange(_objectSpread2({}, value, {
      rands: getRandValueFromPercent(input, totalBenfitAmount),
      percentage: input
    }));
  }; // Handle user input


  var handleChange = function handleChange(e) {
    if (e.target.value.slice(-1) !== '.' && e.target.value.slice(-2) !== '.0' && e.target.value.slice(-3) !== '.00') {
      var val = Number.parseFloat(e.target.value.replaceAll(',', ''));
      setDisplayValue(e.target.value);
      value.unit === 'R' ? handleRandInput(val) : handlePercentageInput(val);
    }
  };

  var currencyMask = createNumberMask$1({
    prefix: '',
    suffix: '',
    includeThousandsSeparator: true,
    thousandsSeparatorSymbol: ',',
    allowDecimal: true,
    decimalSymbol: '.',
    decimalLimit: 2,
    integerLimit: 10,
    allowNegative: false,
    allowLeadingZeroes: false
  });

  var onToggle = function onToggle(unit) {
    onChange(_objectSpread2({}, value, {
      unit: unit
    }));
    textInput.current.inputElement.focus();
  };

  return React$2.createElement(StyledInputContainer, null, React$2.createElement(StyledInput$1, {
    mask: currencyMask,
    id: id,
    name: name,
    "data-testid": "input",
    placeholder: value.unit === 'R' ? 'R 0.00' : '0 %',
    onChange: handleChange,
    autocomplete: "off",
    value: displayValue,
    ref: textInput,
    inputmode: "numeric"
  }), React$2.createElement("span", null), React$2.createElement(ToggleModeButtons, {
    unit: value.unit,
    onToggle: onToggle
  }));
}

BenefitAllocationInput.propTypes = {
  remainingToAllocate: PropTypes.number,
  totalBenfitAmount: PropTypes.number,
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.shape({
    rands: PropTypes.number,
    percentage: PropTypes.number,
    unit: PropTypes.oneOf(['R', '%'])
  }).isRequired,
  onChange: PropTypes.func
};

function BenefitAllocation(_ref) {
  var totalBenfitAmount = _ref.totalBenfitAmount,
      remainingToAllocate = _ref.remainingToAllocate,
      id = _ref.id,
      name = _ref.name,
      value = _ref.value,
      error = _ref.error,
      errorMessage = _ref.errorMessage,
      onChange = _ref.onChange;

  var remainingToAllocatePercent = function remainingToAllocatePercent() {
    if (remainingToAllocate === 0) return 0;
    var p = remainingToAllocate / totalBenfitAmount * 100;
    return squashDecimalPoints(p);
  };

  var handleChange = function handleChange(val) {
    onChange(val);
  };

  return React$2.createElement(Card, null, React$2.createElement(BenefitAllocationCaption, {
    remainingRands: remainingToAllocate,
    remainingPercent: remainingToAllocatePercent()
  }), React$2.createElement(StyledContainer$1, null, React$2.createElement("div", null, React$2.createElement(Label, null, "Allocate to Beneficiary"), React$2.createElement(BenefitAllocationInput, {
    id: id,
    name: name,
    remainingToAllocate: remainingToAllocate,
    totalBenfitAmount: totalBenfitAmount,
    onChange: handleChange,
    value: value
  }), error && React$2.createElement(Validation$4, {
    "data-testid": "error-message"
  }, errorMessage))));
}

BenefitAllocation.propTypes = {
  totalBenfitAmount: PropTypes.number,
  remainingToAllocate: PropTypes.number,
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  error: PropTypes.bool,
  errorMessage: PropTypes.string,
  value: PropTypes.shape({
    rands: PropTypes.number,
    percentage: PropTypes.number,
    unit: PropTypes.oneOf(['R', '%'])
  }).isRequired,
  onChange: PropTypes.func
};
BenefitAllocation.defaultProps = {
  totalBenfitAmount: 0,
  remainingToAllocate: 0,
  id: '',
  name: '',
  error: false,
  currencySelected: true
};

function _templateObject8$a() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  width: 5.813rem;\n  height: 6.313rem;\n  outline: 0;\n  border-radius: ", ";\n  border: 1px solid ", ";\n  text-align: center;\n  background-color: transparent;\n  z-index: 1;\n  position: relative;\n  font-size: 2.125rem;\n  font-weight: ", ";\n\n  ", "\n  ", "\n  ", "\n\n  @media ", " {\n    width: 4.375rem;\n    height: 4.75rem;\n    font-size: 2rem;\n  }\n"]);

  _templateObject8$a = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7$c() {
  var data = _taggedTemplateLiteral(["\n    border-color: ", ";\n  "]);

  _templateObject7$c = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$e() {
  var data = _taggedTemplateLiteral(["\n    background-color: ", ";\n    border-color: ", ";\n    color: ", ";\n  "]);

  _templateObject6$e = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$g() {
  var data = _taggedTemplateLiteral(["\n    border-color: ", ";\n    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.08);\n  "]);

  _templateObject5$g = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$j() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  margin: ", "\n    ", ";\n  background-color: ", ";\n  border-radius: ", ";\n\n  @media ", " {\n    margin: ", " 5px;\n  }\n\n  &:before {\n    content: '';\n    width: 12px;\n    height: 12px;\n    border-radius: 12px;\n    background-color: ", ";\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    margin-left: -6px;\n    margin-top: -6px;\n    display: display: block;\n    z-index: 0;\n  }\n\n  &:after {\n    content: '';\n    height: 3px;\n    width: 16px;\n    background-color: ", ";\n    border-radius: 1.5px;\n    position: absolute;\n    right: -20px;\n    top: 50%;\n    z-index: 0;\n\n    @media ", " {\n      width: 6px;\n      right: -8px;\n    }\n  }\n\n  &:last-of-type {\n    &:after {\n      display: none;\n    }\n  }\n\n  ", "\n  ", "\n"]);

  _templateObject4$j = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$l() {
  var data = _taggedTemplateLiteral(["\n    &:after {\n      background-color: ", ";\n    }\n  "]);

  _templateObject3$l = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$r() {
  var data = _taggedTemplateLiteral(["\n    &:before {\n      display: none;\n    }\n  "]);

  _templateObject2$r = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$B() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n"]);

  _templateObject$B = function _templateObject() {
    return data;
  };

  return data;
}
/**
 * OTP Input Container Styles
 */


var OtpInputContainer = styled.div(_templateObject$B());

var containerFocusedStyles = function containerFocusedStyles() {
  return css(_templateObject2$r());
};

var containerWithValueStyles = function containerWithValueStyles() {
  return css(_templateObject3$l(), function (props) {
    return props.theme.colors.apple;
  });
};

var SingleInputContainer = styled.div(_templateObject4$j(), function (props) {
  return props.theme.gutters[16];
}, function (props) {
  return props.theme.gutters[12];
}, function (props) {
  return props.theme.colors.white;
}, function (props) {
  return props.theme.gutters[8];
}, function (props) {
  return props.theme.BREAKPOINTS.MOBILE_DOWN;
}, function (props) {
  return props.theme.gutters[16];
}, function (props) {
  return props.theme.colors.lightGrey;
}, function (props) {
  return props.theme.colors.white;
}, function (props) {
  return props.theme.BREAKPOINTS.MOBILE_DOWN;
}, function (props) {
  return props.isFocused && containerFocusedStyles();
}, function (props) {
  return props.hasValue && containerWithValueStyles();
});
/**
 * Single Otp Item Styles
 */

var inputFocusedStyles = function inputFocusedStyles(props) {
  var theme = props.theme;
  return css(_templateObject5$g(), theme.colors.apple);
};

var inputWithValueStyles = function inputWithValueStyles(props) {
  var theme = props.theme;
  return css(_templateObject6$e(), theme.colors.apple, theme.colors.apple, function (props) {
    return props.theme.colors.white;
  });
};

var errorStyles$1 = function errorStyles(props) {
  var theme = props.theme;
  return css(_templateObject7$c(), theme.colors.red);
};

var SingleInput = styled.input(_templateObject8$a(), function (props) {
  return props.theme.colors.apple;
}, function (props) {
  return props.theme.gutters[8];
}, function (props) {
  return props.theme.colors.sinbad;
}, function (props) {
  return props.theme.fontWeight.medium;
}, function (props) {
  return props.isFocused && inputFocusedStyles(props);
}, function (props) {
  return props.hasValue && inputWithValueStyles(props);
}, function (props) {
  return props.error && errorStyles$1(props);
}, function (props) {
  return props.theme.BREAKPOINTS.MOBILE_DOWN;
});

function SingleOtpInput(props) {
  var value = props.value,
      focused = props.focused,
      onFocus = props.onFocus,
      onBlur = props.onBlur,
      onChange = props.onChange,
      onPaste = props.onPaste,
      error = props.error;
  var input = useRef(null);
  useEffect(function () {
    if (input && focused) {
      input.current.focus();
    }
  }, [focused]);

  for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    rest[_key - 1] = arguments[_key];
  }

  return React$2.createElement(SingleInputContainer, {
    hasValue: value,
    isFocused: focused
  }, React$2.createElement(SingleInput, _extends({
    type: "number",
    maxLength: "1",
    min: "0",
    max: "9",
    value: value,
    onFocus: onFocus,
    onBlur: onBlur,
    isFocused: focused,
    onChange: onChange,
    onPaste: onPaste,
    ref: input,
    hasValue: value,
    disabled: value,
    error: error
  }, rest)));
}

SingleOtpInput.propTypes = {
  value: PropTypes.string,
  focused: PropTypes.bool,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onPaste: PropTypes.func,
  error: PropTypes.bool
};
SingleOtpInput.defaultProps = {
  value: '',
  focused: false,
  onFocus: function onFocus() {},
  onBlur: function onBlur() {},
  onChange: function onChange() {},
  onPaste: function onPaste() {},
  error: false
};

function OtpInput(props) {
  var numInputs = props.numInputs,
      onChange = props.onChange,
      onComplete = props.onComplete,
      error = props.error,
      autofocus = props.autofocus;

  var _useState = useState(-1),
      _useState2 = _slicedToArray(_useState, 2),
      activeInput = _useState2[0],
      setActiveInput = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      otp = _useState4[0],
      setOtp = _useState4[1];

  useEffect(function () {
    // join otp array
    var joinedOtp = otp.join(''); // onChange prop callback

    onChange(joinedOtp);

    if (otp.length === numInputs) {
      // onComplete prop callback
      onComplete(joinedOtp);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [otp, setOtp, onChange, numInputs]); // Error handling

  useEffect(function () {
    if (error) {
      setOtp([]);
      setActiveInput(0);
    }
  }, [error]); // Autofocus handling

  useEffect(function () {
    if (autofocus) {
      setActiveInput(0);
    }
  }, [autofocus]); // Focus on input by index

  var focusInput = function focusInput(input) {
    var activeInput = Math.max(Math.min(numInputs - 1, input), 0);
    setActiveInput(activeInput);
  }; // Handle next input focus


  var focusNextInput = function focusNextInput() {
    focusInput(activeInput + 1);
  }; // Handle otp state update on change


  var changeOtpOnChange = function changeOtpOnChange(value) {
    setOtp([].concat(_toConsumableArray(otp), [value]));
  }; // Handle pasted OTP


  var handleOnPaste = function handleOnPaste(e) {
    e.preventDefault(); // Get pastedData in an array of max size (num of inputs - current position)

    var pastedData = e.clipboardData.getData('text/plain').slice(0, numInputs - activeInput).split('');
    var pastedOtp = []; // Paste data from focused input onwards

    for (var pos = 0; pos < numInputs; ++pos) {
      if (pos >= activeInput && pastedData.length > 0) {
        pastedOtp[pos] = pastedData.shift();
      }
    }

    setOtp(pastedOtp);
  }; // Handle on change


  var handleOnChange = function handleOnChange(e) {
    changeOtpOnChange(e.target.value);
    focusNextInput();
  };

  var renderInputs = function renderInputs() {
    var inputs = [];

    var _loop = function _loop(i) {
      inputs.push(React$2.createElement(SingleOtpInput, {
        key: i,
        focused: activeInput === i,
        value: otp && otp[i],
        onFocus: function onFocus() {
          setActiveInput(i);
        },
        onBlur: function onBlur() {
          setActiveInput(-1);
        },
        onChange: handleOnChange,
        onPaste: handleOnPaste,
        error: error
      }));
    };

    for (var i = 0; i < numInputs; i++) {
      _loop(i);
    }

    return inputs;
  };

  return React$2.createElement(OtpInputContainer, null, renderInputs());
}

OtpInput.propTypes = {
  numInputs: PropTypes.number,
  onChange: PropTypes.func,
  onComplete: PropTypes.func,
  error: PropTypes.bool,
  autofocus: PropTypes.bool
};
OtpInput.defaultProps = {
  numInputs: 4,
  onChange: function onChange() {},
  onComplete: function onComplete() {},
  error: false,
  autofocus: false
};

function _templateObject22$1() {
  var data = _taggedTemplateLiteral(["\n  background: ", ";\n  overflow: hidden;\n  display: ", ";\n\n  @media ", " {\n    background: ", ";\n  }\n\n  ", " {\n    width: 100%;\n    background: ", ";\n\n    @media ", " {\n      background: ", ";\n    }\n\n    &:last-of-type ", " {\n      &:after {\n        display: none;\n      }\n    }\n\n    &:first-of-type ", ":after {\n      display: none !important;\n    }\n  }\n\n  ", " {\n    width: 20px;\n    height: 20px;\n    border-radius: 20px;\n    margin: 0 1.625rem;\n\n    &:after {\n      background-color: ", ";\n      opacity: 0.5;\n      height: 36px;\n      top: -40px;\n      margin-top: 0;\n      display: block !important;\n    }\n  }\n\n  ", " {\n    padding: 1.375rem 0 1.438em 0;\n\n    &:after {\n      background: ", ";\n    }\n  }\n\n  ", " {\n    font-size: ", ";\n\n    &.isActive {\n      font-weight: ", ";\n    }\n  }\n"]);

  _templateObject22$1 = function _templateObject22() {
    return data;
  };

  return data;
}

function _templateObject21$1() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  height: 20px;\n  margin-right: ", ";\n  margin-top: 1px;\n  transition-duration: 0.3s;\n  transition-property: transform;\n  transform: ", ";\n\n  ", ";\n  ", ";\n"]);

  _templateObject21$1 = function _templateObject21() {
    return data;
  };

  return data;
}

function _templateObject20$1() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n"]);

  _templateObject20$1 = function _templateObject20() {
    return data;
  };

  return data;
}

function _templateObject19$2() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n"]);

  _templateObject19$2 = function _templateObject19() {
    return data;
  };

  return data;
}

function _templateObject18$2() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  cursor: ", ";\n  flex: 1;\n  align-items: center;\n  padding: 0;\n  outline: 0;\n  background: ", ";\n  border: 0;\n\n  @media ", " {\n    background: ", ";\n  }\n\n  ", "\n  ", "\n"]);

  _templateObject18$2 = function _templateObject18() {
    return data;
  };

  return data;
}

function _templateObject17$2() {
  var data = _taggedTemplateLiteral(["\n  background: ", ";\n\n  @media ", " {\n    background: ", ";\n  }\n"]);

  _templateObject17$2 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16$3() {
  var data = _taggedTemplateLiteral(["\n  background: ", ";\n\n  @media ", " {\n    background: ", ";\n  }\n"]);

  _templateObject16$3 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15$3() {
  var data = _taggedTemplateLiteral(["\n  list-style: none;\n  display: flex;\n  flex-direction: column;\n\n  &:last-child ", " {\n    &:after {\n      display: none;\n    }\n  }\n\n  &:first-child ", ":after {\n    display: none;\n  }\n\n  ", "\n"]);

  _templateObject15$3 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14$4() {
  var data = _taggedTemplateLiteral(["\n  margin: 0;\n  padding: ", " 0 0 0;\n"]);

  _templateObject14$4 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13$4() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject13$4 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12$4() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: 1.125em;\n  line-height: 1.22;\n  margin: 0;\n  text-align: left;\n  text-decoration: ", ";\n  ", "\n  ", ";\n"]);

  _templateObject12$4 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11$5() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n"]);

  _templateObject11$5 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10$9() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n"]);

  _templateObject10$9 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9$a() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  flex: 1;\n  padding: 1.563rem 0 1.625rem 0;\n  position: relative;\n\n  @media ", " {\n    padding: 1.313rem 0 1.375rem 0;\n  }\n\n  &:after {\n    content: '';\n    height: 1px;\n    width: 100%;\n    background: ", ";\n    opacity: 0.5;\n    position: absolute;\n    bottom: 0;\n    display: ", ";\n  }\n\n  ", "\n\n  ", "\n"]);

  _templateObject9$a = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8$b() {
  var data = _taggedTemplateLiteral(["\n  &:after {\n    background: ", ";\n  }\n"]);

  _templateObject8$b = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7$d() {
  var data = _taggedTemplateLiteral(["\n  &:after {\n    background: ", ";\n  }\n"]);

  _templateObject7$d = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$f() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  width: 100%;\n  align-items: center;\n\n  @media ", " {\n    padding-left: ", ";\n  }\n\n  @media ", " {\n    padding-left: ", ";\n  }\n"]);

  _templateObject6$f = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$h() {
  var data = _taggedTemplateLiteral(["\n  width: 40px;\n  height: 40px;\n  border-radius: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: ", ";\n  font-weight: ", ";\n  margin: 0 ", ";\n  position: relative;\n\n  &:after {\n    content: '';\n    width: 3px;\n    height: 24px;\n    background-color: ", ";\n    position: absolute;\n    top: -28px;\n    visibility: ", ";\n\n    @media ", " {\n      background-color: ", ";\n      height: 16px;\n      top: -20px;\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject5$h = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$k() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  color: ", ";\n"]);

  _templateObject4$k = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$m() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n"]);

  _templateObject3$m = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$s() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  color: ", ";\n"]);

  _templateObject2$s = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$C() {
  var data = _taggedTemplateLiteral(["\n  background-color: transparent;\n  width: 32px;\n  height: 32px;\n  border-radius: 32px;\n  border: 2px solid ", ";\n  margin: 0 ", ";\n\n  &:after {\n    height: 32px;\n    top: -36px;\n\n    @media ", " {\n      height: 20px;\n      top: -26px;\n    }\n  }\n"]);

  _templateObject$C = function _templateObject() {
    return data;
  };

  return data;
}
/** ********************************************************************
 * Badge styles
 ********************************************************************* */


var incompleteBadge = function incompleteBadge(props) {
  return css(_templateObject$C(), props.theme.colors.sinbad, props.theme.gutters[20], props.theme.BREAKPOINTS.DESKTOP_UP);
};

var activeBadge = function activeBadge(props) {
  return css(_templateObject2$s(), props.isAccordion ? props.theme.colors.white : props.theme.colors.blue, props.isAccordion ? props.theme.colors.blue : props.theme.colors.white);
};

var completeBadge = function completeBadge(props) {
  return css(_templateObject3$m(), props.theme.colors.wasabi);
};

var completeAccordionBadge = function completeAccordionBadge(props) {
  return css(_templateObject4$k(), props.theme.colors.white, props.theme.colors.wasabi);
};

var StepBadge = styled.span(_templateObject5$h(), function (props) {
  return props.theme.colors.white;
}, function (props) {
  return props.theme.fontWeight.bold;
}, function (props) {
  return props.theme.gutters[16];
}, function (props) {
  return props.theme.colors.lightGrey;
}, function (props) {
  return props.isAccordion && props.isActive ? 'hidden' : 'visible';
}, function (props) {
  return props.theme.BREAKPOINTS.DESKTOP_UP;
}, function (props) {
  return props.theme.colors.grey;
}, function (props) {
  return !props.isActive && !props.isComplete && incompleteBadge(props);
}, function (props) {
  return props.isActive && !props.isComplete && activeBadge(props);
}, function (props) {
  return props.isComplete && completeBadge(props);
}, function (props) {
  return props.isComplete && props.isActive && props.isAccordion && completeAccordionBadge(props);
});
/** ********************************************************************
 * Container styles
 ********************************************************************* */

var StepContainer = styled.div(_templateObject6$f(), function (props) {
  return props.theme.BREAKPOINTS.MOBILE_UP;
}, function (props) {
  return props.theme.gutters[8];
}, function (props) {
  return props.theme.BREAKPOINTS.DESKTOP_UP;
}, function (props) {
  return props.theme.gutters[16];
});
/** ********************************************************************
 * Details styles
 ********************************************************************* */

var AccordionActiveStepDetailsStyle = function AccordionActiveStepDetailsStyle(props) {
  return css(_templateObject7$d(), props.theme.colors.blue);
};

var AccordionOpenStepDetailsStyle = function AccordionOpenStepDetailsStyle(props) {
  return css(_templateObject8$b(), props.theme.colors.white);
};

var StepDetails = styled.div(_templateObject9$a(), function (props) {
  return props.theme.BREAKPOINTS.DESKTOP_UP;
}, function (props) {
  return props.theme.colors.grey;
}, function (props) {
  return props.isNextItemActiveAndOpen ? 'none' : 'block';
}, function (props) {
  return props.isAccordion && props.isAccordionOpen && AccordionActiveStepDetailsStyle(props);
}, function (props) {
  return !props.isAccordion && props.isAccordionOpen && AccordionOpenStepDetailsStyle(props);
});

var completeStepTitle = function completeStepTitle(props) {
  return css(_templateObject10$9(), props.theme.colors.charcoal);
};

var activeStepTitle = function activeStepTitle(props) {
  return css(_templateObject11$5(), props.isAccordion ? props.theme.colors.white : props.theme.colors.black);
};

var StepTitle = styled(Text)(_templateObject12$4(), function (props) {
  return props.theme.colors.charcoal;
}, function (props) {
  return props.strikethrough ? 'line-through' : 'none';
}, function (props) {
  return props.isComplete && completeStepTitle(props);
}, function (props) {
  return props.isActive && activeStepTitle(props);
});
/** ********************************************************************
 * Container styles
 ********************************************************************* */

var StyledStepper = styled.section(_templateObject13$4());
var StepperList = styled.ul(_templateObject14$4(), function (props) {
  return props.theme.gutters[12];
});
var Step = styled.li(_templateObject15$3(), StepDetails, StepBadge, function (props) {
  return props.isActive && props.isAccordion && "\n    & + li ".concat(StepBadge, ":after {\n      display: none;\n    }\n  ");
});

var activeAccordionStyles = function activeAccordionStyles(props) {
  return css(_templateObject16$3(), props.theme.colors.blue, function (props) {
    return props.theme.BREAKPOINTS.DESKTOP_UP;
  }, function (props) {
    return props.theme.colors.blue;
  });
};

var completeAccordionStyles = function completeAccordionStyles(props) {
  return css(_templateObject17$2(), props.theme.colors.wasabi, function (props) {
    return props.theme.BREAKPOINTS.DESKTOP_UP;
  }, function (props) {
    return props.theme.colors.wasabi;
  });
};

var StepButton = styled.button(_templateObject18$2(), function (props) {
  return !props.isDisabled ? 'pointer' : 'cursor';
}, function (props) {
  return props.theme.colors.white;
}, function (props) {
  return props.theme.BREAKPOINTS.DESKTOP_UP;
}, function (props) {
  return props.theme.colors.lightGrey;
}, function (props) {
  return props.isAccordion && props.isActive && activeAccordionStyles(props);
}, function (props) {
  return props.isAccordion && props.isComplete && props.isActive && completeAccordionStyles(props);
});
/** ********************************************************************
 * Accordion styles
 ********************************************************************* */

var completeAccordionArrow = function completeAccordionArrow(props) {
  return css(_templateObject19$2(), props.theme.colors.charcoal);
};

var activeAccordionArrow = function activeAccordionArrow(props) {
  return css(_templateObject20$1(), props.theme.colors.scandal);
};

var AccordionArrow = styled.div(_templateObject21$1(), function (props) {
  return props.theme.colors.grey;
}, function (props) {
  return props.theme.gutters[16];
}, function (props) {
  return props.isActive ? 'rotate(180deg)' : 'rotate(0deg)';
}, function (props) {
  return props.isComplete && completeAccordionArrow(props);
}, function (props) {
  return props.isActive && activeAccordionArrow(props);
});
var AccordionContent = styled(animated.div)(_templateObject22$1(), function (props) {
  return props.theme.colors.lightGrey;
}, function (props) {
  return props.isOpen ? 'block' : 'none';
}, function (props) {
  return props.theme.BREAKPOINTS.DESKTOP_UP;
}, function (props) {
  return props.theme.colors.white;
}, StepButton, function (props) {
  return props.theme.colors.lightGrey;
}, function (props) {
  return props.theme.BREAKPOINTS.DESKTOP_UP;
}, function (props) {
  return props.theme.colors.white;
}, StepDetails, StepBadge, StepBadge, function (props) {
  return props.theme.colors.grey;
}, StepDetails, function (props) {
  return props.theme.colors.grey;
}, StepTitle, function (props) {
  return props.theme.fontSize[16];
}, function (props) {
  return props.theme.fontWeight.bold;
});

function Stepper(_ref) {
  var items = _ref.items,
      activeSection = _ref.activeSection,
      activeSubSection = _ref.activeSubSection,
      onSectionClick = _ref.onSectionClick,
      onSubSectionClick = _ref.onSubSectionClick,
      disableNavigation = _ref.disableNavigation,
      strikethrough = _ref.strikethrough;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      currentSection = _useState2[0],
      setCurrentSection = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      currentSubSection = _useState4[0],
      setCurrentSubSection = _useState4[1];

  useEffect(function () {
    // set active section on mount
    if (activeSection !== null) {
      setCurrentSection(activeSection);
    } // set active subsection on mount


    if (activeSubSection !== null) {
      setCurrentSubSection(activeSubSection);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [activeSection, activeSubSection]);
  return React$2.createElement(StyledStepper, null, React$2.createElement(StepperList, null, items.map(function (item) {
    var key = item.key,
        name = item.name,
        isComplete = item.isComplete,
        subsections = item.subsections;
    var isActive = currentSection === key;
    var isAccordion = subsections.length > 0;
    return React$2.createElement(Step, {
      key: key,
      isActive: isActive,
      isAccordion: isAccordion
    }, React$2.createElement(React$2.Fragment, null, React$2.createElement(StepButton, {
      onClick: function onClick() {
        return !disableNavigation && onSectionClick(item);
      },
      isActive: isActive,
      isAccordion: isAccordion,
      isComplete: isComplete,
      isDisabled: disableNavigation
    }, React$2.createElement(StepContainer, null, React$2.createElement(StepBadge, {
      isActive: isActive,
      isComplete: isComplete,
      isAccordion: isAccordion
    }, (isComplete || isActive) && React$2.createElement(Icon, {
      size: "22px",
      icon: !isComplete ? 'MdEdit' : 'MdCheck'
    })), React$2.createElement(StepDetails, {
      isAccordion: isAccordion,
      isActive: isActive
    }, React$2.createElement(StepTitle, {
      level: 4,
      isActive: isActive,
      isComplete: isComplete,
      isAccordion: isAccordion,
      strikethrough: strikethrough
    }, name), isAccordion && React$2.createElement(AccordionArrow, {
      isComplete: isComplete,
      isActive: isActive
    }, React$2.createElement(Icon, {
      icon: "MdKeyboardArrowDown",
      size: "22px"
    }))))), isAccordion && React$2.createElement(AccordionContent, {
      isOpen: isActive
    }, subsections.map(function (subsection) {
      var key = subsection.key,
          name = subsection.name,
          isComplete = subsection.isComplete;
      var isSubSectionActive = currentSubSection === key;
      return React$2.createElement(StepButton, {
        key: key,
        onClick: function onClick() {
          return !disableNavigation && onSubSectionClick(subsection);
        },
        isDisabled: disableNavigation
      }, React$2.createElement(StepContainer, null, React$2.createElement(StepBadge, {
        isActive: isSubSectionActive,
        isComplete: isComplete
      }), React$2.createElement(StepDetails, null, React$2.createElement(StepTitle, {
        level: 4,
        isActive: isSubSectionActive,
        isComplete: isComplete,
        className: isSubSectionActive && 'isActive'
      }, name))));
    }))));
  })));
}

Stepper.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.number,
    name: PropTypes.string,
    isComplete: PropTypes.bool,
    subsections: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string,
      status: PropTypes.oneOf(['incomplete', 'active', 'complete'])
    }))
  })),
  activeSection: PropTypes.string,
  activeSubSection: PropTypes.string,
  onSectionClick: PropTypes.func,
  onSubSectionClick: PropTypes.func,
  disableNavigation: PropTypes.bool,
  strikethrough: PropTypes.bool
};
Stepper.defaultProps = {
  items: [],
  activeSection: null,
  activeSubSection: null,
  onSectionClick: function onSectionClick() {},
  onSubSectionClick: function onSubSectionClick() {},
  disableNavigation: false,
  strikethrough: false
};

function _templateObject14$5() {
  var data = _taggedTemplateLiteral(["\n  line-height: 0;\n  margin-right: 4px;\n"]);

  _templateObject14$5 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13$5() {
  var data = _taggedTemplateLiteral(["\n  margin: ", ";\n\n  @media ", " {\n    text-align: center;\n  }\n"]);

  _templateObject13$5 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12$5() {
  var data = _taggedTemplateLiteral(["\n  @media ", " {\n    margin-bottom: ", ";\n  }\n\n  @media ", " {\n    margin-bottom: ", ";\n  }\n\n  @media ", " {\n    font-size: 18px;\n    margin-bottom: 30px;\n  }\n"]);

  _templateObject12$5 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11$6() {
  var data = _taggedTemplateLiteral(["\n  margin-bottom: ", ";\n\n  @media ", " {\n    font-size: 24px;\n    margin-bottom: 12px;\n    line-height: 30px;\n  }\n"]);

  _templateObject11$6 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10$a() {
  var data = _taggedTemplateLiteral(["\n  padding: 48px 40px 80px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n\n  @media ", " {\n    padding-top: ", ";\n  }\n"]);

  _templateObject10$a = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9$b() {
  var data = _taggedTemplateLiteral(["\n  width: 448px;\n  height: 420px;\n\n  @media ", " {\n    display: none;\n  }\n\n  @media ", " {\n    display: none;\n  }\n"]);

  _templateObject9$b = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8$c() {
  var data = _taggedTemplateLiteral(["\n  width: 448px;\n  height: 420px;\n\n  @media ", " {\n    display: none;\n  }\n"]);

  _templateObject8$c = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7$e() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n\n  button:first-of-type {\n    margin-right: ", ";\n  }\n\n  @media ", " {\n    flex-direction: column;\n\n    button:first-of-type {\n      margin-right: 0;\n    }\n  }\n"]);

  _templateObject7$e = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$g() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n\n  @media ", " {\n    flex-direction: column-reverse;\n    align-items: center;\n\n    & > div {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      text-align: center;\n    }\n  }\n\n  @media ", " {\n    & > div {\n      display: block;\n      width: 100%;\n    }\n  }\n"]);

  _templateObject6$g = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$i() {
  var data = _taggedTemplateLiteral(["\n  text-transform: uppercase;\n  margin: 0;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  \n  @media ", " {\n    font-size: 13px;\n    font-weight: bold;\n  }\n"]);

  _templateObject5$i = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$l() {
  var data = _taggedTemplateLiteral(["\n  width: 116px;\n  height: 72px;\n\n  @media ", " {\n    width: 84px;\n    height: 52px;\n  }\n"]);

  _templateObject4$l = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$n() {
  var data = _taggedTemplateLiteral(["\n  padding: ", ";\n  padding-bottom: ", ";\n  margin-bottom: ", ";\n  border-bottom: 1px solid ", ";\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n\n  @media ", " {\n    padding: ", ";\n  }\n"]);

  _templateObject3$n = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$t() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  background-color: ", ";\n  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.08);\n  max-width: 1196px;\n\n  @media ", " {\n    height: 100%;\n    flex: 1;\n    box-shadow: none;\n    border-bottom: 1px solid ", ";\n  }\n"]);

  _templateObject2$t = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$D() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  min-height: 100%;\n  width: 100%;\n  background: ", "\n    url('https://commonstagingstorage.blob.core.windows.net/design-system/background-scratch.svg')\n    repeat center center;\n  padding: ", ";\n\n  @media ", " {\n    padding: 0;\n    justify-content: space-between;\n    background-color: ", ";\n  }\n"]);

  _templateObject$D = function _templateObject() {
    return data;
  };

  return data;
}

var Container = styled.section(_templateObject$D(), function (props) {
  return props.theme.colors.lightGrey;
}, function (props) {
  return props.theme.gutters[24];
}, function (props) {
  return props.theme.BREAKPOINTS.MOBILE_DOWN;
}, function (props) {
  return props.theme.colors.white;
});
var View = styled.div(_templateObject2$t(), function (props) {
  return props.theme.colors.white;
}, function (props) {
  return props.theme.BREAKPOINTS.MOBILE_DOWN;
}, function (props) {
  return props.theme.colors.lightGrey;
});
var Header = styled.header(_templateObject3$n(), function (props) {
  return props.theme.gutters[32];
}, function (props) {
  return props.theme.gutters[28];
}, function (props) {
  return props.theme.gutters[32];
}, function (props) {
  return props.theme.colors.lightGrey;
}, function (props) {
  return props.theme.BREAKPOINTS.MOBILE_DOWN;
}, function (props) {
  return props.theme.gutters[16];
});
var Logo = styled.img(_templateObject4$l(), function (props) {
  return props.theme.BREAKPOINTS.MOBILE_DOWN;
});
var HeaderText = styled(Text)(_templateObject5$i(), function (props) {
  return props.theme.BREAKPOINTS.MOBILE_DOWN;
});
var ContentArea = styled.article(_templateObject6$g(), function (props) {
  return props.theme.BREAKPOINTS.TABLET_DOWN;
}, function (props) {
  return props.theme.BREAKPOINTS.MOBILE_DOWN;
});
var ButtonContainer = styled.div(_templateObject7$e(), function (props) {
  return props.theme.gutters[16];
}, function (props) {
  return props.theme.BREAKPOINTS.TABLET_DOWN;
});
var IllustrationDesktop = styled.img(_templateObject8$c(), function (props) {
  return props.theme.BREAKPOINTS.TABLET_DOWN;
});
var IllustrationTablet = styled.img(_templateObject9$b(), function (props) {
  return props.theme.BREAKPOINTS.DESKTOP_UP;
}, function (props) {
  return props.theme.BREAKPOINTS.MOBILE_DOWN;
});
var TextContent = styled.div(_templateObject10$a(), function (props) {
  return props.theme.BREAKPOINTS.TABLET_DOWN;
}, function (props) {
  return props.theme.gutters[28];
});
var StyledHeading$1 = styled(Heading)(_templateObject11$6(), function (props) {
  return props.theme.gutters[16];
}, function (props) {
  return props.theme.BREAKPOINTS.MOBILE_DOWN;
});
var StyledSubHeading = styled(Heading)(_templateObject12$5(), function (props) {
  return props.theme.BREAKPOINTS.TABLET_UP;
}, function (props) {
  return props.theme.gutters[24];
}, function (props) {
  return props.theme.BREAKPOINTS.TABLET_DOWN;
}, function (props) {
  return props.theme.gutters[24];
}, function (props) {
  return props.theme.BREAKPOINTS.MOBILE_DOWN;
});
var Footer = styled(Text)(_templateObject13$5(), function (props) {
  return props.theme.gutters[32];
}, function (props) {
  return props.theme.BREAKPOINTS.TABLET_DOWN;
});
var IconWrapper$9 = styled.div(_templateObject14$5());

function ErrorScreen(props) {
  var headerText = props.headerText,
      heading = props.heading,
      subheading = props.subheading,
      primaryButtonText = props.primaryButtonText,
      primaryButtonOnClick = props.primaryButtonOnClick,
      secondaryButtonText = props.secondaryButtonText,
      secondaryButtonOnClick = props.secondaryButtonOnClick,
      illustration = props.illustration;

  var renderIcon = function renderIcon() {
    return React$2.createElement(IconWrapper$9, {
      "data-testid": "error-screen-icon"
    }, React$2.createElement(Icon, {
      icon: "MdReport",
      size: '1.375rem'
    }));
  };

  return React$2.createElement(Container, null, React$2.createElement(View, null, React$2.createElement(Header, null, React$2.createElement(Logo, {
    src: "https://commonstagingstorage.blob.core.windows.net/design-system/fmi-logo-dark.svg",
    alt: "FMI logo"
  }), React$2.createElement(HeaderText, {
    color: "wasabi"
  }, renderIcon(), headerText)), React$2.createElement(ContentArea, null, React$2.createElement(IllustrationDesktop, {
    src: "https://commonstagingstorage.blob.core.windows.net/design-system/illustrations/".concat(illustration, ".svg"),
    alt: "illustation"
  }), React$2.createElement(IllustrationTablet, {
    src: "https://commonstagingstorage.blob.core.windows.net/design-system/illustrations/".concat(illustration, "-responsive.svg"),
    alt: "illustation"
  }), React$2.createElement(TextContent, null, React$2.createElement("div", null, React$2.createElement(StyledHeading$1, {
    level: 2,
    color: "blue"
  }, heading), React$2.createElement(React$2.Fragment, null, subheading.map(function (s) {
    return React$2.createElement(StyledSubHeading, {
      key: s,
      level: 3,
      color: "black"
    }, s);
  }))), React$2.createElement(ButtonContainer, null, React$2.createElement(PrimaryButton, {
    onClick: primaryButtonOnClick
  }, primaryButtonText), secondaryButtonText && React$2.createElement(SecondaryButton, {
    onClick: secondaryButtonOnClick
  }, secondaryButtonText))))), React$2.createElement(Footer, {
    appearance: "small",
    color: "darkGrey"
  }, "All rights reserved. \xA9 ".concat(new Date().getFullYear(), " FMI.co.za. A licensed Life Insurance company\n        and authorised Financial Services Provider FSP 47801.")));
}

ErrorScreen.propTypes = {
  headerText: PropTypes.string,
  heading: PropTypes.string,
  subheading: PropTypes.arrayOf(PropTypes.string),
  primaryButtonText: PropTypes.string,
  primaryButtonOnClick: PropTypes.func,
  secondaryButtonText: PropTypes.string,
  secondaryButtonOnClick: PropTypes.func,
  illustration: PropTypes.oneOf(['chatbot', 'error', 'login', 'blogging'])
};

function _templateObject6$h() {
  var data = _taggedTemplateLiteral(["\n  opacity: 0;\n  width: 0;\n  height: 0;\n\n  &:checked + ", " {\n    background-color: ", ";\n    &:before {\n      background-color: ", ";\n      -webkit-transform: translateX(24px);\n      -ms-transform: translateX(24px);\n      transform: translateX(24px);\n    }\n  }\n"]);

  _templateObject6$h = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$j() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: ", ";\n  border-radius: 8px;\n  -webkit-transition: 0.4s;\n  transition: 0.4s;\n\n  &:before {\n    position: absolute;\n    content: '';\n    height: 24px;\n    width: 24px;\n    left: 0px;\n    bottom: -4px;\n    border-radius: 50%;\n    background-color: ", ";\n    box-shadow: 0 2px 4px 0 rgba(140, 140, 140, 0.32),\n      0 -2px 4px 0 rgba(140, 140, 140, 0.2);\n    -webkit-transition: 0.4s;\n    transition: 0.4s;\n  }\n"]);

  _templateObject5$j = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$m() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  display: inline-block;\n  width: 44px;\n  height: 16px;\n"]);

  _templateObject4$m = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$o() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  padding: 4px 4px;\n"]);

  _templateObject3$o = function _templateObject3() {
    return data;
  };

  return data;
}

var StyledContainer$2 = styled.div(_templateObject3$o());
var StyledLabel$2 = styled.label(_templateObject4$m());
var StyledSlider$1 = styled.span(_templateObject5$j(), function (props) {
  return props.theme.colors.darkGrey;
}, function (props) {
  return props.theme.colors.white;
});
var StyledCheckbox$1 = styled.input.attrs({
  type: 'checkbox'
})(_templateObject6$h(), StyledSlider$1, function (props) {
  return props.theme.colors.sinbad;
}, function (props) {
  return props.theme.colors.blue;
});

function ToggleSwitch(props) {
  var checked = props.checked,
      onChange = props.onChange,
      id = props.id,
      name = props.name,
      value = props.value,
      disabled = props.disabled;

  var _useState = useState(checked),
      _useState2 = _slicedToArray(_useState, 2),
      isChecked = _useState2[0],
      setIsChecked = _useState2[1];

  useEffect(function () {
    setIsChecked(checked);
  }, [checked]);

  var handleChange = function handleChange(event) {
    onChange(event);
    setIsChecked(!isChecked);
  };

  return React$2.createElement(React$2.Fragment, null, React$2.createElement(StyledContainer$2, null, React$2.createElement(StyledLabel$2, null, React$2.createElement(StyledCheckbox$1, {
    "data-testid": "checkbox",
    type: "checkbox",
    id: id,
    name: name,
    value: value,
    onChange: function onChange(event) {
      return handleChange(event);
    },
    checked: isChecked,
    disabled: disabled
  }), React$2.createElement(StyledSlider$1, null))));
}

ToggleSwitch.propTypes = {
  disabled: PropTypes.bool,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  name: PropTypes.string,
  id: PropTypes.string
};
ToggleSwitch.defaultProps = {
  checked: false,
  disabled: false,
  onChange: function onChange() {}
};

function _templateObject3$p() {
  var data = _taggedTemplateLiteral(["\n  margin: 0 0 ", " 0;\n"]);

  _templateObject3$p = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$u() {
  var data = _taggedTemplateLiteral(["\n  margin: 0 0 ", " 0;\n"]);

  _templateObject2$u = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$E() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n"]);

  _templateObject$E = function _templateObject() {
    return data;
  };

  return data;
}

var StyledContainer$3 = styled.div(_templateObject$E());
var HeadingText$2 = styled(Text)(_templateObject2$u(), function (props) {
  return props.theme.gutters[4];
});
var DescriptionText = styled(Text)(_templateObject3$p(), function (props) {
  return props.theme.gutters[4];
});

function BenefitReplacement(props) {
  var selectedForReplacement = props.selectedForReplacement,
      onChange = props.onChange,
      id = props.id,
      value = props.value,
      disabled = props.disabled;

  var _useState = useState(selectedForReplacement),
      _useState2 = _slicedToArray(_useState, 2),
      isBeingReplaced = _useState2[0],
      setIsBeingReplaced = _useState2[1];

  var handleChange = function handleChange(event) {
    onChange(event);
    setIsBeingReplaced(!isBeingReplaced);
  };

  return React$2.createElement(StyledContainer$3, null, React$2.createElement("div", null, React$2.createElement(HeadingText$2, {
    appearance: "bold"
  }, "Benefit Replacement"), React$2.createElement(DescriptionText, {
    color: "charcoal"
  }, "Is this benefit being replaced by this application?")), React$2.createElement(ToggleSwitch, {
    id: id,
    name: id,
    value: value,
    checked: isBeingReplaced,
    disabled: disabled,
    onChange: handleChange
  }));
}

BenefitReplacement.propTypes = {
  disabled: PropTypes.bool,
  id: PropTypes.string.isRequired,
  selectedForReplacement: PropTypes.bool,
  value: PropTypes.string,
  onChange: PropTypes.func
};
BenefitReplacement.defaultProps = {
  id: '',
  name: '',
  value: '',
  selectedForReplacement: false
};
export { Alert, AsyncSelectComponent as AsyncSelect, BenefitAllocation, BenefitReplacement, Button, Caption, Card, Checkbox, Copybox, DatePicker, DetailsCard, ErrorScreen, FileUpload, Heading, Hint, Icon, Indent, InteractiveCard, InteractiveCardItem$1 as InteractiveCardItem, KeyboardSlider, Label, List, Loader, Modal, OtpInput, PrimaryButton, Progressbar, RadioButton, RadioButtonGroup, RippleStyle, Scrollable, SecondaryButton, SegmentedControl, SelectComponent as Select, Slider, StandardInteractiveCard, Stepper, Text, TextInput, Theme as ThemeProvider, ToggleSwitch, UploadCard, ValidationMessage, getPercentFromRandValue, getRandValueFromPercent, prettifyDecimalNumber, squashDecimalPoints, theme };